
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7410"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7410"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
"use strict";

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
"use strict";
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
"use strict";

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
"use strict";
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
"use strict";
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("f00Nn", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aeb779073e6ae545$export$a7c73072b1a182ae, (v) => $aeb779073e6ae545$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aeb779073e6ae545$export$9f27bc3417b4524d, (v) => $aeb779073e6ae545$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aeb779073e6ae545$export$db77ccec0bb4ccac, (v) => $aeb779073e6ae545$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aeb779073e6ae545$export$8392c0c9d3dcbd35, (v) => $aeb779073e6ae545$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aeb779073e6ae545$export$ffb0004e005737fa, (v) => $aeb779073e6ae545$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aeb779073e6ae545$export$b624eff549462981, (v) => $aeb779073e6ae545$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aeb779073e6ae545$export$7897aa7841a5380c, (v) => $aeb779073e6ae545$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aeb779073e6ae545$export$602eac185826482c, (v) => $aeb779073e6ae545$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aeb779073e6ae545$export$e2c29f18771995cb, (v) => $aeb779073e6ae545$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aeb779073e6ae545$export$5f8d39834fd61797, (v) => $aeb779073e6ae545$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aeb779073e6ae545$export$74bf444e3cd11ea5, (v) => $aeb779073e6ae545$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aeb779073e6ae545$export$998bcd577473dd93, (v) => $aeb779073e6ae545$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aeb779073e6ae545$export$92387174baf9b227, (v) => $aeb779073e6ae545$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aeb779073e6ae545$export$ec112efeb987d9c6, (v) => $aeb779073e6ae545$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aeb779073e6ae545$export$b706b080d889d2c9, (v) => $aeb779073e6ae545$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aeb779073e6ae545$export$5be5a87408f70ddc, (v) => $aeb779073e6ae545$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aeb779073e6ae545$export$45a5e7f76e0caa8d, (v) => $aeb779073e6ae545$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aeb779073e6ae545$export$455c2e768291efa6, (v) => $aeb779073e6ae545$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aeb779073e6ae545$export$9522e17588c12572, (v) => $aeb779073e6ae545$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aeb779073e6ae545$export$2110ac352bb060b9, (v) => $aeb779073e6ae545$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aeb779073e6ae545$export$56885ab8b9c456ab, (v) => $aeb779073e6ae545$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aeb779073e6ae545$export$d927fcb6adf8f9de, (v) => $aeb779073e6ae545$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aeb779073e6ae545$export$b82d16f27459e05a, (v) => $aeb779073e6ae545$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aeb779073e6ae545$export$522c17b4f5e123e8, (v) => $aeb779073e6ae545$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aeb779073e6ae545$export$1aabd8a0274ecfd6, (v) => $aeb779073e6ae545$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aeb779073e6ae545$export$3d6c20d97e46b957, (v) => $aeb779073e6ae545$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aeb779073e6ae545$export$9b621391a187a31a, (v) => $aeb779073e6ae545$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aeb779073e6ae545$export$f5bbd400c2f4426f, (v) => $aeb779073e6ae545$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aeb779073e6ae545$export$a7c73072b1a182ae;
var $aeb779073e6ae545$export$9f27bc3417b4524d;
var $aeb779073e6ae545$export$db77ccec0bb4ccac;
var $aeb779073e6ae545$export$8392c0c9d3dcbd35;
var $aeb779073e6ae545$export$ffb0004e005737fa;
var $aeb779073e6ae545$export$b624eff549462981;
var $aeb779073e6ae545$export$7897aa7841a5380c;
var $aeb779073e6ae545$export$602eac185826482c;
var $aeb779073e6ae545$export$e2c29f18771995cb;
var $aeb779073e6ae545$export$5f8d39834fd61797;
var $aeb779073e6ae545$export$74bf444e3cd11ea5;
var $aeb779073e6ae545$export$998bcd577473dd93;
var $aeb779073e6ae545$export$92387174baf9b227;
var $aeb779073e6ae545$export$ec112efeb987d9c6;
var $aeb779073e6ae545$export$b706b080d889d2c9;
var $aeb779073e6ae545$export$5be5a87408f70ddc;
var $aeb779073e6ae545$export$45a5e7f76e0caa8d;
var $aeb779073e6ae545$export$455c2e768291efa6;
var $aeb779073e6ae545$export$9522e17588c12572;
var $aeb779073e6ae545$export$2110ac352bb060b9;
var $aeb779073e6ae545$export$56885ab8b9c456ab;
var $aeb779073e6ae545$export$d927fcb6adf8f9de;
var $aeb779073e6ae545$export$b82d16f27459e05a;
var $aeb779073e6ae545$export$522c17b4f5e123e8;
var $aeb779073e6ae545$export$1aabd8a0274ecfd6;
var $aeb779073e6ae545$export$3d6c20d97e46b957;
var $aeb779073e6ae545$export$9b621391a187a31a;
var $aeb779073e6ae545$export$f5bbd400c2f4426f;
"use strict";
var $aeb779073e6ae545$var$b = Symbol.for("react.element"), $aeb779073e6ae545$var$c = Symbol.for("react.portal"), $aeb779073e6ae545$var$d = Symbol.for("react.fragment"), $aeb779073e6ae545$var$e = Symbol.for("react.strict_mode"), $aeb779073e6ae545$var$f = Symbol.for("react.profiler"), $aeb779073e6ae545$var$g = Symbol.for("react.provider"), $aeb779073e6ae545$var$h = Symbol.for("react.context"), $aeb779073e6ae545$var$k = Symbol.for("react.server_context"), $aeb779073e6ae545$var$l = Symbol.for("react.forward_ref"), $aeb779073e6ae545$var$m = Symbol.for("react.suspense"), $aeb779073e6ae545$var$n = Symbol.for("react.suspense_list"), $aeb779073e6ae545$var$p = Symbol.for("react.memo"), $aeb779073e6ae545$var$q = Symbol.for("react.lazy"), $aeb779073e6ae545$var$t = Symbol.for("react.offscreen"), $aeb779073e6ae545$var$u;
$aeb779073e6ae545$var$u = Symbol.for("react.module.reference");
function $aeb779073e6ae545$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aeb779073e6ae545$var$b:
                switch(a = a.type, a){
                    case $aeb779073e6ae545$var$d:
                    case $aeb779073e6ae545$var$f:
                    case $aeb779073e6ae545$var$e:
                    case $aeb779073e6ae545$var$m:
                    case $aeb779073e6ae545$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aeb779073e6ae545$var$k:
                            case $aeb779073e6ae545$var$h:
                            case $aeb779073e6ae545$var$l:
                            case $aeb779073e6ae545$var$q:
                            case $aeb779073e6ae545$var$p:
                            case $aeb779073e6ae545$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aeb779073e6ae545$var$c:
                return r;
        }
    }
}
$aeb779073e6ae545$export$a7c73072b1a182ae = $aeb779073e6ae545$var$h;
$aeb779073e6ae545$export$9f27bc3417b4524d = $aeb779073e6ae545$var$g;
$aeb779073e6ae545$export$db77ccec0bb4ccac = $aeb779073e6ae545$var$b;
$aeb779073e6ae545$export$8392c0c9d3dcbd35 = $aeb779073e6ae545$var$l;
$aeb779073e6ae545$export$ffb0004e005737fa = $aeb779073e6ae545$var$d;
$aeb779073e6ae545$export$b624eff549462981 = $aeb779073e6ae545$var$q;
$aeb779073e6ae545$export$7897aa7841a5380c = $aeb779073e6ae545$var$p;
$aeb779073e6ae545$export$602eac185826482c = $aeb779073e6ae545$var$c;
$aeb779073e6ae545$export$e2c29f18771995cb = $aeb779073e6ae545$var$f;
$aeb779073e6ae545$export$5f8d39834fd61797 = $aeb779073e6ae545$var$e;
$aeb779073e6ae545$export$74bf444e3cd11ea5 = $aeb779073e6ae545$var$m;
$aeb779073e6ae545$export$998bcd577473dd93 = $aeb779073e6ae545$var$n;
$aeb779073e6ae545$export$92387174baf9b227 = function() {
    return !1;
};
$aeb779073e6ae545$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aeb779073e6ae545$export$b706b080d889d2c9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$h;
};
$aeb779073e6ae545$export$5be5a87408f70ddc = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$g;
};
$aeb779073e6ae545$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aeb779073e6ae545$var$b;
};
$aeb779073e6ae545$export$455c2e768291efa6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$l;
};
$aeb779073e6ae545$export$9522e17588c12572 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$d;
};
$aeb779073e6ae545$export$2110ac352bb060b9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$q;
};
$aeb779073e6ae545$export$56885ab8b9c456ab = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$p;
};
$aeb779073e6ae545$export$d927fcb6adf8f9de = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$c;
};
$aeb779073e6ae545$export$b82d16f27459e05a = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$f;
};
$aeb779073e6ae545$export$522c17b4f5e123e8 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$e;
};
$aeb779073e6ae545$export$1aabd8a0274ecfd6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$m;
};
$aeb779073e6ae545$export$3d6c20d97e46b957 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$n;
};
$aeb779073e6ae545$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aeb779073e6ae545$var$d || a === $aeb779073e6ae545$var$f || a === $aeb779073e6ae545$var$e || a === $aeb779073e6ae545$var$m || a === $aeb779073e6ae545$var$n || a === $aeb779073e6ae545$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aeb779073e6ae545$var$q || a.$$typeof === $aeb779073e6ae545$var$p || a.$$typeof === $aeb779073e6ae545$var$g || a.$$typeof === $aeb779073e6ae545$var$h || a.$$typeof === $aeb779073e6ae545$var$l || a.$$typeof === $aeb779073e6ae545$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aeb779073e6ae545$export$f5bbd400c2f4426f = $aeb779073e6ae545$var$v;

});

parcelRegister("2zAtv", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1OFRX.default;
    }
});

var $1OFRX = parcelRequire("1OFRX");

});
parcelRegister("1OFRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $152af056249ce881$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $gXKvQ = parcelRequire("gXKvQ");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $152af056249ce881$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $gXKvQ.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $gXKvQ.default).muiName;
    return /*#__PURE__*/ $aqdBs.memo(/*#__PURE__*/ $aqdBs.forwardRef(Component));
}

});
parcelRegister("gXKvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5963c738444bd47$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $40jPv = parcelRequire("40jPv");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $eff0b = parcelRequire("eff0b");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $c5963c738444bd47$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $40jPv.default)(color)}`,
            `fontSize${(0, $40jPv.default)(fontSize)}`
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $eff0b.getSvgIconUtilityClass), classes);
};
const $c5963c738444bd47$var$SvgIconRoot = (0, $6JVXO.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $40jPv.default)(ownerState.color)}`],
            styles[`fontSize${(0, $40jPv.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        flexShrink: 0,
        transition: theme.transitions?.create?.("fill", {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: "currentColor"
                }
            },
            {
                props: {
                    fontSize: "inherit"
                },
                style: {
                    fontSize: "inherit"
                }
            },
            {
                props: {
                    fontSize: "small"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || "1.25rem"
                }
            },
            {
                props: {
                    fontSize: "medium"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || "1.5rem"
                }
            },
            {
                props: {
                    fontSize: "large"
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || "2.1875rem"
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: "action"
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: "disabled"
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $c5963c738444bd47$var$SvgIcon = /*#__PURE__*/ $aqdBs.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24", ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $aqdBs.isValidElement(children) && children.type === "svg";
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $c5963c738444bd47$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($c5963c738444bd47$var$SvgIconRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $1Ivrw.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
if ($c5963c738444bd47$var$SvgIcon) $c5963c738444bd47$var$SvgIcon.muiName = "SvgIcon";
var $c5963c738444bd47$export$2e2bcd8739ae039 = $c5963c738444bd47$var$SvgIcon;

});
parcelRegister("fQojQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9d4e7b280b4edb$export$2e2bcd8739ae039);
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;

});

parcelRegister("5ylSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b11a25a862ae5d$export$2e2bcd8739ae039);
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ function $40b11a25a862ae5d$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = "";
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? "" : " ") + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += " " + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("40jPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea68b4e74a5eb69$export$2e2bcd8739ae039);

var $8VvrB = parcelRequire("8VvrB");
var $2ea68b4e74a5eb69$export$2e2bcd8739ae039 = (0, $8VvrB.default);

});
parcelRegister("8VvrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $67fc09c179ec7823$export$2e2bcd8739ae039);

var $9PB6d = parcelRequire("9PB6d");
function $67fc09c179ec7823$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $9PB6d.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("9PB6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7285a7a2c7556340$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $7285a7a2c7556340$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("6JVXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e83e873b395294c$export$2e2bcd8739ae039);

var $h4bqR = parcelRequire("h4bqR");

var $9xlCw = parcelRequire("9xlCw");

var $dbHL4 = parcelRequire("dbHL4");

var $aMtHL = parcelRequire("aMtHL");

"use client";
const $4e83e873b395294c$var$styled = (0, $h4bqR.default)({
    themeId: (0, $dbHL4.default),
    defaultTheme: $9xlCw.default,
    rootShouldForwardProp: $aMtHL.default
});
var $4e83e873b395294c$export$2e2bcd8739ae039 = $4e83e873b395294c$var$styled;

});
parcelRegister("h4bqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6cbad9d886578c8$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ 
var $eFaUn = parcelRequire("eFaUn");

var $88kuG = parcelRequire("88kuG");



var $iqdgc = parcelRequire("iqdgc");

var $3WTHp = parcelRequire("3WTHp");
const $c6cbad9d886578c8$export$35e57303dbd8a66 = (0, $iqdgc.default)();
function $c6cbad9d886578c8$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function $c6cbad9d886578c8$var$resolveTheme(themeId, theme, defaultTheme) {
    return $c6cbad9d886578c8$var$isObjectEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
const $c6cbad9d886578c8$var$PROCESSED_PROPS = Symbol("mui.processed_props");
function $c6cbad9d886578c8$var$attachTheme(props, themeId, defaultTheme) {
    if ($c6cbad9d886578c8$var$PROCESSED_PROPS in props) return props[$c6cbad9d886578c8$var$PROCESSED_PROPS];
    const processedProps = {
        ...props,
        theme: $c6cbad9d886578c8$var$resolveTheme(themeId, props.theme, defaultTheme)
    };
    props[$c6cbad9d886578c8$var$PROCESSED_PROPS] = processedProps;
    processedProps[$c6cbad9d886578c8$var$PROCESSED_PROPS] = processedProps;
    return processedProps;
}
function $c6cbad9d886578c8$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $c6cbad9d886578c8$var$processStyle(style, props) {
    const resolvedStyle = typeof style === "function" ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$c6cbad9d886578c8$var$processStyle(subStyle, props));
    if (Array.isArray(resolvedStyle?.variants)) {
        const { variants: variants, ...otherStyles } = resolvedStyle;
        let result = otherStyles;
        let mergedState; // We might not need it, initalized lazily
        /* eslint-disable no-labels */ variantLoop: for(let i = 0; i < variants.length; i += 1){
            const variant = variants[i];
            if (typeof variant.props === "function") {
                mergedState ??= {
                    ...props,
                    ...props.ownerState,
                    ownerState: props.ownerState
                };
                if (!variant.props(mergedState)) continue;
            } else for(const key in variant.props){
                if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
            }
            if (!Array.isArray(result)) result = [
                result
            ];
            if (typeof variant.style === "function") {
                mergedState ??= {
                    ...props,
                    ...props.ownerState,
                    ownerState: props.ownerState
                };
                result.push(variant.style(mergedState));
            } else result.push(variant.style);
        }
        /* eslint-enable no-labels */ return result;
    }
    return resolvedStyle;
}
function $c6cbad9d886578c8$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c6cbad9d886578c8$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $c6cbad9d886578c8$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $c6cbad9d886578c8$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $3WTHp.default)($c6cbad9d886578c8$var$attachTheme(props, themeId, defaultTheme));
    };
    systemSx.__mui_systemSx = true;
    const styled = (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $eFaUn.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!style?.__mui_systemSx));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c6cbad9d886578c8$var$defaultOverridesResolver($c6cbad9d886578c8$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $c6cbad9d886578c8$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c6cbad9d886578c8$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $eFaUn.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: label,
            ...options
        });
        const transformStyleArg = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === "function" && style.__emotion_real !== style || (0, $88kuG.isPlainObject)(style)) return (props)=>$c6cbad9d886578c8$var$processStyle(style, $c6cbad9d886578c8$var$attachTheme(props, themeId, defaultTheme));
            return style;
        };
        const muiStyledResolver = (style, ...expressions)=>{
            let transformedStyle = transformStyleArg(style);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c6cbad9d886578c8$var$resolveTheme(themeId, props.theme, defaultTheme);
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                const propsWithTheme = $c6cbad9d886578c8$var$attachTheme(props, themeId, defaultTheme);
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $c6cbad9d886578c8$var$processStyle(styleOverrides[slotKey], propsWithTheme);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c6cbad9d886578c8$var$resolveTheme(themeId, props.theme, defaultTheme);
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $c6cbad9d886578c8$var$processStyle({
                    variants: themeVariants
                }, $c6cbad9d886578c8$var$attachTheme(props, themeId, defaultTheme));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(style) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyle = [
                    ...style,
                    ...placeholders
                ];
                transformedStyle.raw = [
                    ...style.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyle, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $c6cbad9d886578c8$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c6cbad9d886578c8$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $c6cbad9d886578c8$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("eFaUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aacd5b2bbb2de666$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $aacd5b2bbb2de666$export$e00380445f2b9e0c);
/**
 * @mui/styled-engine v6.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $a1JC5 = parcelRequire("a1JC5");

var $aIlUA = parcelRequire("aIlUA");
var $j6Zbs = parcelRequire("j6Zbs");


var $LkOKM = parcelRequire("LkOKM");
function $aacd5b2bbb2de666$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $a1JC5.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $aacd5b2bbb2de666$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("a1JC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $74cd61378d7c26c6$export$2e2bcd8739ae039);

var $g4n0U = parcelRequire("g4n0U");
parcelRequire("h1M2F");
parcelRequire("aqdBs");
parcelRequire("fAvwW");

parcelRequire("3YWMq");
parcelRequire("l4Ibs");
parcelRequire("eMr1G");
var $74cd61378d7c26c6$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $74cd61378d7c26c6$export$2e2bcd8739ae039 = (0, $g4n0U.default).bind();
$74cd61378d7c26c6$var$tags.forEach(function(tagName) {
    $74cd61378d7c26c6$export$2e2bcd8739ae039[tagName] = $74cd61378d7c26c6$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("g4n0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2edf185ad0210f$export$2e2bcd8739ae039);

var $lmT1h = parcelRequire("lmT1h");

var $aqdBs = parcelRequire("aqdBs");

var $fAvwW = parcelRequire("fAvwW");
parcelRequire("aIlUA");
var $j6Zbs = parcelRequire("j6Zbs");

var $3YWMq = parcelRequire("3YWMq");

var $l4Ibs = parcelRequire("l4Ibs");

var $eMr1G = parcelRequire("eMr1G");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $bb2edf185ad0210f$var$testOmitPropsOnStringTag = (0, $fAvwW.default);
var $bb2edf185ad0210f$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $bb2edf185ad0210f$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $bb2edf185ad0210f$var$testOmitPropsOnStringTag : $bb2edf185ad0210f$var$testOmitPropsOnComponent;
};
var $bb2edf185ad0210f$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $bb2edf185ad0210f$var$isDevelopment = false;
var $bb2edf185ad0210f$var$isBrowser = typeof document !== "undefined";
var $bb2edf185ad0210f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3YWMq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $eMr1G.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3YWMq.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$bb2edf185ad0210f$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $aqdBs.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $bb2edf185ad0210f$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $bb2edf185ad0210f$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $bb2edf185ad0210f$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $j6Zbs.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $aqdBs.useContext((0, $j6Zbs.T));
            }
            if (typeof props.className === "string") className = (0, $3YWMq.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $l4Ibs.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $bb2edf185ad0210f$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($bb2edf185ad0210f$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $aqdBs.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $bb2edf185ad0210f$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $lmT1h.default)({}, options, nextOptions, {
                shouldForwardProp: $bb2edf185ad0210f$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("lmT1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e654cc5b5e5520$export$2e2bcd8739ae039);
function $f8e654cc5b5e5520$export$2e2bcd8739ae039() {
    return $f8e654cc5b5e5520$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8e654cc5b5e5520$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fAvwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b592ad1486ff26a7$export$2e2bcd8739ae039);

var $jeNL3 = parcelRequire("jeNL3");
// eslint-disable-next-line no-undef
var $b592ad1486ff26a7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b592ad1486ff26a7$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $jeNL3.default)(function(prop) {
    return $b592ad1486ff26a7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("jeNL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e015ec02b8c36601$export$2e2bcd8739ae039);
function $e015ec02b8c36601$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("aIlUA", function(module, exports) {

$parcel$export(module.exports, "Global", () => $7ccf02a5d80acba0$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $7ccf02a5d80acba0$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $7ccf02a5d80acba0$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("j6Zbs")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("j6Zbs")).w);

var $j6Zbs = parcelRequire("j6Zbs");

var $aqdBs = parcelRequire("aqdBs");

var $3YWMq = parcelRequire("3YWMq");

var $eMr1G = parcelRequire("eMr1G");

var $l4Ibs = parcelRequire("l4Ibs");
parcelRequire("9ToLd");
parcelRequire("h1M2F");
parcelRequire("83kLZ");

parcelRequire("4Djfw");
var $7ccf02a5d80acba0$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $j6Zbs.h).call(props, "css")) return $aqdBs.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $j6Zbs.E);
    createElementArgArray[1] = (0, $j6Zbs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $aqdBs.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7ccf02a5d80acba0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $j6Zbs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $l4Ibs.serializeStyles)([
        styles
    ], undefined, $aqdBs.useContext((0, $j6Zbs.T)));
    if (!(0, $j6Zbs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $aqdBs.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $aqdBs.useRef();
    (0, $eMr1G.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $eMr1G.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3YWMq.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $7ccf02a5d80acba0$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $l4Ibs.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $7ccf02a5d80acba0$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $7ccf02a5d80acba0$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $7ccf02a5d80acba0$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7ccf02a5d80acba0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3YWMq.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7ccf02a5d80acba0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $eMr1G.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $3YWMq.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $j6Zbs.i) && res !== undefined) rules += res;
        }
        if (!(0, $j6Zbs.i)) return rules;
    });
    if (!(0, $j6Zbs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $aqdBs.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $7ccf02a5d80acba0$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $j6Zbs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $j6Zbs.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $l4Ibs.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3YWMq.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $j6Zbs.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7ccf02a5d80acba0$var$merge(cache.registered, css, $7ccf02a5d80acba0$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $aqdBs.useContext((0, $j6Zbs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($7ccf02a5d80acba0$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("j6Zbs", function(module, exports) {

$parcel$export(module.exports, "a", () => $de9e09afc3ed55a9$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $de9e09afc3ed55a9$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $de9e09afc3ed55a9$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $de9e09afc3ed55a9$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $de9e09afc3ed55a9$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $de9e09afc3ed55a9$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $de9e09afc3ed55a9$export$a9c23c6ac3fc3eca);

var $aqdBs = parcelRequire("aqdBs");

var $9ToLd = parcelRequire("9ToLd");

var $lmT1h = parcelRequire("lmT1h");

var $83kLZ = parcelRequire("83kLZ");

var $9SnIk = parcelRequire("9SnIk");

var $3YWMq = parcelRequire("3YWMq");

var $l4Ibs = parcelRequire("l4Ibs");

var $eMr1G = parcelRequire("eMr1G");
var $de9e09afc3ed55a9$export$407448d2b89b1813 = false;
var $de9e09afc3ed55a9$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $de9e09afc3ed55a9$var$EmotionCacheContext = /* #__PURE__ */ $aqdBs.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $9ToLd.default)({
    key: "css"
}) : null);
var $de9e09afc3ed55a9$export$e7094788287c5e9b = $de9e09afc3ed55a9$var$EmotionCacheContext.Provider;
var $de9e09afc3ed55a9$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $aqdBs.useContext)($de9e09afc3ed55a9$var$EmotionCacheContext);
};
var $de9e09afc3ed55a9$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $aqdBs.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $aqdBs.useContext)($de9e09afc3ed55a9$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$de9e09afc3ed55a9$export$23f2a1d2818174ef) $de9e09afc3ed55a9$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $aqdBs.useContext)($de9e09afc3ed55a9$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $9ToLd.default)({
                key: "css"
            });
            return /*#__PURE__*/ $aqdBs.createElement($de9e09afc3ed55a9$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $de9e09afc3ed55a9$export$971d5caa766a69d7 = /* #__PURE__ */ $aqdBs.createContext({});
var $de9e09afc3ed55a9$export$3b14a55fb2447963 = function useTheme() {
    return $aqdBs.useContext($de9e09afc3ed55a9$export$971d5caa766a69d7);
};
var $de9e09afc3ed55a9$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $lmT1h.default)({}, outerTheme, theme);
};
var $de9e09afc3ed55a9$var$createCacheWithTheme = /* #__PURE__ */ (0, $83kLZ.default)(function(outerTheme) {
    return (0, $83kLZ.default)(function(theme) {
        return $de9e09afc3ed55a9$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $de9e09afc3ed55a9$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $aqdBs.useContext($de9e09afc3ed55a9$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $de9e09afc3ed55a9$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $aqdBs.createElement($de9e09afc3ed55a9$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $de9e09afc3ed55a9$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $aqdBs.useContext($de9e09afc3ed55a9$export$971d5caa766a69d7);
        return /*#__PURE__*/ $aqdBs.createElement(Component, (0, $lmT1h.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $aqdBs.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $9SnIk.default)(WithTheme, Component);
}
var $de9e09afc3ed55a9$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $de9e09afc3ed55a9$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $de9e09afc3ed55a9$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($de9e09afc3ed55a9$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$de9e09afc3ed55a9$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $de9e09afc3ed55a9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3YWMq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $eMr1G.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3YWMq.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$de9e09afc3ed55a9$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $aqdBs.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $de9e09afc3ed55a9$var$Emotion = /* #__PURE__ */ $de9e09afc3ed55a9$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$de9e09afc3ed55a9$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $3YWMq.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $l4Ibs.serializeStyles)(registeredStyles, undefined, $aqdBs.useContext($de9e09afc3ed55a9$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($de9e09afc3ed55a9$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $de9e09afc3ed55a9$var$typePropName && !$de9e09afc3ed55a9$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($de9e09afc3ed55a9$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $aqdBs.createElement(WrappedComponent, newProps));
});
var $de9e09afc3ed55a9$export$a9c23c6ac3fc3eca = $de9e09afc3ed55a9$var$Emotion;

});
parcelRegister("9ToLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $733c750a2f8732a8$export$2e2bcd8739ae039);

var $bIyd5 = parcelRequire("bIyd5");

var $cEoWI = parcelRequire("cEoWI");

var $83kLZ = parcelRequire("83kLZ");

var $jeNL3 = parcelRequire("jeNL3");
var $733c750a2f8732a8$var$isBrowser = typeof document !== "undefined";
var $733c750a2f8732a8$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cEoWI.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cEoWI.token)(character)) break;
        (0, $cEoWI.next)();
    }
    return (0, $cEoWI.slice)(begin, (0, $cEoWI.position));
};
var $733c750a2f8732a8$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cEoWI.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cEoWI.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $733c750a2f8732a8$var$identifierWithPointTracking((0, $cEoWI.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cEoWI.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cEoWI.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cEoWI.from)(character);
    }
    while (character = (0, $cEoWI.next)());
    return parsed;
};
var $733c750a2f8732a8$var$getRules = function getRules(value, points) {
    return (0, $cEoWI.dealloc)($733c750a2f8732a8$var$toRules((0, $cEoWI.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $733c750a2f8732a8$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $733c750a2f8732a8$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$733c750a2f8732a8$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $733c750a2f8732a8$var$fixedElements.set(element, true);
    var points = [];
    var rules = $733c750a2f8732a8$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $733c750a2f8732a8$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $733c750a2f8732a8$var$prefix(value, length) {
    switch((0, $cEoWI.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cEoWI.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cEoWI.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MOZ) + value + (0, $cEoWI.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + value + value;
        // order
        case 6165:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.replace)(value, /(\w+).+(:[^]+)/, (0, $cEoWI.WEBKIT) + "box-$1$2" + (0, $cEoWI.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + "flex-item-" + (0, $cEoWI.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + "flex-line-pack" + (0, $cEoWI.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $cEoWI.WEBKIT) + "box-" + (0, $cEoWI.replace)(value, "-grow", "") + (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $cEoWI.WEBKIT) + (0, $cEoWI.replace)(value, /([^-])(transform)/g, "$1" + (0, $cEoWI.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $cEoWI.replace)((0, $cEoWI.replace)((0, $cEoWI.replace)(value, /(zoom-|grab)/, (0, $cEoWI.WEBKIT) + "$1"), /(image-set)/, (0, $cEoWI.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cEoWI.replace)(value, /(image-set\([^]*)/, (0, $cEoWI.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $cEoWI.replace)((0, $cEoWI.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cEoWI.WEBKIT) + "box-pack:$3" + (0, $cEoWI.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $cEoWI.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cEoWI.replace)(value, /(.+)-inline(.+)/, (0, $cEoWI.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cEoWI.strlen)(value) - 1 - length > 6) switch((0, $cEoWI.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cEoWI.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cEoWI.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $cEoWI.WEBKIT) + "$2-$3" + "$1" + (0, $cEoWI.MOZ) + ((0, $cEoWI.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cEoWI.indexof)(value, "stretch") ? $733c750a2f8732a8$var$prefix((0, $cEoWI.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cEoWI.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cEoWI.charat)(value, (0, $cEoWI.strlen)(value) - 3 - (~(0, $cEoWI.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $cEoWI.replace)(value, ":", ":" + (0, $cEoWI.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cEoWI.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $cEoWI.WEBKIT) + ((0, $cEoWI.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $cEoWI.WEBKIT) + "$2$3" + "$1" + (0, $cEoWI.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cEoWI.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + value + value;
    }
    return value;
}
var $733c750a2f8732a8$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cEoWI.DECLARATION:
                element["return"] = $733c750a2f8732a8$var$prefix(element.value, element.length);
                break;
            case 0, $cEoWI.KEYFRAMES:
                return (0, $cEoWI.serialize)([
                    (0, $cEoWI.copy)(element, {
                        value: (0, $cEoWI.replace)(element.value, "@", "@" + (0, $cEoWI.WEBKIT))
                    })
                ], callback);
            case 0, $cEoWI.RULESET:
                if (element.length) return (0, $cEoWI.combine)(element.props, function(value) {
                    switch((0, $cEoWI.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $cEoWI.serialize)([
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(read-\w+)/, ":" + (0, $cEoWI.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $cEoWI.serialize)([
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, ":" + (0, $cEoWI.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, ":" + (0, $cEoWI.MOZ) + "$1")
                                    ]
                                }),
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, (0, $cEoWI.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $733c750a2f8732a8$var$getServerStylisCache = $733c750a2f8732a8$var$isBrowser ? undefined : (0, $83kLZ.default)(function() {
    return (0, $jeNL3.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $733c750a2f8732a8$var$defaultStylisPlugins = [
    $733c750a2f8732a8$var$prefixer
];
var $733c750a2f8732a8$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($733c750a2f8732a8$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $733c750a2f8732a8$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($733c750a2f8732a8$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $733c750a2f8732a8$var$compat,
        $733c750a2f8732a8$var$removeLabel
    ];
    if ($733c750a2f8732a8$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cEoWI.stringify),
            (0, $cEoWI.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cEoWI.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cEoWI.serialize)((0, $cEoWI.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cEoWI.stringify)
        ];
        var _serializer = (0, $cEoWI.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cEoWI.serialize)((0, $cEoWI.compile)(styles), _serializer);
        };
        var serverStylisCache = $733c750a2f8732a8$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bIyd5.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bIyd5", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $887e572a59b27363$export$9d753cd7ae895cce);
var $887e572a59b27363$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $887e572a59b27363$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $887e572a59b27363$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $887e572a59b27363$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$887e572a59b27363$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($887e572a59b27363$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $887e572a59b27363$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cEoWI", function(module, exports) {

$parcel$export(module.exports, "MS", () => $be3710ecc2092733$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $be3710ecc2092733$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $be3710ecc2092733$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $be3710ecc2092733$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $be3710ecc2092733$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $be3710ecc2092733$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $be3710ecc2092733$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $be3710ecc2092733$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $be3710ecc2092733$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $be3710ecc2092733$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $be3710ecc2092733$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $be3710ecc2092733$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $be3710ecc2092733$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $be3710ecc2092733$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $be3710ecc2092733$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $be3710ecc2092733$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $be3710ecc2092733$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $be3710ecc2092733$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $be3710ecc2092733$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $be3710ecc2092733$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $be3710ecc2092733$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $be3710ecc2092733$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $be3710ecc2092733$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $be3710ecc2092733$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $be3710ecc2092733$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $be3710ecc2092733$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $be3710ecc2092733$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $be3710ecc2092733$export$38bcb760f1d4871c);
var $be3710ecc2092733$export$71ad59f2e432cfe8 = "-ms-";
var $be3710ecc2092733$export$2c0f367103c8d01c = "-moz-";
var $be3710ecc2092733$export$39dfd62a25e0fe93 = "-webkit-";
var $be3710ecc2092733$export$a29989082612d0d9 = "comm";
var $be3710ecc2092733$export$aa3a2e812ca8570d = "rule";
var $be3710ecc2092733$export$527d108ccf083c2b = "decl";
var $be3710ecc2092733$export$d3d35020fa5b54f0 = "@page";
var $be3710ecc2092733$export$500415a86c544f73 = "@media";
var $be3710ecc2092733$export$a763edbf796b780a = "@import";
var $be3710ecc2092733$export$2790aeb8b4e5c826 = "@charset";
var $be3710ecc2092733$export$1cc683e23b84b133 = "@viewport";
var $be3710ecc2092733$export$9447a5efea57e862 = "@supports";
var $be3710ecc2092733$export$ef011b4e114b1fba = "@document";
var $be3710ecc2092733$export$6aad947bda0f3f46 = "@namespace";
var $be3710ecc2092733$export$b44a8529a35fcb60 = "@keyframes";
var $be3710ecc2092733$export$2c16de31893252e6 = "@font-face";
var $be3710ecc2092733$export$3d846dd52e150c6f = "@counter-style";
var $be3710ecc2092733$export$22314bfbb57653fe = "@font-feature-values";
var $be3710ecc2092733$export$d773506282b3cfe6 = "@layer";
var $be3710ecc2092733$export$2335f513bbd82c6d = Math.abs;
var $be3710ecc2092733$export$6788812c4e6611e6 = String.fromCharCode;
var $be3710ecc2092733$export$e6e34fd1f2686227 = Object.assign;
function $be3710ecc2092733$export$d6af199866bfb566(e, r) {
    return $be3710ecc2092733$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 0)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 1)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 2)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 3) : 0;
}
function $be3710ecc2092733$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $be3710ecc2092733$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $be3710ecc2092733$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $be3710ecc2092733$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $be3710ecc2092733$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $be3710ecc2092733$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $be3710ecc2092733$export$36776f635604f274(e) {
    return e.length;
}
function $be3710ecc2092733$export$f9084667e487ed46(e) {
    return e.length;
}
function $be3710ecc2092733$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $be3710ecc2092733$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $be3710ecc2092733$export$53f1d5ea8de3d7c = 1;
var $be3710ecc2092733$export$4e0c71f277ca26b3 = 1;
var $be3710ecc2092733$export$f24224f1c91d8156 = 0;
var $be3710ecc2092733$export$5880b8b5730aff45 = 0;
var $be3710ecc2092733$export$c0306caf338ac095 = 0;
var $be3710ecc2092733$export$30a86d91af8ff6e6 = "";
function $be3710ecc2092733$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $be3710ecc2092733$export$53f1d5ea8de3d7c,
        column: $be3710ecc2092733$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $be3710ecc2092733$export$784d13d8ee351f07(e, r) {
    return $be3710ecc2092733$export$e6e34fd1f2686227($be3710ecc2092733$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $be3710ecc2092733$export$eba6f6f03b0a92e7() {
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$232faf9add678146() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 > 0 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, --$be3710ecc2092733$export$5880b8b5730aff45) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3--, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c--;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$48cfd1e771a65c4f() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 < $be3710ecc2092733$export$f24224f1c91d8156 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45++) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3++, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c++;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$4d3fb11e950abb9e() {
    return $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$e88cb2efb12ae807() {
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$58adb3bec8346d0f(e, r) {
    return $be3710ecc2092733$export$2f35ab04d2335697($be3710ecc2092733$export$30a86d91af8ff6e6, e, r);
}
function $be3710ecc2092733$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $be3710ecc2092733$export$2de70f21292aac9e(e) {
    return $be3710ecc2092733$export$53f1d5ea8de3d7c = $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$f24224f1c91d8156 = $be3710ecc2092733$export$36776f635604f274($be3710ecc2092733$export$30a86d91af8ff6e6 = e), $be3710ecc2092733$export$5880b8b5730aff45 = 0, [];
}
function $be3710ecc2092733$export$45918ac1574455b1(e) {
    return $be3710ecc2092733$export$30a86d91af8ff6e6 = "", e;
}
function $be3710ecc2092733$export$410ac95b9ec204b8(e) {
    return $be3710ecc2092733$export$87c2784dc9fc4ab($be3710ecc2092733$export$58adb3bec8346d0f($be3710ecc2092733$export$5880b8b5730aff45 - 1, $be3710ecc2092733$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $be3710ecc2092733$export$660b2ee2d4fb4eff(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$5f8c09e3ae6f64e1($be3710ecc2092733$export$2de70f21292aac9e(e)));
}
function $be3710ecc2092733$export$7af1228ff777d175(e) {
    while($be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$4d3fb11e950abb9e())if ($be3710ecc2092733$export$c0306caf338ac095 < 33) $be3710ecc2092733$export$48cfd1e771a65c4f();
    else break;
    return $be3710ecc2092733$export$9e1725a4cfeada27(e) > 2 || $be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $be3710ecc2092733$export$5f8c09e3ae6f64e1(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095)){
        case 0:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$c0306caf338ac095), e);
            break;
        default:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$c0306caf338ac095), e);
    }
    return e;
}
function $be3710ecc2092733$export$955ba06d119e085e(e, r) {
    while(--r && $be3710ecc2092733$export$48cfd1e771a65c4f())if ($be3710ecc2092733$export$c0306caf338ac095 < 48 || $be3710ecc2092733$export$c0306caf338ac095 > 102 || $be3710ecc2092733$export$c0306caf338ac095 > 57 && $be3710ecc2092733$export$c0306caf338ac095 < 65 || $be3710ecc2092733$export$c0306caf338ac095 > 70 && $be3710ecc2092733$export$c0306caf338ac095 < 97) break;
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$e88cb2efb12ae807() + (r < 6 && $be3710ecc2092733$export$4d3fb11e950abb9e() == 32 && $be3710ecc2092733$export$48cfd1e771a65c4f() == 32));
}
function $be3710ecc2092733$export$c889f2fcc19dbf12(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$c0306caf338ac095){
        case e:
            return $be3710ecc2092733$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $be3710ecc2092733$export$c889f2fcc19dbf12($be3710ecc2092733$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $be3710ecc2092733$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $be3710ecc2092733$export$48cfd1e771a65c4f();
            break;
    }
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$4254d4e2b3745c4c(e, r) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())if (e + $be3710ecc2092733$export$c0306caf338ac095 === 57) break;
    else if (e + $be3710ecc2092733$export$c0306caf338ac095 === 84 && $be3710ecc2092733$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $be3710ecc2092733$export$58adb3bec8346d0f(r, $be3710ecc2092733$export$5880b8b5730aff45 - 1) + "*" + $be3710ecc2092733$export$6788812c4e6611e6(e === 47 ? e : $be3710ecc2092733$export$48cfd1e771a65c4f());
}
function $be3710ecc2092733$export$c2ab62c7bf24634(e) {
    while(!$be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$4d3fb11e950abb9e()))$be3710ecc2092733$export$48cfd1e771a65c4f();
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$ef7acd7185315e22(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $be3710ecc2092733$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $be3710ecc2092733$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $be3710ecc2092733$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $be3710ecc2092733$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($be3710ecc2092733$export$f8e21b1e77979a08(j += $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $be3710ecc2092733$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $be3710ecc2092733$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $be3710ecc2092733$export$955ba06d119e085e($be3710ecc2092733$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($be3710ecc2092733$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$4a34f930e789283c($be3710ecc2092733$export$4254d4e2b3745c4c($be3710ecc2092733$export$48cfd1e771a65c4f(), $be3710ecc2092733$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $be3710ecc2092733$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $be3710ecc2092733$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $be3710ecc2092733$export$36776f635604f274(j) - l) $be3710ecc2092733$export$10d8903dec122b9d(p > 32 ? $be3710ecc2092733$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $be3710ecc2092733$export$f8483753829ec8f3($be3710ecc2092733$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $be3710ecc2092733$export$10d8903dec122b9d(y = $be3710ecc2092733$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $be3710ecc2092733$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $be3710ecc2092733$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $be3710ecc2092733$export$98e6a39c04603d36(e, y, y, n && $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $be3710ecc2092733$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $be3710ecc2092733$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $be3710ecc2092733$export$232faf9add678146() == 125) continue;
            }
            switch(j += $be3710ecc2092733$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($be3710ecc2092733$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($be3710ecc2092733$export$4d3fb11e950abb9e() === 45) j += $be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$48cfd1e771a65c4f());
                    v = $be3710ecc2092733$export$4d3fb11e950abb9e(), o = l = $be3710ecc2092733$export$36776f635604f274(g = j += $be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $be3710ecc2092733$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $be3710ecc2092733$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $be3710ecc2092733$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $be3710ecc2092733$export$2f35ab04d2335697(e, v + 1, v = $be3710ecc2092733$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $be3710ecc2092733$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $be3710ecc2092733$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, s === 0 ? $be3710ecc2092733$export$aa3a2e812ca8570d : i, f, o, l);
}
function $be3710ecc2092733$export$4a34f930e789283c(e, r, a) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$a29989082612d0d9, $be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$eba6f6f03b0a92e7()), $be3710ecc2092733$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $be3710ecc2092733$export$f8483753829ec8f3(e, r, a, n) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$527d108ccf083c2b, $be3710ecc2092733$export$2f35ab04d2335697(e, 0, n), $be3710ecc2092733$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $be3710ecc2092733$export$82e9f45cca5ba907(n, c, s) {
    switch($be3710ecc2092733$export$d6af199866bfb566(n, c)){
        case 5103:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $be3710ecc2092733$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$2c0f367103c8d01c + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-$1$2" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-item-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-line-pack" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-grow", "") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-pack:$3" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-column-align" + $be3710ecc2092733$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$be3710ecc2092733$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$be3710ecc2092733$export$f8e21b1e77979a08(s, "span") ? $be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) : +$be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) - +$be3710ecc2092733$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($be3710ecc2092733$export$36776f635604f274(n) - 1 - c > 6) switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $be3710ecc2092733$export$2c0f367103c8d01c + ($be3710ecc2092733$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$be3710ecc2092733$export$f8e21b1e77979a08(n, "stretch") ? $be3710ecc2092733$export$82e9f45cca5ba907($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $be3710ecc2092733$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $be3710ecc2092733$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 6) === 121) return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, $be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + ($be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $be3710ecc2092733$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $be3710ecc2092733$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $be3710ecc2092733$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $be3710ecc2092733$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $be3710ecc2092733$export$a763edbf796b780a:
        case $be3710ecc2092733$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $be3710ecc2092733$export$a29989082612d0d9:
            return "";
        case $be3710ecc2092733$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $be3710ecc2092733$export$36776f635604f274(a = $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $be3710ecc2092733$export$5a7767152ae0305f(e) {
    var r = $be3710ecc2092733$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $be3710ecc2092733$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $be3710ecc2092733$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $be3710ecc2092733$export$527d108ccf083c2b:
                n.return = $be3710ecc2092733$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $be3710ecc2092733$export$b44a8529a35fcb60:
                return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                    $be3710ecc2092733$export$784d13d8ee351f07(n, {
                        value: $be3710ecc2092733$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $be3710ecc2092733$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $be3710ecc2092733$export$aa3a2e812ca8570d:
                if (n.length) return $be3710ecc2092733$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($be3710ecc2092733$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $be3710ecc2092733$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $be3710ecc2092733$export$76a88f7de6507443(e) {
    switch(e.type){
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $be3710ecc2092733$export$1be1fc439b849fdf($be3710ecc2092733$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($be3710ecc2092733$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $be3710ecc2092733$export$2f35ab04d2335697(r, 1, $be3710ecc2092733$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $be3710ecc2092733$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $be3710ecc2092733$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $be3710ecc2092733$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("83kLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dceb7a01231679c$export$2e2bcd8739ae039);
var $5dceb7a01231679c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("9SnIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $730b8d505e26cfb7$export$2e2bcd8739ae039);

var $4Djfw = parcelRequire("4Djfw");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $730b8d505e26cfb7$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(targetComponent, sourceComponent);
};

});
parcelRegister("4Djfw", function(module, exports) {
"use strict";

var $9rjTY = parcelRequire("9rjTY");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($9rjTY.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component["$$typeof"]] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;

});
parcelRegister("9rjTY", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dhnve"));

});



parcelRegister("3YWMq", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $2e64922db703decc$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $2e64922db703decc$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $2e64922db703decc$export$6f077d94b33a01aa);
var $2e64922db703decc$var$isBrowser = typeof document !== "undefined";
function $2e64922db703decc$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $2e64922db703decc$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $2e64922db703decc$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $2e64922db703decc$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $2e64922db703decc$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$2e64922db703decc$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$2e64922db703decc$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("l4Ibs", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $f57c3eb30df30aac$export$6321afa313b251b5);

var $ayDaZ = parcelRequire("ayDaZ");

var $2TSYT = parcelRequire("2TSYT");

var $jeNL3 = parcelRequire("jeNL3");
var $f57c3eb30df30aac$var$isDevelopment = false;
var $f57c3eb30df30aac$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f57c3eb30df30aac$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f57c3eb30df30aac$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f57c3eb30df30aac$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $f57c3eb30df30aac$var$processStyleName = /* #__PURE__ */ (0, $jeNL3.default)(function(styleName) {
    return $f57c3eb30df30aac$var$isCustomProperty(styleName) ? styleName : styleName.replace($f57c3eb30df30aac$var$hyphenateRegex, "-$&").toLowerCase();
});
var $f57c3eb30df30aac$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($f57c3eb30df30aac$var$animationRegex, function(match, p1, p2) {
                $f57c3eb30df30aac$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f57c3eb30df30aac$var$cursor
                };
                return p1;
            });
    }
    if ((0, $2TSYT.default)[key] !== 1 && !$f57c3eb30df30aac$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $f57c3eb30df30aac$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $f57c3eb30df30aac$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $f57c3eb30df30aac$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f57c3eb30df30aac$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f57c3eb30df30aac$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $f57c3eb30df30aac$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $f57c3eb30df30aac$var$cursor;
                var result = interpolation(mergedProps);
                $f57c3eb30df30aac$var$cursor = previousCursor;
                return $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $f57c3eb30df30aac$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($f57c3eb30df30aac$var$isProcessableValue(asString)) string += $f57c3eb30df30aac$var$processStyleName(key) + ":" + $f57c3eb30df30aac$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $f57c3eb30df30aac$var$isDevelopment) throw new Error($f57c3eb30df30aac$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($f57c3eb30df30aac$var$isProcessableValue(value[_i])) string += $f57c3eb30df30aac$var$processStyleName(key) + ":" + $f57c3eb30df30aac$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $f57c3eb30df30aac$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $f57c3eb30df30aac$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $f57c3eb30df30aac$var$cursor;
function $f57c3eb30df30aac$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $f57c3eb30df30aac$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f57c3eb30df30aac$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $f57c3eb30df30aac$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f57c3eb30df30aac$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $ayDaZ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f57c3eb30df30aac$var$cursor
    };
}

});
parcelRegister("ayDaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afb77f31dbef2ab$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7afb77f31dbef2ab$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("2TSYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cb5de91d0b0040$export$2e2bcd8739ae039);
var $21cb5de91d0b0040$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("eMr1G", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $ac2a8330da5c145d$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $ac2a8330da5c145d$export$811a713a7276cb9d);

var $aqdBs = parcelRequire("aqdBs");
var $ac2a8330da5c145d$var$isBrowser = typeof document !== "undefined";
var $ac2a8330da5c145d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $ac2a8330da5c145d$var$useInsertionEffect = $aqdBs.useInsertionEffect ? $aqdBs.useInsertionEffect : false;
var $ac2a8330da5c145d$export$db21c7ffa21794e7 = !$ac2a8330da5c145d$var$isBrowser ? $ac2a8330da5c145d$var$syncFallback : $ac2a8330da5c145d$var$useInsertionEffect || $ac2a8330da5c145d$var$syncFallback;
var $ac2a8330da5c145d$export$811a713a7276cb9d = $ac2a8330da5c145d$var$useInsertionEffect || $aqdBs.useLayoutEffect;

});


parcelRegister("h1M2F", function(module, exports) {
function $c657cbd4e5e84562$var$_extends() {
    return module.exports = $c657cbd4e5e84562$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c657cbd4e5e84562$var$_extends.apply(null, arguments);
}
module.exports = $c657cbd4e5e84562$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("LkOKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e489d7f12450df$export$2e2bcd8739ae039);
parcelRequire("aqdBs");


var $aIlUA = parcelRequire("aIlUA");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $08e489d7f12450df$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $08e489d7f12450df$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($08e489d7f12450df$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $aIlUA.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("1Ivrw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aPfka"));

});



parcelRegister("88kuG", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $5ebef7b8429b7827$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $5ebef7b8429b7827$export$2e2bcd8739ae039);
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $5ebef7b8429b7827$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $5ebef7b8429b7827$var$deepClone(source) {
    if (!$5ebef7b8429b7827$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $5ebef7b8429b7827$var$deepClone(source[key]);
    });
    return output;
}
function $5ebef7b8429b7827$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($5ebef7b8429b7827$export$53b83ca8eaab0383(target) && $5ebef7b8429b7827$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($5ebef7b8429b7827$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $5ebef7b8429b7827$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $5ebef7b8429b7827$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $5ebef7b8429b7827$export$53b83ca8eaab0383(source[key]) ? $5ebef7b8429b7827$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iqdgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d694f0eabd042bd6$export$2e2bcd8739ae039);

var $88kuG = parcelRequire("88kuG");

var $j0Bmx = parcelRequire("j0Bmx");

var $4r6SD = parcelRequire("4r6SD");

var $favMV = parcelRequire("favMV");

var $jrnkK = parcelRequire("jrnkK");

var $3WTHp = parcelRequire("3WTHp");

var $aamMV = parcelRequire("aamMV");

var $cZm3p = parcelRequire("cZm3p");
function $d694f0eabd042bd6$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $j0Bmx.default)(breakpointsInput);
    const spacing = (0, $jrnkK.default)(spacingInput);
    let muiTheme = (0, $88kuG.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: {
            mode: "light",
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $favMV.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $4r6SD.default)(muiTheme);
    muiTheme.applyStyles = (0, $cZm3p.default);
    muiTheme = args.reduce((acc, argument)=>(0, $88kuG.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $aamMV.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3WTHp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d694f0eabd042bd6$export$2e2bcd8739ae039 = $d694f0eabd042bd6$var$createTheme;

});
parcelRegister("j0Bmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6affd390ddda64$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $dd6affd390ddda64$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $dd6affd390ddda64$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $dd6affd390ddda64$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5, ...other } = breakpoints;
    const sortedValues = $dd6affd390ddda64$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("4r6SD", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $33af055233964d9b$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $33af055233964d9b$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $33af055233964d9b$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $33af055233964d9b$export$2e2bcd8739ae039);

function $33af055233964d9b$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith("@container")).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $33af055233964d9b$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === "@" || value.startsWith("@") && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $33af055233964d9b$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $33af055233964d9b$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("favMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b072a9ad237a7b$export$2e2bcd8739ae039);
const $b0b072a9ad237a7b$var$shape = {
    borderRadius: 4
};
var $b0b072a9ad237a7b$export$2e2bcd8739ae039 = $b0b072a9ad237a7b$var$shape;

});

parcelRegister("jrnkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e272a3899b8017b0$export$2e2bcd8739ae039);

var $lE9bp = parcelRequire("lE9bp");
function $e272a3899b8017b0$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $lE9bp.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("lE9bp", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $fc2474f20e8056a3$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $fc2474f20e8056a3$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $fc2474f20e8056a3$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $fc2474f20e8056a3$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $fc2474f20e8056a3$export$6f98e8eaf0be1996);


var $1gEYn = parcelRequire("1gEYn");

var $6CZgg = parcelRequire("6CZgg");

var $1qQFs = parcelRequire("1qQFs");

var $giZbH = parcelRequire("giZbH");
const $fc2474f20e8056a3$var$properties = {
    m: "margin",
    p: "padding"
};
const $fc2474f20e8056a3$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $fc2474f20e8056a3$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fc2474f20e8056a3$var$getCssProperties = (0, $giZbH.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fc2474f20e8056a3$var$aliases[prop]) prop = $fc2474f20e8056a3$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $fc2474f20e8056a3$var$properties[a];
    const direction = $fc2474f20e8056a3$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fc2474f20e8056a3$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $fc2474f20e8056a3$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $fc2474f20e8056a3$var$spacingKeys = [
    ...$fc2474f20e8056a3$export$aab52a0dde05ad8a,
    ...$fc2474f20e8056a3$export$f8397d44f03ab6ad
];
function $fc2474f20e8056a3$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $6CZgg.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === "number" || typeof themeSpacing === "string") return (val)=>{
        if (typeof val === "string") return val;
        if (typeof themeSpacing === "string") return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === "string") return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === "number") return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $fc2474f20e8056a3$export$1def6f833384e3d1(theme) {
    return $fc2474f20e8056a3$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $fc2474f20e8056a3$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    return transformer(propValue);
}
function $fc2474f20e8056a3$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fc2474f20e8056a3$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $fc2474f20e8056a3$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $fc2474f20e8056a3$var$getCssProperties(prop);
    const styleFromPropValue = $fc2474f20e8056a3$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $1gEYn.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fc2474f20e8056a3$var$style(props, keys) {
    const transformer = $fc2474f20e8056a3$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$fc2474f20e8056a3$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $1qQFs.default), {});
}
function $fc2474f20e8056a3$export$7ede87f9b603dd3c(props) {
    return $fc2474f20e8056a3$var$style(props, $fc2474f20e8056a3$export$aab52a0dde05ad8a);
}
$fc2474f20e8056a3$export$7ede87f9b603dd3c.propTypes = {};
$fc2474f20e8056a3$export$7ede87f9b603dd3c.filterProps = $fc2474f20e8056a3$export$aab52a0dde05ad8a;
function $fc2474f20e8056a3$export$6f98e8eaf0be1996(props) {
    return $fc2474f20e8056a3$var$style(props, $fc2474f20e8056a3$export$f8397d44f03ab6ad);
}
$fc2474f20e8056a3$export$6f98e8eaf0be1996.propTypes = {};
$fc2474f20e8056a3$export$6f98e8eaf0be1996.filterProps = $fc2474f20e8056a3$export$f8397d44f03ab6ad;
function $fc2474f20e8056a3$var$spacing(props) {
    return $fc2474f20e8056a3$var$style(props, $fc2474f20e8056a3$var$spacingKeys);
}
$fc2474f20e8056a3$var$spacing.propTypes = {};
$fc2474f20e8056a3$var$spacing.filterProps = $fc2474f20e8056a3$var$spacingKeys;
var $fc2474f20e8056a3$export$2e2bcd8739ae039 = $fc2474f20e8056a3$var$spacing;

});
parcelRegister("1gEYn", function(module, exports) {

$parcel$export(module.exports, "values", () => $0ec7116747255f26$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $0ec7116747255f26$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $0ec7116747255f26$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $0ec7116747255f26$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $0ec7116747255f26$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $0ec7116747255f26$export$980e6a259d807490);


var $88kuG = parcelRequire("88kuG");

var $1qQFs = parcelRequire("1qQFs");

var $4r6SD = parcelRequire("4r6SD");
const $0ec7116747255f26$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $0ec7116747255f26$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$0ec7116747255f26$export$68c286be0e7e55b7[key]}px)`
};
const $0ec7116747255f26$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === "number" ? key : $0ec7116747255f26$export$68c286be0e7e55b7[key] || key;
                if (typeof result === "number") result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $0ec7116747255f26$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $0ec7116747255f26$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $0ec7116747255f26$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $4r6SD.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $4r6SD.getContainerQuery)(theme.containerQueries ? theme : $0ec7116747255f26$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $0ec7116747255f26$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $0ec7116747255f26$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $0ec7116747255f26$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $1qQFs.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $0ec7116747255f26$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $0ec7116747255f26$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $0ec7116747255f26$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $0ec7116747255f26$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $88kuG.default)(prev, next), {});
    return $0ec7116747255f26$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $0ec7116747255f26$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $0ec7116747255f26$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $0ec7116747255f26$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $0ec7116747255f26$export$2e2bcd8739ae039 = $0ec7116747255f26$var$breakpoints;

});
parcelRegister("1qQFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b112e04a87a23c$export$2e2bcd8739ae039);

var $88kuG = parcelRequire("88kuG");
function $10b112e04a87a23c$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $88kuG.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $10b112e04a87a23c$export$2e2bcd8739ae039 = $10b112e04a87a23c$var$merge;

});


parcelRegister("6CZgg", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $4d35cfe3d063e2a5$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $4d35cfe3d063e2a5$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $4d35cfe3d063e2a5$export$2e2bcd8739ae039);

var $8VvrB = parcelRequire("8VvrB");


var $1gEYn = parcelRequire("1gEYn");
function $4d35cfe3d063e2a5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $4d35cfe3d063e2a5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $4d35cfe3d063e2a5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $4d35cfe3d063e2a5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $4d35cfe3d063e2a5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $4d35cfe3d063e2a5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $4d35cfe3d063e2a5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8VvrB.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $1gEYn.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $4d35cfe3d063e2a5$export$2e2bcd8739ae039 = $4d35cfe3d063e2a5$var$style;

});

parcelRegister("giZbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdedca686bc36e55$export$2e2bcd8739ae039);
function $bdedca686bc36e55$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("3WTHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e01fe927d38503b$export$2e2bcd8739ae039);

var $8VvrB = parcelRequire("8VvrB");

var $1qQFs = parcelRequire("1qQFs");

var $6CZgg = parcelRequire("6CZgg");

var $1gEYn = parcelRequire("1gEYn");

var $4r6SD = parcelRequire("4r6SD");

var $aamMV = parcelRequire("aamMV");
function $2e01fe927d38503b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $2e01fe927d38503b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $2e01fe927d38503b$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $6CZgg.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $6CZgg.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $6CZgg.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8VvrB.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $1gEYn.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $aamMV.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $1gEYn.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $2e01fe927d38503b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $1qQFs.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $1gEYn.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($2e01fe927d38503b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $1qQFs.default)(css, breakpointsValues);
                        }
                    } else css = (0, $1qQFs.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $4r6SD.sortContainerQueries)(theme, (0, $1gEYn.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $2e01fe927d38503b$var$styleFunctionSx = $2e01fe927d38503b$export$7d53d8bf2911e013();
$2e01fe927d38503b$var$styleFunctionSx.filterProps = [
    "sx"
];
var $2e01fe927d38503b$export$2e2bcd8739ae039 = $2e01fe927d38503b$var$styleFunctionSx;

});
parcelRegister("aamMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $766c83c7fd2a0e39$export$2e2bcd8739ae039);

var $lE9bp = parcelRequire("lE9bp");

var $gEUNd = parcelRequire("gEUNd");

var $1MNLD = parcelRequire("1MNLD");

var $9OUgG = parcelRequire("9OUgG");

var $3svGu = parcelRequire("3svGu");
const $766c83c7fd2a0e39$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $gEUNd.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $gEUNd.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $9OUgG.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $9OUgG.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $9OUgG.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $lE9bp.padding)
    },
    pt: {
        style: (0, $lE9bp.padding)
    },
    pr: {
        style: (0, $lE9bp.padding)
    },
    pb: {
        style: (0, $lE9bp.padding)
    },
    pl: {
        style: (0, $lE9bp.padding)
    },
    px: {
        style: (0, $lE9bp.padding)
    },
    py: {
        style: (0, $lE9bp.padding)
    },
    padding: {
        style: (0, $lE9bp.padding)
    },
    paddingTop: {
        style: (0, $lE9bp.padding)
    },
    paddingRight: {
        style: (0, $lE9bp.padding)
    },
    paddingBottom: {
        style: (0, $lE9bp.padding)
    },
    paddingLeft: {
        style: (0, $lE9bp.padding)
    },
    paddingX: {
        style: (0, $lE9bp.padding)
    },
    paddingY: {
        style: (0, $lE9bp.padding)
    },
    paddingInline: {
        style: (0, $lE9bp.padding)
    },
    paddingInlineStart: {
        style: (0, $lE9bp.padding)
    },
    paddingInlineEnd: {
        style: (0, $lE9bp.padding)
    },
    paddingBlock: {
        style: (0, $lE9bp.padding)
    },
    paddingBlockStart: {
        style: (0, $lE9bp.padding)
    },
    paddingBlockEnd: {
        style: (0, $lE9bp.padding)
    },
    m: {
        style: (0, $lE9bp.margin)
    },
    mt: {
        style: (0, $lE9bp.margin)
    },
    mr: {
        style: (0, $lE9bp.margin)
    },
    mb: {
        style: (0, $lE9bp.margin)
    },
    ml: {
        style: (0, $lE9bp.margin)
    },
    mx: {
        style: (0, $lE9bp.margin)
    },
    my: {
        style: (0, $lE9bp.margin)
    },
    margin: {
        style: (0, $lE9bp.margin)
    },
    marginTop: {
        style: (0, $lE9bp.margin)
    },
    marginRight: {
        style: (0, $lE9bp.margin)
    },
    marginBottom: {
        style: (0, $lE9bp.margin)
    },
    marginLeft: {
        style: (0, $lE9bp.margin)
    },
    marginX: {
        style: (0, $lE9bp.margin)
    },
    marginY: {
        style: (0, $lE9bp.margin)
    },
    marginInline: {
        style: (0, $lE9bp.margin)
    },
    marginInlineStart: {
        style: (0, $lE9bp.margin)
    },
    marginInlineEnd: {
        style: (0, $lE9bp.margin)
    },
    marginBlock: {
        style: (0, $lE9bp.margin)
    },
    marginBlockStart: {
        style: (0, $lE9bp.margin)
    },
    marginBlockEnd: {
        style: (0, $lE9bp.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $1MNLD.gap)
    },
    rowGap: {
        style: (0, $1MNLD.rowGap)
    },
    columnGap: {
        style: (0, $1MNLD.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $3svGu.sizingTransform)
    },
    maxWidth: {
        style: (0, $3svGu.maxWidth)
    },
    minWidth: {
        transform: (0, $3svGu.sizingTransform)
    },
    height: {
        transform: (0, $3svGu.sizingTransform)
    },
    maxHeight: {
        transform: (0, $3svGu.sizingTransform)
    },
    minHeight: {
        transform: (0, $3svGu.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: "font"
    },
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $766c83c7fd2a0e39$export$2e2bcd8739ae039 = $766c83c7fd2a0e39$var$defaultSxConfig;

});
parcelRegister("gEUNd", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $c20c6fa57f3872f5$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $c20c6fa57f3872f5$export$7a57f79000377ca2);


var $6CZgg = parcelRequire("6CZgg");

var $l1j8d = parcelRequire("l1j8d");

var $lE9bp = parcelRequire("lE9bp");

var $1gEYn = parcelRequire("1gEYn");
function $c20c6fa57f3872f5$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $c20c6fa57f3872f5$var$createBorderStyle(prop, transform) {
    return (0, $6CZgg.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $c20c6fa57f3872f5$export$1edee58a52776cd9 = $c20c6fa57f3872f5$var$createBorderStyle("border", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$f9a7b6bd24892946 = $c20c6fa57f3872f5$var$createBorderStyle("borderTop", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$5abca33e6be905d2 = $c20c6fa57f3872f5$var$createBorderStyle("borderRight", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$e2ce9f12a980a822 = $c20c6fa57f3872f5$var$createBorderStyle("borderBottom", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$47658cca1a909427 = $c20c6fa57f3872f5$var$createBorderStyle("borderLeft", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$e7fb0694ba2404fc = $c20c6fa57f3872f5$var$createBorderStyle("borderColor");
const $c20c6fa57f3872f5$export$126a92c968acdb85 = $c20c6fa57f3872f5$var$createBorderStyle("borderTopColor");
const $c20c6fa57f3872f5$export$85cc51cb8fbb8c0e = $c20c6fa57f3872f5$var$createBorderStyle("borderRightColor");
const $c20c6fa57f3872f5$export$340b0327727f6d1a = $c20c6fa57f3872f5$var$createBorderStyle("borderBottomColor");
const $c20c6fa57f3872f5$export$60beef91a985b4bf = $c20c6fa57f3872f5$var$createBorderStyle("borderLeftColor");
const $c20c6fa57f3872f5$export$f9258c55612cbed7 = $c20c6fa57f3872f5$var$createBorderStyle("outline", $c20c6fa57f3872f5$export$34e2febe53ae29cc);
const $c20c6fa57f3872f5$export$621fe586efeb64b9 = $c20c6fa57f3872f5$var$createBorderStyle("outlineColor");
const $c20c6fa57f3872f5$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $lE9bp.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $lE9bp.getValue)(transformer, propValue)
            });
        return (0, $1gEYn.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c20c6fa57f3872f5$export$7a57f79000377ca2.propTypes = {};
$c20c6fa57f3872f5$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $c20c6fa57f3872f5$var$borders = (0, $l1j8d.default)($c20c6fa57f3872f5$export$1edee58a52776cd9, $c20c6fa57f3872f5$export$f9a7b6bd24892946, $c20c6fa57f3872f5$export$5abca33e6be905d2, $c20c6fa57f3872f5$export$e2ce9f12a980a822, $c20c6fa57f3872f5$export$47658cca1a909427, $c20c6fa57f3872f5$export$e7fb0694ba2404fc, $c20c6fa57f3872f5$export$126a92c968acdb85, $c20c6fa57f3872f5$export$85cc51cb8fbb8c0e, $c20c6fa57f3872f5$export$340b0327727f6d1a, $c20c6fa57f3872f5$export$60beef91a985b4bf, $c20c6fa57f3872f5$export$7a57f79000377ca2, $c20c6fa57f3872f5$export$f9258c55612cbed7, $c20c6fa57f3872f5$export$621fe586efeb64b9);
var $c20c6fa57f3872f5$export$2e2bcd8739ae039 = $c20c6fa57f3872f5$var$borders;

});
parcelRegister("l1j8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d88819d71ac6ca$export$2e2bcd8739ae039);

var $1qQFs = parcelRequire("1qQFs");
function $f4d88819d71ac6ca$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $1qQFs.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $f4d88819d71ac6ca$export$2e2bcd8739ae039 = $f4d88819d71ac6ca$var$compose;

});


parcelRegister("1MNLD", function(module, exports) {

$parcel$export(module.exports, "gap", () => $14d0e0dfa2630f72$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $14d0e0dfa2630f72$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $14d0e0dfa2630f72$export$8a833ffa5f5dbeda);

var $6CZgg = parcelRequire("6CZgg");

var $l1j8d = parcelRequire("l1j8d");

var $lE9bp = parcelRequire("lE9bp");

var $1gEYn = parcelRequire("1gEYn");

const $14d0e0dfa2630f72$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $lE9bp.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $lE9bp.getValue)(transformer, propValue)
            });
        return (0, $1gEYn.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$14d0e0dfa2630f72$export$5df9adcb0db95e1e.propTypes = {};
$14d0e0dfa2630f72$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $14d0e0dfa2630f72$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $lE9bp.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $lE9bp.getValue)(transformer, propValue)
            });
        return (0, $1gEYn.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$14d0e0dfa2630f72$export$ec60d70ff941a580.propTypes = {};
$14d0e0dfa2630f72$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $14d0e0dfa2630f72$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $lE9bp.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $lE9bp.getValue)(transformer, propValue)
            });
        return (0, $1gEYn.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$14d0e0dfa2630f72$export$8a833ffa5f5dbeda.propTypes = {};
$14d0e0dfa2630f72$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $14d0e0dfa2630f72$export$baf44164ca3a34e8 = (0, $6CZgg.default)({
    prop: "gridColumn"
});
const $14d0e0dfa2630f72$export$8f7213a1cd01e832 = (0, $6CZgg.default)({
    prop: "gridRow"
});
const $14d0e0dfa2630f72$export$b0e0abbc49ba668 = (0, $6CZgg.default)({
    prop: "gridAutoFlow"
});
const $14d0e0dfa2630f72$export$bcd8b929d4b4142 = (0, $6CZgg.default)({
    prop: "gridAutoColumns"
});
const $14d0e0dfa2630f72$export$e5039a674e14c828 = (0, $6CZgg.default)({
    prop: "gridAutoRows"
});
const $14d0e0dfa2630f72$export$42bd9088661ffb03 = (0, $6CZgg.default)({
    prop: "gridTemplateColumns"
});
const $14d0e0dfa2630f72$export$920682ae05b999bc = (0, $6CZgg.default)({
    prop: "gridTemplateRows"
});
const $14d0e0dfa2630f72$export$1b88fbdd482fd33a = (0, $6CZgg.default)({
    prop: "gridTemplateAreas"
});
const $14d0e0dfa2630f72$export$bdb486e40d52d26f = (0, $6CZgg.default)({
    prop: "gridArea"
});
const $14d0e0dfa2630f72$var$grid = (0, $l1j8d.default)($14d0e0dfa2630f72$export$5df9adcb0db95e1e, $14d0e0dfa2630f72$export$ec60d70ff941a580, $14d0e0dfa2630f72$export$8a833ffa5f5dbeda, $14d0e0dfa2630f72$export$baf44164ca3a34e8, $14d0e0dfa2630f72$export$8f7213a1cd01e832, $14d0e0dfa2630f72$export$b0e0abbc49ba668, $14d0e0dfa2630f72$export$bcd8b929d4b4142, $14d0e0dfa2630f72$export$e5039a674e14c828, $14d0e0dfa2630f72$export$42bd9088661ffb03, $14d0e0dfa2630f72$export$920682ae05b999bc, $14d0e0dfa2630f72$export$1b88fbdd482fd33a, $14d0e0dfa2630f72$export$bdb486e40d52d26f);
var $14d0e0dfa2630f72$export$2e2bcd8739ae039 = $14d0e0dfa2630f72$var$grid;

});

parcelRegister("9OUgG", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $72646e3d5ce991e6$export$dbaffd4420ea0ac6);

var $6CZgg = parcelRequire("6CZgg");

var $l1j8d = parcelRequire("l1j8d");
function $72646e3d5ce991e6$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $72646e3d5ce991e6$export$35e9368ef982300f = (0, $6CZgg.default)({
    prop: "color",
    themeKey: "palette",
    transform: $72646e3d5ce991e6$export$dbaffd4420ea0ac6
});
const $72646e3d5ce991e6$export$2506f56c10355b33 = (0, $6CZgg.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $72646e3d5ce991e6$export$dbaffd4420ea0ac6
});
const $72646e3d5ce991e6$export$8c5a050822fd698c = (0, $6CZgg.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $72646e3d5ce991e6$export$dbaffd4420ea0ac6
});
const $72646e3d5ce991e6$var$palette = (0, $l1j8d.default)($72646e3d5ce991e6$export$35e9368ef982300f, $72646e3d5ce991e6$export$2506f56c10355b33, $72646e3d5ce991e6$export$8c5a050822fd698c);
var $72646e3d5ce991e6$export$2e2bcd8739ae039 = $72646e3d5ce991e6$var$palette;

});

parcelRegister("3svGu", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $284c90769bba4dff$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $284c90769bba4dff$export$488fda99655ff65a);

var $6CZgg = parcelRequire("6CZgg");

var $l1j8d = parcelRequire("l1j8d");

var $1gEYn = parcelRequire("1gEYn");
function $284c90769bba4dff$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $284c90769bba4dff$export$7e3df82ee760448c = (0, $6CZgg.default)({
    prop: "width",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $1gEYn.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $284c90769bba4dff$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $1gEYn.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$284c90769bba4dff$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $284c90769bba4dff$export$ee148fbbe8357dd2 = (0, $6CZgg.default)({
    prop: "minWidth",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$ac607276a8fe9f0a = (0, $6CZgg.default)({
    prop: "height",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$dc0d8bd0b94f8570 = (0, $6CZgg.default)({
    prop: "maxHeight",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$a43cf604e12f3b17 = (0, $6CZgg.default)({
    prop: "minHeight",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$ffed9f14fb65e276 = (0, $6CZgg.default)({
    prop: "size",
    cssProperty: "width",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$905076ed6620e671 = (0, $6CZgg.default)({
    prop: "size",
    cssProperty: "height",
    transform: $284c90769bba4dff$export$8afece71750ec241
});
const $284c90769bba4dff$export$6ccc93f785106a58 = (0, $6CZgg.default)({
    prop: "boxSizing"
});
const $284c90769bba4dff$var$sizing = (0, $l1j8d.default)($284c90769bba4dff$export$7e3df82ee760448c, $284c90769bba4dff$export$488fda99655ff65a, $284c90769bba4dff$export$ee148fbbe8357dd2, $284c90769bba4dff$export$ac607276a8fe9f0a, $284c90769bba4dff$export$dc0d8bd0b94f8570, $284c90769bba4dff$export$a43cf604e12f3b17, $284c90769bba4dff$export$6ccc93f785106a58);
var $284c90769bba4dff$export$2e2bcd8739ae039 = $284c90769bba4dff$var$sizing;

});



parcelRegister("cZm3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $974c4a06f40b5d6a$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $974c4a06f40b5d6a$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === "&") return styles;
        if (selector.includes("data-") || selector.includes(".")) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("9xlCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f17f772ede3cd91$export$2e2bcd8739ae039);

var $cIIWu = parcelRequire("cIIWu");
"use client";
const $6f17f772ede3cd91$var$defaultTheme = (0, $cIIWu.default)();
var $6f17f772ede3cd91$export$2e2bcd8739ae039 = $6f17f772ede3cd91$var$defaultTheme;

});
parcelRegister("cIIWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $942c74ba2c7f356b$export$2e2bcd8739ae039);

var $94gGt = parcelRequire("94gGt");

var $i156L = parcelRequire("i156L");

var $98T2y = parcelRequire("98T2y");
// eslint-disable-next-line consistent-return
function $942c74ba2c7f356b$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $94gGt.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $942c74ba2c7f356b$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || "light";
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== "boolean" && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!("colorSchemes" in options)) // Behaves exactly as v5
        return (0, $98T2y.default)(options, ...args);
        let paletteOptions = palette;
        if (!("palette" in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === "dark") // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: "dark"
                };
            }
        }
        const theme = (0, $98T2y.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === "light") {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $942c74ba2c7f356b$var$attachColorScheme(theme, "dark", colorSchemesInput.dark);
        }
        if (theme.palette.mode === "dark") {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $942c74ba2c7f356b$var$attachColorScheme(theme, "light", colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !("light" in colorSchemesInput) && defaultColorSchemeInput === "light") colorSchemesInput.light = true;
    return (0, $i156L.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== "boolean" && cssVariables
    }, ...args);
}

});
parcelRegister("94gGt", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a16de811e8308f$export$2e2bcd8739ae039);

var $9PB6d = parcelRequire("9PB6d");

var $88kuG = parcelRequire("88kuG");

var $amKcf = parcelRequire("amKcf");

var $bwa0H = parcelRequire("bwa0H");

var $6hOLz = parcelRequire("6hOLz");

var $5FST9 = parcelRequire("5FST9");

var $1IXr2 = parcelRequire("1IXr2");

var $koCZr = parcelRequire("koCZr");

var $fw9Pv = parcelRequire("fw9Pv");

var $d53TM = parcelRequire("d53TM");

var $evVmh = parcelRequire("evVmh");
const $69a16de811e8308f$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $bwa0H.default).white,
        default: (0, $bwa0H.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $69a16de811e8308f$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $bwa0H.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $bwa0H.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $69a16de811e8308f$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $amKcf.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $amKcf.darken)(intent.main, tonalOffsetDark);
    }
}
function $69a16de811e8308f$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $fw9Pv.default)[200],
        light: (0, $fw9Pv.default)[50],
        dark: (0, $fw9Pv.default)[400]
    };
    return {
        main: (0, $fw9Pv.default)[700],
        light: (0, $fw9Pv.default)[400],
        dark: (0, $fw9Pv.default)[800]
    };
}
function $69a16de811e8308f$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5FST9.default)[200],
        light: (0, $5FST9.default)[50],
        dark: (0, $5FST9.default)[400]
    };
    return {
        main: (0, $5FST9.default)[500],
        light: (0, $5FST9.default)[300],
        dark: (0, $5FST9.default)[700]
    };
}
function $69a16de811e8308f$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1IXr2.default)[500],
        light: (0, $1IXr2.default)[300],
        dark: (0, $1IXr2.default)[700]
    };
    return {
        main: (0, $1IXr2.default)[700],
        light: (0, $1IXr2.default)[400],
        dark: (0, $1IXr2.default)[800]
    };
}
function $69a16de811e8308f$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $d53TM.default)[400],
        light: (0, $d53TM.default)[300],
        dark: (0, $d53TM.default)[700]
    };
    return {
        main: (0, $d53TM.default)[700],
        light: (0, $d53TM.default)[500],
        dark: (0, $d53TM.default)[900]
    };
}
function $69a16de811e8308f$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $evVmh.default)[400],
        light: (0, $evVmh.default)[300],
        dark: (0, $evVmh.default)[700]
    };
    return {
        main: (0, $evVmh.default)[800],
        light: (0, $evVmh.default)[500],
        dark: (0, $evVmh.default)[900]
    };
}
function $69a16de811e8308f$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $koCZr.default)[400],
        light: (0, $koCZr.default)[300],
        dark: (0, $koCZr.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $koCZr.default)[500],
        dark: (0, $koCZr.default)[900]
    };
}
function $69a16de811e8308f$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $69a16de811e8308f$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $69a16de811e8308f$var$getDefaultSecondary(mode);
    const error = palette.error || $69a16de811e8308f$var$getDefaultError(mode);
    const info = palette.info || $69a16de811e8308f$var$getDefaultInfo(mode);
    const success = palette.success || $69a16de811e8308f$var$getDefaultSuccess(mode);
    const warning = palette.warning || $69a16de811e8308f$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $amKcf.getContrastRatio)(background, $69a16de811e8308f$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $69a16de811e8308f$export$55ce6f3a06c59543.text.primary : $69a16de811e8308f$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $9PB6d.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $9PB6d.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $69a16de811e8308f$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $69a16de811e8308f$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $69a16de811e8308f$export$55ce6f3a06c59543,
        light: $69a16de811e8308f$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $88kuG.default)({
        // A collection of common colors.
        common: {
            ...(0, $bwa0H.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $6hOLz.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modes[mode]
    }, other);
    return paletteOutput;
}

});
parcelRegister("amKcf", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", () => $78bfcb20ec65bbd6$export$427365fc3db6fc5e);
$parcel$export(module.exports, "hslToRgb", () => $78bfcb20ec65bbd6$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getContrastRatio", () => $78bfcb20ec65bbd6$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $78bfcb20ec65bbd6$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "private_safeAlpha", () => $78bfcb20ec65bbd6$export$34109543fc7f43f8);
$parcel$export(module.exports, "darken", () => $78bfcb20ec65bbd6$export$4b073707ff63303);
$parcel$export(module.exports, "private_safeDarken", () => $78bfcb20ec65bbd6$export$eaaef2dca3e9e512);
$parcel$export(module.exports, "lighten", () => $78bfcb20ec65bbd6$export$c0816ed86df316af);
$parcel$export(module.exports, "private_safeLighten", () => $78bfcb20ec65bbd6$export$aeeda94ef1d01275);
$parcel$export(module.exports, "private_safeEmphasize", () => $78bfcb20ec65bbd6$export$11bb74ba10c85505);

var $9PB6d = parcelRequire("9PB6d");

var $4ZTqi = parcelRequire("4ZTqi");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $78bfcb20ec65bbd6$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $4ZTqi.default)(value, min, max);
}
function $78bfcb20ec65bbd6$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $78bfcb20ec65bbd6$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $78bfcb20ec65bbd6$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $78bfcb20ec65bbd6$export$677b39864803984e($78bfcb20ec65bbd6$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if (![
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].includes(type)) throw new Error((0, $9PB6d.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if (![
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].includes(colorSpace)) throw new Error((0, $9PB6d.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $78bfcb20ec65bbd6$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes("hsl") && idx !== 0 ? `${val}%` : val).join(" ");
};
const $78bfcb20ec65bbd6$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $78bfcb20ec65bbd6$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $78bfcb20ec65bbd6$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes("rgb")) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes("hsl")) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes("color")) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $78bfcb20ec65bbd6$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith("#")) return color;
    const { values: values } = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$78bfcb20ec65bbd6$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $78bfcb20ec65bbd6$export$29fb7152bd3f781a(color) {
    color = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $78bfcb20ec65bbd6$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $78bfcb20ec65bbd6$export$c852d90bf7403b62(color) {
    color = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $78bfcb20ec65bbd6$export$677b39864803984e($78bfcb20ec65bbd6$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $78bfcb20ec65bbd6$export$d061e26956a60b0a(foreground, background) {
    const lumA = $78bfcb20ec65bbd6$export$c852d90bf7403b62(foreground);
    const lumB = $78bfcb20ec65bbd6$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $78bfcb20ec65bbd6$export$58f0f39f63f3cf42(color, value) {
    color = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    value = $78bfcb20ec65bbd6$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $78bfcb20ec65bbd6$export$211a73f2b8c10ce4(color);
}
function $78bfcb20ec65bbd6$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $78bfcb20ec65bbd6$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $78bfcb20ec65bbd6$export$4b073707ff63303(color, coefficient) {
    color = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    coefficient = $78bfcb20ec65bbd6$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] *= 1 - coefficient;
    else if (color.type.includes("rgb") || color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $78bfcb20ec65bbd6$export$211a73f2b8c10ce4(color);
}
function $78bfcb20ec65bbd6$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $78bfcb20ec65bbd6$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78bfcb20ec65bbd6$export$c0816ed86df316af(color, coefficient) {
    color = $78bfcb20ec65bbd6$export$677b39864803984e(color);
    coefficient = $78bfcb20ec65bbd6$var$clampWrapper(coefficient);
    if (color.type.includes("hsl")) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes("rgb")) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes("color")) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $78bfcb20ec65bbd6$export$211a73f2b8c10ce4(color);
}
function $78bfcb20ec65bbd6$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $78bfcb20ec65bbd6$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78bfcb20ec65bbd6$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $78bfcb20ec65bbd6$export$c852d90bf7403b62(color) > 0.5 ? $78bfcb20ec65bbd6$export$4b073707ff63303(color, coefficient) : $78bfcb20ec65bbd6$export$c0816ed86df316af(color, coefficient);
}
function $78bfcb20ec65bbd6$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $78bfcb20ec65bbd6$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78bfcb20ec65bbd6$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $78bfcb20ec65bbd6$export$677b39864803984e(background);
    const overlayColor = $78bfcb20ec65bbd6$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $78bfcb20ec65bbd6$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("4ZTqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a37d9d579dbab6a$export$2e2bcd8739ae039);
function $3a37d9d579dbab6a$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3a37d9d579dbab6a$export$2e2bcd8739ae039 = $3a37d9d579dbab6a$var$clamp;

});


parcelRegister("bwa0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $862a72b88e5dea67$export$2e2bcd8739ae039);
const $862a72b88e5dea67$var$common = {
    black: "#000",
    white: "#fff"
};
var $862a72b88e5dea67$export$2e2bcd8739ae039 = $862a72b88e5dea67$var$common;

});

parcelRegister("6hOLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $493bb5b545503f93$export$2e2bcd8739ae039);
const $493bb5b545503f93$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $493bb5b545503f93$export$2e2bcd8739ae039 = $493bb5b545503f93$var$grey;

});

parcelRegister("5FST9", function(module, exports) {

$parcel$export(module.exports, "default", () => $421b5bd3252850ac$export$2e2bcd8739ae039);
const $421b5bd3252850ac$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $421b5bd3252850ac$export$2e2bcd8739ae039 = $421b5bd3252850ac$var$purple;

});

parcelRegister("1IXr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $14180113d797f0b8$export$2e2bcd8739ae039);
const $14180113d797f0b8$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $14180113d797f0b8$export$2e2bcd8739ae039 = $14180113d797f0b8$var$red;

});

parcelRegister("koCZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed944b1f77c49a1f$export$2e2bcd8739ae039);
const $ed944b1f77c49a1f$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $ed944b1f77c49a1f$export$2e2bcd8739ae039 = $ed944b1f77c49a1f$var$orange;

});

parcelRegister("fw9Pv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c17827f3de0d28$export$2e2bcd8739ae039);
const $b4c17827f3de0d28$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $b4c17827f3de0d28$export$2e2bcd8739ae039 = $b4c17827f3de0d28$var$blue;

});

parcelRegister("d53TM", function(module, exports) {

$parcel$export(module.exports, "default", () => $985ec434801c90fe$export$2e2bcd8739ae039);
const $985ec434801c90fe$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $985ec434801c90fe$export$2e2bcd8739ae039 = $985ec434801c90fe$var$lightBlue;

});

parcelRegister("evVmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9107420efd3a2ab$export$2e2bcd8739ae039);
const $a9107420efd3a2ab$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a9107420efd3a2ab$export$2e2bcd8739ae039 = $a9107420efd3a2ab$var$green;

});


parcelRegister("i156L", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dc48568741cb0c$export$2e2bcd8739ae039);

var $9PB6d = parcelRequire("9PB6d");

var $88kuG = parcelRequire("88kuG");

var $jrnkK = parcelRequire("jrnkK");
var $l5LiB = parcelRequire("l5LiB");

var $lE9bp = parcelRequire("lE9bp");

var $67JE6 = parcelRequire("67JE6");
var $2vJIu = parcelRequire("2vJIu");
var $1F0Gm = parcelRequire("1F0Gm");

var $3WTHp = parcelRequire("3WTHp");
var $aamMV = parcelRequire("aamMV");

var $amKcf = parcelRequire("amKcf");

var $98T2y = parcelRequire("98T2y");

var $i43aW = parcelRequire("i43aW");

var $bo3eF = parcelRequire("bo3eF");

var $hJgTW = parcelRequire("hJgTW");

var $h3CfH = parcelRequire("h3CfH");
function $d1dc48568741cb0c$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $d1dc48568741cb0c$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $d1dc48568741cb0c$var$toRgb(color) {
    if (!color || !color.startsWith("hsl")) return color;
    return (0, $amKcf.hslToRgb)(color);
}
function $d1dc48568741cb0c$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $amKcf.private_safeColorChannel)($d1dc48568741cb0c$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + "\n" + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $d1dc48568741cb0c$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === "number") return `${spacingInput}px`;
    if (typeof spacingInput === "string" || typeof spacingInput === "function" || Array.isArray(spacingInput)) return spacingInput;
    return "8px";
}
const $d1dc48568741cb0c$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $d1dc48568741cb0c$export$65418b4d9082cc44 = (cssVarPrefix = "mui")=>(0, $l5LiB.default)(cssVarPrefix);
function $d1dc48568741cb0c$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === "dark" ? "dark" : "light";
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $i43aW.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $98T2y.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $i43aW.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $i43aW.getOverlays)(mode)
    };
    return muiTheme;
}
function $d1dc48568741cb0c$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = "mui", shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $bo3eF.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? "media" : undefined, ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== "light" ? "light" : firstColorScheme);
    const getCssVar = $d1dc48568741cb0c$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === "dark" && !("dark" in colorSchemesInput) || defaultColorScheme === "light" && !("light" in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $9PB6d.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $d1dc48568741cb0c$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $d1dc48568741cb0c$var$attachColorScheme(colorSchemes, builtInLight, undefined, "light");
    if (builtInDark && !colorSchemes.dark) $d1dc48568741cb0c$var$attachColorScheme(colorSchemes, builtInDark, undefined, "dark");
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $1F0Gm.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $d1dc48568741cb0c$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split("-");
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === "light") {
            $d1dc48568741cb0c$var$setColor(palette.common, "background", "#fff");
            $d1dc48568741cb0c$var$setColor(palette.common, "onBackground", "#000");
        }
        if (palette.mode === "dark") {
            $d1dc48568741cb0c$var$setColor(palette.common, "background", "#000");
            $d1dc48568741cb0c$var$setColor(palette.common, "onBackground", "#fff");
        }
        // assign component variables
        $d1dc48568741cb0c$var$assignNode(palette, [
            "Alert",
            "AppBar",
            "Avatar",
            "Button",
            "Chip",
            "FilledInput",
            "LinearProgress",
            "Skeleton",
            "Slider",
            "SnackbarContent",
            "SpeedDialAction",
            "StepConnector",
            "StepContent",
            "Switch",
            "TableCell",
            "Tooltip"
        ]);
        if (palette.mode === "light") {
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorColor", (0, $amKcf.private_safeDarken)(palette.error.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoColor", (0, $amKcf.private_safeDarken)(palette.info.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successColor", (0, $amKcf.private_safeDarken)(palette.success.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningColor", (0, $amKcf.private_safeDarken)(palette.warning.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.error.main)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.info.main)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.success.main)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorStandardBg", (0, $amKcf.private_safeLighten)(palette.error.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoStandardBg", (0, $amKcf.private_safeLighten)(palette.info.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successStandardBg", (0, $amKcf.private_safeLighten)(palette.success.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningStandardBg", (0, $amKcf.private_safeLighten)(palette.warning.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $d1dc48568741cb0c$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-100"));
            $d1dc48568741cb0c$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-400"));
            $d1dc48568741cb0c$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-300"));
            $d1dc48568741cb0c$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-A100"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-400"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-700"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-700"));
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "bg", "rgba(0, 0, 0, 0.06)");
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)");
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)");
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "primaryBg", (0, $amKcf.private_safeLighten)(palette.primary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "secondaryBg", (0, $amKcf.private_safeLighten)(palette.secondary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "errorBg", (0, $amKcf.private_safeLighten)(palette.error.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "infoBg", (0, $amKcf.private_safeLighten)(palette.info.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "successBg", (0, $amKcf.private_safeLighten)(palette.success.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "warningBg", (0, $amKcf.private_safeLighten)(palette.warning.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.11)`);
            $d1dc48568741cb0c$var$setColor(palette.Slider, "primaryTrack", (0, $amKcf.private_safeLighten)(palette.primary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "secondaryTrack", (0, $amKcf.private_safeLighten)(palette.secondary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "errorTrack", (0, $amKcf.private_safeLighten)(palette.error.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "infoTrack", (0, $amKcf.private_safeLighten)(palette.info.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "successTrack", (0, $amKcf.private_safeLighten)(palette.success.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "warningTrack", (0, $amKcf.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $amKcf.private_safeEmphasize)(palette.background.default, 0.8);
            $d1dc48568741cb0c$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $d1dc48568741cb0c$var$setColor(palette.SnackbarContent, "color", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $d1dc48568741cb0c$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $amKcf.private_safeEmphasize)(palette.background.paper, 0.15));
            $d1dc48568741cb0c$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-400"));
            $d1dc48568741cb0c$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-400"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-common-white"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-100"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "primaryDisabledColor", (0, $amKcf.private_safeLighten)(palette.primary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $amKcf.private_safeLighten)(palette.secondary.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "errorDisabledColor", (0, $amKcf.private_safeLighten)(palette.error.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "infoDisabledColor", (0, $amKcf.private_safeLighten)(palette.info.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "successDisabledColor", (0, $amKcf.private_safeLighten)(palette.success.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "warningDisabledColor", (0, $amKcf.private_safeLighten)(palette.warning.main, 0.62));
            $d1dc48568741cb0c$var$setColor(palette.TableCell, "border", (0, $amKcf.private_safeLighten)((0, $amKcf.private_safeAlpha)(palette.divider, 1), 0.88));
            $d1dc48568741cb0c$var$setColor(palette.Tooltip, "bg", (0, $amKcf.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === "dark") {
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorColor", (0, $amKcf.private_safeLighten)(palette.error.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoColor", (0, $amKcf.private_safeLighten)(palette.info.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successColor", (0, $amKcf.private_safeLighten)(palette.success.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningColor", (0, $amKcf.private_safeLighten)(palette.warning.light, 0.6));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorFilledBg", setCssVarColor("palette-error-dark"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoFilledBg", setCssVarColor("palette-info-dark"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successFilledBg", setCssVarColor("palette-success-dark"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningFilledBg", setCssVarColor("palette-warning-dark"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningFilledColor", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorStandardBg", (0, $amKcf.private_safeDarken)(palette.error.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoStandardBg", (0, $amKcf.private_safeDarken)(palette.info.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successStandardBg", (0, $amKcf.private_safeDarken)(palette.success.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningStandardBg", (0, $amKcf.private_safeDarken)(palette.warning.light, 0.9));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "errorIconColor", setCssVarColor("palette-error-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "infoIconColor", setCssVarColor("palette-info-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "successIconColor", setCssVarColor("palette-success-main"));
            $d1dc48568741cb0c$var$setColor(palette.Alert, "warningIconColor", setCssVarColor("palette-warning-main"));
            $d1dc48568741cb0c$var$setColor(palette.AppBar, "defaultBg", setCssVarColor("palette-grey-900"));
            $d1dc48568741cb0c$var$setColor(palette.AppBar, "darkBg", setCssVarColor("palette-background-paper")); // specific for dark mode
            $d1dc48568741cb0c$var$setColor(palette.AppBar, "darkColor", setCssVarColor("palette-text-primary")); // specific for dark mode
            $d1dc48568741cb0c$var$setColor(palette.Avatar, "defaultBg", setCssVarColor("palette-grey-600"));
            $d1dc48568741cb0c$var$setColor(palette.Button, "inheritContainedBg", setCssVarColor("palette-grey-800"));
            $d1dc48568741cb0c$var$setColor(palette.Button, "inheritContainedHoverBg", setCssVarColor("palette-grey-700"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultBorder", setCssVarColor("palette-grey-700"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultAvatarColor", setCssVarColor("palette-grey-300"));
            $d1dc48568741cb0c$var$setColor(palette.Chip, "defaultIconColor", setCssVarColor("palette-grey-300"));
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "bg", "rgba(255, 255, 255, 0.09)");
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)");
            $d1dc48568741cb0c$var$setColor(palette.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)");
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "primaryBg", (0, $amKcf.private_safeDarken)(palette.primary.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "secondaryBg", (0, $amKcf.private_safeDarken)(palette.secondary.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "errorBg", (0, $amKcf.private_safeDarken)(palette.error.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "infoBg", (0, $amKcf.private_safeDarken)(palette.info.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "successBg", (0, $amKcf.private_safeDarken)(palette.success.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.LinearProgress, "warningBg", (0, $amKcf.private_safeDarken)(palette.warning.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Skeleton, "bg", `rgba(${setCssVarColor("palette-text-primaryChannel")} / 0.13)`);
            $d1dc48568741cb0c$var$setColor(palette.Slider, "primaryTrack", (0, $amKcf.private_safeDarken)(palette.primary.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "secondaryTrack", (0, $amKcf.private_safeDarken)(palette.secondary.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "errorTrack", (0, $amKcf.private_safeDarken)(palette.error.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "infoTrack", (0, $amKcf.private_safeDarken)(palette.info.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "successTrack", (0, $amKcf.private_safeDarken)(palette.success.main, 0.5));
            $d1dc48568741cb0c$var$setColor(palette.Slider, "warningTrack", (0, $amKcf.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $amKcf.private_safeEmphasize)(palette.background.default, 0.98);
            $d1dc48568741cb0c$var$setColor(palette.SnackbarContent, "bg", snackbarContentBackground);
            $d1dc48568741cb0c$var$setColor(palette.SnackbarContent, "color", $d1dc48568741cb0c$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $d1dc48568741cb0c$var$setColor(palette.SpeedDialAction, "fabHoverBg", (0, $amKcf.private_safeEmphasize)(palette.background.paper, 0.15));
            $d1dc48568741cb0c$var$setColor(palette.StepConnector, "border", setCssVarColor("palette-grey-600"));
            $d1dc48568741cb0c$var$setColor(palette.StepContent, "border", setCssVarColor("palette-grey-600"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "defaultColor", setCssVarColor("palette-grey-300"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "defaultDisabledColor", setCssVarColor("palette-grey-600"));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "primaryDisabledColor", (0, $amKcf.private_safeDarken)(palette.primary.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "secondaryDisabledColor", (0, $amKcf.private_safeDarken)(palette.secondary.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "errorDisabledColor", (0, $amKcf.private_safeDarken)(palette.error.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "infoDisabledColor", (0, $amKcf.private_safeDarken)(palette.info.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "successDisabledColor", (0, $amKcf.private_safeDarken)(palette.success.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.Switch, "warningDisabledColor", (0, $amKcf.private_safeDarken)(palette.warning.main, 0.55));
            $d1dc48568741cb0c$var$setColor(palette.TableCell, "border", (0, $amKcf.private_safeDarken)((0, $amKcf.private_safeAlpha)(palette.divider, 1), 0.68));
            $d1dc48568741cb0c$var$setColor(palette.Tooltip, "bg", (0, $amKcf.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $d1dc48568741cb0c$var$setColorChannel(palette.background, "default");
        // added for consistency with the `background.default` token
        $d1dc48568741cb0c$var$setColorChannel(palette.background, "paper");
        $d1dc48568741cb0c$var$setColorChannel(palette.common, "background");
        $d1dc48568741cb0c$var$setColorChannel(palette.common, "onBackground");
        $d1dc48568741cb0c$var$setColorChannel(palette, "divider");
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (colors && typeof colors === "object") {
                // Silent the error for custom palettes.
                if (colors.main) $d1dc48568741cb0c$var$setColor(palette[color], "mainChannel", (0, $amKcf.private_safeColorChannel)($d1dc48568741cb0c$var$toRgb(colors.main)));
                if (colors.light) $d1dc48568741cb0c$var$setColor(palette[color], "lightChannel", (0, $amKcf.private_safeColorChannel)($d1dc48568741cb0c$var$toRgb(colors.light)));
                if (colors.dark) $d1dc48568741cb0c$var$setColor(palette[color], "darkChannel", (0, $amKcf.private_safeColorChannel)($d1dc48568741cb0c$var$toRgb(colors.dark)));
                if (colors.contrastText) $d1dc48568741cb0c$var$setColor(palette[color], "contrastTextChannel", (0, $amKcf.private_safeColorChannel)($d1dc48568741cb0c$var$toRgb(colors.contrastText)));
                if (color === "text") {
                    // Text colors: text.primary, text.secondary
                    $d1dc48568741cb0c$var$setColorChannel(palette[color], "primary");
                    $d1dc48568741cb0c$var$setColorChannel(palette[color], "secondary");
                }
                if (color === "action") {
                    // Action colors: action.active, action.selected
                    if (colors.active) $d1dc48568741cb0c$var$setColorChannel(palette[color], "active");
                    if (colors.selected) $d1dc48568741cb0c$var$setColorChannel(palette[color], "selected");
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $88kuG.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $hJgTW.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $2vJIu.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $jrnkK.default)(input.spacing, (0, $lE9bp.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $67JE6.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $aamMV.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $3WTHp.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $h3CfH.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("l5LiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aec13bebbbedda$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $f5aec13bebbbedda$export$2e2bcd8739ae039(prefix = "") {
    function appendVar(...vars) {
        if (!vars.length) return "";
        const value = vars[0];
        if (typeof value === "string" && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ""}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ""}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("67JE6", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", () => $4756cdda7096d347$export$858538ff6c0d421d);
/* eslint-disable import/prefer-default-export */ function $4756cdda7096d347$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === "media") return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith("data-") && !selector.includes("%s")) return `[${selector}="${colorScheme}"] &`;
            if (selector === "class") return `.${colorScheme} &`;
            if (selector === "data") return `[data-${colorScheme}] &`;
            return `${selector.replace("%s", colorScheme)} &`;
        }
        return "&";
    };
}

});

parcelRegister("2vJIu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d41f0675ff64f53$export$2e2bcd8739ae039);

var $88kuG = parcelRequire("88kuG");

var $2KpQB = parcelRequire("2KpQB");
function $1d41f0675ff64f53$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = "light", ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $2KpQB.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $2KpQB.default)(scheme, parserConfig);
        themeVars = (0, $88kuG.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $2KpQB.default)(defaultScheme, parserConfig);
        themeVars = (0, $88kuG.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if (selector?.startsWith("data-") && !selector.includes("%s")) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === "media") {
                if (theme.defaultColorScheme === colorScheme) return ":root";
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ":root": cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace("%s", String(colorScheme))}`;
                return rule.replace("%s", String(colorScheme));
            }
        }
        return ":root";
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $88kuG.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || "light";
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === "string" ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $1d41f0675ff64f53$export$2e2bcd8739ae039 = $1d41f0675ff64f53$var$prepareCssVars;

});
parcelRegister("2KpQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2003ed63f4e08af6$export$2e2bcd8739ae039);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2003ed63f4e08af6$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === "object") temp[k] = value;
        } else if (temp && typeof temp === "object") {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $2003ed63f4e08af6$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === "object" && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $2003ed63f4e08af6$var$getCssValue = (keys, value)=>{
    if (typeof value === "number") {
        if ([
            "lineHeight",
            "fontWeight",
            "opacity",
            "zIndex"
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes("opacity")) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $2003ed63f4e08af6$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2003ed63f4e08af6$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === "string" || typeof value === "number") {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ""}${keys.join("-")}`;
                const resolvedValue = $2003ed63f4e08af6$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $2003ed63f4e08af6$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $2003ed63f4e08af6$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === "vars" // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("1F0Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a263be8a7c6e5$export$2e2bcd8739ae039);
function $135a263be8a7c6e5$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === "object") vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ""}${value.fontVariant ? `${value.fontVariant} ` : ""}${value.fontWeight ? `${value.fontWeight} ` : ""}${value.fontStretch ? `${value.fontStretch} ` : ""}${value.fontSize || ""}${value.lineHeight ? `/${value.lineHeight} ` : ""}${value.fontFamily || ""}`;
    });
    return vars;
}

});

parcelRegister("98T2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7f8e42a0d93d85$export$2e2bcd8739ae039);

var $9PB6d = parcelRequire("9PB6d");

var $88kuG = parcelRequire("88kuG");

var $3WTHp = parcelRequire("3WTHp");
var $aamMV = parcelRequire("aamMV");

var $iqdgc = parcelRequire("iqdgc");


var $6tPQW = parcelRequire("6tPQW");

var $94gGt = parcelRequire("94gGt");

var $9J536 = parcelRequire("9J536");

var $b4u91 = parcelRequire("b4u91");

var $2FOJy = parcelRequire("2FOJy");

var $aagKj = parcelRequire("aagKj");
function $6a7f8e42a0d93d85$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars) throw new Error((0, $9PB6d.default)(20));
    const palette = (0, $94gGt.default)(paletteInput);
    const systemTheme = (0, $iqdgc.default)(options);
    let muiTheme = (0, $88kuG.default)(systemTheme, {
        mixins: (0, $6tPQW.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $b4u91.default).slice(),
        typography: (0, $9J536.default)(palette, typographyInput),
        transitions: (0, $2FOJy.default)(transitionsInput),
        zIndex: {
            ...(0, $aagKj.default)
        }
    });
    muiTheme = (0, $88kuG.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $88kuG.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $aamMV.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3WTHp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $6a7f8e42a0d93d85$var$warnedOnce = false;
function $6a7f8e42a0d93d85$export$c469355549431d9b(...args) {
    return $6a7f8e42a0d93d85$var$createThemeNoVars(...args);
}
var $6a7f8e42a0d93d85$export$2e2bcd8739ae039 = $6a7f8e42a0d93d85$var$createThemeNoVars;

});
parcelRegister("6tPQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7dac66ba34dffb$export$2e2bcd8739ae039);
function $4b7dac66ba34dffb$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("9J536", function(module, exports) {

$parcel$export(module.exports, "default", () => $714c3bad34a51191$export$2e2bcd8739ae039);

var $88kuG = parcelRequire("88kuG");
function $714c3bad34a51191$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $714c3bad34a51191$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $714c3bad34a51191$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $714c3bad34a51191$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $714c3bad34a51191$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === "function" ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $714c3bad34a51191$var$defaultFontFamily ? {
                letterSpacing: `${$714c3bad34a51191$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $714c3bad34a51191$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $714c3bad34a51191$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $88kuG.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("b4u91", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f7737c93ecda97$export$2e2bcd8739ae039);
const $80f7737c93ecda97$var$shadowKeyUmbraOpacity = 0.2;
const $80f7737c93ecda97$var$shadowKeyPenumbraOpacity = 0.14;
const $80f7737c93ecda97$var$shadowAmbientShadowOpacity = 0.12;
function $80f7737c93ecda97$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$80f7737c93ecda97$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$80f7737c93ecda97$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$80f7737c93ecda97$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $80f7737c93ecda97$var$shadows = [
    "none",
    $80f7737c93ecda97$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $80f7737c93ecda97$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $80f7737c93ecda97$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $80f7737c93ecda97$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $80f7737c93ecda97$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $80f7737c93ecda97$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $80f7737c93ecda97$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $80f7737c93ecda97$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $80f7737c93ecda97$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $80f7737c93ecda97$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $80f7737c93ecda97$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $80f7737c93ecda97$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $80f7737c93ecda97$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $80f7737c93ecda97$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $80f7737c93ecda97$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $80f7737c93ecda97$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $80f7737c93ecda97$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $80f7737c93ecda97$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $80f7737c93ecda97$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $80f7737c93ecda97$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $80f7737c93ecda97$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $80f7737c93ecda97$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $80f7737c93ecda97$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $80f7737c93ecda97$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $80f7737c93ecda97$export$2e2bcd8739ae039 = $80f7737c93ecda97$var$shadows;

});

parcelRegister("2FOJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f26c3c3f1000619$export$2e2bcd8739ae039);
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $1f26c3c3f1000619$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $1f26c3c3f1000619$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $1f26c3c3f1000619$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $1f26c3c3f1000619$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $1f26c3c3f1000619$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$1f26c3c3f1000619$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$1f26c3c3f1000619$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $1f26c3c3f1000619$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $1f26c3c3f1000619$var$formatMs(delay)}`).join(",");
    };
    return {
        getAutoHeightDuration: $1f26c3c3f1000619$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("aagKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7667d3effe853c23$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $7667d3effe853c23$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $7667d3effe853c23$export$2e2bcd8739ae039 = $7667d3effe853c23$var$zIndex;

});


parcelRegister("i43aW", function(module, exports) {

$parcel$export(module.exports, "getOpacity", () => $d26b1049bf24dec6$export$c85e0347fceb69ba);
$parcel$export(module.exports, "getOverlays", () => $d26b1049bf24dec6$export$dd191566510330d3);
$parcel$export(module.exports, "default", () => $d26b1049bf24dec6$export$2e2bcd8739ae039);

var $94gGt = parcelRequire("94gGt");

var $6expx = parcelRequire("6expx");
const $d26b1049bf24dec6$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return "none";
    const overlay = (0, $6expx.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $d26b1049bf24dec6$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === "dark" ? 0.5 : 0.42,
        inputUnderline: mode === "dark" ? 0.7 : 0.42,
        switchTrackDisabled: mode === "dark" ? 0.2 : 0.12,
        switchTrack: mode === "dark" ? 0.3 : 0.38
    };
}
function $d26b1049bf24dec6$export$dd191566510330d3(mode) {
    return mode === "dark" ? $d26b1049bf24dec6$var$defaultDarkOverlays : [];
}
function $d26b1049bf24dec6$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: "light"
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $94gGt.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$d26b1049bf24dec6$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $d26b1049bf24dec6$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("6expx", function(module, exports) {

$parcel$export(module.exports, "default", () => $489df7965b9d7639$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $489df7965b9d7639$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("bo3eF", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a472195860e93a$export$2e2bcd8739ae039);
function $84a472195860e93a$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === "palette" && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("hJgTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce83bfe6caca5a7e$export$2e2bcd8739ae039);

var $arm9C = parcelRequire("arm9C");
var $ce83bfe6caca5a7e$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === "class") rule = ".%s";
        if (selector === "data") rule = "[data-%s]";
        if (selector?.startsWith("data-") && !selector.includes("%s")) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === "dark") {
                const excludedVariables = {};
                (0, $arm9C.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === "media") return {
                    ":root": css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        ":root": excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace("%s", colorScheme)]: excludedVariables,
                    [`:root, ${rule.replace("%s", colorScheme)}`]: css
                };
                return {
                    ":root": {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== "media") return `:root, ${rule.replace("%s", String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === "media") return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    ":root": css
                }
            };
            if (rule) return rule.replace("%s", String(colorScheme));
        }
        return ":root";
    };

});
parcelRegister("arm9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $799d9c5793ab30e5$export$2e2bcd8739ae039);
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $799d9c5793ab30e5$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ""}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ""}palette-AppBar-darkColor`
    ];
var $799d9c5793ab30e5$export$2e2bcd8739ae039 = $799d9c5793ab30e5$var$excludeVariablesFromRoot;

});


parcelRegister("h3CfH", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", () => $c6b0638f6386c180$export$32c2afa5f91892aa);
/* eslint-disable import/prefer-default-export */ 
var $88kuG = parcelRequire("88kuG");
function $c6b0638f6386c180$var$isSerializable(val) {
    return (0, $88kuG.isPlainObject)(val) || typeof val === "undefined" || typeof val === "string" || typeof val === "boolean" || typeof val === "number" || Array.isArray(val);
}
function $c6b0638f6386c180$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$c6b0638f6386c180$var$isSerializable(value) || key.startsWith("unstable_")) delete object[key];
            else if ((0, $88kuG.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});




parcelRegister("dbHL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $999e3eec2564df37$export$2e2bcd8739ae039);
var $999e3eec2564df37$export$2e2bcd8739ae039 = "$$material";

});

parcelRegister("aMtHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d956ddbb42a5a00$export$2e2bcd8739ae039);

var $1TjQ0 = parcelRequire("1TjQ0");
const $7d956ddbb42a5a00$var$rootShouldForwardProp = (prop)=>(0, $1TjQ0.default)(prop) && prop !== "classes";
var $7d956ddbb42a5a00$export$2e2bcd8739ae039 = $7d956ddbb42a5a00$var$rootShouldForwardProp;

});
parcelRegister("1TjQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $160a50deda699f02$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $160a50deda699f02$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $160a50deda699f02$export$2e2bcd8739ae039 = $160a50deda699f02$var$slotShouldForwardProp;

});



parcelRegister("iAnBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87de6fc25e239c5$export$2e2bcd8739ae039);
// We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $d87de6fc25e239c5$var$arg = {
    theme: undefined
};
function $d87de6fc25e239c5$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return (props)=>{
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $d87de6fc25e239c5$var$arg.theme = props.theme;
            value = styleFn($d87de6fc25e239c5$var$arg);
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("2MrFe", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $206585fcec330ef4$export$2440da353cedad43);
parcelRequire("aqdBs");


var $8lEpA = parcelRequire("8lEpA");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $206585fcec330ef4$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8lEpA.default), {
        ...props
    });
}
var $206585fcec330ef4$export$2e2bcd8739ae039 = $206585fcec330ef4$var$DefaultPropsProvider;
function $206585fcec330ef4$export$2440da353cedad43(params) {
    return (0, $8lEpA.useDefaultProps)(params);
}

});
parcelRegister("8lEpA", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $613fa1d5976dd65b$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $613fa1d5976dd65b$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");


var $9iMQk = parcelRequire("9iMQk");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $613fa1d5976dd65b$var$PropsContext = /*#__PURE__*/ $aqdBs.createContext(undefined);
function $613fa1d5976dd65b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($613fa1d5976dd65b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $613fa1d5976dd65b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $9iMQk.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $9iMQk.default)(config, props);
    return props;
}
function $613fa1d5976dd65b$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $aqdBs.useContext($613fa1d5976dd65b$var$PropsContext);
    return $613fa1d5976dd65b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $613fa1d5976dd65b$export$2e2bcd8739ae039 = $613fa1d5976dd65b$var$DefaultPropsProvider;

});
parcelRegister("9iMQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c5baeb1feba939b$export$2e2bcd8739ae039);
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $6c5baeb1feba939b$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === "components" || propName === "slots") output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === "componentsProps" || propName === "slotProps") {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $6c5baeb1feba939b$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("eff0b", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $a5ee1a7b6552e7e7$export$c7c50641356bdfa5);

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $a5ee1a7b6552e7e7$export$c7c50641356bdfa5(slot) {
    return (0, $igOtJ.default)("MuiSvgIcon", slot);
}
const $a5ee1a7b6552e7e7$var$svgIconClasses = (0, $jIPNy.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $a5ee1a7b6552e7e7$export$2e2bcd8739ae039 = $a5ee1a7b6552e7e7$var$svgIconClasses;

});
parcelRegister("jIPNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5ba4e728fd69d46$export$2e2bcd8739ae039);

var $igOtJ = parcelRequire("igOtJ");
function $e5ba4e728fd69d46$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $igOtJ.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("igOtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d0e09b9d9ae1a8$export$2e2bcd8739ae039);

var $hILTa = parcelRequire("hILTa");
const $d4d0e09b9d9ae1a8$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $d4d0e09b9d9ae1a8$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $d4d0e09b9d9ae1a8$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $hILTa.default).generate(componentName)}-${slot}`;
}
function $d4d0e09b9d9ae1a8$export$34c0130b1f3e8ae3(slot) {
    return $d4d0e09b9d9ae1a8$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("hILTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6bb17438260ec5$export$2e2bcd8739ae039);
const $ce6bb17438260ec5$var$defaultGenerator = (componentName)=>componentName;
const $ce6bb17438260ec5$var$createClassNameGenerator = ()=>{
    let generate = $ce6bb17438260ec5$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $ce6bb17438260ec5$var$defaultGenerator;
        }
    };
};
const $ce6bb17438260ec5$var$ClassNameGenerator = $ce6bb17438260ec5$var$createClassNameGenerator();
var $ce6bb17438260ec5$export$2e2bcd8739ae039 = $ce6bb17438260ec5$var$ClassNameGenerator;

});








var $1Ivrw = parcelRequire("1Ivrw");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
"use strict";
var $e813d4480671d45c$exports = {};
"use strict";
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

$e813d4480671d45c$exports = (parcelRequire("l8cRS"));


var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $e813d4480671d45c$exports.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $e813d4480671d45c$exports.hydrateRoot;


/**
 * react-router v7.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $aqdBs = parcelRequire("aqdBs");
var $3caee95e8f5bb11a$exports = {};
"use strict";
Object.defineProperty($3caee95e8f5bb11a$exports, "__esModule", {
    value: true
});
$3caee95e8f5bb11a$exports.encode = $3caee95e8f5bb11a$exports.decode = void 0;
var $a96623150574e2cb$exports = {};
"use strict";
Object.defineProperty($a96623150574e2cb$exports, "__esModule", {
    value: true
});
$a96623150574e2cb$exports.flatten = void 0;
var $6d11a0554ad14a6a$exports = {};
"use strict";
Object.defineProperty($6d11a0554ad14a6a$exports, "__esModule", {
    value: true
});
$6d11a0554ad14a6a$exports.createLineSplittingTransform = $6d11a0554ad14a6a$exports.Deferred = $6d11a0554ad14a6a$exports.TYPE_PREVIOUS_RESOLVED = $6d11a0554ad14a6a$exports.TYPE_URL = $6d11a0554ad14a6a$exports.TYPE_SYMBOL = $6d11a0554ad14a6a$exports.TYPE_SET = $6d11a0554ad14a6a$exports.TYPE_REGEXP = $6d11a0554ad14a6a$exports.TYPE_PROMISE = $6d11a0554ad14a6a$exports.TYPE_NULL_OBJECT = $6d11a0554ad14a6a$exports.TYPE_MAP = $6d11a0554ad14a6a$exports.TYPE_ERROR = $6d11a0554ad14a6a$exports.TYPE_DATE = $6d11a0554ad14a6a$exports.TYPE_BIGINT = $6d11a0554ad14a6a$exports.UNDEFINED = $6d11a0554ad14a6a$exports.POSITIVE_INFINITY = $6d11a0554ad14a6a$exports.NULL = $6d11a0554ad14a6a$exports.NEGATIVE_ZERO = $6d11a0554ad14a6a$exports.NEGATIVE_INFINITY = $6d11a0554ad14a6a$exports.NAN = $6d11a0554ad14a6a$exports.HOLE = void 0;
$6d11a0554ad14a6a$exports.HOLE = -1;
$6d11a0554ad14a6a$exports.NAN = -2;
$6d11a0554ad14a6a$exports.NEGATIVE_INFINITY = -3;
$6d11a0554ad14a6a$exports.NEGATIVE_ZERO = -4;
$6d11a0554ad14a6a$exports.NULL = -5;
$6d11a0554ad14a6a$exports.POSITIVE_INFINITY = -6;
$6d11a0554ad14a6a$exports.UNDEFINED = -7;
$6d11a0554ad14a6a$exports.TYPE_BIGINT = "B";
$6d11a0554ad14a6a$exports.TYPE_DATE = "D";
$6d11a0554ad14a6a$exports.TYPE_ERROR = "E";
$6d11a0554ad14a6a$exports.TYPE_MAP = "M";
$6d11a0554ad14a6a$exports.TYPE_NULL_OBJECT = "N";
$6d11a0554ad14a6a$exports.TYPE_PROMISE = "P";
$6d11a0554ad14a6a$exports.TYPE_REGEXP = "R";
$6d11a0554ad14a6a$exports.TYPE_SET = "S";
$6d11a0554ad14a6a$exports.TYPE_SYMBOL = "Y";
$6d11a0554ad14a6a$exports.TYPE_URL = "U";
$6d11a0554ad14a6a$exports.TYPE_PREVIOUS_RESOLVED = "Z";
class $6d11a0554ad14a6a$var$Deferred {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
$6d11a0554ad14a6a$exports.Deferred = $6d11a0554ad14a6a$var$Deferred;
function $6d11a0554ad14a6a$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
$6d11a0554ad14a6a$exports.createLineSplittingTransform = $6d11a0554ad14a6a$var$createLineSplittingTransform;


function $a96623150574e2cb$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $6d11a0554ad14a6a$exports.UNDEFINED;
    if (input === null) return $6d11a0554ad14a6a$exports.NULL;
    if (Number.isNaN(input)) return $6d11a0554ad14a6a$exports.NAN;
    if (input === Number.POSITIVE_INFINITY) return $6d11a0554ad14a6a$exports.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $6d11a0554ad14a6a$exports.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $6d11a0554ad14a6a$exports.NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $a96623150574e2cb$var$stringify.call(this, input, index);
    return index;
}
$a96623150574e2cb$exports.flatten = $a96623150574e2cb$var$flatten;
function $a96623150574e2cb$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$a96623150574e2cb$var$flatten.call(this, k)}":${$a96623150574e2cb$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$6d11a0554ad14a6a$exports.NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$a96623150574e2cb$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? $a96623150574e2cb$var$flatten.call(this, input[i]) : $6d11a0554ad14a6a$exports.HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_DATE}",${input.getTime()}]`;
                        else if (input instanceof URL) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_SET}",${[
                                ...input
                            ].map((val)=>$a96623150574e2cb$var$flatten.call(this, val)).join(",")}]`;
                            else str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    $a96623150574e2cb$var$flatten.call(this, k),
                                    $a96623150574e2cb$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$6d11a0554ad14a6a$exports.TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($a96623150574e2cb$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$a96623150574e2cb$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>$a96623150574e2cb$var$flatten.call(this, v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $a96623150574e2cb$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $a96623150574e2cb$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $a96623150574e2cb$var$objectProtoNames;
}


var $8f4cde91f3fa116d$exports = {};
"use strict";
Object.defineProperty($8f4cde91f3fa116d$exports, "__esModule", {
    value: true
});
$8f4cde91f3fa116d$exports.unflatten = void 0;

const $8f4cde91f3fa116d$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $8f4cde91f3fa116d$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $8f4cde91f3fa116d$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $8f4cde91f3fa116d$var$hydrate.call(this, startIndex);
}
$8f4cde91f3fa116d$exports.unflatten = $8f4cde91f3fa116d$var$unflatten;
function $8f4cde91f3fa116d$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case $6d11a0554ad14a6a$exports.UNDEFINED:
                set(undefined);
                continue;
            case $6d11a0554ad14a6a$exports.NULL:
                set(null);
                continue;
            case $6d11a0554ad14a6a$exports.NAN:
                set(NaN);
                continue;
            case $6d11a0554ad14a6a$exports.POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $6d11a0554ad14a6a$exports.NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $6d11a0554ad14a6a$exports.NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $6d11a0554ad14a6a$exports.TYPE_DATE:
                        set(hydrated[index] = new Date(b));
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_URL:
                        set(hydrated[index] = new URL(b));
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_BIGINT:
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_REGEXP:
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_SYMBOL:
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_SET:
                        const newSet = new Set();
                        hydrated[index] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_MAP:
                        const map = new Map();
                        hydrated[index] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_NULL_OBJECT:
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new $6d11a0554ad14a6a$exports.Deferred();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $8f4cde91f3fa116d$var$globalObj && $8f4cde91f3fa116d$var$globalObj[errorType] ? new $8f4cde91f3fa116d$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case $6d11a0554ad14a6a$exports.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $6d11a0554ad14a6a$exports.HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}



async function $3caee95e8f5bb11a$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $6d11a0554ad14a6a$exports.Deferred();
    const reader = readable.pipeThrough((0, $6d11a0554ad14a6a$exports.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $3caee95e8f5bb11a$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $3caee95e8f5bb11a$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
$3caee95e8f5bb11a$exports.decode = $3caee95e8f5bb11a$var$decode;
async function $3caee95e8f5bb11a$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $8f4cde91f3fa116d$exports.unflatten.call(this, line)
    };
}
async function $3caee95e8f5bb11a$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $6d11a0554ad14a6a$exports.TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $8f4cde91f3fa116d$exports.unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $6d11a0554ad14a6a$exports.TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $8f4cde91f3fa116d$exports.unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $3caee95e8f5bb11a$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $a96623150574e2cb$exports.flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $3caee95e8f5bb11a$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id = $a96623150574e2cb$exports.flatten.call(encoder, resolved);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_PROMISE}${deferredId}:[["${$6d11a0554ad14a6a$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_PROMISE}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_PROMISE}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id = $a96623150574e2cb$exports.flatten.call(encoder, reason);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_ERROR}${deferredId}:[["${$6d11a0554ad14a6a$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_ERROR}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$6d11a0554ad14a6a$exports.TYPE_ERROR}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
$3caee95e8f5bb11a$exports.encode = $3caee95e8f5bb11a$var$encode;
function $3caee95e8f5bb11a$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $fa5e80d5b8cb06bd$exports = {};
"use strict";
Object.defineProperty($fa5e80d5b8cb06bd$exports, "__esModule", {
    value: true
});
$fa5e80d5b8cb06bd$exports.parse = $fa5e80d5b8cb06bd$var$parse;
$fa5e80d5b8cb06bd$exports.serialize = $fa5e80d5b8cb06bd$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $fa5e80d5b8cb06bd$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $fa5e80d5b8cb06bd$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $fa5e80d5b8cb06bd$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $fa5e80d5b8cb06bd$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $fa5e80d5b8cb06bd$var$__toString = Object.prototype.toString;
const $fa5e80d5b8cb06bd$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $fa5e80d5b8cb06bd$var$parse(str, options) {
    const obj = new $fa5e80d5b8cb06bd$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $fa5e80d5b8cb06bd$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $fa5e80d5b8cb06bd$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $fa5e80d5b8cb06bd$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $fa5e80d5b8cb06bd$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $fa5e80d5b8cb06bd$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $fa5e80d5b8cb06bd$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $fa5e80d5b8cb06bd$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $fa5e80d5b8cb06bd$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$fa5e80d5b8cb06bd$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$fa5e80d5b8cb06bd$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$fa5e80d5b8cb06bd$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$fa5e80d5b8cb06bd$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$fa5e80d5b8cb06bd$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $fa5e80d5b8cb06bd$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $fa5e80d5b8cb06bd$var$isDate(val) {
    return $fa5e80d5b8cb06bd$var$__toString.call(val) === "[object Date]";
}


var $d5a8529af310c2d4$exports = {};
"use strict";
var $d5a8529af310c2d4$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $d5a8529af310c2d4$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $d5a8529af310c2d4$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($d5a8529af310c2d4$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $d5a8529af310c2d4$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $d5a8529af310c2d4$var$defaultParseOptions, options) : $d5a8529af310c2d4$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $d5a8529af310c2d4$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $d5a8529af310c2d4$var$parse(input, options) {
    options = options ? Object.assign({}, $d5a8529af310c2d4$var$defaultParseOptions, options) : $d5a8529af310c2d4$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($d5a8529af310c2d4$var$isNonEmptyString).map(function(str) {
        return $d5a8529af310c2d4$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($d5a8529af310c2d4$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $d5a8529af310c2d4$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $d5a8529af310c2d4$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$d5a8529af310c2d4$exports = $d5a8529af310c2d4$var$parse;
$d5a8529af310c2d4$exports.parse = $d5a8529af310c2d4$var$parse;
$d5a8529af310c2d4$exports.parseString = $d5a8529af310c2d4$var$parseString;
$d5a8529af310c2d4$exports.splitCookiesString = $d5a8529af310c2d4$var$splitCookiesString;


var $bdd5c91922f45546$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.0.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-router/dist/production/chunk-7R3XDUXW.mjs"
});
var $bdd5c91922f45546$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($bdd5c91922f45546$export$e19cd5f9376f8cee || {});
var $bdd5c91922f45546$var$PopStateEventType = "popstate";
function $bdd5c91922f45546$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $bdd5c91922f45546$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $bdd5c91922f45546$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $bdd5c91922f45546$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $bdd5c91922f45546$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to);
    }
    return $bdd5c91922f45546$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $bdd5c91922f45546$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $bdd5c91922f45546$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $bdd5c91922f45546$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $bdd5c91922f45546$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $bdd5c91922f45546$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $bdd5c91922f45546$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $bdd5c91922f45546$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $bdd5c91922f45546$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $bdd5c91922f45546$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $bdd5c91922f45546$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $bdd5c91922f45546$var$createKey()
    };
    return location;
}
function $bdd5c91922f45546$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $bdd5c91922f45546$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $bdd5c91922f45546$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $bdd5c91922f45546$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $bdd5c91922f45546$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $bdd5c91922f45546$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $bdd5c91922f45546$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to);
        href = href.replace(/ $/, "%20");
        $bdd5c91922f45546$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($bdd5c91922f45546$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($bdd5c91922f45546$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $bdd5c91922f45546$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $bdd5c91922f45546$var$isIndexRoute(route) {
    return route.index === true;
}
function $bdd5c91922f45546$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $bdd5c91922f45546$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $bdd5c91922f45546$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($bdd5c91922f45546$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $bdd5c91922f45546$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $bdd5c91922f45546$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $bdd5c91922f45546$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $bdd5c91922f45546$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $bdd5c91922f45546$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $bdd5c91922f45546$var$flattenRoutes(routes);
    $bdd5c91922f45546$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $bdd5c91922f45546$var$decodePath(pathname);
        matches = $bdd5c91922f45546$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $bdd5c91922f45546$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $bdd5c91922f45546$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $bdd5c91922f45546$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $bdd5c91922f45546$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $bdd5c91922f45546$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $bdd5c91922f45546$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $bdd5c91922f45546$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $bdd5c91922f45546$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $bdd5c91922f45546$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $bdd5c91922f45546$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $bdd5c91922f45546$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $bdd5c91922f45546$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $bdd5c91922f45546$var$paramRe = /^:[\w-]+$/;
var $bdd5c91922f45546$var$dynamicSegmentValue = 3;
var $bdd5c91922f45546$var$indexRouteValue = 2;
var $bdd5c91922f45546$var$emptySegmentValue = 1;
var $bdd5c91922f45546$var$staticSegmentValue = 10;
var $bdd5c91922f45546$var$splatPenalty = -2;
var $bdd5c91922f45546$var$isSplat = (s)=>s === "*";
function $bdd5c91922f45546$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($bdd5c91922f45546$var$isSplat)) initialScore += $bdd5c91922f45546$var$splatPenalty;
    if (index) initialScore += $bdd5c91922f45546$var$indexRouteValue;
    return segments.filter((s)=>!$bdd5c91922f45546$var$isSplat(s)).reduce((score, segment)=>score + ($bdd5c91922f45546$var$paramRe.test(segment) ? $bdd5c91922f45546$var$dynamicSegmentValue : segment === "" ? $bdd5c91922f45546$var$emptySegmentValue : $bdd5c91922f45546$var$staticSegmentValue), initialScore);
}
function $bdd5c91922f45546$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $bdd5c91922f45546$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $bdd5c91922f45546$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $bdd5c91922f45546$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $bdd5c91922f45546$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $bdd5c91922f45546$var$normalizePathname($bdd5c91922f45546$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $bdd5c91922f45546$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $bdd5c91922f45546$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $bdd5c91922f45546$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $bdd5c91922f45546$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $bdd5c91922f45546$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $bdd5c91922f45546$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $bdd5c91922f45546$var$compilePath(path, caseSensitive = false, end = true) {
    $bdd5c91922f45546$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $bdd5c91922f45546$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $bdd5c91922f45546$var$warning(false, `The URL path "${value}" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $bdd5c91922f45546$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $bdd5c91922f45546$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $bdd5c91922f45546$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $bdd5c91922f45546$var$normalizeSearch(search),
        hash: $bdd5c91922f45546$var$normalizeHash(hash)
    };
}
function $bdd5c91922f45546$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $bdd5c91922f45546$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $bdd5c91922f45546$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $bdd5c91922f45546$var$getResolveToMatches(matches) {
    let pathMatches = $bdd5c91922f45546$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $bdd5c91922f45546$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $bdd5c91922f45546$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $bdd5c91922f45546$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $bdd5c91922f45546$var$getInvalidPathError("?", "pathname", "search", to));
        $bdd5c91922f45546$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $bdd5c91922f45546$var$getInvalidPathError("#", "pathname", "hash", to));
        $bdd5c91922f45546$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $bdd5c91922f45546$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $bdd5c91922f45546$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $bdd5c91922f45546$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $bdd5c91922f45546$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $bdd5c91922f45546$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $bdd5c91922f45546$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $bdd5c91922f45546$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $bdd5c91922f45546$export$4051a07651545597(data2, init) {
    return new $bdd5c91922f45546$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $bdd5c91922f45546$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $bdd5c91922f45546$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $bdd5c91922f45546$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $bdd5c91922f45546$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $bdd5c91922f45546$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $bdd5c91922f45546$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $bdd5c91922f45546$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $bdd5c91922f45546$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $bdd5c91922f45546$var$validMutationMethods = new Set($bdd5c91922f45546$var$validMutationMethodsArr);
var $bdd5c91922f45546$var$validRequestMethodsArr = [
    "GET",
    ...$bdd5c91922f45546$var$validMutationMethodsArr
];
var $bdd5c91922f45546$var$validRequestMethods = new Set($bdd5c91922f45546$var$validRequestMethodsArr);
var $bdd5c91922f45546$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $bdd5c91922f45546$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $bdd5c91922f45546$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $bdd5c91922f45546$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $bdd5c91922f45546$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $bdd5c91922f45546$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $bdd5c91922f45546$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $bdd5c91922f45546$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $bdd5c91922f45546$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $bdd5c91922f45546$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $bdd5c91922f45546$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $bdd5c91922f45546$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $bdd5c91922f45546$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $bdd5c91922f45546$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $bdd5c91922f45546$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $bdd5c91922f45546$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$bdd5c91922f45546$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$bdd5c91922f45546$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $bdd5c91922f45546$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $bdd5c91922f45546$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $bdd5c91922f45546$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $bdd5c91922f45546$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$bdd5c91922f45546$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $bdd5c91922f45546$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $bdd5c91922f45546$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $bdd5c91922f45546$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $bdd5c91922f45546$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $bdd5c91922f45546$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $bdd5c91922f45546$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $bdd5c91922f45546$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $bdd5c91922f45546$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $bdd5c91922f45546$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $bdd5c91922f45546$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $bdd5c91922f45546$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $bdd5c91922f45546$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && $bdd5c91922f45546$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $bdd5c91922f45546$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $bdd5c91922f45546$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $bdd5c91922f45546$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $bdd5c91922f45546$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($bdd5c91922f45546$var$isErrorResult(result) && $bdd5c91922f45546$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $bdd5c91922f45546$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $bdd5c91922f45546$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$bdd5c91922f45546$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $bdd5c91922f45546$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $bdd5c91922f45546$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $bdd5c91922f45546$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $bdd5c91922f45546$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($bdd5c91922f45546$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $bdd5c91922f45546$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($bdd5c91922f45546$var$isErrorResult(result)) {
            let boundaryMatch = $bdd5c91922f45546$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $bdd5c91922f45546$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $bdd5c91922f45546$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $bdd5c91922f45546$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $bdd5c91922f45546$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$bdd5c91922f45546$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $bdd5c91922f45546$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $bdd5c91922f45546$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $bdd5c91922f45546$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$bdd5c91922f45546$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $bdd5c91922f45546$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $bdd5c91922f45546$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $bdd5c91922f45546$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $bdd5c91922f45546$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $bdd5c91922f45546$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $bdd5c91922f45546$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $bdd5c91922f45546$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $bdd5c91922f45546$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $bdd5c91922f45546$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $bdd5c91922f45546$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $bdd5c91922f45546$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $bdd5c91922f45546$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($bdd5c91922f45546$var$isRedirectResult(actionResult) || $bdd5c91922f45546$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $bdd5c91922f45546$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($bdd5c91922f45546$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $bdd5c91922f45546$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $bdd5c91922f45546$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($bdd5c91922f45546$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $bdd5c91922f45546$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $bdd5c91922f45546$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $bdd5c91922f45546$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $bdd5c91922f45546$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $bdd5c91922f45546$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $bdd5c91922f45546$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $bdd5c91922f45546$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $bdd5c91922f45546$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $bdd5c91922f45546$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $bdd5c91922f45546$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $bdd5c91922f45546$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $bdd5c91922f45546$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $bdd5c91922f45546$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $bdd5c91922f45546$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $bdd5c91922f45546$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $bdd5c91922f45546$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $bdd5c91922f45546$var$getDoneFetcher(void 0));
            return;
        }
        if ($bdd5c91922f45546$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $bdd5c91922f45546$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($bdd5c91922f45546$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $bdd5c91922f45546$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $bdd5c91922f45546$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $bdd5c91922f45546$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $bdd5c91922f45546$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($bdd5c91922f45546$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $bdd5c91922f45546$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $bdd5c91922f45546$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($bdd5c91922f45546$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $bdd5c91922f45546$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $bdd5c91922f45546$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $bdd5c91922f45546$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($bdd5c91922f45546$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $bdd5c91922f45546$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $bdd5c91922f45546$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $bdd5c91922f45546$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $bdd5c91922f45546$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $bdd5c91922f45546$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $bdd5c91922f45546$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $bdd5c91922f45546$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $bdd5c91922f45546$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $bdd5c91922f45546$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $bdd5c91922f45546$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $bdd5c91922f45546$export$386d57f03f0b2883;
        $bdd5c91922f45546$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $bdd5c91922f45546$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $bdd5c91922f45546$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $bdd5c91922f45546$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $bdd5c91922f45546$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$bdd5c91922f45546$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $bdd5c91922f45546$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $bdd5c91922f45546$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $bdd5c91922f45546$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $bdd5c91922f45546$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $bdd5c91922f45546$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $bdd5c91922f45546$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $bdd5c91922f45546$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $bdd5c91922f45546$var$createStaticHandler(routes, opts) {
    $bdd5c91922f45546$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $bdd5c91922f45546$var$defaultMapRouteProperties;
    let dataRoutes = $bdd5c91922f45546$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $bdd5c91922f45546$var$createLocation("", $bdd5c91922f45546$export$fe53371bee54353d(url), null, "default");
        let matches = $bdd5c91922f45546$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$bdd5c91922f45546$var$isValidMethod(method) && method !== "HEAD") {
            let error = $bdd5c91922f45546$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $bdd5c91922f45546$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $bdd5c91922f45546$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bdd5c91922f45546$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($bdd5c91922f45546$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $bdd5c91922f45546$var$createLocation("", $bdd5c91922f45546$export$fe53371bee54353d(url), null, "default");
        let matches = $bdd5c91922f45546$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$bdd5c91922f45546$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $bdd5c91922f45546$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $bdd5c91922f45546$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $bdd5c91922f45546$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $bdd5c91922f45546$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $bdd5c91922f45546$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($bdd5c91922f45546$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $bdd5c91922f45546$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($bdd5c91922f45546$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $bdd5c91922f45546$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $bdd5c91922f45546$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($bdd5c91922f45546$var$isDataStrategyResult(e) && $bdd5c91922f45546$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($bdd5c91922f45546$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $bdd5c91922f45546$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $bdd5c91922f45546$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($bdd5c91922f45546$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($bdd5c91922f45546$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($bdd5c91922f45546$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $bdd5c91922f45546$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $bdd5c91922f45546$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $bdd5c91922f45546$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? $bdd5c91922f45546$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $bdd5c91922f45546$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $bdd5c91922f45546$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $bdd5c91922f45546$var$callDataStrategyImpl(dataStrategy || $bdd5c91922f45546$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($bdd5c91922f45546$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $bdd5c91922f45546$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($bdd5c91922f45546$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $bdd5c91922f45546$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $bdd5c91922f45546$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $bdd5c91922f45546$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $bdd5c91922f45546$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $bdd5c91922f45546$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $bdd5c91922f45546$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $bdd5c91922f45546$var$resolveTo(to ? to : ".", $bdd5c91922f45546$var$getResolveToMatches(contextualMatches), $bdd5c91922f45546$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $bdd5c91922f45546$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $bdd5c91922f45546$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $bdd5c91922f45546$export$fe53371bee54353d(path);
}
function $bdd5c91922f45546$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$bdd5c91922f45546$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$bdd5c91922f45546$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $bdd5c91922f45546$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $bdd5c91922f45546$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $bdd5c91922f45546$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$bdd5c91922f45546$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$bdd5c91922f45546$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $bdd5c91922f45546$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $bdd5c91922f45546$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $bdd5c91922f45546$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $bdd5c91922f45546$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $bdd5c91922f45546$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($bdd5c91922f45546$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $bdd5c91922f45546$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $bdd5c91922f45546$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $bdd5c91922f45546$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $bdd5c91922f45546$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $bdd5c91922f45546$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $bdd5c91922f45546$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $bdd5c91922f45546$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $bdd5c91922f45546$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($bdd5c91922f45546$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $bdd5c91922f45546$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $bdd5c91922f45546$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $bdd5c91922f45546$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $bdd5c91922f45546$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $bdd5c91922f45546$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $bdd5c91922f45546$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $bdd5c91922f45546$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $bdd5c91922f45546$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $bdd5c91922f45546$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $bdd5c91922f45546$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $bdd5c91922f45546$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$bdd5c91922f45546$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $bdd5c91922f45546$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $bdd5c91922f45546$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$bdd5c91922f45546$var$isSameRoute(aChild, bChild)));
}
async function $bdd5c91922f45546$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $bdd5c91922f45546$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $bdd5c91922f45546$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$bdd5c91922f45546$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $bdd5c91922f45546$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $bdd5c91922f45546$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $bdd5c91922f45546$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $bdd5c91922f45546$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $bdd5c91922f45546$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $bdd5c91922f45546$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $bdd5c91922f45546$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $bdd5c91922f45546$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($bdd5c91922f45546$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $bdd5c91922f45546$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($bdd5c91922f45546$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new $bdd5c91922f45546$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $bdd5c91922f45546$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($bdd5c91922f45546$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $bdd5c91922f45546$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $bdd5c91922f45546$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$bdd5c91922f45546$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $bdd5c91922f45546$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $bdd5c91922f45546$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($bdd5c91922f45546$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $bdd5c91922f45546$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $bdd5c91922f45546$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($bdd5c91922f45546$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $bdd5c91922f45546$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $bdd5c91922f45546$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $bdd5c91922f45546$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $bdd5c91922f45546$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $bdd5c91922f45546$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $bdd5c91922f45546$export$f5708dca728d7177(!$bdd5c91922f45546$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($bdd5c91922f45546$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $bdd5c91922f45546$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $bdd5c91922f45546$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $bdd5c91922f45546$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $bdd5c91922f45546$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $bdd5c91922f45546$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $bdd5c91922f45546$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($bdd5c91922f45546$var$isErrorResult(result)) {
            let boundaryMatch = $bdd5c91922f45546$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($bdd5c91922f45546$var$isRedirectResult(result)) $bdd5c91922f45546$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $bdd5c91922f45546$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $bdd5c91922f45546$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $bdd5c91922f45546$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $bdd5c91922f45546$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $bdd5c91922f45546$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $bdd5c91922f45546$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $bdd5c91922f45546$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $bdd5c91922f45546$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $bdd5c91922f45546$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $bdd5c91922f45546$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($bdd5c91922f45546$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $bdd5c91922f45546$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(path) : path;
    return $bdd5c91922f45546$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $bdd5c91922f45546$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $bdd5c91922f45546$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $bdd5c91922f45546$var$isRedirectDataStrategyResult(result) {
    return $bdd5c91922f45546$var$isResponse(result.result) && $bdd5c91922f45546$var$redirectStatusCodes.has(result.result.status);
}
function $bdd5c91922f45546$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $bdd5c91922f45546$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $bdd5c91922f45546$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $bdd5c91922f45546$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $bdd5c91922f45546$var$isRedirectStatusCode(statusCode) {
    return $bdd5c91922f45546$var$redirectStatusCodes.has(statusCode);
}
function $bdd5c91922f45546$var$isRedirectResponse(result) {
    return $bdd5c91922f45546$var$isResponse(result) && $bdd5c91922f45546$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $bdd5c91922f45546$var$isValidMethod(method) {
    return $bdd5c91922f45546$var$validRequestMethods.has(method.toUpperCase());
}
function $bdd5c91922f45546$var$isMutationMethod(method) {
    return $bdd5c91922f45546$var$validMutationMethods.has(method.toUpperCase());
}
function $bdd5c91922f45546$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $bdd5c91922f45546$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $bdd5c91922f45546$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $bdd5c91922f45546$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $bdd5c91922f45546$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $bdd5c91922f45546$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $bdd5c91922f45546$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $bdd5c91922f45546$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $bdd5c91922f45546$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $bdd5c91922f45546$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $bdd5c91922f45546$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($bdd5c91922f45546$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $bdd5c91922f45546$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($bdd5c91922f45546$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $bdd5c91922f45546$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $bdd5c91922f45546$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $bdd5c91922f45546$export$2eeee58951ff3c1c = $aqdBs.createContext(null);
$bdd5c91922f45546$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $bdd5c91922f45546$export$315e3ffb01f217 = $aqdBs.createContext(null);
$bdd5c91922f45546$export$315e3ffb01f217.displayName = "DataRouterState";
var $bdd5c91922f45546$export$3681f408decb40d1 = $aqdBs.createContext({
    isTransitioning: false
});
$bdd5c91922f45546$export$3681f408decb40d1.displayName = "ViewTransition";
var $bdd5c91922f45546$export$cb3f1df1bef00a39 = $aqdBs.createContext(/* @__PURE__ */ new Map());
$bdd5c91922f45546$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $bdd5c91922f45546$var$AwaitContext = $aqdBs.createContext(null);
$bdd5c91922f45546$var$AwaitContext.displayName = "Await";
var $bdd5c91922f45546$export$3044ab7fdabeaee6 = $aqdBs.createContext(null);
$bdd5c91922f45546$export$3044ab7fdabeaee6.displayName = "Navigation";
var $bdd5c91922f45546$export$e6a44b110a0c44d3 = $aqdBs.createContext(null);
$bdd5c91922f45546$export$e6a44b110a0c44d3.displayName = "Location";
var $bdd5c91922f45546$export$aac280ed165a4397 = $aqdBs.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$bdd5c91922f45546$export$aac280ed165a4397.displayName = "Route";
var $bdd5c91922f45546$var$RouteErrorContext = $aqdBs.createContext(null);
$bdd5c91922f45546$var$RouteErrorContext.displayName = "RouteError";
var $bdd5c91922f45546$var$ENABLE_DEV_WARNINGS = false;
function $bdd5c91922f45546$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $bdd5c91922f45546$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $bdd5c91922f45546$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $bdd5c91922f45546$export$9c954a9d03d32f4a() {
    return $aqdBs.useContext($bdd5c91922f45546$export$e6a44b110a0c44d3) != null;
}
function $bdd5c91922f45546$export$45d76561a5302f2b() {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $aqdBs.useContext($bdd5c91922f45546$export$e6a44b110a0c44d3).location;
}
function $bdd5c91922f45546$export$1b3f31771c5d07c() {
    return $aqdBs.useContext($bdd5c91922f45546$export$e6a44b110a0c44d3).navigationType;
}
function $bdd5c91922f45546$export$6c330e8992e8a295(pattern) {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $bdd5c91922f45546$export$45d76561a5302f2b();
    return $aqdBs.useMemo(()=>$bdd5c91922f45546$export$81336c211d5ff295(pattern, $bdd5c91922f45546$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $bdd5c91922f45546$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $bdd5c91922f45546$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6).static;
    if (!isStatic) $aqdBs.useLayoutEffect(cb);
}
function $bdd5c91922f45546$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    return isDataRoute ? $bdd5c91922f45546$var$useNavigateStable() : $bdd5c91922f45546$var$useNavigateUnstable();
}
function $bdd5c91922f45546$var$useNavigateUnstable() {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $aqdBs.useContext($bdd5c91922f45546$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let { matches: matches } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let { pathname: locationPathname } = $bdd5c91922f45546$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($bdd5c91922f45546$var$getResolveToMatches(matches));
    let activeRef = $aqdBs.useRef(false);
    $bdd5c91922f45546$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback((to, options = {})=>{
        $bdd5c91922f45546$var$warning(activeRef.current, $bdd5c91922f45546$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $bdd5c91922f45546$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $bdd5c91922f45546$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $bdd5c91922f45546$var$OutletContext = $aqdBs.createContext(null);
function $bdd5c91922f45546$export$4138103a3ae699cc() {
    return $aqdBs.useContext($bdd5c91922f45546$var$OutletContext);
}
function $bdd5c91922f45546$export$a3be3530d8e40d0b(context) {
    let outlet = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $bdd5c91922f45546$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $bdd5c91922f45546$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let { pathname: locationPathname } = $bdd5c91922f45546$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($bdd5c91922f45546$var$getResolveToMatches(matches));
    return $aqdBs.useMemo(()=>$bdd5c91922f45546$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $bdd5c91922f45546$export$5d3fca4a98652595(routes, locationArg) {
    return $bdd5c91922f45546$var$useRoutesImpl(routes, locationArg);
}
function $bdd5c91922f45546$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $bdd5c91922f45546$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $bdd5c91922f45546$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $bdd5c91922f45546$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $bdd5c91922f45546$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $bdd5c91922f45546$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS) {
        $bdd5c91922f45546$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $bdd5c91922f45546$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $bdd5c91922f45546$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $bdd5c91922f45546$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $bdd5c91922f45546$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $bdd5c91922f45546$var$DefaultErrorComponent() {
    let error = $bdd5c91922f45546$export$ed527bf60f6e05f2();
    let message = $bdd5c91922f45546$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $aqdBs.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $aqdBs.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $aqdBs.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $aqdBs.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $aqdBs.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $bdd5c91922f45546$var$defaultErrorElement = /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$DefaultErrorComponent, null);
var $bdd5c91922f45546$var$RenderErrorBoundary = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $bdd5c91922f45546$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $aqdBs.useContext($bdd5c91922f45546$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $bdd5c91922f45546$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $bdd5c91922f45546$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $bdd5c91922f45546$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $bdd5c91922f45546$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $aqdBs.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $bdd5c91922f45546$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $bdd5c91922f45546$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext($bdd5c91922f45546$export$2eeee58951ff3c1c);
    $bdd5c91922f45546$export$f5708dca728d7177(ctx, $bdd5c91922f45546$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $bdd5c91922f45546$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext($bdd5c91922f45546$export$315e3ffb01f217);
    $bdd5c91922f45546$export$f5708dca728d7177(state, $bdd5c91922f45546$var$getDataRouterConsoleError(hookName));
    return state;
}
function $bdd5c91922f45546$var$useRouteContext(hookName) {
    let route = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    $bdd5c91922f45546$export$f5708dca728d7177(route, $bdd5c91922f45546$var$getDataRouterConsoleError(hookName));
    return route;
}
function $bdd5c91922f45546$var$useCurrentRouteId(hookName) {
    let route = $bdd5c91922f45546$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $bdd5c91922f45546$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $bdd5c91922f45546$var$useRouteId() {
    return $bdd5c91922f45546$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $bdd5c91922f45546$export$d0fd4b7106de2769() {
    let state = $bdd5c91922f45546$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $bdd5c91922f45546$export$600dc272ed516c15() {
    let dataRouterContext = $bdd5c91922f45546$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $bdd5c91922f45546$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $aqdBs.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $bdd5c91922f45546$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $bdd5c91922f45546$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $aqdBs.useMemo(()=>matches.map((m)=>$bdd5c91922f45546$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $bdd5c91922f45546$export$1448a5050d252c4d() {
    let state = $bdd5c91922f45546$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $bdd5c91922f45546$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $bdd5c91922f45546$export$fd5d37484eab868d(routeId) {
    let state = $bdd5c91922f45546$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $bdd5c91922f45546$export$fdc00f3f26066d5e() {
    let state = $bdd5c91922f45546$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $bdd5c91922f45546$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $bdd5c91922f45546$export$ed527bf60f6e05f2() {
    let error = $aqdBs.useContext($bdd5c91922f45546$var$RouteErrorContext);
    let state = $bdd5c91922f45546$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $bdd5c91922f45546$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $bdd5c91922f45546$export$78a72ddb39bdd145() {
    let value = $aqdBs.useContext($bdd5c91922f45546$var$AwaitContext);
    return value?._data;
}
function $bdd5c91922f45546$export$17f53340677d5831() {
    let value = $aqdBs.useContext($bdd5c91922f45546$var$AwaitContext);
    return value?._error;
}
var $bdd5c91922f45546$var$blockerId = 0;
function $bdd5c91922f45546$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $bdd5c91922f45546$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $bdd5c91922f45546$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $aqdBs.useState("");
    let blockerFunction = $aqdBs.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $bdd5c91922f45546$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $bdd5c91922f45546$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $aqdBs.useEffect(()=>{
        let key = String(++$bdd5c91922f45546$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $aqdBs.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $bdd5c91922f45546$export$386d57f03f0b2883;
}
function $bdd5c91922f45546$var$useNavigateStable() {
    let { router: router } = $bdd5c91922f45546$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $bdd5c91922f45546$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $aqdBs.useRef(false);
    $bdd5c91922f45546$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(async (to, options = {})=>{
        $bdd5c91922f45546$var$warning(activeRef.current, $bdd5c91922f45546$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $bdd5c91922f45546$var$alreadyWarned = {};
function $bdd5c91922f45546$var$warningOnce(key, cond, message) {
    if (!cond && !$bdd5c91922f45546$var$alreadyWarned[key]) {
        $bdd5c91922f45546$var$alreadyWarned[key] = true;
        $bdd5c91922f45546$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $bdd5c91922f45546$var$alreadyWarned2 = {};
function $bdd5c91922f45546$var$warnOnce(condition, message) {
    if (!condition && !$bdd5c91922f45546$var$alreadyWarned2[message]) {
        $bdd5c91922f45546$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $bdd5c91922f45546$var$ENABLE_DEV_WARNINGS2 = false;
function $bdd5c91922f45546$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $bdd5c91922f45546$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $aqdBs.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $bdd5c91922f45546$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $aqdBs.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($bdd5c91922f45546$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $bdd5c91922f45546$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $aqdBs.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $bdd5c91922f45546$export$f30f7e456d254e83(routes, opts) {
    return $bdd5c91922f45546$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $bdd5c91922f45546$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $bdd5c91922f45546$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $bdd5c91922f45546$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $bdd5c91922f45546$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let [pendingState, setPendingState] = $aqdBs.useState();
    let [vtContext, setVtContext] = $aqdBs.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aqdBs.useState();
    let [transition, setTransition] = $aqdBs.useState();
    let [interruption, setInterruption] = $aqdBs.useState();
    let fetcherData = $aqdBs.useRef(/* @__PURE__ */ new Map());
    let setState = $aqdBs.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        $bdd5c91922f45546$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $bdd5c91922f45546$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $aqdBs.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aqdBs.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $bdd5c91922f45546$var$Deferred());
    }, [
        vtContext
    ]);
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $aqdBs.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $aqdBs.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $bdd5c91922f45546$var$MemoizedDataRoutes = $aqdBs.memo($bdd5c91922f45546$var$DataRoutes);
function $bdd5c91922f45546$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $bdd5c91922f45546$var$useRoutesImpl(routes, void 0, state, future);
}
function $bdd5c91922f45546$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $bdd5c91922f45546$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $bdd5c91922f45546$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $bdd5c91922f45546$export$f5708dca728d7177($bdd5c91922f45546$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    $bdd5c91922f45546$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let { pathname: locationPathname } = $bdd5c91922f45546$export$45d76561a5302f2b();
    let navigate = $bdd5c91922f45546$export$9770f232ac06a008();
    let path = $bdd5c91922f45546$var$resolveTo(to, $bdd5c91922f45546$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aqdBs.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $bdd5c91922f45546$export$910ae8079b2c2852(props) {
    return $bdd5c91922f45546$export$a3be3530d8e40d0b(props.context);
}
function $bdd5c91922f45546$export$e7b0ac011bb776c6(_props) {
    $bdd5c91922f45546$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $bdd5c91922f45546$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $bdd5c91922f45546$export$f5708dca728d7177(!$bdd5c91922f45546$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aqdBs.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $bdd5c91922f45546$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aqdBs.useMemo(()=>{
        let trailingPathname = $bdd5c91922f45546$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $bdd5c91922f45546$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $bdd5c91922f45546$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $bdd5c91922f45546$export$5d3fca4a98652595($bdd5c91922f45546$export$16da398f5434bdec(children), location);
}
function $bdd5c91922f45546$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$ResolveAwait, null, children));
}
var $bdd5c91922f45546$var$AwaitErrorBoundary = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $bdd5c91922f45546$var$ResolveAwait({ children: children }) {
    let data2 = $bdd5c91922f45546$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, toRender);
}
function $bdd5c91922f45546$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $aqdBs.Children.forEach(children, (element, index)=>{
        if (!$aqdBs.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aqdBs.Fragment) {
            routes.push.apply(routes, $bdd5c91922f45546$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $bdd5c91922f45546$export$f5708dca728d7177(element.type === $bdd5c91922f45546$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $bdd5c91922f45546$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $bdd5c91922f45546$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
function $bdd5c91922f45546$export$daf73786167a7f72(matches) {
    return $bdd5c91922f45546$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $bdd5c91922f45546$var$defaultMethod = "get";
var $bdd5c91922f45546$var$defaultEncType = "application/x-www-form-urlencoded";
function $bdd5c91922f45546$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $bdd5c91922f45546$var$isButtonElement(object) {
    return $bdd5c91922f45546$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $bdd5c91922f45546$var$isFormElement(object) {
    return $bdd5c91922f45546$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $bdd5c91922f45546$var$isInputElement(object) {
    return $bdd5c91922f45546$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $bdd5c91922f45546$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $bdd5c91922f45546$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$bdd5c91922f45546$var$isModifiedEvent(event);
}
function $bdd5c91922f45546$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $bdd5c91922f45546$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $bdd5c91922f45546$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $bdd5c91922f45546$var$_formDataSupportsSubmitter = null;
function $bdd5c91922f45546$var$isFormDataSubmitterSupported() {
    if ($bdd5c91922f45546$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $bdd5c91922f45546$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $bdd5c91922f45546$var$_formDataSupportsSubmitter = true;
    }
    return $bdd5c91922f45546$var$_formDataSupportsSubmitter;
}
var $bdd5c91922f45546$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $bdd5c91922f45546$var$getFormEncType(encType) {
    if (encType != null && !$bdd5c91922f45546$var$supportedFormEncTypes.has(encType)) {
        $bdd5c91922f45546$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$bdd5c91922f45546$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $bdd5c91922f45546$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($bdd5c91922f45546$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $bdd5c91922f45546$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $bdd5c91922f45546$var$defaultMethod;
        encType = $bdd5c91922f45546$var$getFormEncType(target.getAttribute("enctype")) || $bdd5c91922f45546$var$defaultEncType;
        formData = new FormData(target);
    } else if ($bdd5c91922f45546$var$isButtonElement(target) || $bdd5c91922f45546$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $bdd5c91922f45546$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $bdd5c91922f45546$var$defaultMethod;
        encType = $bdd5c91922f45546$var$getFormEncType(target.getAttribute("formenctype")) || $bdd5c91922f45546$var$getFormEncType(form.getAttribute("enctype")) || $bdd5c91922f45546$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$bdd5c91922f45546$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($bdd5c91922f45546$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $bdd5c91922f45546$var$defaultMethod;
        action = null;
        encType = $bdd5c91922f45546$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $bdd5c91922f45546$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $bdd5c91922f45546$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $bdd5c91922f45546$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $bdd5c91922f45546$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $bdd5c91922f45546$var$getCurrentPageModulePreloadHrefs(matches, manifest);
    return $bdd5c91922f45546$var$dedupeLinkDescriptors(descriptors, preloads);
}
async function $bdd5c91922f45546$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$bdd5c91922f45546$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$bdd5c91922f45546$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map($bdd5c91922f45546$var$prefetchStyleLink));
}
async function $bdd5c91922f45546$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $bdd5c91922f45546$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $bdd5c91922f45546$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $bdd5c91922f45546$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $bdd5c91922f45546$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $bdd5c91922f45546$var$dedupeLinkDescriptors(links.flat(1).filter($bdd5c91922f45546$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $bdd5c91922f45546$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $bdd5c91922f45546$var$getModuleLinkHrefs(matches, manifestPatch) {
    return $bdd5c91922f45546$var$dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $bdd5c91922f45546$var$getCurrentPageModulePreloadHrefs(matches, manifest) {
    return $bdd5c91922f45546$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $bdd5c91922f45546$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $bdd5c91922f45546$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $bdd5c91922f45546$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$bdd5c91922f45546$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($bdd5c91922f45546$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $bdd5c91922f45546$var$_isPreloadSupported;
function $bdd5c91922f45546$var$isPreloadSupported() {
    if ($bdd5c91922f45546$var$_isPreloadSupported !== void 0) return $bdd5c91922f45546$var$_isPreloadSupported;
    let el = document.createElement("link");
    $bdd5c91922f45546$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $bdd5c91922f45546$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $bdd5c91922f45546$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $bdd5c91922f45546$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $bdd5c91922f45546$var$escapeHtml(html) {
    return html.replace($bdd5c91922f45546$var$ESCAPE_REGEX, (match)=>$bdd5c91922f45546$var$ESCAPE_LOOKUP[match]);
}
function $bdd5c91922f45546$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $bdd5c91922f45546$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $bdd5c91922f45546$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $bdd5c91922f45546$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $aqdBs.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$bdd5c91922f45546$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, scriptTag, /* @__PURE__ */ $aqdBs.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, scriptTag, /* @__PURE__ */ $aqdBs.createElement($aqdBs.Suspense, null, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $bdd5c91922f45546$export$c7c51be9b423c4d6(manifest, routeModules, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $bdd5c91922f45546$var$singleFetchActionStrategy(request, matches);
        if (fetcherKey) return $bdd5c91922f45546$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $bdd5c91922f45546$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function $bdd5c91922f45546$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $bdd5c91922f45546$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $bdd5c91922f45546$var$singleFetchUrl(request.url);
            let init = await $bdd5c91922f45546$var$createRequestInit(request);
            let { data: data2, status: status } = await $bdd5c91922f45546$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $bdd5c91922f45546$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($bdd5c91922f45546$var$isResponse(result.result) || $bdd5c91922f45546$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $bdd5c91922f45546$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $bdd5c91922f45546$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$bdd5c91922f45546$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $bdd5c91922f45546$var$createDeferred2();
    let url = $bdd5c91922f45546$var$stripIndexParam($bdd5c91922f45546$var$singleFetchUrl(request.url));
    let init = await $bdd5c91922f45546$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $bdd5c91922f45546$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $bdd5c91922f45546$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $bdd5c91922f45546$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $bdd5c91922f45546$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $bdd5c91922f45546$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $bdd5c91922f45546$var$stripIndexParam($bdd5c91922f45546$var$singleFetchUrl(request.url));
        let init = await $bdd5c91922f45546$var$createRequestInit(request);
        return $bdd5c91922f45546$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $bdd5c91922f45546$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $bdd5c91922f45546$var$fetchAndDecode(singleLoaderUrl, init);
        return $bdd5c91922f45546$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $bdd5c91922f45546$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $bdd5c91922f45546$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $bdd5c91922f45546$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $bdd5c91922f45546$export$f2680fa305b734ca(404, "Not Found", true);
    $bdd5c91922f45546$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $bdd5c91922f45546$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $bdd5c91922f45546$export$4023ad4ecd4126a2(body, global2) {
    return (0, $3caee95e8f5bb11a$exports.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $bdd5c91922f45546$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$bdd5c91922f45546$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $bdd5c91922f45546$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$bdd5c91922f45546$export$60644022b8b46aaa];
    if (redirect2) return $bdd5c91922f45546$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $bdd5c91922f45546$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $bdd5c91922f45546$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        return $bdd5c91922f45546$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $bdd5c91922f45546$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $bdd5c91922f45546$export$32e57f52df4b6e34 = class extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $bdd5c91922f45546$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $aqdBs.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($bdd5c91922f45546$export$972111febbeef05b(error)) return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $aqdBs.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $aqdBs.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $aqdBs.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $bdd5c91922f45546$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $bdd5c91922f45546$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $aqdBs.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $aqdBs.createElement("head", null, /* @__PURE__ */ $aqdBs.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $aqdBs.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $aqdBs.createElement("title", null, title)), /* @__PURE__ */ $aqdBs.createElement("body", null, /* @__PURE__ */ $aqdBs.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$ff0bf87698939488, null) : null)));
}
function $bdd5c91922f45546$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $aqdBs.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $bdd5c91922f45546$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $bdd5c91922f45546$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $bdd5c91922f45546$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $bdd5c91922f45546$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$RemixRootDefaultErrorBoundary, {
            error: $bdd5c91922f45546$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $aqdBs.createElement(routeModule.Layout, null, /* @__PURE__ */ $aqdBs.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $bdd5c91922f45546$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $bdd5c91922f45546$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $bdd5c91922f45546$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$bdd5c91922f45546$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $bdd5c91922f45546$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $bdd5c91922f45546$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return $bdd5c91922f45546$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, "", $bdd5c91922f45546$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $bdd5c91922f45546$var$preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new $bdd5c91922f45546$export$f2680fa305b734ca(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new $bdd5c91922f45546$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $bdd5c91922f45546$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $bdd5c91922f45546$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $bdd5c91922f45546$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = $bdd5c91922f45546$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $bdd5c91922f45546$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $bdd5c91922f45546$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $bdd5c91922f45546$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$bdd5c91922f45546$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $bdd5c91922f45546$var$getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $bdd5c91922f45546$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $bdd5c91922f45546$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $bdd5c91922f45546$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $bdd5c91922f45546$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $bdd5c91922f45546$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $bdd5c91922f45546$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $bdd5c91922f45546$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await $bdd5c91922f45546$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $bdd5c91922f45546$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $bdd5c91922f45546$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $bdd5c91922f45546$var$getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $bdd5c91922f45546$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $bdd5c91922f45546$var$getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return $bdd5c91922f45546$var$wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $bdd5c91922f45546$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $bdd5c91922f45546$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await $bdd5c91922f45546$var$loadRouteModule(route, routeModules);
    await $bdd5c91922f45546$var$prefetchStyleLinks(route, routeModule);
    return {
        Component: $bdd5c91922f45546$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $bdd5c91922f45546$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $bdd5c91922f45546$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $bdd5c91922f45546$var$nextPaths = /* @__PURE__ */ new Set();
var $bdd5c91922f45546$var$discoveredPathsMaxSize = 1e3;
var $bdd5c91922f45546$var$discoveredPaths = /* @__PURE__ */ new Set();
var $bdd5c91922f45546$var$URL_LIMIT = 7680;
function $bdd5c91922f45546$var$isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function $bdd5c91922f45546$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $bdd5c91922f45546$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $bdd5c91922f45546$export$72ab377a1030deb9(manifest, routeModules, isSpaMode, basename) {
    if (!$bdd5c91922f45546$var$isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path: path, patch: patch })=>{
        if ($bdd5c91922f45546$var$discoveredPaths.has(path)) return;
        await $bdd5c91922f45546$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function $bdd5c91922f45546$export$5ef046b23d96090d(router, manifest, routeModules, isSpaMode) {
    $aqdBs.useEffect(()=>{
        if (!$bdd5c91922f45546$var$isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!$bdd5c91922f45546$var$discoveredPaths.has(url.pathname)) $bdd5c91922f45546$var$nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from($bdd5c91922f45546$var$nextPaths.keys()).filter((path)=>{
                if ($bdd5c91922f45546$var$discoveredPaths.has(path)) {
                    $bdd5c91922f45546$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $bdd5c91922f45546$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = $bdd5c91922f45546$var$debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $bdd5c91922f45546$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $bdd5c91922f45546$var$URL_LIMIT) {
        $bdd5c91922f45546$var$nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$bdd5c91922f45546$var$addToFifoQueue(p, $bdd5c91922f45546$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $bdd5c91922f45546$export$af76e85f27ba0229(patches, routeModules, null, isSpaMode, parentId)));
}
function $bdd5c91922f45546$var$addToFifoQueue(path, queue) {
    if (queue.size >= $bdd5c91922f45546$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $bdd5c91922f45546$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $bdd5c91922f45546$var$useDataRouterContext2() {
    let context = $aqdBs.useContext($bdd5c91922f45546$export$2eeee58951ff3c1c);
    $bdd5c91922f45546$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $bdd5c91922f45546$var$useDataRouterStateContext() {
    let context = $aqdBs.useContext($bdd5c91922f45546$export$315e3ffb01f217);
    $bdd5c91922f45546$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $bdd5c91922f45546$export$208d6a3bc3aa62bd = $aqdBs.createContext(void 0);
$bdd5c91922f45546$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $bdd5c91922f45546$var$useFrameworkContext() {
    let context = $aqdBs.useContext($bdd5c91922f45546$export$208d6a3bc3aa62bd);
    $bdd5c91922f45546$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $bdd5c91922f45546$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $aqdBs.useContext($bdd5c91922f45546$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $aqdBs.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $aqdBs.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $aqdBs.useRef(null);
    $aqdBs.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $aqdBs.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $bdd5c91922f45546$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $bdd5c91922f45546$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $bdd5c91922f45546$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $bdd5c91922f45546$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $bdd5c91922f45546$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $bdd5c91922f45546$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $bdd5c91922f45546$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$bdd5c91922f45546$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $bdd5c91922f45546$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $bdd5c91922f45546$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $bdd5c91922f45546$var$useDataRouterStateContext();
    let matches = $bdd5c91922f45546$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $aqdBs.useMemo(()=>$bdd5c91922f45546$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, criticalCss ? /* @__PURE__ */ $aqdBs.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$bdd5c91922f45546$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $aqdBs.createElement("link", {
            key: key,
            ...link
        })));
}
function $bdd5c91922f45546$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $bdd5c91922f45546$var$useDataRouterContext2();
    let matches = $aqdBs.useMemo(()=>$bdd5c91922f45546$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) {
        console.warn(`Tried to prefetch ${page} but no routes matched.`);
        return null;
    }
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $bdd5c91922f45546$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $bdd5c91922f45546$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $aqdBs.useState([]);
    $aqdBs.useEffect(()=>{
        let interrupted = false;
        $bdd5c91922f45546$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $bdd5c91922f45546$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $bdd5c91922f45546$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $bdd5c91922f45546$var$useDataRouterStateContext();
    let newMatchesForData = $aqdBs.useMemo(()=>$bdd5c91922f45546$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $aqdBs.useMemo(()=>$bdd5c91922f45546$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $aqdBs.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $bdd5c91922f45546$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $aqdBs.useMemo(()=>$bdd5c91922f45546$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $bdd5c91922f45546$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $aqdBs.createElement("link", {
            key: key,
            ...link
        })));
}
function $bdd5c91922f45546$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $bdd5c91922f45546$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $bdd5c91922f45546$var$useDataRouterStateContext();
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let _matches = $bdd5c91922f45546$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$bdd5c91922f45546$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $aqdBs.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $aqdBs.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $aqdBs.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $aqdBs.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $aqdBs.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $bdd5c91922f45546$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $bdd5c91922f45546$var$isHydrated = false;
function $bdd5c91922f45546$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta } = $bdd5c91922f45546$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $bdd5c91922f45546$var$useDataRouterContext2();
    let { matches: routerMatches } = $bdd5c91922f45546$var$useDataRouterStateContext();
    let enableFogOfWar = $bdd5c91922f45546$var$isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $bdd5c91922f45546$var$getActiveMatches(routerMatches, null, isSpaMode);
    $aqdBs.useEffect(()=>{
        $bdd5c91922f45546$var$isHydrated = true;
    }, []);
    let initialScripts = $aqdBs.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($bdd5c91922f45546$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $bdd5c91922f45546$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $aqdBs.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $bdd5c91922f45546$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = $bdd5c91922f45546$var$isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return $bdd5c91922f45546$var$isHydrated ? null : /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $aqdBs.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $aqdBs.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $bdd5c91922f45546$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $aqdBs.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $bdd5c91922f45546$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $bdd5c91922f45546$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $bdd5c91922f45546$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($bdd5c91922f45546$var$isBrowser) window.__reactRouterVersion = "7.0.1";
} catch (e) {}
function $bdd5c91922f45546$export$1f3f55432a00e06d(routes, opts) {
    return $bdd5c91922f45546$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $bdd5c91922f45546$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $bdd5c91922f45546$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $bdd5c91922f45546$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $bdd5c91922f45546$export$1ba7ed8a3a7b3765(routes, opts) {
    return $bdd5c91922f45546$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $bdd5c91922f45546$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $bdd5c91922f45546$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $bdd5c91922f45546$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $bdd5c91922f45546$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $bdd5c91922f45546$var$deserializeErrors(state.errors)
    };
    return state;
}
function $bdd5c91922f45546$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $bdd5c91922f45546$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $bdd5c91922f45546$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $bdd5c91922f45546$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $bdd5c91922f45546$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = $bdd5c91922f45546$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $bdd5c91922f45546$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aqdBs.useCallback((newState)=>{
        $aqdBs.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$bdd5c91922f45546$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $bdd5c91922f45546$export$a6c7ac8248d6e38a = $aqdBs.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($bdd5c91922f45546$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $bdd5c91922f45546$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $bdd5c91922f45546$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $bdd5c91922f45546$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $bdd5c91922f45546$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $bdd5c91922f45546$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $aqdBs.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $bdd5c91922f45546$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, link, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$bdd5c91922f45546$export$a6c7ac8248d6e38a.displayName = "Link";
var $bdd5c91922f45546$export$b0d92dbee9b5b60d = $aqdBs.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $bdd5c91922f45546$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let routerState = $aqdBs.useContext($bdd5c91922f45546$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bdd5c91922f45546$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $bdd5c91922f45546$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$bdd5c91922f45546$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $bdd5c91922f45546$export$a7fed597f4b8afd8 = $aqdBs.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $bdd5c91922f45546$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $bdd5c91922f45546$export$47c85c6e3a081d3();
    let formAction = $bdd5c91922f45546$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $aqdBs.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$bdd5c91922f45546$export$a7fed597f4b8afd8.displayName = "Form";
function $bdd5c91922f45546$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $aqdBs.useContext($bdd5c91922f45546$export$208d6a3bc3aa62bd);
    let { basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let matches = $bdd5c91922f45546$export$2378eb7f5ff86053();
    $bdd5c91922f45546$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $aqdBs.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $bdd5c91922f45546$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $aqdBs.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $bdd5c91922f45546$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$bdd5c91922f45546$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $bdd5c91922f45546$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $bdd5c91922f45546$var$useDataRouterContext3(hookName) {
    let ctx = $aqdBs.useContext($bdd5c91922f45546$export$2eeee58951ff3c1c);
    $bdd5c91922f45546$export$f5708dca728d7177(ctx, $bdd5c91922f45546$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $bdd5c91922f45546$var$useDataRouterState2(hookName) {
    let state = $aqdBs.useContext($bdd5c91922f45546$export$315e3ffb01f217);
    $bdd5c91922f45546$export$f5708dca728d7177(state, $bdd5c91922f45546$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $bdd5c91922f45546$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $bdd5c91922f45546$export$9770f232ac06a008();
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let path = $bdd5c91922f45546$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $aqdBs.useCallback((event)=>{
        if ($bdd5c91922f45546$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $bdd5c91922f45546$export$fe53371bee54353d(location) === $bdd5c91922f45546$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $bdd5c91922f45546$export$f1a78c17382fe22a(defaultInit) {
    $bdd5c91922f45546$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $aqdBs.useRef($bdd5c91922f45546$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aqdBs.useRef(false);
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let searchParams = $aqdBs.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $bdd5c91922f45546$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $bdd5c91922f45546$export$9770f232ac06a008();
    let setSearchParams = $aqdBs.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $bdd5c91922f45546$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $bdd5c91922f45546$var$fetcherId = 0;
var $bdd5c91922f45546$var$getUniqueFetcherId = ()=>`__${String(++$bdd5c91922f45546$var$fetcherId)}__`;
function $bdd5c91922f45546$export$47c85c6e3a081d3() {
    let { router: router } = $bdd5c91922f45546$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let currentRouteId = $bdd5c91922f45546$var$useRouteId();
    return $aqdBs.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $bdd5c91922f45546$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $bdd5c91922f45546$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $bdd5c91922f45546$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let routeContext = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    $bdd5c91922f45546$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$bdd5c91922f45546$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $bdd5c91922f45546$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $bdd5c91922f45546$export$fe53371bee54353d(path);
}
function $bdd5c91922f45546$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $bdd5c91922f45546$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $bdd5c91922f45546$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $aqdBs.useContext($bdd5c91922f45546$export$cb3f1df1bef00a39);
    let route = $aqdBs.useContext($bdd5c91922f45546$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $bdd5c91922f45546$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $bdd5c91922f45546$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $bdd5c91922f45546$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $aqdBs.useId();
    let [fetcherKey, setFetcherKey] = $aqdBs.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $aqdBs.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $aqdBs.useCallback(async (href, opts)=>{
        $bdd5c91922f45546$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $bdd5c91922f45546$export$47c85c6e3a081d3();
    let submit = $aqdBs.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $aqdBs.useMemo(()=>{
        let FetcherForm2 = $aqdBs.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $bdd5c91922f45546$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aqdBs.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $bdd5c91922f45546$export$fa996778a3a31087() {
    let state = $bdd5c91922f45546$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $bdd5c91922f45546$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $bdd5c91922f45546$var$savedScrollPositions = {};
function $bdd5c91922f45546$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $bdd5c91922f45546$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $bdd5c91922f45546$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $bdd5c91922f45546$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $bdd5c91922f45546$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $aqdBs.useContext($bdd5c91922f45546$export$3044ab7fdabeaee6);
    let location = $bdd5c91922f45546$export$45d76561a5302f2b();
    let matches = $bdd5c91922f45546$export$2378eb7f5ff86053();
    let navigation = $bdd5c91922f45546$export$d0fd4b7106de2769();
    $aqdBs.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $bdd5c91922f45546$var$usePageHide($aqdBs.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $bdd5c91922f45546$var$getScrollRestorationKey(location, matches, basename, getKey);
            $bdd5c91922f45546$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $bdd5c91922f45546$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($bdd5c91922f45546$var$savedScrollPositions));
        } catch (error) {
            $bdd5c91922f45546$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $aqdBs.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $bdd5c91922f45546$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $bdd5c91922f45546$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $aqdBs.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($bdd5c91922f45546$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$bdd5c91922f45546$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $aqdBs.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $bdd5c91922f45546$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $bdd5c91922f45546$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $bdd5c91922f45546$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $bdd5c91922f45546$export$b273b3273281a049(when);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $bdd5c91922f45546$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $aqdBs.useContext($bdd5c91922f45546$export$3681f408decb40d1);
    $bdd5c91922f45546$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $bdd5c91922f45546$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $bdd5c91922f45546$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $bdd5c91922f45546$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $bdd5c91922f45546$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $bdd5c91922f45546$export$81336c211d5ff295(path.pathname, nextPath) != null || $bdd5c91922f45546$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $bdd5c91922f45546$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $bdd5c91922f45546$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $bdd5c91922f45546$var$getStatelessNavigator();
    return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $bdd5c91922f45546$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $bdd5c91922f45546$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $bdd5c91922f45546$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $bdd5c91922f45546$var$serializeErrors(context.errors)
        };
        let json = $bdd5c91922f45546$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $aqdBs.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $bdd5c91922f45546$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $bdd5c91922f45546$var$useRoutesImpl(routes, void 0, state, future);
}
function $bdd5c91922f45546$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($bdd5c91922f45546$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $bdd5c91922f45546$var$getStatelessNavigator() {
    return {
        createHref: $bdd5c91922f45546$var$createHref,
        encodeLocation: $bdd5c91922f45546$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $bdd5c91922f45546$export$3336b097a6fbc59a(routes, opts) {
    return $bdd5c91922f45546$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $bdd5c91922f45546$export$9269a41d8c4635e
    });
}
function $bdd5c91922f45546$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $bdd5c91922f45546$var$convertRoutesToDataRoutes(routes, $bdd5c91922f45546$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $bdd5c91922f45546$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $bdd5c91922f45546$var$createHref,
        encodeLocation: $bdd5c91922f45546$var$encodeLocation,
        getFetcher () {
            return $bdd5c91922f45546$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $bdd5c91922f45546$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $bdd5c91922f45546$var$createHref(to) {
    return typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to);
}
function $bdd5c91922f45546$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $bdd5c91922f45546$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $bdd5c91922f45546$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $bdd5c91922f45546$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $bdd5c91922f45546$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $bdd5c91922f45546$var$htmlEscape(str) {
    return str.replace($bdd5c91922f45546$var$ESCAPE_REGEX2, (match)=>$bdd5c91922f45546$var$ESCAPE_LOOKUP2[match]);
}
function $bdd5c91922f45546$export$7246f7e18cebe1bd({ context: context, url: url, abortDelay: abortDelay, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $bdd5c91922f45546$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $bdd5c91922f45546$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $bdd5c91922f45546$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $aqdBs.createElement($aqdBs.Fragment, null, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            abortDelay: abortDelay,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $aqdBs.createElement($aqdBs.Suspense, null, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $bdd5c91922f45546$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $aqdBs.useRef();
        let remixContextRef = $aqdBs.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = $bdd5c91922f45546$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $bdd5c91922f45546$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $bdd5c91922f45546$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $aqdBs.createElement($bdd5c91922f45546$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $bdd5c91922f45546$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $bdd5c91922f45546$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $bdd5c91922f45546$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $bdd5c91922f45546$var$encoder = new TextEncoder();
var $bdd5c91922f45546$var$sign = async (value, secret)=>{
    let data2 = $bdd5c91922f45546$var$encoder.encode(value);
    let key = await $bdd5c91922f45546$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $bdd5c91922f45546$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $bdd5c91922f45546$var$encoder.encode(value);
    let key = await $bdd5c91922f45546$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $bdd5c91922f45546$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $bdd5c91922f45546$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $bdd5c91922f45546$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $bdd5c91922f45546$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $bdd5c91922f45546$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $bdd5c91922f45546$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $fa5e80d5b8cb06bd$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $bdd5c91922f45546$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $fa5e80d5b8cb06bd$exports.serialize)(name, value === "" ? "" : await $bdd5c91922f45546$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $bdd5c91922f45546$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $bdd5c91922f45546$var$encodeCookieValue(value, secrets) {
    let encoded = $bdd5c91922f45546$var$encodeData(value);
    if (secrets.length > 0) encoded = await $bdd5c91922f45546$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $bdd5c91922f45546$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $bdd5c91922f45546$var$unsign(value, secret);
            if (unsignedValue !== false) return $bdd5c91922f45546$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $bdd5c91922f45546$var$decodeData(value);
}
function $bdd5c91922f45546$var$encodeData(value) {
    return btoa($bdd5c91922f45546$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $bdd5c91922f45546$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($bdd5c91922f45546$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $bdd5c91922f45546$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $bdd5c91922f45546$var$hex(code, 2);
            else result += "%u" + $bdd5c91922f45546$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $bdd5c91922f45546$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $bdd5c91922f45546$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $bdd5c91922f45546$var$warnOnceAboutExpiresCookie(name, expires) {
    $bdd5c91922f45546$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $bdd5c91922f45546$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $bdd5c91922f45546$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($bdd5c91922f45546$export$e7973f87fd96e4f2 || {});
function $bdd5c91922f45546$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $bdd5c91922f45546$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $bdd5c91922f45546$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $bdd5c91922f45546$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $bdd5c91922f45546$var$serializeError(error, serverMode) {
    let sanitized = $bdd5c91922f45546$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $bdd5c91922f45546$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($bdd5c91922f45546$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $bdd5c91922f45546$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $bdd5c91922f45546$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $bdd5c91922f45546$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $bdd5c91922f45546$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $bdd5c91922f45546$var$stripRoutesParam($bdd5c91922f45546$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($bdd5c91922f45546$var$isDataWithResponseInit(result) && result.init && result.init.status && $bdd5c91922f45546$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $bdd5c91922f45546$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $bdd5c91922f45546$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $bdd5c91922f45546$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $bdd5c91922f45546$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $bdd5c91922f45546$var$createRoutes(manifest, parentId = "", routesByParentId = $bdd5c91922f45546$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $bdd5c91922f45546$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $bdd5c91922f45546$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $bdd5c91922f45546$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $bdd5c91922f45546$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $bdd5c91922f45546$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $bdd5c91922f45546$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $bdd5c91922f45546$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $bdd5c91922f45546$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$bdd5c91922f45546$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $bdd5c91922f45546$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $bdd5c91922f45546$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $bdd5c91922f45546$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $bdd5c91922f45546$var$escapeHtml2(html) {
    return html.replace($bdd5c91922f45546$var$ESCAPE_REGEX3, (match)=>$bdd5c91922f45546$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $bdd5c91922f45546$var$createServerHandoffString(serverHandoff) {
    return $bdd5c91922f45546$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $bdd5c91922f45546$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $bdd5c91922f45546$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$bdd5c91922f45546$var$globalDevServerHooksKey] = devServerHooks;
}
function $bdd5c91922f45546$var$getDevServerHooks() {
    return globalThis[$bdd5c91922f45546$var$globalDevServerHooksKey];
}
function $bdd5c91922f45546$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $bdd5c91922f45546$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $bdd5c91922f45546$var$prependCookies(errorHeaders, headers2);
            $bdd5c91922f45546$var$prependCookies(actionHeaders, headers2);
            $bdd5c91922f45546$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $bdd5c91922f45546$var$prependCookies(errorHeaders, headers);
        $bdd5c91922f45546$var$prependCookies(actionHeaders, headers);
        $bdd5c91922f45546$var$prependCookies(loaderHeaders, headers);
        $bdd5c91922f45546$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $bdd5c91922f45546$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $d5a8529af310c2d4$exports.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $bdd5c91922f45546$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $bdd5c91922f45546$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $bdd5c91922f45546$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($bdd5c91922f45546$var$isResponse(result)) return {
            result: $bdd5c91922f45546$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $bdd5c91922f45546$var$getDocumentHeaders(build, context);
        if ($bdd5c91922f45546$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $bdd5c91922f45546$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$bdd5c91922f45546$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $bdd5c91922f45546$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $bdd5c91922f45546$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $bdd5c91922f45546$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($bdd5c91922f45546$var$isResponse(result)) return {
            result: {
                [$bdd5c91922f45546$export$60644022b8b46aaa]: $bdd5c91922f45546$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $bdd5c91922f45546$var$getDocumentHeaders(build, context);
        if ($bdd5c91922f45546$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$bdd5c91922f45546$export$60644022b8b46aaa]: $bdd5c91922f45546$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$bdd5c91922f45546$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $bdd5c91922f45546$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $bdd5c91922f45546$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $bdd5c91922f45546$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $bdd5c91922f45546$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $3caee95e8f5bb11a$exports.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $bdd5c91922f45546$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $bdd5c91922f45546$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $bdd5c91922f45546$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$bdd5c91922f45546$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $bdd5c91922f45546$var$derive(build, mode) {
    let routes = $bdd5c91922f45546$var$createRoutes(build.routes);
    let dataRoutes = $bdd5c91922f45546$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $bdd5c91922f45546$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $bdd5c91922f45546$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $bdd5c91922f45546$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $bdd5c91922f45546$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $bdd5c91922f45546$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $bdd5c91922f45546$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $bdd5c91922f45546$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $bdd5c91922f45546$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $bdd5c91922f45546$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = $bdd5c91922f45546$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $bdd5c91922f45546$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($bdd5c91922f45546$var$isRedirectResponse(response)) {
                    let result = $bdd5c91922f45546$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$bdd5c91922f45546$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($bdd5c91922f45546$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $bdd5c91922f45546$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $bdd5c91922f45546$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $bdd5c91922f45546$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $bdd5c91922f45546$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $bdd5c91922f45546$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $bdd5c91922f45546$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $bdd5c91922f45546$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $bdd5c91922f45546$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $bdd5c91922f45546$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($bdd5c91922f45546$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $bdd5c91922f45546$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($bdd5c91922f45546$var$isResponse(context)) return context;
    let headers = $bdd5c91922f45546$var$getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$bdd5c91922f45546$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $bdd5c91922f45546$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $bdd5c91922f45546$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $bdd5c91922f45546$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $bdd5c91922f45546$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: $bdd5c91922f45546$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>$bdd5c91922f45546$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($bdd5c91922f45546$var$isResponse(error)) try {
            let data2 = await $bdd5c91922f45546$var$unwrapResponse(error);
            errorForSecondRender = new $bdd5c91922f45546$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $bdd5c91922f45546$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $bdd5c91922f45546$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $bdd5c91922f45546$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $bdd5c91922f45546$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: $bdd5c91922f45546$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $bdd5c91922f45546$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $bdd5c91922f45546$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        $bdd5c91922f45546$var$invariant3($bdd5c91922f45546$var$isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if ($bdd5c91922f45546$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($bdd5c91922f45546$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $bdd5c91922f45546$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $bdd5c91922f45546$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $bdd5c91922f45546$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($bdd5c91922f45546$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $bdd5c91922f45546$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $bdd5c91922f45546$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $bdd5c91922f45546$var$flash(name) {
    return `__flash_${name}__`;
}
var $bdd5c91922f45546$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($bdd5c91922f45546$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $bdd5c91922f45546$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($bdd5c91922f45546$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $bdd5c91922f45546$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $bdd5c91922f45546$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $bdd5c91922f45546$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $bdd5c91922f45546$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $bdd5c91922f45546$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $bdd5c91922f45546$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $bdd5c91922f45546$var$warnOnceAboutSigningSessionCookie(cookie) {
    $bdd5c91922f45546$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $bdd5c91922f45546$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $bdd5c91922f45546$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $bdd5c91922f45546$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $bdd5c91922f45546$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $bdd5c91922f45546$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $bdd5c91922f45546$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $bdd5c91922f45546$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function $bdd5c91922f45546$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $bdd5c91922f45546$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");
var $f48cbf5a79e3fcf4$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $f48cbf5a79e3fcf4$export$18a094aefa070634 = (obj, member, getter)=>{
    $f48cbf5a79e3fcf4$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $f48cbf5a79e3fcf4$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $f48cbf5a79e3fcf4$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $f48cbf5a79e3fcf4$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $f48cbf5a79e3fcf4$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $f48cbf5a79e3fcf4$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $f48cbf5a79e3fcf4$export$18a094aefa070634(obj, member, getter);
        }
    });
var $f48cbf5a79e3fcf4$export$fa92d15b718fce20 = (obj, member, method)=>{
    $f48cbf5a79e3fcf4$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $66d37cb3d8195cdd$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $66d37cb3d8195cdd$export$8793edee2d425525() {
    return void 0;
}
function $66d37cb3d8195cdd$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $66d37cb3d8195cdd$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $66d37cb3d8195cdd$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $66d37cb3d8195cdd$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $66d37cb3d8195cdd$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $66d37cb3d8195cdd$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $66d37cb3d8195cdd$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$66d37cb3d8195cdd$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $66d37cb3d8195cdd$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($66d37cb3d8195cdd$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $66d37cb3d8195cdd$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$66d37cb3d8195cdd$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $66d37cb3d8195cdd$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $66d37cb3d8195cdd$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $66d37cb3d8195cdd$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$66d37cb3d8195cdd$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $66d37cb3d8195cdd$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$66d37cb3d8195cdd$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $66d37cb3d8195cdd$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $66d37cb3d8195cdd$export$7a8558113332b71e(a) && $66d37cb3d8195cdd$export$7a8558113332b71e(b);
    if (array || $66d37cb3d8195cdd$export$53b83ca8eaab0383(a) && $66d37cb3d8195cdd$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $66d37cb3d8195cdd$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $66d37cb3d8195cdd$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $66d37cb3d8195cdd$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $66d37cb3d8195cdd$export$53b83ca8eaab0383(o) {
    if (!$66d37cb3d8195cdd$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$66d37cb3d8195cdd$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $66d37cb3d8195cdd$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $66d37cb3d8195cdd$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $66d37cb3d8195cdd$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $66d37cb3d8195cdd$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $66d37cb3d8195cdd$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $66d37cb3d8195cdd$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $66d37cb3d8195cdd$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $66d37cb3d8195cdd$export$1aa5a89531b7670d = Symbol();
function $66d37cb3d8195cdd$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $66d37cb3d8195cdd$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}







// src/notifyManager.ts
function $5f301ba98937b677$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $5f301ba98937b677$export$520687f44db6e1ab = $5f301ba98937b677$export$316a8efd03cd1458();





// src/subscribable.ts
var $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $1e6dc4a1c9ba3fa2$var$_focused, $1e6dc4a1c9ba3fa2$var$_cleanup, $1e6dc4a1c9ba3fa2$var$_setup;
var $1e6dc4a1c9ba3fa2$export$86f1af424b2ca4de = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $1e6dc4a1c9ba3fa2$var$_focused, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $1e6dc4a1c9ba3fa2$var$_cleanup, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $1e6dc4a1c9ba3fa2$var$_setup, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $1e6dc4a1c9ba3fa2$var$_setup, (onFocus)=>{
            if (!(0, $66d37cb3d8195cdd$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_cleanup)) this.setEventListener((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_cleanup)) == null || _a.call(this);
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $1e6dc4a1c9ba3fa2$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $1e6dc4a1c9ba3fa2$var$_setup, setup);
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_cleanup)) == null || _a.call(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $1e6dc4a1c9ba3fa2$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_focused) !== focused;
        if (changed) {
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $1e6dc4a1c9ba3fa2$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_focused) === "boolean") return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $1e6dc4a1c9ba3fa2$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1e6dc4a1c9ba3fa2$var$_focused = new WeakMap();
$1e6dc4a1c9ba3fa2$var$_cleanup = new WeakMap();
$1e6dc4a1c9ba3fa2$var$_setup = new WeakMap();
var $1e6dc4a1c9ba3fa2$export$6bf54661be5b02cf = new $1e6dc4a1c9ba3fa2$export$86f1af424b2ca4de();





var $7221da7d70dd3c1e$var$_online, $7221da7d70dd3c1e$var$_cleanup, $7221da7d70dd3c1e$var$_setup;
var $7221da7d70dd3c1e$export$58774fb55d5ff7fc = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $7221da7d70dd3c1e$var$_online, true);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $7221da7d70dd3c1e$var$_cleanup, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $7221da7d70dd3c1e$var$_setup, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $7221da7d70dd3c1e$var$_setup, (onOnline)=>{
            if (!(0, $66d37cb3d8195cdd$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_cleanup)) this.setEventListener((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_cleanup)) == null || _a.call(this);
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $7221da7d70dd3c1e$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $7221da7d70dd3c1e$var$_setup, setup);
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_cleanup)) == null || _a.call(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $7221da7d70dd3c1e$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_online) !== online;
        if (changed) {
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $7221da7d70dd3c1e$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $7221da7d70dd3c1e$var$_online);
    }
};
$7221da7d70dd3c1e$var$_online = new WeakMap();
$7221da7d70dd3c1e$var$_cleanup = new WeakMap();
$7221da7d70dd3c1e$var$_setup = new WeakMap();
var $7221da7d70dd3c1e$export$b113e788b2dd3fdc = new $7221da7d70dd3c1e$export$58774fb55d5ff7fc();



function $72f27ffb3a4d5a33$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $72f27ffb3a4d5a33$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $7221da7d70dd3c1e$export$b113e788b2dd3fdc).isOnline() : true;
}
var $72f27ffb3a4d5a33$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $72f27ffb3a4d5a33$export$986cc6445c1d323(value) {
    return value instanceof $72f27ffb3a4d5a33$export$a8430ed4188f35a9;
}
function $72f27ffb3a4d5a33$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $72f27ffb3a4d5a33$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $1e6dc4a1c9ba3fa2$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $7221da7d70dd3c1e$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$72f27ffb3a4d5a33$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $66d37cb3d8195cdd$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $72f27ffb3a4d5a33$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $66d37cb3d8195cdd$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}




var $463173508d7b2517$var$_gcTimeout;
var $463173508d7b2517$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $463173508d7b2517$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $66d37cb3d8195cdd$export$e539f754e934e270)(this.gcTime)) (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $463173508d7b2517$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $66d37cb3d8195cdd$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $463173508d7b2517$var$_gcTimeout)) {
            clearTimeout((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $463173508d7b2517$var$_gcTimeout));
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $463173508d7b2517$var$_gcTimeout, void 0);
        }
    }
};
$463173508d7b2517$var$_gcTimeout = new WeakMap();


var $b96cec5c826539f2$var$_initialState, $b96cec5c826539f2$var$_revertState, $b96cec5c826539f2$var$_cache, $b96cec5c826539f2$var$_retryer, $b96cec5c826539f2$var$_defaultOptions, $b96cec5c826539f2$var$_abortSignalConsumed, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn;
var $b96cec5c826539f2$export$62297b13309008b2 = class extends (0, $463173508d7b2517$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_dispatch);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_initialState, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_revertState, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_cache, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_retryer, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_defaultOptions, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $b96cec5c826539f2$var$_abortSignalConsumed, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_abortSignalConsumed, false);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_initialState, $b96cec5c826539f2$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $66d37cb3d8195cdd$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $66d37cb3d8195cdd$export$8793edee2d425525)).catch((0, $66d37cb3d8195cdd$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $66d37cb3d8195cdd$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) {
                    if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_abortSignalConsumed)) (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer)) {
                (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer).continueRetry();
                return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $66d37cb3d8195cdd$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $72f27ffb3a4d5a33$export$986cc6445c1d323)(error) && error.silent)) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $72f27ffb3a4d5a33$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $b96cec5c826539f2$var$_retryer, (0, $72f27ffb3a4d5a33$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $b96cec5c826539f2$var$_dispatch, $b96cec5c826539f2$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_retryer).start();
    }
};
$b96cec5c826539f2$var$_initialState = new WeakMap();
$b96cec5c826539f2$var$_revertState = new WeakMap();
$b96cec5c826539f2$var$_cache = new WeakMap();
$b96cec5c826539f2$var$_retryer = new WeakMap();
$b96cec5c826539f2$var$_defaultOptions = new WeakMap();
$b96cec5c826539f2$var$_abortSignalConsumed = new WeakMap();
$b96cec5c826539f2$var$_dispatch = new WeakSet();
$b96cec5c826539f2$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$b96cec5c826539f2$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $72f27ffb3a4d5a33$export$986cc6445c1d323)(error) && error.revert && (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_revertState)) return {
                    ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $b96cec5c826539f2$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $b96cec5c826539f2$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $72f27ffb3a4d5a33$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $b96cec5c826539f2$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $dd9d44869d937016$var$_queries;
var $dd9d44869d937016$export$5dde0cd941da8468 = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $dd9d44869d937016$var$_queries, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $dd9d44869d937016$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $66d37cb3d8195cdd$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $b96cec5c826539f2$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).has(query.queryHash)) {
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $dd9d44869d937016$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $66d37cb3d8195cdd$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $66d37cb3d8195cdd$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$dd9d44869d937016$var$_queries = new WeakMap();








var $4d43d2ef3a97bc05$var$_observers, $4d43d2ef3a97bc05$var$_mutationCache, $4d43d2ef3a97bc05$var$_retryer, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn;
var $4d43d2ef3a97bc05$export$17b8b19c814bcf56 = class extends (0, $463173508d7b2517$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $4d43d2ef3a97bc05$var$_dispatch);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $4d43d2ef3a97bc05$var$_observers, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $4d43d2ef3a97bc05$var$_mutationCache, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $4d43d2ef3a97bc05$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $4d43d2ef3a97bc05$var$_mutationCache, config.mutationCache);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $4d43d2ef3a97bc05$var$_observers, []);
        this.state = config.state || $4d43d2ef3a97bc05$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_observers).includes(observer)) {
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $4d43d2ef3a97bc05$var$_observers, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $4d43d2ef3a97bc05$var$_retryer, (0, $72f27ffb3a4d5a33$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_retryer).start();
            await ((_f = (_e = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $4d43d2ef3a97bc05$var$_dispatch, $4d43d2ef3a97bc05$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).runNext(this);
        }
    }
};
$4d43d2ef3a97bc05$var$_observers = new WeakMap();
$4d43d2ef3a97bc05$var$_mutationCache = new WeakMap();
$4d43d2ef3a97bc05$var$_retryer = new WeakMap();
$4d43d2ef3a97bc05$var$_dispatch = new WeakSet();
$4d43d2ef3a97bc05$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $4d43d2ef3a97bc05$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $4d43d2ef3a97bc05$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $21443f5cebfb06d2$var$_mutations, $21443f5cebfb06d2$var$_mutationId;
var $21443f5cebfb06d2$export$1fcfd9a244434844 = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $21443f5cebfb06d2$var$_mutations, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $21443f5cebfb06d2$var$_mutationId, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $21443f5cebfb06d2$var$_mutations, /* @__PURE__ */ new Map());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $21443f5cebfb06d2$var$_mutationId, Date.now());
    }
    build(client, options, state) {
        const mutation = new (0, $4d43d2ef3a97bc05$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $f48cbf5a79e3fcf4$export$b1fe7cbb4502036b)(this, $21443f5cebfb06d2$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $21443f5cebfb06d2$var$scopeFor(mutation);
        const mutations = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).get(scope) ?? [];
        mutations.push(mutation);
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        var _a;
        const scope = $21443f5cebfb06d2$var$scopeFor(mutation);
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).has(scope)) {
            const mutations = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).get(scope)) == null ? void 0 : _a.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).delete(scope);
                else (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        var _a;
        const firstPendingMutation = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).get($21443f5cebfb06d2$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        var _a;
        const foundMutation = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).get($21443f5cebfb06d2$var$scopeFor(mutation))) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
        return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    }
    clear() {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $21443f5cebfb06d2$var$_mutations).values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $66d37cb3d8195cdd$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $66d37cb3d8195cdd$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $66d37cb3d8195cdd$export$8793edee2d425525)))));
    }
};
$21443f5cebfb06d2$var$_mutations = new WeakMap();
$21443f5cebfb06d2$var$_mutationId = new WeakMap();
function $21443f5cebfb06d2$var$scopeFor(mutation) {
    var _a;
    return ((_a = mutation.options.scope) == null ? void 0 : _a.id) ?? String(mutation.mutationId);
}







function $af5126d6c99fd45b$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $66d37cb3d8195cdd$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $66d37cb3d8195cdd$export$8c6246b73dd61f4a) : (0, $66d37cb3d8195cdd$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $af5126d6c99fd45b$var$getPreviousPageParam : $af5126d6c99fd45b$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $af5126d6c99fd45b$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $af5126d6c99fd45b$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $af5126d6c99fd45b$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $af5126d6c99fd45b$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $af5126d6c99fd45b$var$getNextPageParam(options, data) != null;
}
function $af5126d6c99fd45b$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $af5126d6c99fd45b$var$getPreviousPageParam(options, data) != null;
}


var $217e29d78e49d51a$var$_queryCache, $217e29d78e49d51a$var$_mutationCache, $217e29d78e49d51a$var$_defaultOptions, $217e29d78e49d51a$var$_queryDefaults, $217e29d78e49d51a$var$_mutationDefaults, $217e29d78e49d51a$var$_mountCount, $217e29d78e49d51a$var$_unsubscribeFocus, $217e29d78e49d51a$var$_unsubscribeOnline;
var $217e29d78e49d51a$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_queryCache, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_mutationCache, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_defaultOptions, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_queryDefaults, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_mutationDefaults, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_mountCount, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_unsubscribeFocus, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $217e29d78e49d51a$var$_unsubscribeOnline, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_queryCache, config.queryCache || new (0, $dd9d44869d937016$export$5dde0cd941da8468)());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_mutationCache, config.mutationCache || new (0, $21443f5cebfb06d2$export$1fcfd9a244434844)());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_defaultOptions, config.defaultOptions || {});
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_mountCount, 0);
    }
    mount() {
        (0, $f48cbf5a79e3fcf4$export$b1fe7cbb4502036b)(this, $217e29d78e49d51a$var$_mountCount)._++;
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mountCount) !== 1) return;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_unsubscribeFocus, (0, $1e6dc4a1c9ba3fa2$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).onFocus();
            }
        }));
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_unsubscribeOnline, (0, $7221da7d70dd3c1e$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $f48cbf5a79e3fcf4$export$b1fe7cbb4502036b)(this, $217e29d78e49d51a$var$_mountCount)._--;
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mountCount) !== 0) return;
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_unsubscribeFocus, void 0);
        (_b = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime((0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $66d37cb3d8195cdd$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache);
        (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $66d37cb3d8195cdd$export$8793edee2d425525)).catch((0, $66d37cb3d8195cdd$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $66d37cb3d8195cdd$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $66d37cb3d8195cdd$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $66d37cb3d8195cdd$export$8793edee2d425525)).catch((0, $66d37cb3d8195cdd$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $af5126d6c99fd45b$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $66d37cb3d8195cdd$export$8793edee2d425525)).catch((0, $66d37cb3d8195cdd$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $af5126d6c99fd45b$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $7221da7d70dd3c1e$export$b113e788b2dd3fdc).isOnline()) return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache);
    }
    getMutationCache() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $217e29d78e49d51a$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryDefaults).set((0, $66d37cb3d8195cdd$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $66d37cb3d8195cdd$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationDefaults).set((0, $66d37cb3d8195cdd$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $66d37cb3d8195cdd$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $66d37cb3d8195cdd$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $66d37cb3d8195cdd$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_queryCache).clear();
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $217e29d78e49d51a$var$_mutationCache).clear();
    }
};
$217e29d78e49d51a$var$_queryCache = new WeakMap();
$217e29d78e49d51a$var$_mutationCache = new WeakMap();
$217e29d78e49d51a$var$_defaultOptions = new WeakMap();
$217e29d78e49d51a$var$_queryDefaults = new WeakMap();
$217e29d78e49d51a$var$_mutationDefaults = new WeakMap();
$217e29d78e49d51a$var$_mountCount = new WeakMap();
$217e29d78e49d51a$var$_unsubscribeFocus = new WeakMap();
$217e29d78e49d51a$var$_unsubscribeOnline = new WeakMap();


var $aqdBs = parcelRequire("aqdBs");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $da27b542cb58aea7$export$da112d31b0149f31 = $aqdBs.createContext(void 0);
var $da27b542cb58aea7$export$22e77b9572c4fded = (queryClient)=>{
    const client = $aqdBs.useContext($da27b542cb58aea7$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $da27b542cb58aea7$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $aqdBs.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $1Ivrw.jsx)($da27b542cb58aea7$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $172d8be976204b2c$var$extendStatics = function(d, b) {
    $172d8be976204b2c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $172d8be976204b2c$var$extendStatics(d, b);
};
function $172d8be976204b2c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $172d8be976204b2c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $172d8be976204b2c$export$18ce0697a983be9b = function() {
    $172d8be976204b2c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $172d8be976204b2c$export$18ce0697a983be9b.apply(this, arguments);
};
function $172d8be976204b2c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $172d8be976204b2c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $172d8be976204b2c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $172d8be976204b2c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $172d8be976204b2c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $172d8be976204b2c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $172d8be976204b2c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $172d8be976204b2c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $172d8be976204b2c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $172d8be976204b2c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $172d8be976204b2c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $172d8be976204b2c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $172d8be976204b2c$export$45d3717a4c69092e(o, m, p);
}
function $172d8be976204b2c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $172d8be976204b2c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $172d8be976204b2c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($172d8be976204b2c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $172d8be976204b2c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $172d8be976204b2c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $172d8be976204b2c$export$10c90e4f7922046c(v) {
    return this instanceof $172d8be976204b2c$export$10c90e4f7922046c ? (this.v = v, this) : new $172d8be976204b2c$export$10c90e4f7922046c(v);
}
function $172d8be976204b2c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $172d8be976204b2c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $172d8be976204b2c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $172d8be976204b2c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $172d8be976204b2c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $172d8be976204b2c$export$19a8beecd37a4c45 === "function" ? $172d8be976204b2c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $172d8be976204b2c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $172d8be976204b2c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $172d8be976204b2c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $172d8be976204b2c$export$45d3717a4c69092e(result, mod, k);
    }
    $172d8be976204b2c$var$__setModuleDefault(result, mod);
    return result;
}
function $172d8be976204b2c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $172d8be976204b2c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $172d8be976204b2c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $172d8be976204b2c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $172d8be976204b2c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $172d8be976204b2c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $172d8be976204b2c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $172d8be976204b2c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $172d8be976204b2c$export$2e2bcd8739ae039 = {
    __extends: $172d8be976204b2c$export$a8ba968b8961cb8a,
    __assign: $172d8be976204b2c$export$18ce0697a983be9b,
    __rest: $172d8be976204b2c$export$3c9a16f847548506,
    __decorate: $172d8be976204b2c$export$29e00dfd3077644b,
    __param: $172d8be976204b2c$export$d5ad3fd78186038f,
    __metadata: $172d8be976204b2c$export$f1db080c865becb9,
    __awaiter: $172d8be976204b2c$export$1050f835b63b671e,
    __generator: $172d8be976204b2c$export$67ebef60e6f28a6,
    __createBinding: $172d8be976204b2c$export$45d3717a4c69092e,
    __exportStar: $172d8be976204b2c$export$f33643c0debef087,
    __values: $172d8be976204b2c$export$19a8beecd37a4c45,
    __read: $172d8be976204b2c$export$8d051b38c9118094,
    __spread: $172d8be976204b2c$export$afc72e2116322959,
    __spreadArrays: $172d8be976204b2c$export$6388937ca91ccae8,
    __spreadArray: $172d8be976204b2c$export$1216008129fb82ed,
    __await: $172d8be976204b2c$export$10c90e4f7922046c,
    __asyncGenerator: $172d8be976204b2c$export$e427f37a30a4de9b,
    __asyncDelegator: $172d8be976204b2c$export$bbd80228419bb833,
    __asyncValues: $172d8be976204b2c$export$e3b29a3d6162315f,
    __makeTemplateObject: $172d8be976204b2c$export$4fb47efe1390b86f,
    __importStar: $172d8be976204b2c$export$c21735bcef00d192,
    __importDefault: $172d8be976204b2c$export$da59b14a69baef04,
    __classPrivateFieldGet: $172d8be976204b2c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $172d8be976204b2c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $172d8be976204b2c$export$81fdc39f203e4e04,
    __addDisposableResource: $172d8be976204b2c$export$88ac25d8e944e405,
    __disposeResources: $172d8be976204b2c$export$8f076105dc360e92
};



//
// Main
//
function $c0efcad3d117c949$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c0efcad3d117c949$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c0efcad3d117c949$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c0efcad3d117c949$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c0efcad3d117c949$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c0efcad3d117c949$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c0efcad3d117c949$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c0efcad3d117c949$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c0efcad3d117c949$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c0efcad3d117c949$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c0efcad3d117c949$var$monadic : $c0efcad3d117c949$var$variadic;
    return $c0efcad3d117c949$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c0efcad3d117c949$var$strategyVariadic(fn, options) {
    return $c0efcad3d117c949$var$assemble(fn, this, $c0efcad3d117c949$var$variadic, options.cache.create(), options.serializer);
}
function $c0efcad3d117c949$var$strategyMonadic(fn, options) {
    return $c0efcad3d117c949$var$assemble(fn, this, $c0efcad3d117c949$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c0efcad3d117c949$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c0efcad3d117c949$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c0efcad3d117c949$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c0efcad3d117c949$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c0efcad3d117c949$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c0efcad3d117c949$var$ObjectWithoutPrototypeCache();
    }
};
var $c0efcad3d117c949$export$c5491a8691a23b9e = {
    variadic: $c0efcad3d117c949$var$strategyVariadic,
    monadic: $c0efcad3d117c949$var$strategyMonadic
};


var $d1afb162ccec23da$exports = {};

$parcel$defineInteropFlag($d1afb162ccec23da$exports);
$parcel$export($d1afb162ccec23da$exports, "ErrorCode", () => $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb);
$parcel$export($d1afb162ccec23da$exports, "FormatError", () => $090d13e3fbcbc25a$export$7369836851cc1329);
$parcel$export($d1afb162ccec23da$exports, "isFormatXMLElementFn", () => $b6000f41b8308671$export$df0c12a2d414a163);

$parcel$export($d1afb162ccec23da$exports, "IntlMessageFormat", () => $417e28b9308fe358$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 


var $89c8c3492420a2a1$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($89c8c3492420a2a1$export$896afd8541959ee5 || ($89c8c3492420a2a1$export$896afd8541959ee5 = {}));




var $29f71628b36435b8$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($29f71628b36435b8$export$b87f371cbc396fcf || ($29f71628b36435b8$export$b87f371cbc396fcf = {}));
var $29f71628b36435b8$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($29f71628b36435b8$export$906452485466fa53 || ($29f71628b36435b8$export$906452485466fa53 = {}));
function $29f71628b36435b8$export$cfa10c5697238752(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.literal;
}
function $29f71628b36435b8$export$4f55724281bdfaf9(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.argument;
}
function $29f71628b36435b8$export$e11187b219e191e1(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.number;
}
function $29f71628b36435b8$export$32d811605da75f40(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.date;
}
function $29f71628b36435b8$export$34ec46f596b1702f(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.time;
}
function $29f71628b36435b8$export$dcfe1c11d168b5a1(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.select;
}
function $29f71628b36435b8$export$6c796d116f0a4fbc(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.plural;
}
function $29f71628b36435b8$export$c0ece297bdd0c082(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.pound;
}
function $29f71628b36435b8$export$5c83de34745812b(el) {
    return el.type === $29f71628b36435b8$export$b87f371cbc396fcf.tag;
}
function $29f71628b36435b8$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $29f71628b36435b8$export$906452485466fa53.number);
}
function $29f71628b36435b8$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $29f71628b36435b8$export$906452485466fa53.dateTime);
}
function $29f71628b36435b8$export$f0ac572c1121c662(value) {
    return {
        type: $29f71628b36435b8$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $29f71628b36435b8$export$425e864b0ba114f1(value, style) {
    return {
        type: $29f71628b36435b8$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $e502fadc07dd3ca5$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $e502fadc07dd3ca5$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $25a23f9a8b6ca9ad$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $25a23f9a8b6ca9ad$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($25a23f9a8b6ca9ad$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}



// @generated from regex-gen.ts
var $83b8b6c3c847bff5$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $c7d90183e7bb4c46$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $83b8b6c3c847bff5$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $c7d90183e7bb4c46$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $c7d90183e7bb4c46$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $c7d90183e7bb4c46$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $c7d90183e7bb4c46$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $c7d90183e7bb4c46$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $c7d90183e7bb4c46$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($c7d90183e7bb4c46$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $c7d90183e7bb4c46$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $c7d90183e7bb4c46$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$c7d90183e7bb4c46$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $c7d90183e7bb4c46$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $c7d90183e7bb4c46$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $c7d90183e7bb4c46$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $c7d90183e7bb4c46$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, all), $c7d90183e7bb4c46$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, all), $c7d90183e7bb4c46$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($c7d90183e7bb4c46$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($c7d90183e7bb4c46$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($c7d90183e7bb4c46$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($c7d90183e7bb4c46$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), $c7d90183e7bb4c46$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($c7d90183e7bb4c46$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), $c7d90183e7bb4c46$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $c7d90183e7bb4c46$var$parseSign(token.stem);
        if (signOpts) result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $c7d90183e7bb4c46$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $3b31e4b617cb432b$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $30c7217b83da3e58$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $30c7217b83da3e58$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $30c7217b83da3e58$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $3b31e4b617cb432b$export$a8c9209db4084317)[regionTag || ""] || (0, $3b31e4b617cb432b$export$a8c9209db4084317)[languageTag || ""] || (0, $3b31e4b617cb432b$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $3b31e4b617cb432b$export$a8c9209db4084317)["001"];
    return hourCycles[0];
}


var $14597ce327ce1209$var$_a;
var $14597ce327ce1209$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $e502fadc07dd3ca5$export$523451f94304dd6c).source, "*"));
var $14597ce327ce1209$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $e502fadc07dd3ca5$export$523451f94304dd6c).source, "*$"));
function $14597ce327ce1209$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $14597ce327ce1209$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $14597ce327ce1209$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $14597ce327ce1209$var$hasNativeFromEntries = !!Object.fromEntries;
var $14597ce327ce1209$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $14597ce327ce1209$var$hasTrimStart = !!String.prototype.trimStart;
var $14597ce327ce1209$var$hasTrimEnd = !!String.prototype.trimEnd;
var $14597ce327ce1209$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $14597ce327ce1209$var$isSafeInteger = $14597ce327ce1209$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $14597ce327ce1209$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $14597ce327ce1209$var$re = $14597ce327ce1209$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $14597ce327ce1209$var$REGEX_SUPPORTS_U_AND_Y = (($14597ce327ce1209$var$_a = $14597ce327ce1209$var$re.exec("a")) === null || $14597ce327ce1209$var$_a === void 0 ? void 0 : $14597ce327ce1209$var$_a[0]) === "a";
} catch (_) {
    $14597ce327ce1209$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $14597ce327ce1209$var$startsWith = $14597ce327ce1209$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $14597ce327ce1209$var$fromCodePoint = $14597ce327ce1209$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $14597ce327ce1209$var$fromEntries = // native
$14597ce327ce1209$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $14597ce327ce1209$var$codePointAt = $14597ce327ce1209$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $14597ce327ce1209$var$trimStart = $14597ce327ce1209$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($14597ce327ce1209$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $14597ce327ce1209$var$trimEnd = $14597ce327ce1209$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($14597ce327ce1209$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $14597ce327ce1209$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $14597ce327ce1209$var$matchIdentifierAtIndex;
if ($14597ce327ce1209$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $14597ce327ce1209$var$IDENTIFIER_PREFIX_RE_1 = $14597ce327ce1209$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $14597ce327ce1209$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $14597ce327ce1209$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $14597ce327ce1209$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$14597ce327ce1209$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $14597ce327ce1209$var$codePointAt(s, index);
        if (c === undefined || $14597ce327ce1209$var$_isWhiteSpace(c) || $14597ce327ce1209$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $14597ce327ce1209$var$fromCodePoint.apply(void 0, match);
};
var $14597ce327ce1209$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).pound,
                    location: $14597ce327ce1209$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $14597ce327ce1209$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $14597ce327ce1209$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$14597ce327ce1209$var$_isAlpha(this.char())) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_TAG, $14597ce327ce1209$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $14597ce327ce1209$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_TAG, $14597ce327ce1209$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $14597ce327ce1209$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).UNCLOSED_TAG, $14597ce327ce1209$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_TAG, $14597ce327ce1209$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $14597ce327ce1209$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $14597ce327ce1209$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$14597ce327ce1209$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $14597ce327ce1209$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $14597ce327ce1209$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EMPTY_ARGUMENT, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).MALFORMED_ARGUMENT, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).MALFORMED_ARGUMENT, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $14597ce327ce1209$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $14597ce327ce1209$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $14597ce327ce1209$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $14597ce327ce1209$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $14597ce327ce1209$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $14597ce327ce1209$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $14597ce327ce1209$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $30c7217b83da3e58$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $29f71628b36435b8$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $25a23f9a8b6ca9ad$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $29f71628b36435b8$export$b87f371cbc396fcf).date : (0, $29f71628b36435b8$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $29f71628b36435b8$export$b87f371cbc396fcf).number : argType === "date" ? (0, $29f71628b36435b8$export$b87f371cbc396fcf).date : (0, $29f71628b36435b8$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $14597ce327ce1209$var$createLocation(typeEndPosition_1, (0, $172d8be976204b2c$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $14597ce327ce1209$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $29f71628b36435b8$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $14597ce327ce1209$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $14597ce327ce1209$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $14597ce327ce1209$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $c7d90183e7bb4c46$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $29f71628b36435b8$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $c7d90183e7bb4c46$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $89c8c3492420a2a1$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $14597ce327ce1209$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $89c8c3492420a2a1$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $89c8c3492420a2a1$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $14597ce327ce1209$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $89c8c3492420a2a1$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $89c8c3492420a2a1$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $14597ce327ce1209$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $14597ce327ce1209$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$14597ce327ce1209$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $14597ce327ce1209$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($14597ce327ce1209$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $14597ce327ce1209$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $14597ce327ce1209$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $14597ce327ce1209$var$_isAlphaOrSlash(codepoint) {
    return $14597ce327ce1209$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $14597ce327ce1209$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $14597ce327ce1209$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $14597ce327ce1209$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $b99f3e38b8b7796f$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $29f71628b36435b8$export$dcfe1c11d168b5a1)(el) || (0, $29f71628b36435b8$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b99f3e38b8b7796f$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $29f71628b36435b8$export$e11187b219e191e1)(el) && (0, $29f71628b36435b8$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $29f71628b36435b8$export$32d811605da75f40)(el) || (0, $29f71628b36435b8$export$34ec46f596b1702f)(el)) && (0, $29f71628b36435b8$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $29f71628b36435b8$export$5c83de34745812b)(el)) $b99f3e38b8b7796f$var$pruneLocation(el.children);
    });
}
function $b99f3e38b8b7796f$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $172d8be976204b2c$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $14597ce327ce1209$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $89c8c3492420a2a1$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b99f3e38b8b7796f$var$pruneLocation(result.val);
    return result.val;
}
var $b99f3e38b8b7796f$export$d3c1bfa0f7d806e9 = (0, $14597ce327ce1209$export$7acfa6ed01010e37);




var $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($090d13e3fbcbc25a$export$d4e71bc0b80dc0fb || ($090d13e3fbcbc25a$export$d4e71bc0b80dc0fb = {}));
var $090d13e3fbcbc25a$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $090d13e3fbcbc25a$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($090d13e3fbcbc25a$export$7369836851cc1329);
var $090d13e3fbcbc25a$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($090d13e3fbcbc25a$export$7369836851cc1329);
var $090d13e3fbcbc25a$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($090d13e3fbcbc25a$export$7369836851cc1329);


var $b6000f41b8308671$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($b6000f41b8308671$export$49694c2877b44c57 || ($b6000f41b8308671$export$49694c2877b44c57 = {}));
function $b6000f41b8308671$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $b6000f41b8308671$export$49694c2877b44c57.literal || part.type !== $b6000f41b8308671$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $b6000f41b8308671$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $b6000f41b8308671$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $29f71628b36435b8$export$cfa10c5697238752)(els[0])) return [
        {
            type: $b6000f41b8308671$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $29f71628b36435b8$export$cfa10c5697238752)(el)) {
            result.push({
                type: $b6000f41b8308671$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $29f71628b36435b8$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $b6000f41b8308671$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $090d13e3fbcbc25a$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $29f71628b36435b8$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $b6000f41b8308671$export$49694c2877b44c57.literal : $b6000f41b8308671$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $29f71628b36435b8$export$32d811605da75f40)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $29f71628b36435b8$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $b6000f41b8308671$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $29f71628b36435b8$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $29f71628b36435b8$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $b6000f41b8308671$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $29f71628b36435b8$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $29f71628b36435b8$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $b6000f41b8308671$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $29f71628b36435b8$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$b6000f41b8308671$export$df0c12a2d414a163(formatFn)) throw new (0, $090d13e3fbcbc25a$export$cbc0db47c750f7c9)(value_1, "function", originalMessage);
            var parts = $b6000f41b8308671$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $b6000f41b8308671$export$49694c2877b44c57.literal : $b6000f41b8308671$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $29f71628b36435b8$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $090d13e3fbcbc25a$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $b6000f41b8308671$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $29f71628b36435b8$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $090d13e3fbcbc25a$export$7369836851cc1329)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $090d13e3fbcbc25a$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $b6000f41b8308671$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $b6000f41b8308671$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $417e28b9308fe358$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $417e28b9308fe358$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $417e28b9308fe358$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $172d8be976204b2c$export$18ce0697a983be9b)({}, defaultConfig));
}
function $417e28b9308fe358$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $417e28b9308fe358$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $417e28b9308fe358$var$createFastMemoizeCache(cache.number),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $417e28b9308fe358$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $417e28b9308fe358$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        })
    };
}
var $417e28b9308fe358$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $b6000f41b8308671$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $b6000f41b8308671$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $172d8be976204b2c$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $417e28b9308fe358$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $417e28b9308fe358$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b99f3e38b8b7796f$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();




var $d1afb162ccec23da$export$2e2bcd8739ae039 = (0, $417e28b9308fe358$export$d342343268debc40);



var $6f564e5c46d9fb4b$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($6f564e5c46d9fb4b$export$557d6acb76e8a244 || ($6f564e5c46d9fb4b$export$557d6acb76e8a244 = {}));
var $6f564e5c46d9fb4b$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $6f564e5c46d9fb4b$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $6f564e5c46d9fb4b$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($6f564e5c46d9fb4b$export$c016d36112f6ddf8);
var $6f564e5c46d9fb4b$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $6f564e5c46d9fb4b$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($6f564e5c46d9fb4b$export$c016d36112f6ddf8);
var $6f564e5c46d9fb4b$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $6f564e5c46d9fb4b$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($6f564e5c46d9fb4b$export$c016d36112f6ddf8);
var $6f564e5c46d9fb4b$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $6f564e5c46d9fb4b$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($6f564e5c46d9fb4b$export$c016d36112f6ddf8);
var $6f564e5c46d9fb4b$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($6f564e5c46d9fb4b$export$e3b7eee1dbc44895);
var $6f564e5c46d9fb4b$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $6f564e5c46d9fb4b$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($6f564e5c46d9fb4b$export$c016d36112f6ddf8);


function $c226c69c2b65ed76$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $c226c69c2b65ed76$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $c226c69c2b65ed76$var$defaultErrorHandler = function(error) {};
var $c226c69c2b65ed76$var$defaultWarnHandler = function(warning) {};
var $c226c69c2b65ed76$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $c226c69c2b65ed76$var$defaultErrorHandler,
    onWarn: $c226c69c2b65ed76$var$defaultWarnHandler
};
function $c226c69c2b65ed76$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $c226c69c2b65ed76$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $c226c69c2b65ed76$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $c226c69c2b65ed76$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.number),
        strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $172d8be976204b2c$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $417e28b9308fe358$export$d342343268debc40)(message, locales, overrideFormats, (0, $172d8be976204b2c$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.message),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.list),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $c0efcad3d117c949$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $172d8be976204b2c$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $c226c69c2b65ed76$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $c0efcad3d117c949$export$c5491a8691a23b9e).variadic
        })
    };
}
function $c226c69c2b65ed76$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $6f564e5c46d9fb4b$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

function $d10f71186d2a040e$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $d10f71186d2a040e$export$45c4bbf6e55bba1f(intl) {
    $d10f71186d2a040e$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $d10f71186d2a040e$export$b52f8d6fc0d47415 = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, (0, $c226c69c2b65ed76$export$b52f8d6fc0d47415)), {
    textComponent: $aqdBs.Fragment
});
function $d10f71186d2a040e$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($aqdBs.Children.toArray(parts));
    };
}
function $d10f71186d2a040e$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}




var $4Djfw = parcelRequire("4Djfw");

var $aqdBs = parcelRequire("aqdBs");

function $3f9cd05dec716d3d$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $3f9cd05dec716d3d$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $aqdBs.createContext(null)) : $aqdBs.createContext(null);
var $3f9cd05dec716d3d$var$IntlConsumer = $3f9cd05dec716d3d$var$IntlContext.Consumer, $3f9cd05dec716d3d$var$IntlProvider = $3f9cd05dec716d3d$var$IntlContext.Provider;
var $3f9cd05dec716d3d$export$2881499e37b75b9a = $3f9cd05dec716d3d$var$IntlProvider;
var $3f9cd05dec716d3d$export$841858b892ce1f4c = $3f9cd05dec716d3d$var$IntlContext;
function $3f9cd05dec716d3d$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $aqdBs.createElement($3f9cd05dec716d3d$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $d10f71186d2a040e$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $aqdBs.createElement(WrappedComponent, (0, $172d8be976204b2c$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($3f9cd05dec716d3d$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(// @ts-expect-error
    $aqdBs.forwardRef(function(props, ref) {
        return $aqdBs.createElement(WithIntl, (0, $172d8be976204b2c$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(WithIntl, WrappedComponent);
}


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 




var $b3e40ee13e2dd0d7$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $b3e40ee13e2dd0d7$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $c226c69c2b65ed76$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $b3e40ee13e2dd0d7$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $b3e40ee13e2dd0d7$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3e40ee13e2dd0d7$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $b3e40ee13e2dd0d7$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3e40ee13e2dd0d7$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $b3e40ee13e2dd0d7$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $b3e40ee13e2dd0d7$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $b3e40ee13e2dd0d7$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3e40ee13e2dd0d7$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $b3e40ee13e2dd0d7$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3e40ee13e2dd0d7$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return [];
}





var $74651564494dea69$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $74651564494dea69$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $090d13e3fbcbc25a$export$7369836851cc1329)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $74651564494dea69$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting display name.", locale, e));
    }
}







var $0be4f77d45581727$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $0be4f77d45581727$var$now = Date.now();
function $0be4f77d45581727$var$generateToken(i) {
    return "".concat($0be4f77d45581727$var$now, "_").concat(i, "_").concat($0be4f77d45581727$var$now);
}
function $0be4f77d45581727$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $0be4f77d45581727$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $0be4f77d45581727$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $090d13e3fbcbc25a$export$7369836851cc1329)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $0be4f77d45581727$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $0be4f77d45581727$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}







function $e25af260fec857ca$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $172d8be976204b2c$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $e25af260fec857ca$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $e25af260fec857ca$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $417e28b9308fe358$export$d342343268debc40).formats;
    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $e25af260fec857ca$var$deepMergeOptions($e25af260fec857ca$var$setTimeZoneInOptions(mfFormats.date, timeZone), $e25af260fec857ca$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $e25af260fec857ca$var$deepMergeOptions($e25af260fec857ca$var$setTimeZoneInOptions(mfFormats.time, timeZone), $e25af260fec857ca$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $e25af260fec857ca$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $c226c69c2b65ed76$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $29f71628b36435b8$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $e25af260fec857ca$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $e25af260fec857ca$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $6f564e5c46d9fb4b$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $6f564e5c46d9fb4b$export$74a601a3d3f31621)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $172d8be976204b2c$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$74a601a3d3f31621)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$74a601a3d3f31621)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};




var $d0339ba0f14abda0$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    // ES2023 NumberFormat
    // @ts-expect-error: TypeScript doesn't know about this yet
    "trailingZeroDisplay",
    // @ts-expect-error: TypeScript doesn't know about this yet
    "roundingPriority",
    // @ts-expect-error: TypeScript doesn't know about this yet
    "roundingIncrement",
    // @ts-expect-error: TypeScript doesn't know about this yet
    "roundingMode"
];
function $d0339ba0f14abda0$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $c226c69c2b65ed76$export$4ee1db8ce44a209b)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $d0339ba0f14abda0$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $d0339ba0f14abda0$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d0339ba0f14abda0$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $d0339ba0f14abda0$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d0339ba0f14abda0$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return [];
}





var $9798810769aecc13$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $9798810769aecc13$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $090d13e3fbcbc25a$export$7369836851cc1329)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $9798810769aecc13$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting plural.", locale, e));
    }
    return "other";
}





var $2bc6a4bc2a3a37ba$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $2bc6a4bc2a3a37ba$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $c226c69c2b65ed76$export$4ee1db8ce44a209b)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $c226c69c2b65ed76$export$d697c39a2985a4c)(options, $2bc6a4bc2a3a37ba$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $2bc6a4bc2a3a37ba$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $090d13e3fbcbc25a$export$7369836851cc1329)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $090d13e3fbcbc25a$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $2bc6a4bc2a3a37ba$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $6f564e5c46d9fb4b$export$e3b7eee1dbc44895)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}



function $ece58f3eae898db5$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $ece58f3eae898db5$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $ece58f3eae898db5$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution');
}
function $ece58f3eae898db5$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $c226c69c2b65ed76$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, (0, $c226c69c2b65ed76$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $6f564e5c46d9fb4b$export$3ca04dd7fb305893)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6f564e5c46d9fb4b$export$c1eaf877d81384b6)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6f564e5c46d9fb4b$export$c1eaf877d81384b6)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details')));
    $ece58f3eae898db5$var$verifyConfigMessages(resolvedConfig);
    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $d0339ba0f14abda0$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $d0339ba0f14abda0$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $2bc6a4bc2a3a37ba$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $b3e40ee13e2dd0d7$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $b3e40ee13e2dd0d7$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $b3e40ee13e2dd0d7$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $b3e40ee13e2dd0d7$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $b3e40ee13e2dd0d7$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $9798810769aecc13$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $e25af260fec857ca$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $e25af260fec857ca$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $0be4f77d45581727$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $0be4f77d45581727$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $74651564494dea69$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}




var $aqdBs = parcelRequire("aqdBs");

function $d914b5491cab3391$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $b6000f41b8308671$export$df0c12a2d414a163)(v) ? (0, $d10f71186d2a040e$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $d914b5491cab3391$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $d914b5491cab3391$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $e25af260fec857ca$export$25868d1e8e76735f).apply(void 0, (0, $172d8be976204b2c$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $aqdBs.Children.toArray(chunks);
    return chunks;
};
var $d914b5491cab3391$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $172d8be976204b2c$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $d914b5491cab3391$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $ece58f3eae898db5$export$7e4cbedfdd7b4c0d)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, (0, $d10f71186d2a040e$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $172d8be976204b2c$export$18ce0697a983be9b)((0, $172d8be976204b2c$export$18ce0697a983be9b)({}, coreIntl), {
        formatMessage: $d914b5491cab3391$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $d914b5491cab3391$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};


function $3c16bc68840ca824$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $3c16bc68840ca824$var$IntlProvider = /** @class */ function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $c226c69c2b65ed76$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $d914b5491cab3391$export$7e4cbedfdd7b4c0d)($3c16bc68840ca824$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $3c16bc68840ca824$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $3c16bc68840ca824$var$processIntlConfig(props);
        if (!(0, $d10f71186d2a040e$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $d914b5491cab3391$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $d10f71186d2a040e$export$45c4bbf6e55bba1f)(this.state.intl);
        return $aqdBs.createElement((0, $3f9cd05dec716d3d$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $d10f71186d2a040e$export$b52f8d6fc0d47415);
    return IntlProvider;
}($aqdBs.PureComponent);
var $3c16bc68840ca824$export$2e2bcd8739ae039 = $3c16bc68840ca824$var$IntlProvider;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $63da19232827992a$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $63da19232827992a$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($63da19232827992a$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $63da19232827992a$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $63da19232827992a$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $40jPv = parcelRequire("40jPv");

var $aqdBs = parcelRequire("aqdBs");
function $af3b9cb46350c6ee$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $aqdBs.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $2d63bff2d84de95e$export$2e2bcd8739ae039 = (0, $af3b9cb46350c6ee$export$2e2bcd8739ae039);



var $aqdBs = parcelRequire("aqdBs");
/**
 * @ignore - internal component.
 */ const $0bd1617b338bed15$var$FormControlContext = /*#__PURE__*/ $aqdBs.createContext(undefined);
var $0bd1617b338bed15$export$2e2bcd8739ae039 = $0bd1617b338bed15$var$FormControlContext;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $cff963e707701b7a$export$149c8b8bab2289d1(slot) {
    return (0, $igOtJ.default)("MuiFormControl", slot);
}
const $cff963e707701b7a$var$formControlClasses = (0, $jIPNy.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $cff963e707701b7a$export$2e2bcd8739ae039 = $cff963e707701b7a$var$formControlClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $4ea6f68cc48b79d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $40jPv.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $cff963e707701b7a$export$149c8b8bab2289d1), classes);
};
const $4ea6f68cc48b79d3$var$FormControlRoot = (0, $6JVXO.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return {
            ...styles.root,
            ...styles[`margin${(0, $40jPv.default)(ownerState.margin)}`],
            ...ownerState.fullWidth && styles.fullWidth
        };
    }
})({
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top",
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: "normal"
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: "dense"
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $4ea6f68cc48b79d3$var$FormControl = /*#__PURE__*/ $aqdBs.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $4ea6f68cc48b79d3$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $aqdBs.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $aqdBs.Children.forEach(children, (child)=>{
            if (!(0, $2d63bff2d84de95e$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $2d63bff2d84de95e$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $63da19232827992a$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $aqdBs.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $aqdBs.Children.forEach(children, (child)=>{
            if (!(0, $2d63bff2d84de95e$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $63da19232827992a$export$d652b828d7fdeff8)(child.props, true) || (0, $63da19232827992a$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $aqdBs.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $aqdBs.useRef(false);
    const childContext = $aqdBs.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $0bd1617b338bed15$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($4ea6f68cc48b79d3$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $fQojQ.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $4ea6f68cc48b79d3$export$2e2bcd8739ae039 = $4ea6f68cc48b79d3$var$FormControl;


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");

var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $aqdBs = parcelRequire("aqdBs");
"use client";
/**
 * @ignore - internal component.
 */ const $5fb826b9df292b71$var$ListContext = /*#__PURE__*/ $aqdBs.createContext({});
var $5fb826b9df292b71$export$2e2bcd8739ae039 = $5fb826b9df292b71$var$ListContext;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");



var $5ylSM = parcelRequire("5ylSM");
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $b21c773ae1c18b82$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(":focus-visible");
    } catch (error) {}
    return false;
}



var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");

var $aqdBs = parcelRequire("aqdBs");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $efb6cfe1f6c0a8d7$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $4a1f2448cbd5074a$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $aqdBs.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $efb6cfe1f6c0a8d7$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $e2928a743af788d2$export$2e2bcd8739ae039 = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039);



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $35a0d5759101fc88$var$useEnhancedEffect = typeof window !== "undefined" ? $aqdBs.useLayoutEffect : $aqdBs.useEffect;
var $35a0d5759101fc88$export$2e2bcd8739ae039 = $35a0d5759101fc88$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $051bb790d9c06a84$var$useEventCallback(fn) {
    const ref = $aqdBs.useRef(fn);
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $aqdBs.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $051bb790d9c06a84$export$2e2bcd8739ae039 = $051bb790d9c06a84$var$useEventCallback;


"use client";
var $4963f8336749096a$export$2e2bcd8739ae039 = (0, $051bb790d9c06a84$export$2e2bcd8739ae039);



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
"use client";
const $b4146ec3ac868fb7$var$UNINITIALIZED = {};
function $b4146ec3ac868fb7$export$2e2bcd8739ae039(init, initArg) {
    const ref = $aqdBs.useRef($b4146ec3ac868fb7$var$UNINITIALIZED);
    if (ref.current === $b4146ec3ac868fb7$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


"use client";
class $acb7a73a2d071eaa$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $acb7a73a2d071eaa$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $b4146ec3ac868fb7$export$2e2bcd8739ae039)($acb7a73a2d071eaa$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $aqdBs.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $aqdBs.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $acb7a73a2d071eaa$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $acb7a73a2d071eaa$export$2e2bcd8739ae039() {
    return $acb7a73a2d071eaa$export$f5de0641c7db4154.use();
}
function $acb7a73a2d071eaa$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $aqdBs = parcelRequire("aqdBs");

function $4d44d0dfc06e7f09$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $lmT1h = parcelRequire("lmT1h");
function $9bb33f3f4e416bf4$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $1d87b1b1ec46e83f$export$2e2bcd8739ae039(t, e) {
    return $1d87b1b1ec46e83f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $1d87b1b1ec46e83f$export$2e2bcd8739ae039(t, e);
}


function $80ee30fc473fbc65$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $1d87b1b1ec46e83f$export$2e2bcd8739ae039)(t, o);
}




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
var $e478f5f5f9961ba0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(null);



var $aqdBs = parcelRequire("aqdBs");
function $80cd014e807a7d32$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $aqdBs.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $aqdBs.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $80cd014e807a7d32$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $80cd014e807a7d32$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $80cd014e807a7d32$export$fa71e2345c31d7a2(props, onExited) {
    return $80cd014e807a7d32$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $aqdBs.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $80cd014e807a7d32$var$getProp(child, "appear", props),
            enter: $80cd014e807a7d32$var$getProp(child, "enter", props),
            exit: $80cd014e807a7d32$var$getProp(child, "exit", props)
        });
    });
}
function $80cd014e807a7d32$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $80cd014e807a7d32$export$bbc8a025727ea824(nextProps.children);
    var children = $80cd014e807a7d32$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $aqdBs.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $aqdBs.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $aqdBs.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $80cd014e807a7d32$var$getProp(child, "exit", nextProps),
            enter: $80cd014e807a7d32$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $aqdBs.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $aqdBs.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $aqdBs.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $80cd014e807a7d32$var$getProp(child, "exit", nextProps),
            enter: $80cd014e807a7d32$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $135cd7b6bdc7f5bc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $135cd7b6bdc7f5bc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $135cd7b6bdc7f5bc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $80ee30fc473fbc65$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $9bb33f3f4e416bf4$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $80cd014e807a7d32$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $80cd014e807a7d32$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $80cd014e807a7d32$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $lmT1h.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4d44d0dfc06e7f09$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $135cd7b6bdc7f5bc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e478f5f5f9961ba0$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e478f5f5f9961ba0$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Component);
$135cd7b6bdc7f5bc$var$TransitionGroup.propTypes = {};
$135cd7b6bdc7f5bc$var$TransitionGroup.defaultProps = $135cd7b6bdc7f5bc$var$defaultProps;
var $135cd7b6bdc7f5bc$export$2e2bcd8739ae039 = $135cd7b6bdc7f5bc$var$TransitionGroup;



var $fQojQ = parcelRequire("fQojQ");


var $aqdBs = parcelRequire("aqdBs");
"use client";
const $ec313753e5697e82$var$EMPTY = [];
function $ec313753e5697e82$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $aqdBs.useEffect(fn, $ec313753e5697e82$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $d9e2a257f7c2918a$export$786b4da70f00938b {
    static create() {
        return new $d9e2a257f7c2918a$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $d9e2a257f7c2918a$export$2e2bcd8739ae039() {
    const timeout = (0, $b4146ec3ac868fb7$export$2e2bcd8739ae039)($d9e2a257f7c2918a$export$786b4da70f00938b.create).current;
    (0, $ec313753e5697e82$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



var $aIlUA = parcelRequire("aIlUA");
var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $84ddf423d5e42d08$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $aqdBs.useState(false);
    const rippleClassName = (0, $fQojQ.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fQojQ.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $aqdBs.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
            className: childClassName
        })
    });
}
var $84ddf423d5e42d08$export$2e2bcd8739ae039 = $84ddf423d5e42d08$var$Ripple;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $e3806feb2f24f3cd$export$b464606f735ab902(slot) {
    return (0, $igOtJ.default)("MuiTouchRipple", slot);
}
const $e3806feb2f24f3cd$var$touchRippleClasses = (0, $jIPNy.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $e3806feb2f24f3cd$export$2e2bcd8739ae039 = $e3806feb2f24f3cd$var$touchRippleClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $e7a8a2cfa6413e0a$var$DURATION = 550;
const $e7a8a2cfa6413e0a$export$95d0c9356b2231a3 = 80;
const $e7a8a2cfa6413e0a$var$enterKeyframe = (0, $aIlUA.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $e7a8a2cfa6413e0a$var$exitKeyframe = (0, $aIlUA.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $e7a8a2cfa6413e0a$var$pulsateKeyframe = (0, $aIlUA.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $e7a8a2cfa6413e0a$export$f6b7418508c72c25 = (0, $6JVXO.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $e7a8a2cfa6413e0a$export$676cfe7b12693c4b = (0, $6JVXO.default)((0, $84ddf423d5e42d08$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${(0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$e7a8a2cfa6413e0a$var$enterKeyframe};
    animation-duration: ${$e7a8a2cfa6413e0a$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$e7a8a2cfa6413e0a$var$exitKeyframe};
    animation-duration: ${$e7a8a2cfa6413e0a$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$e7a8a2cfa6413e0a$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $e7a8a2cfa6413e0a$var$TouchRipple = /*#__PURE__*/ $aqdBs.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $aqdBs.useState([]);
    const nextKey = $aqdBs.useRef(0);
    const rippleCallback = $aqdBs.useRef(null);
    $aqdBs.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $aqdBs.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $d9e2a257f7c2918a$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $aqdBs.useRef(null);
    const container = $aqdBs.useRef(null);
    const startCommit = $aqdBs.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $1Ivrw.jsx)($e7a8a2cfa6413e0a$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fQojQ.default)(classes.ripple, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $fQojQ.default)(classes.rippleVisible, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $fQojQ.default)(classes.ripplePulsate, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $fQojQ.default)(classes.child, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $fQojQ.default)(classes.childLeaving, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $fQojQ.default)(classes.childPulsate, (0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $e7a8a2cfa6413e0a$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $aqdBs.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($e7a8a2cfa6413e0a$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $aqdBs.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $aqdBs.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $aqdBs.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($e7a8a2cfa6413e0a$export$f6b7418508c72c25, {
        className: (0, $fQojQ.default)((0, $e3806feb2f24f3cd$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $135cd7b6bdc7f5bc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $e7a8a2cfa6413e0a$export$2e2bcd8739ae039 = $e7a8a2cfa6413e0a$var$TouchRipple;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $cf7dc665ed940f9e$export$fccb0498dcd99783(slot) {
    return (0, $igOtJ.default)("MuiButtonBase", slot);
}
const $cf7dc665ed940f9e$var$buttonBaseClasses = (0, $jIPNy.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $cf7dc665ed940f9e$export$2e2bcd8739ae039 = $cf7dc665ed940f9e$var$buttonBaseClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $27fd4653351996cf$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $cf7dc665ed940f9e$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $27fd4653351996cf$export$7ec0dcc5e3cdcd36 = (0, $6JVXO.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $cf7dc665ed940f9e$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $27fd4653351996cf$var$ButtonBase = /*#__PURE__*/ $aqdBs.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $aqdBs.useRef(null);
    const ripple = (0, $acb7a73a2d071eaa$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $aqdBs.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $aqdBs.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $aqdBs.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $4963f8336749096a$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore) ripple[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        if (!(0, $b21c773ae1c18b82$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4963f8336749096a$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $b21c773ae1c18b82$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    const handleKeyDown = (0, $4963f8336749096a$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === " ") ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4963f8336749096a$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $27fd4653351996cf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($27fd4653351996cf$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $e7a8a2cfa6413e0a$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
var $27fd4653351996cf$export$2e2bcd8739ae039 = $27fd4653351996cf$var$ButtonBase;



"use client";
var $bb494485a70ff421$export$2e2bcd8739ae039 = (0, $35a0d5759101fc88$export$2e2bcd8739ae039);




var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $146ef4c0b8fb3a51$export$46f01d01378ec5a2(slot) {
    return (0, $igOtJ.default)("MuiDivider", slot);
}
const $146ef4c0b8fb3a51$var$dividerClasses = (0, $jIPNy.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $146ef4c0b8fb3a51$export$2e2bcd8739ae039 = $146ef4c0b8fb3a51$var$dividerClasses;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $07ec5233e256e50a$export$81478e24460c57f2(slot) {
    return (0, $igOtJ.default)("MuiListItemIcon", slot);
}
const $07ec5233e256e50a$var$listItemIconClasses = (0, $jIPNy.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $07ec5233e256e50a$export$2e2bcd8739ae039 = $07ec5233e256e50a$var$listItemIconClasses;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $ad48cb22ee8f78ea$export$1061006a0db3aeb5(slot) {
    return (0, $igOtJ.default)("MuiListItemText", slot);
}
const $ad48cb22ee8f78ea$var$listItemTextClasses = (0, $jIPNy.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $ad48cb22ee8f78ea$export$2e2bcd8739ae039 = $ad48cb22ee8f78ea$var$listItemTextClasses;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $dafac6c192b24235$export$515f8c67b5305377(slot) {
    return (0, $igOtJ.default)("MuiMenuItem", slot);
}
const $dafac6c192b24235$var$menuItemClasses = (0, $jIPNy.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $dafac6c192b24235$export$2e2bcd8739ae039 = $dafac6c192b24235$var$menuItemClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $609cc9f9ea58bcc3$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $609cc9f9ea58bcc3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $dafac6c192b24235$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $609cc9f9ea58bcc3$var$MenuItemRoot = (0, $6JVXO.default)((0, $27fd4653351996cf$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $609cc9f9ea58bcc3$export$4334bb34c76fef24
})((0, $iAnBN.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap",
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $dafac6c192b24235$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $amKcf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $dafac6c192b24235$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $amKcf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $dafac6c192b24235$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $amKcf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $amKcf.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $dafac6c192b24235$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dafac6c192b24235$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $146ef4c0b8fb3a51$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $146ef4c0b8fb3a51$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $ad48cb22ee8f78ea$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $ad48cb22ee8f78ea$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $07ec5233e256e50a$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: "padding-box"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up("sm")]: {
                        minHeight: "auto"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $07ec5233e256e50a$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: "1.25rem"
                    }
                }
            }
        ]
    })));
const $609cc9f9ea58bcc3$var$MenuItem = /*#__PURE__*/ $aqdBs.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $aqdBs.useContext((0, $5fb826b9df292b71$export$2e2bcd8739ae039));
    const childContext = $aqdBs.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $aqdBs.useRef(null);
    (0, $bb494485a70ff421$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $609cc9f9ea58bcc3$var$useUtilityClasses(props);
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5fb826b9df292b71$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($609cc9f9ea58bcc3$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fQojQ.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fQojQ.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $609cc9f9ea58bcc3$export$2e2bcd8739ae039 = $609cc9f9ea58bcc3$var$MenuItem;


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $88kuG = parcelRequire("88kuG");

var $aqdBs = parcelRequire("aqdBs");
function $e0c9f14768ae2407$export$2e2bcd8739ae039(element) {
    if (!element || !/*#__PURE__*/ $aqdBs.isValidElement(element)) return null;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    return element.props.propertyIsEnumerable("ref") ? element.props.ref : // @ts-expect-error element.ref is not included in the ReactElement type
    // We cannot check for it, but isValidElement is true at this point
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    element.ref;
}



var $9PB6d = parcelRequire("9PB6d");

var $aqdBs = parcelRequire("aqdBs");
var $a3de43725b7a590e$exports = {};
"use strict";

$a3de43725b7a590e$exports = (parcelRequire("f00Nn"));




var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $aqdBs = parcelRequire("aqdBs");
"use client";
let $5bb3c8b9df84a75b$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $5bb3c8b9df84a75b$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $aqdBs.useState(idOverride);
    const id = idOverride || defaultId;
    $aqdBs.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $5bb3c8b9df84a75b$var$globalId += 1;
            setDefaultId(`mui-${$5bb3c8b9df84a75b$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $5bb3c8b9df84a75b$var$safeReact = {
    ...$aqdBs
};
const $5bb3c8b9df84a75b$var$maybeReactUseId = $5bb3c8b9df84a75b$var$safeReact.useId;
function $5bb3c8b9df84a75b$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($5bb3c8b9df84a75b$var$maybeReactUseId !== undefined) {
        const reactId = $5bb3c8b9df84a75b$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $5bb3c8b9df84a75b$var$useGlobalId(idOverride);
}



function $9a3a4de14b1e7c3e$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039 = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039);



var $40jPv = parcelRequire("40jPv");

var $aqdBs = parcelRequire("aqdBs");



var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");


var $aqdBs = parcelRequire("aqdBs");


var $1Ivrw = parcelRequire("1Ivrw");
const $4ec2abae1b3c08a6$var$RtlContext = /*#__PURE__*/ $aqdBs.createContext();
function $4ec2abae1b3c08a6$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($4ec2abae1b3c08a6$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $4ec2abae1b3c08a6$export$b2dd014b6c321cb = ()=>{
    const value = $aqdBs.useContext($4ec2abae1b3c08a6$var$RtlContext);
    return value ?? false;
};
var $4ec2abae1b3c08a6$export$2e2bcd8739ae039 = $4ec2abae1b3c08a6$var$RtlProvider;



/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $4fa4a30606a1d1dc$var$isHostComponent(element) {
    return typeof element === "string";
}
var $4fa4a30606a1d1dc$export$2e2bcd8739ae039 = $4fa4a30606a1d1dc$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $098459453229a1cb$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $4fa4a30606a1d1dc$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $098459453229a1cb$export$2e2bcd8739ae039 = $098459453229a1cb$var$appendOwnerState;



var $fQojQ = parcelRequire("fQojQ");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $53bdd6e1e98844a0$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $53bdd6e1e98844a0$export$2e2bcd8739ae039 = $53bdd6e1e98844a0$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $30dbda89f28389d5$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $30dbda89f28389d5$export$2e2bcd8739ae039 = $30dbda89f28389d5$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $5aee131b305872c2$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $fQojQ.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $53bdd6e1e98844a0$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $30dbda89f28389d5$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $30dbda89f28389d5$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $fQojQ.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $5aee131b305872c2$export$2e2bcd8739ae039 = $5aee131b305872c2$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $845d56d92217f2bf$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $845d56d92217f2bf$export$2e2bcd8739ae039 = $845d56d92217f2bf$var$resolveComponentProps;


"use client";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $22cfa03321abf1c8$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $845d56d92217f2bf$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $5aee131b305872c2$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $098459453229a1cb$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $22cfa03321abf1c8$export$2e2bcd8739ae039 = $22cfa03321abf1c8$var$useSlotProps;



var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");


var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $032c3d0ec2b4260d$export$c6bd6795ed6e3203(slot) {
    return (0, $igOtJ.default)("MuiList", slot);
}
const $032c3d0ec2b4260d$var$listClasses = (0, $jIPNy.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $032c3d0ec2b4260d$export$2e2bcd8739ae039 = $032c3d0ec2b4260d$var$listClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $444be26050de47bd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $032c3d0ec2b4260d$export$c6bd6795ed6e3203), classes);
};
const $444be26050de47bd$var$ListRoot = (0, $6JVXO.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $444be26050de47bd$var$List = /*#__PURE__*/ $aqdBs.forwardRef(function List(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $aqdBs.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $444be26050de47bd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5fb826b9df292b71$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)($444be26050de47bd$var$ListRoot, {
            as: component,
            className: (0, $fQojQ.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $444be26050de47bd$export$2e2bcd8739ae039 = $444be26050de47bd$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $4738a14c4ae27aba$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $978f51ab4e287060$export$2e2bcd8739ae039 = (0, $4738a14c4ae27aba$export$2e2bcd8739ae039);





var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $4ce0e9b09c8c6101$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4ce0e9b09c8c6101$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4ce0e9b09c8c6101$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(""));
}
function $4ce0e9b09c8c6101$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$4ce0e9b09c8c6101$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $4ce0e9b09c8c6101$var$MenuList = /*#__PURE__*/ $aqdBs.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu", ...other } = props;
    const listRef = $aqdBs.useRef(null);
    const textCriteriaRef = $aqdBs.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $bb494485a70ff421$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $aqdBs.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $978f51ab4e287060$export$2e2bcd8739ae039)((0, $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $4ce0e9b09c8c6101$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4ce0e9b09c8c6101$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $4ce0e9b09c8c6101$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4ce0e9b09c8c6101$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $4ce0e9b09c8c6101$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4ce0e9b09c8c6101$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $4ce0e9b09c8c6101$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4ce0e9b09c8c6101$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $4ce0e9b09c8c6101$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4ce0e9b09c8c6101$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4ce0e9b09c8c6101$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aqdBs.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $aqdBs.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $aqdBs.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $444be26050de47bd$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $4ce0e9b09c8c6101$export$2e2bcd8739ae039 = $4ce0e9b09c8c6101$var$MenuList;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");





/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $ca8eeb6ece5c2069$var$isHostComponent(element) {
    return typeof element === "string";
}
var $ca8eeb6ece5c2069$export$2e2bcd8739ae039 = $ca8eeb6ece5c2069$var$isHostComponent;



var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $29f1ffbdcfc0bb30$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $c04942e8bfaab9a5$export$2e2bcd8739ae039 = (0, $29f1ffbdcfc0bb30$export$2e2bcd8739ae039);




function $4574527c4f66bd2f$export$2e2bcd8739ae039(node) {
    const doc = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $37e29802075747fd$export$2e2bcd8739ae039 = (0, $4574527c4f66bd2f$export$2e2bcd8739ae039);




var $aqdBs = parcelRequire("aqdBs");








var $aqdBs = parcelRequire("aqdBs");

var $e1c2ae7a80da78aa$export$2e2bcd8739ae039 = {
    disabled: false
};




var $8de142fdcd6e8327$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0e3db6016de1057e$export$bb38bb9a1161268 = "unmounted";
var $0e3db6016de1057e$export$84cbff306f539230 = "exited";
var $0e3db6016de1057e$export$df38205c966be359 = "entering";
var $0e3db6016de1057e$export$78e9e6e3e014d60a = "entered";
var $0e3db6016de1057e$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0e3db6016de1057e$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $80ee30fc473fbc65$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0e3db6016de1057e$export$84cbff306f539230;
                _this.appearStatus = $0e3db6016de1057e$export$df38205c966be359;
            } else initialStatus = $0e3db6016de1057e$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0e3db6016de1057e$export$bb38bb9a1161268;
        else initialStatus = $0e3db6016de1057e$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0e3db6016de1057e$export$bb38bb9a1161268) return {
            status: $0e3db6016de1057e$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0e3db6016de1057e$export$df38205c966be359 && status !== $0e3db6016de1057e$export$78e9e6e3e014d60a) nextStatus = $0e3db6016de1057e$export$df38205c966be359;
            } else if (status === $0e3db6016de1057e$export$df38205c966be359 || status === $0e3db6016de1057e$export$78e9e6e3e014d60a) nextStatus = $0e3db6016de1057e$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0e3db6016de1057e$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e813d4480671d45c$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8de142fdcd6e8327$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0e3db6016de1057e$export$84cbff306f539230) this.setState({
            status: $0e3db6016de1057e$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e813d4480671d45c$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $e1c2ae7a80da78aa$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0e3db6016de1057e$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0e3db6016de1057e$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0e3db6016de1057e$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e813d4480671d45c$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $e1c2ae7a80da78aa$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0e3db6016de1057e$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0e3db6016de1057e$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0e3db6016de1057e$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e813d4480671d45c$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0e3db6016de1057e$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4d44d0dfc06e7f09$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e478f5f5f9961ba0$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Component);
$0e3db6016de1057e$var$Transition.contextType = (0, $e478f5f5f9961ba0$export$2e2bcd8739ae039);
$0e3db6016de1057e$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0e3db6016de1057e$var$noop() {}
$0e3db6016de1057e$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0e3db6016de1057e$var$noop,
    onEntering: $0e3db6016de1057e$var$noop,
    onEntered: $0e3db6016de1057e$var$noop,
    onExit: $0e3db6016de1057e$var$noop,
    onExiting: $0e3db6016de1057e$var$noop,
    onExited: $0e3db6016de1057e$var$noop
};
$0e3db6016de1057e$var$Transition.UNMOUNTED = $0e3db6016de1057e$export$bb38bb9a1161268;
$0e3db6016de1057e$var$Transition.EXITED = $0e3db6016de1057e$export$84cbff306f539230;
$0e3db6016de1057e$var$Transition.ENTERING = $0e3db6016de1057e$export$df38205c966be359;
$0e3db6016de1057e$var$Transition.ENTERED = $0e3db6016de1057e$export$78e9e6e3e014d60a;
$0e3db6016de1057e$var$Transition.EXITING = $0e3db6016de1057e$export$4aacc83d4d59139f;
var $0e3db6016de1057e$export$2e2bcd8739ae039 = $0e3db6016de1057e$var$Transition;


parcelRequire("aqdBs");

var $iqdgc = parcelRequire("iqdgc");

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("aIlUA");
var $j6Zbs = parcelRequire("j6Zbs");
"use client";
function $27be6d923f5fe768$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $27be6d923f5fe768$var$useTheme(defaultTheme = null) {
    const contextTheme = $aqdBs.useContext((0, $j6Zbs.T));
    return !contextTheme || $27be6d923f5fe768$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $27be6d923f5fe768$export$2e2bcd8739ae039 = $27be6d923f5fe768$var$useTheme;


"use client";
const $6df9c97a08eacc3d$export$35e57303dbd8a66 = (0, $iqdgc.default)();
function $6df9c97a08eacc3d$var$useTheme(defaultTheme = $6df9c97a08eacc3d$export$35e57303dbd8a66) {
    return (0, $27be6d923f5fe768$export$2e2bcd8739ae039)(defaultTheme);
}
var $6df9c97a08eacc3d$export$2e2bcd8739ae039 = $6df9c97a08eacc3d$var$useTheme;



var $9xlCw = parcelRequire("9xlCw");

var $dbHL4 = parcelRequire("dbHL4");
"use client";
function $5d230ce41f490aa3$export$2e2bcd8739ae039() {
    const theme = (0, $6df9c97a08eacc3d$export$2e2bcd8739ae039)((0, $9xlCw.default));
    return theme[0, $dbHL4.default] || theme;
}


const $9ff9956d6215cfe9$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $9ff9956d6215cfe9$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === "number" ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === "object" ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $d6a99e50448a94c9$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6a99e50448a94c9$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6a99e50448a94c9$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6a99e50448a94c9$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6a99e50448a94c9$var$Grow = /*#__PURE__*/ $aqdBs.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0e3db6016de1057e$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $d9e2a257f7c2918a$export$2e2bcd8739ae039)();
    const autoTimeout = $aqdBs.useRef();
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const nodeRef = $aqdBs.useRef(null);
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(nodeRef, (0, $e0c9f14768ae2407$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $9ff9956d6215cfe9$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $9ff9956d6215cfe9$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6a99e50448a94c9$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $9ff9956d6215cfe9$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6a99e50448a94c9$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6a99e50448a94c9$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $d6a99e50448a94c9$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout,
        ...other,
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aqdBs.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d6a99e50448a94c9$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$d6a99e50448a94c9$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...childProps
            });
        }
    });
});
if ($d6a99e50448a94c9$var$Grow) $d6a99e50448a94c9$var$Grow.muiSupportAuto = true;
var $d6a99e50448a94c9$export$2e2bcd8739ae039 = $d6a99e50448a94c9$var$Grow;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");



var $5ylSM = parcelRequire("5ylSM");

var $aqdBs = parcelRequire("aqdBs");



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $23ffecd49a75cf33$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $23ffecd49a75cf33$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $23ffecd49a75cf33$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $23ffecd49a75cf33$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $23ffecd49a75cf33$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $23ffecd49a75cf33$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($23ffecd49a75cf33$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $23ffecd49a75cf33$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$23ffecd49a75cf33$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $23ffecd49a75cf33$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $23ffecd49a75cf33$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $23ffecd49a75cf33$var$defaultGetTabbable, isEnabled: isEnabled = $23ffecd49a75cf33$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $aqdBs.useRef(false);
    const sentinelStart = $aqdBs.useRef(null);
    const sentinelEnd = $aqdBs.useRef(null);
    const nodeToRestore = $aqdBs.useRef(null);
    const reactFocusEventTarget = $aqdBs.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $aqdBs.useRef(false);
    const rootRef = $aqdBs.useRef(null);
    const handleRef = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)((0, $e0c9f14768ae2407$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $aqdBs.useRef(null);
    $aqdBs.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $aqdBs.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $aqdBs.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $aqdBs.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $23ffecd49a75cf33$export$2e2bcd8739ae039 = $23ffecd49a75cf33$var$FocusTrap;



var $aqdBs = parcelRequire("aqdBs");




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $b98aa5cf9fd97257$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $b98aa5cf9fd97257$var$Portal = /*#__PURE__*/ $aqdBs.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $aqdBs.useState(null);
    const handleRef = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)((0, $e0c9f14768ae2407$export$2e2bcd8739ae039)(children), forwardedRef);
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($b98aa5cf9fd97257$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $efb6cfe1f6c0a8d7$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $efb6cfe1f6c0a8d7$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $aqdBs.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $aqdBs.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $1Ivrw.jsx)($aqdBs.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($aqdBs.Fragment, {
        children: mountNode ? /*#__PURE__*/ $e813d4480671d45c$exports.createPortal(children, mountNode) : mountNode
    });
});
var $b98aa5cf9fd97257$export$2e2bcd8739ae039 = $b98aa5cf9fd97257$var$Portal;



var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");




"use client";
function $bbfd36af71b5b056$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $845d56d92217f2bf$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $5aee131b305872c2$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = {
        ...ownerState,
        ...slotOwnerState
    };
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $098459453229a1cb$export$2e2bcd8739ae039)(elementType, {
        ...name === "root" && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== "root" && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && {
            as: LeafComponent
        },
        ref: ref
    }, finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $aqdBs = parcelRequire("aqdBs");








var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $4b253693d6d955c3$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4b253693d6d955c3$var$Fade = /*#__PURE__*/ $aqdBs.forwardRef(function Fade(props, ref) {
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0e3db6016de1057e$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $aqdBs.useRef(null);
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(nodeRef, (0, $e0c9f14768ae2407$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $9ff9956d6215cfe9$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $9ff9956d6215cfe9$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $9ff9956d6215cfe9$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, childProps)=>{
            return /*#__PURE__*/ $aqdBs.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined,
                    ...$4b253693d6d955c3$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...childProps
            });
        }
    });
});
var $4b253693d6d955c3$export$2e2bcd8739ae039 = $4b253693d6d955c3$var$Fade;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $6b23b7a2409cfba9$export$9927a91fd93152bd(slot) {
    return (0, $igOtJ.default)("MuiBackdrop", slot);
}
const $6b23b7a2409cfba9$var$backdropClasses = (0, $jIPNy.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $6b23b7a2409cfba9$export$2e2bcd8739ae039 = $6b23b7a2409cfba9$var$backdropClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $9c811864513a06df$var$removeOwnerState = (props)=>{
    const { ownerState: ownerState, ...rest } = props;
    return rest;
};
const $9c811864513a06df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $6b23b7a2409cfba9$export$9927a91fd93152bd), classes);
};
const $9c811864513a06df$var$BackdropRoot = (0, $6JVXO.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent",
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: "transparent"
            }
        }
    ]
});
const $9c811864513a06df$var$Backdrop = /*#__PURE__*/ $aqdBs.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $9c811864513a06df$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("root", {
        elementType: $9c811864513a06df$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("transition", {
        elementType: (0, $4b253693d6d955c3$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const transitionPropsRemoved = $9c811864513a06df$var$removeOwnerState(transitionProps);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionPropsRemoved,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $9c811864513a06df$export$2e2bcd8739ae039 = $9c811864513a06df$var$Backdrop;



var $aqdBs = parcelRequire("aqdBs");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $fb72dfca04499bc0$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $42be54d6771f0516$var$isOverflowing(container) {
    const doc = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $4574527c4f66bd2f$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $42be54d6771f0516$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $42be54d6771f0516$var$getPaddingRight(element) {
    return parseInt((0, $4574527c4f66bd2f$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $42be54d6771f0516$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $42be54d6771f0516$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$42be54d6771f0516$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $42be54d6771f0516$export$e1bd0c6150f13d96(element, show);
    });
}
function $42be54d6771f0516$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $42be54d6771f0516$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($42be54d6771f0516$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $4738a14c4ae27aba$export$2e2bcd8739ae039)((0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$42be54d6771f0516$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$42be54d6771f0516$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $4574527c4f66bd2f$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $42be54d6771f0516$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $42be54d6771f0516$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $42be54d6771f0516$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $42be54d6771f0516$var$getHiddenSiblings(container);
        $42be54d6771f0516$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $42be54d6771f0516$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $42be54d6771f0516$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $42be54d6771f0516$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $42be54d6771f0516$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $42be54d6771f0516$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $42be54d6771f0516$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $42be54d6771f0516$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $00d0828ee3a712d4$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $00d0828ee3a712d4$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $00d0828ee3a712d4$var$defaultManager = new (0, $42be54d6771f0516$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $00d0828ee3a712d4$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $00d0828ee3a712d4$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $aqdBs.useRef({});
    const mountNodeRef = $aqdBs.useRef(null);
    const modalRef = $aqdBs.useRef(null);
    const handleRef = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $aqdBs.useState(!open);
    const hasTransition = $00d0828ee3a712d4$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $9a3a4de14b1e7c3e$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $051bb790d9c06a84$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $00d0828ee3a712d4$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $aqdBs.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $051bb790d9c06a84$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $42be54d6771f0516$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $aqdBs.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $aqdBs.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $aqdBs.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $53bdd6e1e98844a0$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            role: "presentation",
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            "aria-hidden": true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $fb72dfca04499bc0$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter),
            onExited: (0, $fb72dfca04499bc0$export$2e2bcd8739ae039)(handleExited, children?.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $00d0828ee3a712d4$export$2e2bcd8739ae039 = $00d0828ee3a712d4$var$useModal;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $b246648e8187a9e5$export$67960e22b12a638d(slot) {
    return (0, $igOtJ.default)("MuiModal", slot);
}
const $b246648e8187a9e5$var$modalClasses = (0, $jIPNy.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $b246648e8187a9e5$export$2e2bcd8739ae039 = $b246648e8187a9e5$var$modalClasses;





var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $d1c8393a8a89eabd$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $b246648e8187a9e5$export$67960e22b12a638d), classes);
};
const $d1c8393a8a89eabd$var$ModalRoot = (0, $6JVXO.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: "hidden"
                }
            }
        ]
    })));
const $d1c8393a8a89eabd$var$ModalBackdrop = (0, $6JVXO.default)((0, $9c811864513a06df$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $d1c8393a8a89eabd$var$Modal = /*#__PURE__*/ $aqdBs.forwardRef(function Modal(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $d1c8393a8a89eabd$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $00d0828ee3a712d4$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $d1c8393a8a89eabd$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        ...other,
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("root", {
        elementType: $d1c8393a8a89eabd$var$ModalRoot,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $fQojQ.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("backdrop", {
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers?.onClick) otherHandlers.onClick(e);
                }
            });
        },
        className: (0, $fQojQ.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    const backdropRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(BackdropProps?.ref, backdropProps.ref);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b98aa5cf9fd97257$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $1Ivrw.jsx)(BackdropSlot, {
                    ...backdropProps,
                    ref: backdropRef
                }) : null,
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $23ffecd49a75cf33$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $aqdBs.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $d1c8393a8a89eabd$export$2e2bcd8739ae039 = $d1c8393a8a89eabd$var$Modal;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");



var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $6expx = parcelRequire("6expx");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $ed016903c1b205f9$export$29cdb466b9b6f20b(slot) {
    return (0, $igOtJ.default)("MuiPaper", slot);
}
const $ed016903c1b205f9$var$paperClasses = (0, $jIPNy.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $ed016903c1b205f9$export$2e2bcd8739ae039 = $ed016903c1b205f9$var$paperClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $f843ecc7e1945ca7$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $ed016903c1b205f9$export$29cdb466b9b6f20b), classes);
};
const $f843ecc7e1945ca7$var$PaperRoot = (0, $6JVXO.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow"),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: "elevation"
                },
                style: {
                    boxShadow: "var(--Paper-shadow)",
                    backgroundImage: "var(--Paper-overlay)"
                }
            }
        ]
    })));
const $f843ecc7e1945ca7$var$Paper = /*#__PURE__*/ $aqdBs.forwardRef(function Paper(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiPaper"
    });
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation", ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $f843ecc7e1945ca7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($f843ecc7e1945ca7$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === "elevation" && {
                "--Paper-shadow": (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    "--Paper-overlay": theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === "dark" && {
                    "--Paper-overlay": `linear-gradient(${(0, $amKcf.alpha)("#fff", (0, $6expx.default)(elevation))}, ${(0, $amKcf.alpha)("#fff", (0, $6expx.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $f843ecc7e1945ca7$export$2e2bcd8739ae039 = $f843ecc7e1945ca7$var$Paper;



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $633eac054e31a08c$export$88f455dd56c95edb(slot) {
    return (0, $igOtJ.default)("MuiPopover", slot);
}
const $633eac054e31a08c$var$popoverClasses = (0, $jIPNy.default)("MuiPopover", [
    "root",
    "paper"
]);
var $633eac054e31a08c$export$2e2bcd8739ae039 = $633eac054e31a08c$var$popoverClasses;




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $c2f71c22ca43cf0b$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $c2f71c22ca43cf0b$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $c2f71c22ca43cf0b$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $c2f71c22ca43cf0b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $c2f71c22ca43cf0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $633eac054e31a08c$export$88f455dd56c95edb), classes);
};
const $c2f71c22ca43cf0b$export$bcce13685275fc99 = (0, $6JVXO.default)((0, $d1c8393a8a89eabd$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c2f71c22ca43cf0b$export$821346c38a2d9390 = (0, $6JVXO.default)((0, $f843ecc7e1945ca7$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c2f71c22ca43cf0b$var$Popover = /*#__PURE__*/ $aqdBs.forwardRef(function Popover(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $d6a99e50448a94c9$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, disableScrollLock: disableScrollLock = false, ...other } = props;
    const externalPaperSlotProps = slotProps?.paper ?? PaperPropsProp;
    const paperRef = $aqdBs.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $c2f71c22ca43cf0b$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $aqdBs.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $c2f71c22ca43cf0b$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $c2f71c22ca43cf0b$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $c2f71c22ca43cf0b$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $aqdBs.useCallback((elemRect)=>{
        return {
            vertical: $c2f71c22ca43cf0b$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $c2f71c22ca43cf0b$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $aqdBs.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $c2f71c22ca43cf0b$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $37e29802075747fd$export$2e2bcd8739ae039)($c2f71c22ca43cf0b$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $c2f71c22ca43cf0b$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $aqdBs.useState(open);
    const setPositioningStyles = $aqdBs.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty("top", positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $aqdBs.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $aqdBs.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $aqdBs.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $aqdBs.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $c04942e8bfaab9a5$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $37e29802075747fd$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039)($c2f71c22ca43cf0b$var$resolveAnchorEl(anchorEl)).body : undefined);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...slotProps,
            paper: externalPaperSlotProps
        }
    };
    const [PaperSlot, paperProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("paper", {
        elementType: $c2f71c22ca43cf0b$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: elevation,
            className: (0, $fQojQ.default)(classes.paper, externalPaperSlotProps?.className),
            style: isPositioned ? externalPaperSlotProps.style : {
                ...externalPaperSlotProps.style,
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    const [RootSlot, { slotProps: rootSlotPropsProp, ...rootProps }] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("root", {
        elementType: $c2f71c22ca43cf0b$export$bcce13685275fc99,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className)
    });
    const handlePaperRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(paperRef, paperProps.ref);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $ca8eeb6ece5c2069$export$2e2bcd8739ae039)(RootSlot) && {
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        ...other,
        ref: ref,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)(TransitionComponent, {
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration,
            ...TransitionProps,
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)(PaperSlot, {
                ...paperProps,
                ref: handlePaperRef,
                children: children
            })
        })
    });
});
var $c2f71c22ca43cf0b$export$2e2bcd8739ae039 = $c2f71c22ca43cf0b$var$Popover;



var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $7da0eef1215873c0$export$2cf86a63a84fe23d(slot) {
    return (0, $igOtJ.default)("MuiMenu", slot);
}
const $7da0eef1215873c0$var$menuClasses = (0, $jIPNy.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $7da0eef1215873c0$export$2e2bcd8739ae039 = $7da0eef1215873c0$var$menuClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $ca8690a6d8852c3d$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $ca8690a6d8852c3d$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $ca8690a6d8852c3d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $7da0eef1215873c0$export$2cf86a63a84fe23d), classes);
};
const $ca8690a6d8852c3d$var$MenuRoot = (0, $6JVXO.default)((0, $c2f71c22ca43cf0b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $ca8690a6d8852c3d$export$4f7c51a5920c9f33 = (0, $6JVXO.default)((0, $c2f71c22ca43cf0b$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $ca8690a6d8852c3d$var$MenuMenuList = (0, $6JVXO.default)((0, $4ce0e9b09c8c6101$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $ca8690a6d8852c3d$var$Menu = /*#__PURE__*/ $aqdBs.forwardRef(function Menu(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $4ec2abae1b3c08a6$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $ca8690a6d8852c3d$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $aqdBs.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $aqdBs.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = slots.paper ?? $ca8690a6d8852c3d$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = slotProps.paper ?? PaperProps;
    const rootSlotProps = (0, $22cfa03321abf1c8$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $22cfa03321abf1c8$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($ca8690a6d8852c3d$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $ca8690a6d8852c3d$var$RTL_ORIGIN : $ca8690a6d8852c3d$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: {
            onEntering: handleEntering,
            ...TransitionProps
        },
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($ca8690a6d8852c3d$var$MenuMenuList, {
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...MenuListProps,
            className: (0, $fQojQ.default)(classes.list, MenuListProps.className),
            children: children
        })
    });
});
var $ca8690a6d8852c3d$export$2e2bcd8739ae039 = $ca8690a6d8852c3d$var$Menu;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");


var $5ylSM = parcelRequire("5ylSM");

var $40jPv = parcelRequire("40jPv");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $227ad629f4bc08d2$export$1ee13051fd9e2ab5(slot) {
    return (0, $igOtJ.default)("MuiNativeSelect", slot);
}
const $227ad629f4bc08d2$var$nativeSelectClasses = (0, $jIPNy.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $227ad629f4bc08d2$export$2e2bcd8739ae039 = $227ad629f4bc08d2$var$nativeSelectClasses;



var $6JVXO = parcelRequire("6JVXO");

var $aMtHL = parcelRequire("aMtHL");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $6c3fe450d1a69246$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $40jPv.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $227ad629f4bc08d2$export$1ee13051fd9e2ab5), classes);
};
const $6c3fe450d1a69246$export$50b3545a8ccd87af = (0, $6JVXO.default)("select")(({ theme: theme })=>({
        // Reset
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        // Reset
        borderRadius: 0,
        cursor: "pointer",
        "&:focus": {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $227ad629f4bc08d2$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== "filled" && ownerState.variant !== "outlined",
                style: {
                    // Bump specificity to allow extending custom inputs
                    "&&&": {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    "&&&": {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    "&:focus": {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    "&&&": {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $6c3fe450d1a69246$var$NativeSelectSelect = (0, $6JVXO.default)($6c3fe450d1a69246$export$50b3545a8ccd87af, {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $aMtHL.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $227ad629f4bc08d2$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $6c3fe450d1a69246$export$7dd4d92f143902e3 = (0, $6JVXO.default)("svg")(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        // Center vertically, height is 1em
        top: "calc(50% - .5em)",
        // Don't block pointer events on the select under the icon.
        pointerEvents: "none",
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $227ad629f4bc08d2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: "rotate(180deg)"
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $6c3fe450d1a69246$var$NativeSelectIcon = (0, $6JVXO.default)($6c3fe450d1a69246$export$7dd4d92f143902e3, {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $40jPv.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $6c3fe450d1a69246$var$NativeSelectInput = /*#__PURE__*/ $aqdBs.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard", ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $6c3fe450d1a69246$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)($6c3fe450d1a69246$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $fQojQ.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $1Ivrw.jsx)($6c3fe450d1a69246$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $6c3fe450d1a69246$export$2e2bcd8739ae039 = $6c3fe450d1a69246$var$NativeSelectInput;




var $6JVXO = parcelRequire("6JVXO");

var $1TjQ0 = parcelRequire("1TjQ0");


var $aqdBs = parcelRequire("aqdBs");
"use client";
function $bcd9363fc7ce1ab5$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $aqdBs.useRef(controlled !== undefined);
    const [valueState, setValue] = $aqdBs.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $aqdBs.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $5d1fc5162a19c3bf$export$2e2bcd8739ae039 = (0, $bcd9363fc7ce1ab5$export$2e2bcd8739ae039);



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $0bb8312415fc73e9$export$2c0c1ee5a3392e(slot) {
    return (0, $igOtJ.default)("MuiSelect", slot);
}
const $0bb8312415fc73e9$var$selectClasses = (0, $jIPNy.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $0bb8312415fc73e9$export$2e2bcd8739ae039 = $0bb8312415fc73e9$var$selectClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $e2a261a2522ecf32$var$_span;
const $e2a261a2522ecf32$var$SelectSelect = (0, $6JVXO.default)((0, $6c3fe450d1a69246$export$50b3545a8ccd87af), {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $0bb8312415fc73e9$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $0bb8312415fc73e9$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $0bb8312415fc73e9$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $0bb8312415fc73e9$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $0bb8312415fc73e9$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $e2a261a2522ecf32$var$SelectIcon = (0, $6JVXO.default)((0, $6c3fe450d1a69246$export$7dd4d92f143902e3), {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $40jPv.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $e2a261a2522ecf32$var$SelectNativeInput = (0, $6JVXO.default)("input", {
    shouldForwardProp: (prop)=>(0, $1TjQ0.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $e2a261a2522ecf32$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $e2a261a2522ecf32$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $e2a261a2522ecf32$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $40jPv.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $0bb8312415fc73e9$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $e2a261a2522ecf32$var$SelectInput = /*#__PURE__*/ $aqdBs.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = "standard", ...other } = props;
    const [value, setValueState] = (0, $5d1fc5162a19c3bf$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $5d1fc5162a19c3bf$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $aqdBs.useRef(null);
    const displayRef = $aqdBs.useRef(null);
    const [displayNode, setDisplayNode] = $aqdBs.useState(null);
    const { current: isOpenControlled } = $aqdBs.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $aqdBs.useState();
    const handleRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $aqdBs.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $aqdBs.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $aqdBs.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $aqdBs.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $aqdBs.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $f77ebcf4f5bfd5ea$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $aqdBs.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $63da19232827992a$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9PB6d.default)(2));
            selected = value.some((v)=>$e2a261a2522ecf32$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $e2a261a2522ecf32$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $aqdBs.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $e2a261a2522ecf32$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $5bb3c8b9df84a75b$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)($e2a261a2522ecf32$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $fQojQ.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $e2a261a2522ecf32$var$isEmpty(display) ? $e2a261a2522ecf32$var$_span || ($e2a261a2522ecf32$var$_span = /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)($e2a261a2522ecf32$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)($e2a261a2522ecf32$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ca8690a6d8852c3d$export$2e2bcd8739ae039), {
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                ...MenuProps,
                MenuListProps: {
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId,
                    ...MenuProps.MenuListProps
                },
                slotProps: {
                    ...MenuProps.slotProps,
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $e2a261a2522ecf32$export$2e2bcd8739ae039 = $e2a261a2522ecf32$var$SelectInput;


function $485a8839646c9150$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $aqdBs = parcelRequire("aqdBs");

"use client";
function $67d20c430b7ed8a6$export$2e2bcd8739ae039() {
    return $aqdBs.useContext((0, $0bd1617b338bed15$export$2e2bcd8739ae039));
}


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $4bf730583a59b871$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $aqdBs = parcelRequire("aqdBs");


var $5ylSM = parcelRequire("5ylSM");

var $88kuG = parcelRequire("88kuG");


var $9PB6d = parcelRequire("9PB6d");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");



var $5ylSM = parcelRequire("5ylSM");

var $aqdBs = parcelRequire("aqdBs");



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $7d0d6c885bc155e2$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $7d0d6c885bc155e2$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $7d0d6c885bc155e2$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $7d0d6c885bc155e2$var$TextareaAutosize = /*#__PURE__*/ $aqdBs.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $aqdBs.useRef(value != null);
    const inputRef = $aqdBs.useRef(null);
    const handleRef = (0, $4a1f2448cbd5074a$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $aqdBs.useRef(null);
    const shadowRef = $aqdBs.useRef(null);
    const calculateTextareaStyles = $aqdBs.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $4574527c4f66bd2f$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $7d0d6c885bc155e2$var$getStyleValue(computedStyle.paddingBottom) + $7d0d6c885bc155e2$var$getStyleValue(computedStyle.paddingTop);
        const border = $7d0d6c885bc155e2$var$getStyleValue(computedStyle.borderBottomWidth) + $7d0d6c885bc155e2$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $aqdBs.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($7d0d6c885bc155e2$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $29f1ffbdcfc0bb30$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $4574527c4f66bd2f$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: {
                    ...$7d0d6c885bc155e2$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $7d0d6c885bc155e2$export$2e2bcd8739ae039 = $7d0d6c885bc155e2$var$TextareaAutosize;






parcelRequire("aqdBs");

var $88kuG = parcelRequire("88kuG");

var $aamMV = parcelRequire("aamMV");
const $98eda6bb3dc6d08b$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $aamMV.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $98eda6bb3dc6d08b$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $98eda6bb3dc6d08b$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $88kuG.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



parcelRequire("aqdBs");

parcelRequire("aqdBs");


var $LkOKM = parcelRequire("LkOKM");


var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $046efc2c2c12bee0$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $6df9c97a08eacc3d$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $LkOKM.default), {
        styles: globalStyles
    });
}
var $046efc2c2c12bee0$export$2e2bcd8739ae039 = $046efc2c2c12bee0$var$GlobalStyles;



var $9xlCw = parcelRequire("9xlCw");

var $dbHL4 = parcelRequire("dbHL4");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $8acc9e63ae6073c5$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $046efc2c2c12bee0$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $9xlCw.default),
        themeId: (0, $dbHL4.default)
    });
}
var $8acc9e63ae6073c5$export$2e2bcd8739ae039 = $8acc9e63ae6073c5$var$GlobalStyles;



var $1Ivrw = parcelRequire("1Ivrw");

var $aIlUA = parcelRequire("aIlUA");

var $6JVXO = parcelRequire("6JVXO");
function $14ea7e7763bb5a2b$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $1Ivrw.jsx)((0, $8acc9e63ae6073c5$export$2e2bcd8739ae039), {
            styles: typeof styles === "function" ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $14ea7e7763bb5a2b$export$7e7f5719ff4debb1() {
    return 0, $98eda6bb3dc6d08b$export$2e2bcd8739ae039;
}


var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $40jPv = parcelRequire("40jPv");




var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $8338a3d1a5e5a355$export$ef57d5c8ca2278f6(slot) {
    return (0, $igOtJ.default)("MuiInputBase", slot);
}
const $8338a3d1a5e5a355$var$inputBaseClasses = (0, $jIPNy.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $8338a3d1a5e5a355$export$2e2bcd8739ae039 = $8338a3d1a5e5a355$var$inputBaseClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $4990f7d2f8e3372a$var$_InputGlobalStyles;
const $4990f7d2f8e3372a$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $40jPv.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $4990f7d2f8e3372a$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $4990f7d2f8e3372a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $40jPv.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $40jPv.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $8338a3d1a5e5a355$export$ef57d5c8ca2278f6), classes);
};
const $4990f7d2f8e3372a$export$298a043133d72a38 = (0, $6JVXO.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $4990f7d2f8e3372a$export$965edad20a84fa75
})((0, $iAnBN.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "4px 0 5px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: "100%"
                }
            }
        ]
    })));
const $4990f7d2f8e3372a$export$ee10465db6ff6017 = (0, $6JVXO.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $4990f7d2f8e3372a$export$cf507b112810e72d
})((0, $iAnBN.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const placeholder = {
        color: "currentColor",
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: "mui-auto-fill-cancel",
                    animationDuration: "10ms",
                    "&:-webkit-autofill": {
                        animationDuration: "5000s",
                        animationName: "mui-auto-fill"
                    }
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: "auto",
                    resize: "none",
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: "search"
                },
                style: {
                    MozAppearance: "textfield" // Improve type search style.
                }
            }
        ]
    };
}));
const $4990f7d2f8e3372a$var$InputGlobalStyles = (0, $14ea7e7763bb5a2b$export$db53682eef82cc11)({
    "@keyframes mui-auto-fill": {
        from: {
            display: "block"
        }
    },
    "@keyframes mui-auto-fill-cancel": {
        from: {
            display: "block"
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $4990f7d2f8e3372a$var$InputBase = /*#__PURE__*/ $aqdBs.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $aqdBs.useRef(value != null);
    const inputRef = $aqdBs.useRef();
    const handleInputRefWarning = $aqdBs.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $aqdBs.useState(false);
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $aqdBs.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $aqdBs.useCallback((obj)=>{
        if ((0, $63da19232827992a$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $bb494485a70ff421$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9PB6d.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $aqdBs.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $7d0d6c885bc155e2$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $aqdBs.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $4990f7d2f8e3372a$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $4990f7d2f8e3372a$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $4990f7d2f8e3372a$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $4990f7d2f8e3372a$var$InputGlobalStyles === "function" && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($4990f7d2f8e3372a$var$_InputGlobalStyles || ($4990f7d2f8e3372a$var$_InputGlobalStyles = /*#__PURE__*/ (0, $1Ivrw.jsx)($4990f7d2f8e3372a$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $1Ivrw.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $ca8eeb6ece5c2069$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $fQojQ.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $0bd1617b338bed15$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $ca8eeb6ece5c2069$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $fQojQ.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $4990f7d2f8e3372a$export$2e2bcd8739ae039 = $4990f7d2f8e3372a$var$InputBase;



var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $896610d28a93be93$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === "string";
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $896610d28a93be93$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$896610d28a93be93$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== "string") return false;
    }
    return true;
}
function $896610d28a93be93$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $896610d28a93be93$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");

function $a9c473271d1995cc$export$cdb270390122322b(slot) {
    return (0, $igOtJ.default)("MuiInput", slot);
}
const $a9c473271d1995cc$var$inputClasses = {
    ...(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039),
    ...(0, $jIPNy.default)("MuiInput", [
        "root",
        "underline",
        "input"
    ])
};
var $a9c473271d1995cc$export$2e2bcd8739ae039 = $a9c473271d1995cc$var$inputClasses;




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $5c4cceefff246698$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $a9c473271d1995cc$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $5c4cceefff246698$var$InputRoot = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $4990f7d2f8e3372a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: "relative",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    "label + &": {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $a9c473271d1995cc$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $a9c473271d1995cc$export$2e2bcd8739ae039).error}`]: {
                        "&::before, &::after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $a9c473271d1995cc$export$2e2bcd8739ae039).disabled}, .${(0, $a9c473271d1995cc$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $a9c473271d1995cc$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        "&::after": {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $5c4cceefff246698$var$InputInput = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$ee10465db6ff6017), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $4990f7d2f8e3372a$export$cf507b112810e72d)
})({});
const $5c4cceefff246698$var$Input = /*#__PURE__*/ $aqdBs.forwardRef(function Input(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text", ...other } = props;
    const classes = $5c4cceefff246698$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $88kuG.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $5c4cceefff246698$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $5c4cceefff246698$var$InputInput;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4990f7d2f8e3372a$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
if ($5c4cceefff246698$var$Input) $5c4cceefff246698$var$Input.muiName = "Input";
var $5c4cceefff246698$export$2e2bcd8739ae039 = $5c4cceefff246698$var$Input;




var $aqdBs = parcelRequire("aqdBs");

var $88kuG = parcelRequire("88kuG");



var $5ylSM = parcelRequire("5ylSM");


var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");


var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");

function $6f392fcbe22e27f3$export$3331e419f1a48437(slot) {
    return (0, $igOtJ.default)("MuiFilledInput", slot);
}
const $6f392fcbe22e27f3$var$filledInputClasses = {
    ...(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039),
    ...(0, $jIPNy.default)("MuiFilledInput", [
        "root",
        "underline",
        "input",
        "adornedStart",
        "adornedEnd",
        "sizeSmall",
        "multiline",
        "hiddenLabel"
    ])
};
var $6f392fcbe22e27f3$export$2e2bcd8739ae039 = $6f392fcbe22e27f3$var$filledInputClasses;




var $40jPv = parcelRequire("40jPv");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $4acd92adf7ce06be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            size === "small" && `size${(0, $40jPv.default)(size)}`,
            hiddenLabel && "hiddenLabel",
            multiline && "multiline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $6f392fcbe22e27f3$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $4acd92adf7ce06be$var$FilledInputRoot = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $4990f7d2f8e3372a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return {
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).error}`]: {
                        "&::before, &::after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).disabled}, .${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $6f392fcbe22e27f3$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        "&::after": {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "25px 12px 8px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === "small",
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $4acd92adf7ce06be$var$FilledInputInput = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$ee10465db6ff6017), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $4990f7d2f8e3372a$export$cf507b112810e72d)
})((0, $iAnBN.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
                caretColor: theme.palette.mode === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        ...theme.vars && {
            "&:-webkit-autofill": {
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            },
            [theme.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 100px #266798 inset",
                    WebkitTextFillColor: "#fff",
                    caretColor: "#fff"
                }
            }
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === "small",
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $4acd92adf7ce06be$var$FilledInput = /*#__PURE__*/ $aqdBs.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text", ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $4acd92adf7ce06be$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $88kuG.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $4acd92adf7ce06be$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $4acd92adf7ce06be$var$FilledInputInput;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4990f7d2f8e3372a$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
if ($4acd92adf7ce06be$var$FilledInput) $4acd92adf7ce06be$var$FilledInput.muiName = "Input";
var $4acd92adf7ce06be$export$2e2bcd8739ae039 = $4acd92adf7ce06be$var$FilledInput;



var $aqdBs = parcelRequire("aqdBs");



var $5ylSM = parcelRequire("5ylSM");
parcelRequire("aqdBs");


var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $2bb9c613ffc972e7$var$_span;
const $2bb9c613ffc972e7$var$NotchedOutlineRoot = (0, $6JVXO.default)("fieldset", {
    shouldForwardProp: (0, $aMtHL.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $2bb9c613ffc972e7$var$NotchedOutlineLegend = (0, $6JVXO.default)("legend", {
    shouldForwardProp: (0, $aMtHL.default)
})((0, $iAnBN.default)(({ theme: theme })=>({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden",
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: "11px",
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create("width", {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: "block",
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: theme.transitions.create("max-width", {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: "inline-block",
                        opacity: 0,
                        visibility: "visible"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: "100%",
                    transition: theme.transitions.create("max-width", {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $2bb9c613ffc972e7$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== "";
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($2bb9c613ffc972e7$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($2bb9c613ffc972e7$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
                children: label
            }) : $2bb9c613ffc972e7$var$_span || ($2bb9c613ffc972e7$var$_span = /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    });
}





var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");


var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");

function $2838e8fcd66683de$export$89922944c7227687(slot) {
    return (0, $igOtJ.default)("MuiOutlinedInput", slot);
}
const $2838e8fcd66683de$var$outlinedInputClasses = {
    ...(0, $8338a3d1a5e5a355$export$2e2bcd8739ae039),
    ...(0, $jIPNy.default)("MuiOutlinedInput", [
        "root",
        "notchedOutline",
        "input"
    ])
};
var $2838e8fcd66683de$export$2e2bcd8739ae039 = $2838e8fcd66683de$var$outlinedInputClasses;




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $e5536adbffcfe8db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $2838e8fcd66683de$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $e5536adbffcfe8db$var$OutlinedInputRoot = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $4990f7d2f8e3372a$export$965edad20a84fa75)
})((0, $iAnBN.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        [`&.${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).focused} .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).focused} .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        [`&:hover .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
                        }
                    },
                    [`&.${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).error} .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).disabled} .${(0, $2838e8fcd66683de$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: "16.5px 14px"
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === "small",
                style: {
                    padding: "8.5px 14px"
                }
            }
        ]
    };
}));
const $e5536adbffcfe8db$var$NotchedOutlineRoot = (0, $6JVXO.default)((0, $2bb9c613ffc972e7$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $iAnBN.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $e5536adbffcfe8db$var$OutlinedInputInput = (0, $6JVXO.default)((0, $4990f7d2f8e3372a$export$ee10465db6ff6017), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $4990f7d2f8e3372a$export$cf507b112810e72d)
})((0, $iAnBN.default)(({ theme: theme })=>({
        padding: "16.5px 14px",
        ...!theme.vars && {
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
                caretColor: theme.palette.mode === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        ...theme.vars && {
            "&:-webkit-autofill": {
                borderRadius: "inherit"
            },
            [theme.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 100px #266798 inset",
                    WebkitTextFillColor: "#fff",
                    caretColor: "#fff"
                }
            }
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    padding: "8.5px 14px"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $e5536adbffcfe8db$var$OutlinedInput = /*#__PURE__*/ $aqdBs.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text", ...other } = props;
    const classes = $e5536adbffcfe8db$var$useUtilityClasses(props);
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $e5536adbffcfe8db$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $e5536adbffcfe8db$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4990f7d2f8e3372a$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $1Ivrw.jsx)($e5536adbffcfe8db$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
if ($e5536adbffcfe8db$var$OutlinedInput) $e5536adbffcfe8db$var$OutlinedInput.muiName = "Input";
var $e5536adbffcfe8db$export$2e2bcd8739ae039 = $e5536adbffcfe8db$var$OutlinedInput;



var $9iMQk = parcelRequire("9iMQk");
function $cb6a59fe0e4a296f$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $9iMQk.default)(theme.components[name].defaultProps, props);
}



"use client";
function $70c33c2f46246d59$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $6df9c97a08eacc3d$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $cb6a59fe0e4a296f$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



var $9xlCw = parcelRequire("9xlCw");

var $dbHL4 = parcelRequire("dbHL4");
"use client";
function $96e6a52dfe8d6626$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $70c33c2f46246d59$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $9xlCw.default,
        themeId: (0, $dbHL4.default)
    });
}




var $6JVXO = parcelRequire("6JVXO");

var $aMtHL = parcelRequire("aMtHL");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $58786d866a7f202c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $58786d866a7f202c$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $58786d866a7f202c$var$StyledInput = (0, $6JVXO.default)((0, $5c4cceefff246698$export$2e2bcd8739ae039), $58786d866a7f202c$var$styledRootConfig)("");
const $58786d866a7f202c$var$StyledOutlinedInput = (0, $6JVXO.default)((0, $e5536adbffcfe8db$export$2e2bcd8739ae039), $58786d866a7f202c$var$styledRootConfig)("");
const $58786d866a7f202c$var$StyledFilledInput = (0, $6JVXO.default)((0, $4acd92adf7ce06be$export$2e2bcd8739ae039), $58786d866a7f202c$var$styledRootConfig)("");
const $58786d866a7f202c$var$Select = /*#__PURE__*/ $aqdBs.forwardRef(function Select(inProps, ref) {
    const props = (0, $96e6a52dfe8d6626$export$2e2bcd8739ae039)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $4bf730583a59b871$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined", ...other } = props;
    const inputComponent = native ? (0, $6c3fe450d1a69246$export$2e2bcd8739ae039) : (0, $e2a261a2522ecf32$export$2e2bcd8739ae039);
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $58786d866a7f202c$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $1Ivrw.jsx)($58786d866a7f202c$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $1Ivrw.jsx)($58786d866a7f202c$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $1Ivrw.jsx)($58786d866a7f202c$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $e2928a743af788d2$export$2e2bcd8739ae039)(ref, (0, $e0c9f14768ae2407$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($aqdBs.Fragment, {
        children: /*#__PURE__*/ $aqdBs.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $88kuG.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === "outlined" ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $fQojQ.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$58786d866a7f202c$var$Select.muiName = "Select";
var $58786d866a7f202c$export$2e2bcd8739ae039 = $58786d866a7f202c$var$Select;



var $aqdBs = parcelRequire("aqdBs");

var $fQojQ = parcelRequire("fQojQ");

var $eFaUn = parcelRequire("eFaUn");

var $3WTHp = parcelRequire("3WTHp");


var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $d3229ae3545ef2c6$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $eFaUn.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $3WTHp.default));
    const Box = /*#__PURE__*/ $aqdBs.forwardRef(function Box(inProps, ref) {
        const theme = (0, $6df9c97a08eacc3d$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = "div", ...other } = (0, $98eda6bb3dc6d08b$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $1Ivrw.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $fQojQ.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $hILTa = parcelRequire("hILTa");

var $cIIWu = parcelRequire("cIIWu");

var $dbHL4 = parcelRequire("dbHL4");

var $jIPNy = parcelRequire("jIPNy");
const $a40eca30b3053633$var$boxClasses = (0, $jIPNy.default)("MuiBox", [
    "root"
]);
var $a40eca30b3053633$export$2e2bcd8739ae039 = $a40eca30b3053633$var$boxClasses;


"use client";
const $31cc929a959e1d45$var$defaultTheme = (0, $cIIWu.default)();
const $31cc929a959e1d45$var$Box = (0, $d3229ae3545ef2c6$export$2e2bcd8739ae039)({
    themeId: (0, $dbHL4.default),
    defaultTheme: $31cc929a959e1d45$var$defaultTheme,
    defaultClassName: (0, $a40eca30b3053633$export$2e2bcd8739ae039).root,
    generateClassName: (0, $hILTa.default).generate
});
var $31cc929a959e1d45$export$2e2bcd8739ae039 = $31cc929a959e1d45$var$Box;


var $23d061f5ca9565f7$exports = {};
"use strict";
"use client";
var $40a8df7d40f3cb7f$exports = {};
function $40a8df7d40f3cb7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$40a8df7d40f3cb7f$exports = $40a8df7d40f3cb7f$var$_interopRequireDefault, $40a8df7d40f3cb7f$exports.__esModule = true, $40a8df7d40f3cb7f$exports["default"] = $40a8df7d40f3cb7f$exports;


Object.defineProperty($23d061f5ca9565f7$exports, "__esModule", {
    value: true
});
$23d061f5ca9565f7$exports.default = void 0;

var $23d061f5ca9565f7$var$_createSvgIcon = $40a8df7d40f3cb7f$exports((parcelRequire("2zAtv")));

var $1Ivrw = parcelRequire("1Ivrw");
var $23d061f5ca9565f7$var$_default = $23d061f5ca9565f7$exports.default = (0, $23d061f5ca9565f7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");



var $6318401b812764d3$exports = {};
$6318401b812764d3$exports = new URL("LogoMoovyWhite.20265a7d.svg", import.meta.url).toString();


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


function $00e6da6e00acc8ce$export$2e2bcd8739ae039() {
    var intl = $aqdBs.useContext((0, $3f9cd05dec716d3d$export$841858b892ce1f4c));
    (0, $d10f71186d2a040e$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


function $a30851f4d571c489$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $172d8be976204b2c$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $172d8be976204b2c$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $d10f71186d2a040e$export$d36bdfa510afb180)(nextValues, values) && (0, $d10f71186d2a040e$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $a30851f4d571c489$var$FormattedMessage(props) {
    var intl = (0, $00e6da6e00acc8ce$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $aqdBs.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $aqdBs.createElement(Component, null, $aqdBs.Children.toArray(nodes));
    return $aqdBs.createElement($aqdBs.Fragment, null, nodes);
}
$a30851f4d571c489$var$FormattedMessage.displayName = "FormattedMessage";
var $a30851f4d571c489$var$MemoizedFormattedMessage = $aqdBs.memo($a30851f4d571c489$var$FormattedMessage, $a30851f4d571c489$var$areEqual);
$a30851f4d571c489$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $a30851f4d571c489$export$2e2bcd8739ae039 = $a30851f4d571c489$var$MemoizedFormattedMessage;


const $65991b192542b017$var$KioskAppBar = ({ language: language, onLanguageChange: onLanguageChange })=>{
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const handleChange = (event)=>{
        const selectedLanguage = event.target.value;
        onLanguageChange(selectedLanguage);
    };
    const languageOptions = [
        {
            value: "fi",
            label: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                id: "language.finnish"
            })
        },
        {
            value: "en",
            label: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                id: "language.english"
            })
        }
    ];
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            background: theme.palette.gradient.primary,
            height: "68px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                component: "img",
                sx: {
                    height: "60%",
                    marginLeft: "15px"
                },
                alt: "Moovy logo",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6318401b812764d3$exports)))
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4ea6f68cc48b79d3$export$2e2bcd8739ae039), {
                variant: "standard",
                sx: {
                    marginRight: "15px"
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $58786d866a7f202c$export$2e2bcd8739ae039), {
                    "aria-label": "Kieli",
                    IconComponent: ()=>/*#__PURE__*/ (0, $1Ivrw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($23d061f5ca9565f7$exports))), {
                            sx: {
                                color: "white"
                            }
                        }),
                    disableUnderline: true,
                    labelId: "select-language",
                    id: "kiosk-app-bar-select-lang",
                    value: language,
                    onChange: handleChange,
                    sx: {
                        color: "white"
                    },
                    children: languageOptions.map((option)=>/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $609cc9f9ea58bcc3$export$2e2bcd8739ae039), {
                            value: option.value,
                            children: option.label
                        }, option.value))
                })
            })
        ]
    });
};
var $65991b192542b017$export$2e2bcd8739ae039 = $65991b192542b017$var$KioskAppBar;


const { slice: $4119d9f3f4ecd47e$var$slice, forEach: $4119d9f3f4ecd47e$var$forEach } = [];
function $4119d9f3f4ecd47e$var$defaults(obj) {
    $4119d9f3f4ecd47e$var$forEach.call($4119d9f3f4ecd47e$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
const $4119d9f3f4ecd47e$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $4119d9f3f4ecd47e$var$serializeCookie = (name, val, options)=>{
    const opt = options || {};
    opt.path = opt.path || "/";
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$4119d9f3f4ecd47e$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$4119d9f3f4ecd47e$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
const $4119d9f3f4ecd47e$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $4119d9f3f4ecd47e$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(";");
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name) {
        this.create(name, "", -1);
    }
};
var $4119d9f3f4ecd47e$var$cookie$1 = {
    name: "cookie",
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== "undefined") return $4119d9f3f4ecd47e$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== "undefined") $4119d9f3f4ecd47e$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $4119d9f3f4ecd47e$var$querystring = {
    name: "querystring",
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== "undefined") {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            const query = search.substring(1);
            const params = query.split("&");
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf("=");
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
let $4119d9f3f4ecd47e$var$hasLocalStorageSupport = null;
const $4119d9f3f4ecd47e$var$localStorageAvailable = ()=>{
    if ($4119d9f3f4ecd47e$var$hasLocalStorageSupport !== null) return $4119d9f3f4ecd47e$var$hasLocalStorageSupport;
    try {
        $4119d9f3f4ecd47e$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        const testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $4119d9f3f4ecd47e$var$hasLocalStorageSupport = false;
    }
    return $4119d9f3f4ecd47e$var$hasLocalStorageSupport;
};
var $4119d9f3f4ecd47e$var$localStorage = {
    name: "localStorage",
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $4119d9f3f4ecd47e$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $4119d9f3f4ecd47e$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $4119d9f3f4ecd47e$var$hasSessionStorageSupport = null;
const $4119d9f3f4ecd47e$var$sessionStorageAvailable = ()=>{
    if ($4119d9f3f4ecd47e$var$hasSessionStorageSupport !== null) return $4119d9f3f4ecd47e$var$hasSessionStorageSupport;
    try {
        $4119d9f3f4ecd47e$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        const testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $4119d9f3f4ecd47e$var$hasSessionStorageSupport = false;
    }
    return $4119d9f3f4ecd47e$var$hasSessionStorageSupport;
};
var $4119d9f3f4ecd47e$var$sessionStorage = {
    name: "sessionStorage",
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $4119d9f3f4ecd47e$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $4119d9f3f4ecd47e$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $4119d9f3f4ecd47e$var$navigator$1 = {
    name: "navigator",
    lookup (options) {
        const found = [];
        if (typeof navigator !== "undefined") {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $4119d9f3f4ecd47e$var$htmlTag = {
    name: "htmlTag",
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === "function") found = internalHtmlTag.getAttribute("lang");
        return found;
    }
};
var $4119d9f3f4ecd47e$var$path = {
    name: "path",
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === "undefined") return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === "number" ? lookupFromPathIndex : 0;
        return language[index]?.replace("/", "");
    }
};
var $4119d9f3f4ecd47e$var$subdomain = {
    name: "subdomain",
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === "number" ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== "undefined" && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
function $4119d9f3f4ecd47e$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    };
}
class $4119d9f3f4ecd47e$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services || {
            languageUtils: {}
        }; // this way the language detector can be used without i18next
        this.options = $4119d9f3f4ecd47e$var$defaults(options, this.options || {}, $4119d9f3f4ecd47e$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = (l)=>l.replace("-", "_");
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($4119d9f3f4ecd47e$var$cookie$1);
        this.addDetector($4119d9f3f4ecd47e$var$querystring);
        this.addDetector($4119d9f3f4ecd47e$var$localStorage);
        this.addDetector($4119d9f3f4ecd47e$var$sessionStorage);
        this.addDetector($4119d9f3f4ecd47e$var$navigator$1);
        this.addDetector($4119d9f3f4ecd47e$var$htmlTag);
        this.addDetector($4119d9f3f4ecd47e$var$path);
        this.addDetector($4119d9f3f4ecd47e$var$subdomain);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect(detectionOrder) {
        if (!detectionOrder) detectionOrder = this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === "string") lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng, caches) {
        if (!caches) caches = this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$4119d9f3f4ecd47e$export$2e2bcd8739ae039.type = "languageDetector";


const $48682d66c9c47d0c$var$isString = (obj)=>typeof obj === "string";
const $48682d66c9c47d0c$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $48682d66c9c47d0c$var$makeString = (object)=>{
    if (object == null) return "";
    return "" + object;
};
const $48682d66c9c47d0c$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $48682d66c9c47d0c$var$lastOfPathSeparatorRegExp = /###/g;
const $48682d66c9c47d0c$var$cleanKey = (key)=>key && key.indexOf("###") > -1 ? key.replace($48682d66c9c47d0c$var$lastOfPathSeparatorRegExp, ".") : key;
const $48682d66c9c47d0c$var$canNotTraverseDeeper = (object)=>!object || $48682d66c9c47d0c$var$isString(object);
const $48682d66c9c47d0c$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$48682d66c9c47d0c$var$isString(path) ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($48682d66c9c47d0c$var$canNotTraverseDeeper(object)) return {};
        const key = $48682d66c9c47d0c$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($48682d66c9c47d0c$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $48682d66c9c47d0c$var$cleanKey(stack[stackIndex])
    };
};
const $48682d66c9c47d0c$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $48682d66c9c47d0c$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $48682d66c9c47d0c$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $48682d66c9c47d0c$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $48682d66c9c47d0c$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $48682d66c9c47d0c$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $48682d66c9c47d0c$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $48682d66c9c47d0c$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $48682d66c9c47d0c$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $48682d66c9c47d0c$var$getPath(data, key);
    if (value !== undefined) return value;
    return $48682d66c9c47d0c$var$getPath(defaultData, key);
};
const $48682d66c9c47d0c$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if ($48682d66c9c47d0c$var$isString(target[prop]) || target[prop] instanceof String || $48682d66c9c47d0c$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $48682d66c9c47d0c$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $48682d66c9c47d0c$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var $48682d66c9c47d0c$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
const $48682d66c9c47d0c$var$escape = (data)=>{
    if ($48682d66c9c47d0c$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$48682d66c9c47d0c$var$_entityMap[s]);
    return data;
};
class $48682d66c9c47d0c$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $48682d66c9c47d0c$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $48682d66c9c47d0c$var$looksLikeObjectPathRegExpCache = new $48682d66c9c47d0c$var$RegExpCache(20);
const $48682d66c9c47d0c$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $48682d66c9c47d0c$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $48682d66c9c47d0c$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $48682d66c9c47d0c$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $48682d66c9c47d0c$var$getCleanedCode = (code)=>code && code.replace("_", "-");
const $48682d66c9c47d0c$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $48682d66c9c47d0c$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $48682d66c9c47d0c$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($48682d66c9c47d0c$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $48682d66c9c47d0c$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $48682d66c9c47d0c$var$Logger(this.logger, options);
    }
}
var $48682d66c9c47d0c$var$baseLogger = new $48682d66c9c47d0c$var$Logger();
class $48682d66c9c47d0c$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $48682d66c9c47d0c$var$ResourceStore extends $48682d66c9c47d0c$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($48682d66c9c47d0c$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $48682d66c9c47d0c$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || !$48682d66c9c47d0c$var$isString(key)) return result;
        return $48682d66c9c47d0c$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $48682d66c9c47d0c$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($48682d66c9c47d0c$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $48682d66c9c47d0c$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $48682d66c9c47d0c$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $48682d66c9c47d0c$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $48682d66c9c47d0c$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $48682d66c9c47d0c$var$checkedLoadedFor = {};
class $48682d66c9c47d0c$var$Translator extends $48682d66c9c47d0c$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $48682d66c9c47d0c$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$48682d66c9c47d0c$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if ($48682d66c9c47d0c$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$48682d66c9c47d0c$var$isString(res) && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($48682d66c9c47d0c$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $48682d66c9c47d0c$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$48682d66c9c47d0c$var$isString(options.count);
            const hasDefaultValue = $48682d66c9c47d0c$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $48682d66c9c47d0c$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$48682d66c9c47d0c$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $48682d66c9c47d0c$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $48682d66c9c47d0c$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($48682d66c9c47d0c$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$48682d66c9c47d0c$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($48682d66c9c47d0c$var$isString(options.context) || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$48682d66c9c47d0c$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $48682d66c9c47d0c$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && !$48682d66c9c47d0c$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $48682d66c9c47d0c$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $48682d66c9c47d0c$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $48682d66c9c47d0c$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $48682d66c9c47d0c$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($48682d66c9c47d0c$var$isString(code) && code.indexOf("-") > -1) {
            if (typeof Intl !== "undefined" && typeof Intl.getCanonicalLocales !== "undefined") try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $48682d66c9c47d0c$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $48682d66c9c47d0c$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $48682d66c9c47d0c$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if ($48682d66c9c47d0c$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($48682d66c9c47d0c$var$isString(code) && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if ($48682d66c9c47d0c$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $48682d66c9c47d0c$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $48682d66c9c47d0c$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $48682d66c9c47d0c$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $48682d66c9c47d0c$var$intlVersions = [
    "v4"
];
const $48682d66c9c47d0c$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $48682d66c9c47d0c$var$createRules = ()=>{
    const rules = {};
    $48682d66c9c47d0c$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $48682d66c9c47d0c$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $48682d66c9c47d0c$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $48682d66c9c47d0c$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $48682d66c9c47d0c$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            const cleanedCode = $48682d66c9c47d0c$var$getCleanedCode(code === "dev" ? "en" : code);
            const type = options.ordinal ? "ordinal" : "cardinal";
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            const rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$48682d66c9c47d0c$var$suffixesOrder[pluralCategory1] - $48682d66c9c47d0c$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$48682d66c9c47d0c$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $48682d66c9c47d0c$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $48682d66c9c47d0c$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $48682d66c9c47d0c$var$isString(key)) {
        path = $48682d66c9c47d0c$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $48682d66c9c47d0c$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $48682d66c9c47d0c$var$regexSafe = (val)=>val.replace(/\$/g, "$$$$");
class $48682d66c9c47d0c$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $48682d66c9c47d0c$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $48682d66c9c47d0c$var$regexEscape(prefix) : prefixEscaped || "{{";
        this.suffix = suffix ? $48682d66c9c47d0c$var$regexEscape(suffix) : suffixEscaped || "}}";
        this.formatSeparator = formatSeparator || ",";
        this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
        this.nestingPrefix = nestingPrefix ? $48682d66c9c47d0c$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $48682d66c9c47d0c$var$regexEscape("$t(");
        this.nestingSuffix = nestingSuffix ? $48682d66c9c47d0c$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $48682d66c9c47d0c$var$regexEscape(")");
        this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $48682d66c9c47d0c$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($48682d66c9c47d0c$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$48682d66c9c47d0c$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $48682d66c9c47d0c$var$regexSafe(this.escape(val)) : $48682d66c9c47d0c$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $48682d66c9c47d0c$var$isString(temp) ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (!$48682d66c9c47d0c$var$isString(value) && !this.useRawValueToEscape) value = $48682d66c9c47d0c$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$48682d66c9c47d0c$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$48682d66c9c47d0c$var$isString(value)) return value;
            if (!$48682d66c9c47d0c$var$isString(value)) value = $48682d66c9c47d0c$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $48682d66c9c47d0c$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(":");
                    const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === "false") formatOptions[trimmedKey] = false;
                    if (val === "true") formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $48682d66c9c47d0c$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($48682d66c9c47d0c$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $48682d66c9c47d0c$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $48682d66c9c47d0c$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $48682d66c9c47d0c$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $48682d66c9c47d0c$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $48682d66c9c47d0c$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $48682d66c9c47d0c$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $48682d66c9c47d0c$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find((f)=>f.indexOf(")") > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(")") > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $48682d66c9c47d0c$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $48682d66c9c47d0c$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $48682d66c9c47d0c$var$Connector extends $48682d66c9c47d0c$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $48682d66c9c47d0c$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $48682d66c9c47d0c$var$pushPath(q.loaded, [
                lng
            ], ns);
            $48682d66c9c47d0c$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if ($48682d66c9c47d0c$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($48682d66c9c47d0c$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $48682d66c9c47d0c$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if ($48682d66c9c47d0c$var$isString(args[1])) ret.defaultValue = args[1];
            if ($48682d66c9c47d0c$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $48682d66c9c47d0c$var$transformOptions = (options)=>{
    if ($48682d66c9c47d0c$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($48682d66c9c47d0c$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($48682d66c9c47d0c$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
};
const $48682d66c9c47d0c$var$noop = ()=>{};
const $48682d66c9c47d0c$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
};
class $48682d66c9c47d0c$var$I18n extends $48682d66c9c47d0c$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $48682d66c9c47d0c$var$transformOptions(options);
        this.services = {};
        this.logger = $48682d66c9c47d0c$var$baseLogger;
        this.modules = {
            external: []
        };
        $48682d66c9c47d0c$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($48682d66c9c47d0c$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $48682d66c9c47d0c$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$48682d66c9c47d0c$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $48682d66c9c47d0c$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $48682d66c9c47d0c$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $48682d66c9c47d0c$var$Formatter;
            const lu = new $48682d66c9c47d0c$var$LanguageUtil(this.options);
            this.store = new $48682d66c9c47d0c$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $48682d66c9c47d0c$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $48682d66c9c47d0c$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $48682d66c9c47d0c$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $48682d66c9c47d0c$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $48682d66c9c47d0c$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $48682d66c9c47d0c$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $48682d66c9c47d0c$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $48682d66c9c47d0c$var$noop;
        let usedCallback = callback;
        const usedLng = $48682d66c9c47d0c$var$isString(language) ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $48682d66c9c47d0c$var$defer();
        if (typeof lngs === "function") {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === "function") {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $48682d66c9c47d0c$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $48682d66c9c47d0c$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $48682d66c9c47d0c$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $48682d66c9c47d0c$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($48682d66c9c47d0c$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $48682d66c9c47d0c$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($48682d66c9c47d0c$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $48682d66c9c47d0c$var$defer();
        if ($48682d66c9c47d0c$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $48682d66c9c47d0c$var$LanguageUtil($48682d66c9c47d0c$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $48682d66c9c47d0c$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $48682d66c9c47d0c$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $48682d66c9c47d0c$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $48682d66c9c47d0c$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $48682d66c9c47d0c$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $48682d66c9c47d0c$export$2e2bcd8739ae039 = $48682d66c9c47d0c$var$I18n.createInstance();
$48682d66c9c47d0c$export$2e2bcd8739ae039.createInstance = $48682d66c9c47d0c$var$I18n.createInstance;
const $48682d66c9c47d0c$export$99152e8d49ca4e7d = $48682d66c9c47d0c$export$2e2bcd8739ae039.createInstance;
const $48682d66c9c47d0c$export$147ec2801e896265 = $48682d66c9c47d0c$export$2e2bcd8739ae039.dir;
const $48682d66c9c47d0c$export$2cd8252107eb640b = $48682d66c9c47d0c$export$2e2bcd8739ae039.init;
const $48682d66c9c47d0c$export$d3d08d944062d7e = $48682d66c9c47d0c$export$2e2bcd8739ae039.loadResources;
const $48682d66c9c47d0c$export$a5d9bf5d83fcab09 = $48682d66c9c47d0c$export$2e2bcd8739ae039.reloadResources;
const $48682d66c9c47d0c$export$1f96ae73734a86cc = $48682d66c9c47d0c$export$2e2bcd8739ae039.use;
const $48682d66c9c47d0c$export$61465194746e7fd2 = $48682d66c9c47d0c$export$2e2bcd8739ae039.changeLanguage;
const $48682d66c9c47d0c$export$f90d180fc7da3b3b = $48682d66c9c47d0c$export$2e2bcd8739ae039.getFixedT;
const $48682d66c9c47d0c$export$625550452a3fa3ec = $48682d66c9c47d0c$export$2e2bcd8739ae039.t;
const $48682d66c9c47d0c$export$f7e9f41ea797a17 = $48682d66c9c47d0c$export$2e2bcd8739ae039.exists;
const $48682d66c9c47d0c$export$2b4b218e406d2d00 = $48682d66c9c47d0c$export$2e2bcd8739ae039.setDefaultNamespace;
const $48682d66c9c47d0c$export$93d9ee97c1ad3f31 = $48682d66c9c47d0c$export$2e2bcd8739ae039.hasLoadedNamespace;
const $48682d66c9c47d0c$export$83be934b53fff43b = $48682d66c9c47d0c$export$2e2bcd8739ae039.loadNamespaces;
const $48682d66c9c47d0c$export$8cd7e7a54fa865bc = $48682d66c9c47d0c$export$2e2bcd8739ae039.loadLanguages;



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
var $ccee921df779fd30$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $ccee921df779fd30$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $ac3d873e565289f8$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $ac3d873e565289f8$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($ccee921df779fd30$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($ac3d873e565289f8$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $ac3d873e565289f8$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $ac3d873e565289f8$var$i = /^\s*$/, $ac3d873e565289f8$var$s = Object.create(null);
function $ac3d873e565289f8$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($ac3d873e565289f8$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $ac3d873e565289f8$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $ac3d873e565289f8$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($ac3d873e565289f8$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $ac3d873e565289f8$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $ac3d873e565289f8$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $ac3d873e565289f8$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $ac3d873e565289f8$var$a("", t);
        }, "");
    }
};
var $ac3d873e565289f8$export$2e2bcd8739ae039 = $ac3d873e565289f8$var$c;


const $432e8b8020bdbba5$export$c106dd0671a0fc2d = (...args)=>{
    if (console?.warn) {
        if ($432e8b8020bdbba5$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
};
const $432e8b8020bdbba5$var$alreadyWarned = {};
const $432e8b8020bdbba5$export$5b28268982f175ba = (...args)=>{
    if ($432e8b8020bdbba5$export$844ec244b1367d54(args[0]) && $432e8b8020bdbba5$var$alreadyWarned[args[0]]) return;
    if ($432e8b8020bdbba5$export$844ec244b1367d54(args[0])) $432e8b8020bdbba5$var$alreadyWarned[args[0]] = new Date();
    $432e8b8020bdbba5$export$c106dd0671a0fc2d(...args);
};
const $432e8b8020bdbba5$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
const $432e8b8020bdbba5$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $432e8b8020bdbba5$var$loadedClb(i18n, cb));
};
const $432e8b8020bdbba5$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($432e8b8020bdbba5$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $432e8b8020bdbba5$var$loadedClb(i18n, cb));
};
const $432e8b8020bdbba5$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $432e8b8020bdbba5$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n?.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $432e8b8020bdbba5$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($432e8b8020bdbba5$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : "Unknown");
const $432e8b8020bdbba5$export$844ec244b1367d54 = (obj)=>typeof obj === "string";
const $432e8b8020bdbba5$export$a6cdc56e425d0d0a = (obj)=>typeof obj === "object" && obj !== null;


const $1e320ce1d0fd7133$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $1e320ce1d0fd7133$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $1e320ce1d0fd7133$var$unescapeHtmlEntity = (m)=>$1e320ce1d0fd7133$var$htmlEntities[m];
const $1e320ce1d0fd7133$export$e8bacd2802a88316 = (text)=>text.replace($1e320ce1d0fd7133$var$matchHtmlEntity, $1e320ce1d0fd7133$var$unescapeHtmlEntity);


let $ae813f950864c32f$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $1e320ce1d0fd7133$export$e8bacd2802a88316
};
const $ae813f950864c32f$export$2e2366488d12e20d = (options = {})=>{
    $ae813f950864c32f$var$defaultOptions = {
        ...$ae813f950864c32f$var$defaultOptions,
        ...options
    };
};
const $ae813f950864c32f$export$212bb2fc580a90a8 = ()=>$ae813f950864c32f$var$defaultOptions;


let $e0afdc003a86c984$var$i18nInstance;
const $e0afdc003a86c984$export$a039134f2fc7e0 = (instance)=>{
    $e0afdc003a86c984$var$i18nInstance = instance;
};
const $e0afdc003a86c984$export$64af334f494c2f47 = ()=>$e0afdc003a86c984$var$i18nInstance;


const $507caed0207a4789$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $507caed0207a4789$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $507caed0207a4789$var$getAsArray(children) : children;
};
const $507caed0207a4789$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $aqdBs.isValidElement));
const $507caed0207a4789$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $507caed0207a4789$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $507caed0207a4789$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $507caed0207a4789$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $432e8b8020bdbba5$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $aqdBs.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $432e8b8020bdbba5$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $507caed0207a4789$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $432e8b8020bdbba5$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $432e8b8020bdbba5$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $432e8b8020bdbba5$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $507caed0207a4789$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $507caed0207a4789$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $432e8b8020bdbba5$export$844ec244b1367d54)(child)) return;
            if ($507caed0207a4789$var$hasChildren(child)) getData($507caed0207a4789$var$getChildren(child));
            else if ((0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(child) && !(0, $aqdBs.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $ac3d873e565289f8$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $507caed0207a4789$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $507caed0207a4789$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $aqdBs.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $aqdBs.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $aqdBs.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $507caed0207a4789$var$getAsArray(reactNode);
        const astNodes = $507caed0207a4789$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $507caed0207a4789$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $aqdBs.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $507caed0207a4789$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $432e8b8020bdbba5$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($507caed0207a4789$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $aqdBs.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $aqdBs.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $aqdBs.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $507caed0207a4789$var$getAsArray(children || []));
    return $507caed0207a4789$var$getChildren(result[0]);
};
function $507caed0207a4789$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $e0afdc003a86c984$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $432e8b8020bdbba5$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $ae813f950864c32f$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $432e8b8020bdbba5$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $507caed0207a4789$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        if (!components[c].key) components[c] = (0, $aqdBs.cloneElement)(components[c], {
            key: c
        });
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $aqdBs.createElement)((0, $aqdBs.Fragment), null, comp);
        }
        components[c] = (0, $aqdBs.createElement)(Componentized);
    });
    const content = $507caed0207a4789$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $aqdBs.createElement)(useAsParent, additionalProps, content) : content;
}



var $aqdBs = parcelRequire("aqdBs");




const $74fc5637c34ee583$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $ae813f950864c32f$export$2e2366488d12e20d)(instance.options.react);
        (0, $e0afdc003a86c984$export$a039134f2fc7e0)(instance);
    }
};


const $d6c969c6f5f5554f$export$5603ab5ced17ce64 = (0, $aqdBs.createContext)();
class $d6c969c6f5f5554f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $d6c969c6f5f5554f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $d6c969c6f5f5554f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $d6c969c6f5f5554f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $e0afdc003a86c984$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $88cb8571d077bf71$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $aqdBs.useContext)((0, $d6c969c6f5f5554f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $e0afdc003a86c984$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $507caed0207a4789$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $aqdBs = parcelRequire("aqdBs");


const $7a4e960510cdb529$var$usePrevious = (value, ignore)=>{
    const ref = (0, $aqdBs.useRef)();
    (0, $aqdBs.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $7a4e960510cdb529$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $7a4e960510cdb529$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $aqdBs.useCallback)($7a4e960510cdb529$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $7a4e960510cdb529$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $aqdBs.useContext)((0, $d6c969c6f5f5554f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $e0afdc003a86c984$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $d6c969c6f5f5554f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $432e8b8020bdbba5$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $432e8b8020bdbba5$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $432e8b8020bdbba5$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $432e8b8020bdbba5$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $432e8b8020bdbba5$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $ae813f950864c32f$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $432e8b8020bdbba5$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $432e8b8020bdbba5$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $7a4e960510cdb529$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$7a4e960510cdb529$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $aqdBs.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $7a4e960510cdb529$var$usePrevious(joinedNS);
    const isMounted = (0, $aqdBs.useRef)(true);
    (0, $aqdBs.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $432e8b8020bdbba5$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $432e8b8020bdbba5$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n) bindI18n?.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $432e8b8020bdbba5$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $432e8b8020bdbba5$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $aqdBs = parcelRequire("aqdBs");


const $4fd9712549e4208e$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $7a4e960510cdb529$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $aqdBs.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $432e8b8020bdbba5$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $aqdBs.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $aqdBs.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $f59c027c99d2026a$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $7a4e960510cdb529$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $aqdBs = parcelRequire("aqdBs");

function $14c6e38199098d7c$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $aqdBs.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $aqdBs.createElement)((0, $d6c969c6f5f5554f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

const $d5f2aeaa12af32b5$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $aqdBs.useContext)((0, $d6c969c6f5f5554f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $e0afdc003a86c984$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $324de61374518389$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d5f2aeaa12af32b5$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $aqdBs.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $d6c969c6f5f5554f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $432e8b8020bdbba5$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $591a08e49183ba81$export$324d90190a8b822a = ()=>"";
const $591a08e49183ba81$export$2da9be4cfdb689b1 = ()=>"";
const $591a08e49183ba81$export$98e628dec113755e = ()=>"";
const $591a08e49183ba81$export$2e6c959c16ff56b8 = ()=>"";
const $591a08e49183ba81$export$4e35d5c922a95490 = ()=>"";
const $591a08e49183ba81$export$720a3b9db04b7a0f = ()=>"";


var $5b7c337df226eaa3$exports = {};
$5b7c337df226eaa3$exports = JSON.parse('{"moovyVirtualKeyboard.button.redeemPermit":"Lunasta lupa","page.qrcode.welcome":"Tervetuloa!","page.device.login.button":"Kirjaudu sis\xe4\xe4n","page.device.textfield.login.username":"K\xe4ytt\xe4j\xe4tunnus","page.device.textfield.login.password":"Salasana","page.homePage.instructions.parkingInfo.organization":"{permitDuration}h pys\xe4k\xf6intilupa","page.homePage.instructions.parkingInfo.default":"Pys\xe4k\xf6intilupa","page.homePage.instructions.visitorMessage.default":"Pys\xe4k\xf6intilupa on voimassa sy\xf6tt\xe4miesi tietojen mukaan.","page.homePage.select.product":"Valitse pys\xe4k\xf6intilupa","page.homePage.instructions.enterRegisterNumber":"SY\xd6T\xc4 REKISTERITUNNUS: ","page.homePage.instructions.registerNumber.arialabel":"Rekisteritunnus","page.homePage.instructions.visitorMessage.organization.arialabel":"Yritys","page.homePage.toast.permitGranted":"Pys\xe4k\xf6intilupa my\xf6nnetty.","page.homePage.toast.errorCreatingPermit":"Pys\xe4k\xf6intilupaa ei my\xf6nnetty.","page.homePage.toast.errorCreatingPermit.localizedErrorMessage":"Pys\xe4k\xf6intilupaa ei my\xf6nnetty: {message}","page.homePage.success.grantedSuccessfully":"Pys\xe4k\xf6intilupa on my\xf6nnetty onnistuneesti rekisteritunnukselle","page.homePage.success.permitType":"Pys\xe4k\xf6intilupa","page.homePage.success.permitTime":"Ajankohta","page.homePage.success.licensePlate":"Rekisteritunnus","page.homePage.success.okButton":"Valmis","page.homePage.success.clearingPage":"T\xe4m\xe4 sivu tyhjennet\xe4\xe4n 10 sekunnin p\xe4\xe4st\xe4.","page.homePage.configurationError.title":"Pys\xe4k\xf6intilupa","page.homePage.configurationError.body":"Lupien my\xf6nt\xe4minen ei valitettavasti ole mahdollista. Ota yhteytt\xe4 henkil\xf6kuntaan.","page.homePage.configurationError.alert":"Asennustietoja ei voitu ladata","page.homePage.configurationError.button":"Lataa tiedot uudelleen","page.passcodePrompt.header":"Sy\xf6t\xe4 tunnussana","page.passcodePrompt.label":"Tunnussana","page.passcodePrompt.submit":"Tallenna","page.passcodePrompt.configurationFetch.error":"Konfiguraation haku ei onnistunut","page.passcodePrompt.configurationFetch.error.401":"Tunnussana v\xe4\xe4rin","page.passcodePrompt.configurationFetch.success":"Konfiguraatio ladattiin onnistuneesti","page.passcodePrompt.configurationFetch.reload":"Jatka","language.finnish":"Suomeksi","language.english":"In English","api.error.code.generic":"Tapahtui virhe","moovyErrorPage.oops":"Hups!","moovyErrorPage.message":"Pahoittelut, sivua ei voi ladata. Tarkista osoite ja yrit\xe4 ladata sivu uudestaan.","common.actions.error":"Tapahtui virhe","common.actions.get.error":"Tietojen haku ep\xe4onnistui","common.actions.network.error.message":"Lataus ep\xe4onnistui. Lupaa ei my\xf6nnetty.","common.network.offline":"Ei Internet-yhteytt\xe4. Tarkista verkko, jotta voit jatkaa palvelun k\xe4ytt\xf6\xe4."}');


var $83394db86e022347$exports = {};
$83394db86e022347$exports = JSON.parse('{"moovyVirtualKeyboard.button.redeemPermit":"Redeem permit","page.qrcode.welcome":"Welcome!","page.device.login.button":"Login","page.device.textfield.login.username":"Username","page.device.textfield.login.password":"Password","page.homePage.instructions.parkingInfo.organization":"{permitDuration}-hour parking permit","page.homePage.instructions.parkingInfo.default":"Parking permit","page.homePage.instructions.visitorMessage.default":"Parking permit is valid according to the information you enter.","page.homePage.select.product":"Select a parking permit","page.homePage.instructions.enterRegisterNumber":"ENTER LICENCE PLATE NUMBER: ","page.homePage.instructions.registerNumber.arialabel":"Licence plate","page.homePage.instructions.visitorMessage.organization.arialabel":"Organization","page.homePage.toast.permitGranted":"Parking permit granted.","page.homePage.toast.errorCreatingPermit":"Parking permit not granted.","page.homePage.toast.errorCreatingPermit.localizedErrorMessage":"Parking permit not granted: {message}","page.homePage.success.grantedSuccessfully":"Permit is granted successfully to license plate","page.homePage.success.permitType":"Parking permit","page.homePage.success.permitTime":"Validity","page.homePage.success.licensePlate":"Licenseplate","page.homePage.success.okButton":"Done","page.homePage.success.clearingPage":"This page will be cleared after 10 seconds.","page.homePage.configurationError.title":"Parking permit","page.homePage.configurationError.body":"Unfortunately, it is not possible to issue permits. Please contact the staff.","page.homePage.configurationError.alert":"Configuration information could not be fetched","page.homePage.configurationError.button":"Try to load again","page.passcodePrompt.header":"Input passcode","page.passcodePrompt.label":"Passcode","page.passcodePrompt.submit":"Submit","page.passcodePrompt.configurationFetch.error":"Configuration fetch failed","page.passcodePrompt.configurationFetch.error.401":"Wrong passcode","page.passcodePrompt.configurationFetch.success":"Configuration was fetched successfully","page.passcodePrompt.configurationFetch.reload":"Continue","language.finnish":"Suomeksi","language.english":"In English","api.error.code.generic":"An error occurred","moovyErrorPage.oops":"Oops!","moovyErrorPage.message":"Sorry, an unexpected error has occurred. Please, check the url and try to refresh the view again.","common.actions.error":"An error occurred","common.actions.get.error":"Failed to get data","common.actions.network.error.message":"Network request failed. Permit not granted.","common.network.offline":"You\u2019re currently offline. Please reconnect to continue using this service."}');


(0, $48682d66c9c47d0c$export$2e2bcd8739ae039).use((0, $4119d9f3f4ecd47e$export$2e2bcd8739ae039)).use((0, $74fc5637c34ee583$export$ae7e14d40d89f296)).init({
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    resources: {
        fi: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($5b7c337df226eaa3$exports)))
        },
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($83394db86e022347$exports)))
        }
    }
});
var $6c154842fccf6556$export$2e2bcd8739ae039 = (0, $48682d66c9c47d0c$export$2e2bcd8739ae039);





var $1Ivrw = parcelRequire("1Ivrw");


var $1Ivrw = parcelRequire("1Ivrw");


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $88kuG = parcelRequire("88kuG");

var $igOtJ = parcelRequire("igOtJ");

var $5ylSM = parcelRequire("5ylSM");

var $h4bqR = parcelRequire("h4bqR");
const $2a108c9b8aac6572$var$styled = (0, $h4bqR.default)();
var $2a108c9b8aac6572$export$2e2bcd8739ae039 = $2a108c9b8aac6572$var$styled;





var $iqdgc = parcelRequire("iqdgc");

var $1gEYn = parcelRequire("1gEYn");

var $lE9bp = parcelRequire("lE9bp");

var $1Ivrw = parcelRequire("1Ivrw");
const $2382d92ea4b7ea78$var$defaultTheme = (0, $iqdgc.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $2382d92ea4b7ea78$var$defaultCreateStyledComponent = (0, $2a108c9b8aac6572$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $2382d92ea4b7ea78$var$useThemePropsDefault(props) {
    return (0, $70c33c2f46246d59$export$2e2bcd8739ae039)({
        props: props,
        name: "MuiStack",
        defaultTheme: $2382d92ea4b7ea78$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $2382d92ea4b7ea78$var$joinChildren(children, separator) {
    const childrenArray = $aqdBs.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $aqdBs.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $2382d92ea4b7ea78$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $2382d92ea4b7ea78$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: "flex",
        flexDirection: "column",
        ...(0, $1gEYn.handleBreakpoints)({
            theme: theme
        }, (0, $1gEYn.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $lE9bp.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $1gEYn.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $1gEYn.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $lE9bp.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$2382d92ea4b7ea78$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $lE9bp.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $88kuG.default)(styles, (0, $1gEYn.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $1gEYn.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $2382d92ea4b7ea78$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $2382d92ea4b7ea78$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $2382d92ea4b7ea78$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $5ylSM.default)(slots, (slot)=>(0, $igOtJ.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($2382d92ea4b7ea78$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $aqdBs.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $98eda6bb3dc6d08b$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $1Ivrw.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $fQojQ.default)(classes.root, className),
            ...other,
            children: divider ? $2382d92ea4b7ea78$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}



var $6JVXO = parcelRequire("6JVXO");

"use client";
const $b5d4434a9401e2dd$var$Stack = (0, $2382d92ea4b7ea78$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $6JVXO.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $96e6a52dfe8d6626$export$2e2bcd8739ae039)({
            props: inProps,
            name: "MuiStack"
        })
});
var $b5d4434a9401e2dd$export$2e2bcd8739ae039 = $b5d4434a9401e2dd$var$Stack;


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $40jPv = parcelRequire("40jPv");


var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $9bfc5fe50bdc9bad$export$24c1f8f60cbac79e(slot) {
    return (0, $igOtJ.default)("MuiTypography", slot);
}
const $9bfc5fe50bdc9bad$var$typographyClasses = (0, $jIPNy.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $9bfc5fe50bdc9bad$export$2e2bcd8739ae039 = $9bfc5fe50bdc9bad$var$typographyClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $fafac108772b9e19$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $fafac108772b9e19$var$extendSxProp = (0, $14ea7e7763bb5a2b$export$7e7f5719ff4debb1)();
const $fafac108772b9e19$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $40jPv.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $9bfc5fe50bdc9bad$export$24c1f8f60cbac79e), classes);
};
const $fafac108772b9e19$export$140e2f5526d3cad8 = (0, $6JVXO.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $40jPv.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: "inherit"
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: "inherit",
                    lineHeight: "inherit",
                    letterSpacing: "inherit"
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== "inherit" && value && typeof value === "object").map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === "string").map(([color])=>({
                    props: {
                        color: `text${(0, $40jPv.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== "inherit",
                style: {
                    textAlign: "var(--Typography-textAlign)"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: "0.35em"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $fafac108772b9e19$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
const $fafac108772b9e19$var$Typography = /*#__PURE__*/ $aqdBs.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiTypography"
    });
    const isSxColor = !$fafac108772b9e19$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $fafac108772b9e19$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $fafac108772b9e19$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $fafac108772b9e19$var$defaultVariantMapping[variant]) || "span";
    const classes = $fafac108772b9e19$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($fafac108772b9e19$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== "inherit" && {
                "--Typography-textAlign": align
            },
            ...other.style
        }
    });
});
var $fafac108772b9e19$export$2e2bcd8739ae039 = $fafac108772b9e19$var$Typography;



const $7e5751a376ee6bc4$var$CodePage = ()=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 1,
        sx: {
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "200px"
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
            variant: "h1",
            "aria-label": "Paikka",
            sx: {
                color: "primary.main",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                id: "page.qrcode.welcome"
            })
        })
    });
};
var $7e5751a376ee6bc4$export$2e2bcd8739ae039 = $7e5751a376ee6bc4$var$CodePage;



var $1Ivrw = parcelRequire("1Ivrw");






var $d764fc7fda0b4c99$var$_client, $d764fc7fda0b4c99$var$_currentQuery, $d764fc7fda0b4c99$var$_currentQueryInitialState, $d764fc7fda0b4c99$var$_currentResult, $d764fc7fda0b4c99$var$_currentResultState, $d764fc7fda0b4c99$var$_currentResultOptions, $d764fc7fda0b4c99$var$_selectError, $d764fc7fda0b4c99$var$_selectFn, $d764fc7fda0b4c99$var$_selectResult, $d764fc7fda0b4c99$var$_lastQueryWithDefinedData, $d764fc7fda0b4c99$var$_staleTimeoutId, $d764fc7fda0b4c99$var$_refetchIntervalId, $d764fc7fda0b4c99$var$_currentRefetchInterval, $d764fc7fda0b4c99$var$_trackedProps, $d764fc7fda0b4c99$var$_executeFetch, $d764fc7fda0b4c99$var$executeFetch_fn, $d764fc7fda0b4c99$var$_updateStaleTimeout, $d764fc7fda0b4c99$var$updateStaleTimeout_fn, $d764fc7fda0b4c99$var$_computeRefetchInterval, $d764fc7fda0b4c99$var$computeRefetchInterval_fn, $d764fc7fda0b4c99$var$_updateRefetchInterval, $d764fc7fda0b4c99$var$updateRefetchInterval_fn, $d764fc7fda0b4c99$var$_updateTimers, $d764fc7fda0b4c99$var$updateTimers_fn, $d764fc7fda0b4c99$var$_clearStaleTimeout, $d764fc7fda0b4c99$var$clearStaleTimeout_fn, $d764fc7fda0b4c99$var$_clearRefetchInterval, $d764fc7fda0b4c99$var$clearRefetchInterval_fn, $d764fc7fda0b4c99$var$_updateQuery, $d764fc7fda0b4c99$var$updateQuery_fn, $d764fc7fda0b4c99$var$_notify, $d764fc7fda0b4c99$var$notify_fn;
var $d764fc7fda0b4c99$export$a06cf8c0066f0d4c = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_executeFetch);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_updateStaleTimeout);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_computeRefetchInterval);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_updateRefetchInterval);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_updateTimers);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_clearStaleTimeout);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_clearRefetchInterval);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_updateQuery);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_notify);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_client, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentQuery, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentQueryInitialState, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentResult, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentResultState, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentResultOptions, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_selectError, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_selectFn, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_lastQueryWithDefinedData, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_staleTimeoutId, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_refetchIntervalId, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $d764fc7fda0b4c99$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_client, client);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).addObserver(this);
            if ($d764fc7fda0b4c99$var$shouldFetchOnMount((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery), this.options)) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_executeFetch, $d764fc7fda0b4c99$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateTimers, $d764fc7fda0b4c99$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $d764fc7fda0b4c99$var$shouldFetchOn((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $d764fc7fda0b4c99$var$shouldFetchOn((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_clearStaleTimeout, $d764fc7fda0b4c99$var$clearStaleTimeout_fn).call(this);
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_clearRefetchInterval, $d764fc7fda0b4c99$var$clearRefetchInterval_fn).call(this);
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery);
        this.options = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateQuery, $d764fc7fda0b4c99$var$updateQuery_fn).call(this);
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $66d37cb3d8195cdd$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $d764fc7fda0b4c99$var$shouldFetchOptionally((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_executeFetch, $d764fc7fda0b4c99$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery) !== prevQuery || (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) !== (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) || (0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) !== (0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)))) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateStaleTimeout, $d764fc7fda0b4c99$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_computeRefetchInterval, $d764fc7fda0b4c99$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery) !== prevQuery || (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) !== (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) || nextRefetchInterval !== (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval))) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateRefetchInterval, $d764fc7fda0b4c99$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).getQueryCache().build((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client), options);
        const result = this.createResult(query, options);
        if ($d764fc7fda0b4c99$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResult, result);
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResultOptions, this.options);
            (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResultState, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).defaultQueryOptions(options);
        const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).getQueryCache().build((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_executeFetch, $d764fc7fda0b4c99$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult);
        const prevResultState = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResultState);
        const prevResultOptions = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $d764fc7fda0b4c99$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $d764fc7fda0b4c99$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $b96cec5c826539f2$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_selectFn)) data = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_selectResult);
            else try {
                (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $66d37cb3d8195cdd$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectResult, data);
                (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectError, null);
            } catch (selectError) {
                (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectError, null);
                } catch (selectError) {
                    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $66d37cb3d8195cdd$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_selectError)) {
            error = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_selectError);
            data = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $d764fc7fda0b4c99$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult);
        const nextResult = this.createResult((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery), this.options);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResultState, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).state);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResultOptions, this.options);
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResultState).data !== void 0) (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_lastQueryWithDefinedData, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery));
        if ((0, $66d37cb3d8195cdd$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_notify, $d764fc7fda0b4c99$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateTimers, $d764fc7fda0b4c99$var$updateTimers_fn).call(this);
    }
};
$d764fc7fda0b4c99$var$_client = new WeakMap();
$d764fc7fda0b4c99$var$_currentQuery = new WeakMap();
$d764fc7fda0b4c99$var$_currentQueryInitialState = new WeakMap();
$d764fc7fda0b4c99$var$_currentResult = new WeakMap();
$d764fc7fda0b4c99$var$_currentResultState = new WeakMap();
$d764fc7fda0b4c99$var$_currentResultOptions = new WeakMap();
$d764fc7fda0b4c99$var$_selectError = new WeakMap();
$d764fc7fda0b4c99$var$_selectFn = new WeakMap();
$d764fc7fda0b4c99$var$_selectResult = new WeakMap();
$d764fc7fda0b4c99$var$_lastQueryWithDefinedData = new WeakMap();
$d764fc7fda0b4c99$var$_staleTimeoutId = new WeakMap();
$d764fc7fda0b4c99$var$_refetchIntervalId = new WeakMap();
$d764fc7fda0b4c99$var$_currentRefetchInterval = new WeakMap();
$d764fc7fda0b4c99$var$_trackedProps = new WeakMap();
$d764fc7fda0b4c99$var$_executeFetch = new WeakSet();
$d764fc7fda0b4c99$var$executeFetch_fn = function(fetchOptions) {
    (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateQuery, $d764fc7fda0b4c99$var$updateQuery_fn).call(this);
    let promise = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $66d37cb3d8195cdd$export$8793edee2d425525));
    return promise;
};
$d764fc7fda0b4c99$var$_updateStaleTimeout = new WeakSet();
$d764fc7fda0b4c99$var$updateStaleTimeout_fn = function() {
    (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_clearStaleTimeout, $d764fc7fda0b4c99$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(this.options.staleTime, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery));
    if ((0, $66d37cb3d8195cdd$export$6acf61af03e62db) || (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult).isStale || !(0, $66d37cb3d8195cdd$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $66d37cb3d8195cdd$export$811b83d62bcf47f0)((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$d764fc7fda0b4c99$var$_computeRefetchInterval = new WeakSet();
$d764fc7fda0b4c99$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$d764fc7fda0b4c99$var$_updateRefetchInterval = new WeakSet();
$d764fc7fda0b4c99$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_clearRefetchInterval, $d764fc7fda0b4c99$var$clearRefetchInterval_fn).call(this);
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval, nextInterval);
    if ((0, $66d37cb3d8195cdd$export$6acf61af03e62db) || (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(this.options.enabled, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) === false || !(0, $66d37cb3d8195cdd$export$e539f754e934e270)((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval)) || (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval) === 0) return;
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $1e6dc4a1c9ba3fa2$export$6bf54661be5b02cf).isFocused()) (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_executeFetch, $d764fc7fda0b4c99$var$executeFetch_fn).call(this);
    }, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentRefetchInterval)));
};
$d764fc7fda0b4c99$var$_updateTimers = new WeakSet();
$d764fc7fda0b4c99$var$updateTimers_fn = function() {
    (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateStaleTimeout, $d764fc7fda0b4c99$var$updateStaleTimeout_fn).call(this);
    (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_updateRefetchInterval, $d764fc7fda0b4c99$var$updateRefetchInterval_fn).call(this, (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $d764fc7fda0b4c99$var$_computeRefetchInterval, $d764fc7fda0b4c99$var$computeRefetchInterval_fn).call(this));
};
$d764fc7fda0b4c99$var$_clearStaleTimeout = new WeakSet();
$d764fc7fda0b4c99$var$clearStaleTimeout_fn = function() {
    if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_staleTimeoutId)) {
        clearTimeout((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_staleTimeoutId));
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_staleTimeoutId, void 0);
    }
};
$d764fc7fda0b4c99$var$_clearRefetchInterval = new WeakSet();
$d764fc7fda0b4c99$var$clearRefetchInterval_fn = function() {
    if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_refetchIntervalId)) {
        clearInterval((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_refetchIntervalId));
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_refetchIntervalId, void 0);
    }
};
$d764fc7fda0b4c99$var$_updateQuery = new WeakSet();
$d764fc7fda0b4c99$var$updateQuery_fn = function() {
    const query = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).getQueryCache().build((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client), this.options);
    if (query === (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery)) return;
    const prevQuery = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery);
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentQuery, query);
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $d764fc7fda0b4c99$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$d764fc7fda0b4c99$var$_notify = new WeakSet();
$d764fc7fda0b4c99$var$notify_fn = function(notifyOptions) {
    (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentResult));
        });
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_client).getQueryCache().notify({
            query: (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $d764fc7fda0b4c99$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $d764fc7fda0b4c99$var$shouldLoadOnMount(query, options) {
    return (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $d764fc7fda0b4c99$var$shouldFetchOnMount(query, options) {
    return $d764fc7fda0b4c99$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $d764fc7fda0b4c99$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $d764fc7fda0b4c99$var$shouldFetchOn(query, options, field) {
    if ((0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $d764fc7fda0b4c99$var$isStale(query, options);
    }
    return false;
}
function $d764fc7fda0b4c99$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $d764fc7fda0b4c99$var$isStale(query, options);
}
function $d764fc7fda0b4c99$var$isStale(query, options) {
    return (0, $66d37cb3d8195cdd$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $66d37cb3d8195cdd$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $d764fc7fda0b4c99$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $66d37cb3d8195cdd$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $83b6ed5e05227d50$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $83b6ed5e05227d50$var$QueryErrorResetBoundaryContext = $aqdBs.createContext($83b6ed5e05227d50$var$createValue());
var $83b6ed5e05227d50$export$50dfac555130cafd = ()=>$aqdBs.useContext($83b6ed5e05227d50$var$QueryErrorResetBoundaryContext);
var $83b6ed5e05227d50$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $aqdBs.useState(()=>$83b6ed5e05227d50$var$createValue());
    return /* @__PURE__ */ (0, $1Ivrw.jsx)($83b6ed5e05227d50$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};




var $aqdBs = parcelRequire("aqdBs");
"use client";
var $adb77e23f97339b0$var$IsRestoringContext = $aqdBs.createContext(false);
var $adb77e23f97339b0$export$4da0178d6b5f553 = ()=>$aqdBs.useContext($adb77e23f97339b0$var$IsRestoringContext);
var $adb77e23f97339b0$export$593807d4e94f9621 = $adb77e23f97339b0$var$IsRestoringContext.Provider;



var $aqdBs = parcelRequire("aqdBs");
// src/utils.ts
function $4def3f93cfc9db2e$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $4def3f93cfc9db2e$export$8793edee2d425525() {}


"use client";
var $e0e7f262b54c1796$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $e0e7f262b54c1796$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $aqdBs.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $e0e7f262b54c1796$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $4def3f93cfc9db2e$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $980a28ead551befa$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $980a28ead551befa$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $980a28ead551befa$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $980a28ead551befa$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $980a28ead551befa$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $649f4643f2da4d51$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d;
    const client = (0, $da27b542cb58aea7$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $adb77e23f97339b0$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $83b6ed5e05227d50$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $980a28ead551befa$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $e0e7f262b54c1796$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $e0e7f262b54c1796$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $aqdBs.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $aqdBs.useSyncExternalStore($aqdBs.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $5f301ba98937b677$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $aqdBs.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $980a28ead551befa$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $980a28ead551befa$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $e0e7f262b54c1796$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $a83b6e6e4e1b774b$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $649f4643f2da4d51$export$fff0865807e996c5)(options, (0, $d764fc7fda0b4c99$export$a06cf8c0066f0d4c), queryClient);
}



var $aqdBs = parcelRequire("aqdBs");

"use strict";
function $6d5e785c5f814af7$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $dd87d7aee5b911f1$var$toString } = Object.prototype;
const { getPrototypeOf: $dd87d7aee5b911f1$var$getPrototypeOf } = Object;
const $dd87d7aee5b911f1$var$kindOf = ((cache)=>(thing)=>{
        const str = $dd87d7aee5b911f1$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $dd87d7aee5b911f1$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$dd87d7aee5b911f1$var$kindOf(thing) === type;
};
const $dd87d7aee5b911f1$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $dd87d7aee5b911f1$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $dd87d7aee5b911f1$var$isUndefined = $dd87d7aee5b911f1$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $dd87d7aee5b911f1$var$isBuffer(val) {
    return val !== null && !$dd87d7aee5b911f1$var$isUndefined(val) && val.constructor !== null && !$dd87d7aee5b911f1$var$isUndefined(val.constructor) && $dd87d7aee5b911f1$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $dd87d7aee5b911f1$var$isArrayBuffer = $dd87d7aee5b911f1$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $dd87d7aee5b911f1$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $dd87d7aee5b911f1$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $dd87d7aee5b911f1$var$isString = $dd87d7aee5b911f1$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $dd87d7aee5b911f1$var$isFunction = $dd87d7aee5b911f1$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $dd87d7aee5b911f1$var$isNumber = $dd87d7aee5b911f1$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $dd87d7aee5b911f1$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $dd87d7aee5b911f1$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $dd87d7aee5b911f1$var$isPlainObject = (val)=>{
    if ($dd87d7aee5b911f1$var$kindOf(val) !== "object") return false;
    const prototype = $dd87d7aee5b911f1$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $dd87d7aee5b911f1$var$isDate = $dd87d7aee5b911f1$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $dd87d7aee5b911f1$var$isFile = $dd87d7aee5b911f1$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $dd87d7aee5b911f1$var$isBlob = $dd87d7aee5b911f1$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $dd87d7aee5b911f1$var$isFileList = $dd87d7aee5b911f1$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $dd87d7aee5b911f1$var$isStream = (val)=>$dd87d7aee5b911f1$var$isObject(val) && $dd87d7aee5b911f1$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $dd87d7aee5b911f1$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $dd87d7aee5b911f1$var$isFunction(thing.append) && ((kind = $dd87d7aee5b911f1$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $dd87d7aee5b911f1$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $dd87d7aee5b911f1$var$isURLSearchParams = $dd87d7aee5b911f1$var$kindOfTest("URLSearchParams");
const [$dd87d7aee5b911f1$var$isReadableStream, $dd87d7aee5b911f1$var$isRequest, $dd87d7aee5b911f1$var$isResponse, $dd87d7aee5b911f1$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($dd87d7aee5b911f1$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $dd87d7aee5b911f1$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $dd87d7aee5b911f1$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($dd87d7aee5b911f1$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $dd87d7aee5b911f1$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $dd87d7aee5b911f1$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $dd87d7aee5b911f1$var$isContextDefined = (context)=>!$dd87d7aee5b911f1$var$isUndefined(context) && context !== $dd87d7aee5b911f1$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $dd87d7aee5b911f1$var$merge() {
    const { caseless: caseless } = $dd87d7aee5b911f1$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $dd87d7aee5b911f1$var$findKey(result, key) || key;
        if ($dd87d7aee5b911f1$var$isPlainObject(result[targetKey]) && $dd87d7aee5b911f1$var$isPlainObject(val)) result[targetKey] = $dd87d7aee5b911f1$var$merge(result[targetKey], val);
        else if ($dd87d7aee5b911f1$var$isPlainObject(val)) result[targetKey] = $dd87d7aee5b911f1$var$merge({}, val);
        else if ($dd87d7aee5b911f1$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $dd87d7aee5b911f1$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $dd87d7aee5b911f1$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $dd87d7aee5b911f1$var$forEach(b, (val, key)=>{
        if (thisArg && $dd87d7aee5b911f1$var$isFunction(val)) a[key] = (0, $6d5e785c5f814af7$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $dd87d7aee5b911f1$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $dd87d7aee5b911f1$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $dd87d7aee5b911f1$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $dd87d7aee5b911f1$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $dd87d7aee5b911f1$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $dd87d7aee5b911f1$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($dd87d7aee5b911f1$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$dd87d7aee5b911f1$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $dd87d7aee5b911f1$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $dd87d7aee5b911f1$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $dd87d7aee5b911f1$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $dd87d7aee5b911f1$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $dd87d7aee5b911f1$var$isHTMLForm = $dd87d7aee5b911f1$var$kindOfTest("HTMLFormElement");
const $dd87d7aee5b911f1$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $dd87d7aee5b911f1$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $dd87d7aee5b911f1$var$isRegExp = $dd87d7aee5b911f1$var$kindOfTest("RegExp");
const $dd87d7aee5b911f1$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $dd87d7aee5b911f1$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $dd87d7aee5b911f1$var$freezeMethods = (obj)=>{
    $dd87d7aee5b911f1$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($dd87d7aee5b911f1$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$dd87d7aee5b911f1$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $dd87d7aee5b911f1$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $dd87d7aee5b911f1$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $dd87d7aee5b911f1$var$noop = ()=>{};
const $dd87d7aee5b911f1$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $dd87d7aee5b911f1$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $dd87d7aee5b911f1$var$DIGIT = "0123456789";
const $dd87d7aee5b911f1$var$ALPHABET = {
    DIGIT: $dd87d7aee5b911f1$var$DIGIT,
    ALPHA: $dd87d7aee5b911f1$var$ALPHA,
    ALPHA_DIGIT: $dd87d7aee5b911f1$var$ALPHA + $dd87d7aee5b911f1$var$ALPHA.toUpperCase() + $dd87d7aee5b911f1$var$DIGIT
};
const $dd87d7aee5b911f1$var$generateString = (size = 16, alphabet = $dd87d7aee5b911f1$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $dd87d7aee5b911f1$var$isSpecCompliantForm(thing) {
    return !!(thing && $dd87d7aee5b911f1$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $dd87d7aee5b911f1$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($dd87d7aee5b911f1$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $dd87d7aee5b911f1$var$isArray(source) ? [] : {};
                $dd87d7aee5b911f1$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$dd87d7aee5b911f1$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $dd87d7aee5b911f1$var$isAsyncFn = $dd87d7aee5b911f1$var$kindOfTest("AsyncFunction");
const $dd87d7aee5b911f1$var$isThenable = (thing)=>thing && ($dd87d7aee5b911f1$var$isObject(thing) || $dd87d7aee5b911f1$var$isFunction(thing)) && $dd87d7aee5b911f1$var$isFunction(thing.then) && $dd87d7aee5b911f1$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $dd87d7aee5b911f1$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $dd87d7aee5b911f1$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $dd87d7aee5b911f1$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $dd87d7aee5b911f1$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $dd87d7aee5b911f1$var$isFunction($dd87d7aee5b911f1$var$_global.postMessage));
const $dd87d7aee5b911f1$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($dd87d7aee5b911f1$var$_global) : typeof $371a3837fd81d701$exports !== "undefined" && $371a3837fd81d701$exports.nextTick || $dd87d7aee5b911f1$var$_setImmediate;
var // *********************
$dd87d7aee5b911f1$export$2e2bcd8739ae039 = {
    isArray: $dd87d7aee5b911f1$var$isArray,
    isArrayBuffer: $dd87d7aee5b911f1$var$isArrayBuffer,
    isBuffer: $dd87d7aee5b911f1$var$isBuffer,
    isFormData: $dd87d7aee5b911f1$var$isFormData,
    isArrayBufferView: $dd87d7aee5b911f1$var$isArrayBufferView,
    isString: $dd87d7aee5b911f1$var$isString,
    isNumber: $dd87d7aee5b911f1$var$isNumber,
    isBoolean: $dd87d7aee5b911f1$var$isBoolean,
    isObject: $dd87d7aee5b911f1$var$isObject,
    isPlainObject: $dd87d7aee5b911f1$var$isPlainObject,
    isReadableStream: $dd87d7aee5b911f1$var$isReadableStream,
    isRequest: $dd87d7aee5b911f1$var$isRequest,
    isResponse: $dd87d7aee5b911f1$var$isResponse,
    isHeaders: $dd87d7aee5b911f1$var$isHeaders,
    isUndefined: $dd87d7aee5b911f1$var$isUndefined,
    isDate: $dd87d7aee5b911f1$var$isDate,
    isFile: $dd87d7aee5b911f1$var$isFile,
    isBlob: $dd87d7aee5b911f1$var$isBlob,
    isRegExp: $dd87d7aee5b911f1$var$isRegExp,
    isFunction: $dd87d7aee5b911f1$var$isFunction,
    isStream: $dd87d7aee5b911f1$var$isStream,
    isURLSearchParams: $dd87d7aee5b911f1$var$isURLSearchParams,
    isTypedArray: $dd87d7aee5b911f1$var$isTypedArray,
    isFileList: $dd87d7aee5b911f1$var$isFileList,
    forEach: $dd87d7aee5b911f1$var$forEach,
    merge: $dd87d7aee5b911f1$var$merge,
    extend: $dd87d7aee5b911f1$var$extend,
    trim: $dd87d7aee5b911f1$var$trim,
    stripBOM: $dd87d7aee5b911f1$var$stripBOM,
    inherits: $dd87d7aee5b911f1$var$inherits,
    toFlatObject: $dd87d7aee5b911f1$var$toFlatObject,
    kindOf: $dd87d7aee5b911f1$var$kindOf,
    kindOfTest: $dd87d7aee5b911f1$var$kindOfTest,
    endsWith: $dd87d7aee5b911f1$var$endsWith,
    toArray: $dd87d7aee5b911f1$var$toArray,
    forEachEntry: $dd87d7aee5b911f1$var$forEachEntry,
    matchAll: $dd87d7aee5b911f1$var$matchAll,
    isHTMLForm: $dd87d7aee5b911f1$var$isHTMLForm,
    hasOwnProperty: $dd87d7aee5b911f1$var$hasOwnProperty,
    hasOwnProp: $dd87d7aee5b911f1$var$hasOwnProperty,
    reduceDescriptors: $dd87d7aee5b911f1$var$reduceDescriptors,
    freezeMethods: $dd87d7aee5b911f1$var$freezeMethods,
    toObjectSet: $dd87d7aee5b911f1$var$toObjectSet,
    toCamelCase: $dd87d7aee5b911f1$var$toCamelCase,
    noop: $dd87d7aee5b911f1$var$noop,
    toFiniteNumber: $dd87d7aee5b911f1$var$toFiniteNumber,
    findKey: $dd87d7aee5b911f1$var$findKey,
    global: $dd87d7aee5b911f1$var$_global,
    isContextDefined: $dd87d7aee5b911f1$var$isContextDefined,
    ALPHABET: $dd87d7aee5b911f1$var$ALPHABET,
    generateString: $dd87d7aee5b911f1$var$generateString,
    isSpecCompliantForm: $dd87d7aee5b911f1$var$isSpecCompliantForm,
    toJSONObject: $dd87d7aee5b911f1$var$toJSONObject,
    isAsyncFn: $dd87d7aee5b911f1$var$isAsyncFn,
    isThenable: $dd87d7aee5b911f1$var$isThenable,
    setImmediate: $dd87d7aee5b911f1$var$_setImmediate,
    asap: $dd87d7aee5b911f1$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $5ea015c4d79f37d4$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).inherits($5ea015c4d79f37d4$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $5ea015c4d79f37d4$var$prototype = $5ea015c4d79f37d4$var$AxiosError.prototype;
const $5ea015c4d79f37d4$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $5ea015c4d79f37d4$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5ea015c4d79f37d4$var$AxiosError, $5ea015c4d79f37d4$var$descriptors);
Object.defineProperty($5ea015c4d79f37d4$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$5ea015c4d79f37d4$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($5ea015c4d79f37d4$var$prototype);
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $5ea015c4d79f37d4$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $5ea015c4d79f37d4$export$2e2bcd8739ae039 = $5ea015c4d79f37d4$var$AxiosError;


// eslint-disable-next-line strict
var $e672bf91317ec75e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
"use strict";
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
"use strict";
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup["-".charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup["_".charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case "ascii":
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case "base64":
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8dff54558831dec9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $91eefa0e9905462d$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $91eefa0e9905462d$var$isVisitable(thing) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $91eefa0e9905462d$var$removeBrackets(key) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $91eefa0e9905462d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $91eefa0e9905462d$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $91eefa0e9905462d$var$isFlatArray(arr) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(arr) && !arr.some($91eefa0e9905462d$var$isVisitable);
}
const $91eefa0e9905462d$var$predicates = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $91eefa0e9905462d$var$toFormData(obj, formData, options) {
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $e672bf91317ec75e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $91eefa0e9905462d$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) && $91eefa0e9905462d$var$isFlatArray(value) || ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFileList(value) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $91eefa0e9905462d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $91eefa0e9905462d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($91eefa0e9905462d$var$isVisitable(value)) return true;
        formData.append($91eefa0e9905462d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($91eefa0e9905462d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $91eefa0e9905462d$var$isVisitable
    });
    function build(value, path) {
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $91eefa0e9905462d$export$2e2bcd8739ae039 = $91eefa0e9905462d$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a8ace30d6be5420f$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a8ace30d6be5420f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(params, this, options);
}
const $a8ace30d6be5420f$var$prototype = $a8ace30d6be5420f$var$AxiosURLSearchParams.prototype;
$a8ace30d6be5420f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a8ace30d6be5420f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a8ace30d6be5420f$var$encode);
    } : $a8ace30d6be5420f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $a8ace30d6be5420f$export$2e2bcd8739ae039 = $a8ace30d6be5420f$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4fd1af83f2f58271$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4fd1af83f2f58271$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4fd1af83f2f58271$var$encode;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a8ace30d6be5420f$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $32eaa2f57683a696$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $32eaa2f57683a696$export$2e2bcd8739ae039 = $32eaa2f57683a696$var$InterceptorManager;





"use strict";
var $752758ab0a7f5c66$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $355bc59bf705c9c1$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $a8ace30d6be5420f$export$2e2bcd8739ae039);


"use strict";
var $11b43b7e85819944$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $f4103de442339deb$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $e2de44a9ceb94f00$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $355bc59bf705c9c1$export$2e2bcd8739ae039,
        FormData: $11b43b7e85819944$export$2e2bcd8739ae039,
        Blob: $f4103de442339deb$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $39b78c5090c22bee$exports = {};

$parcel$export($39b78c5090c22bee$exports, "hasBrowserEnv", () => $39b78c5090c22bee$export$c4996c4b7b93b0bf);
$parcel$export($39b78c5090c22bee$exports, "navigator", () => $39b78c5090c22bee$export$ec7c8efa7f5790ae);
$parcel$export($39b78c5090c22bee$exports, "hasStandardBrowserEnv", () => $39b78c5090c22bee$export$c0bcc9250309d66);
$parcel$export($39b78c5090c22bee$exports, "hasStandardBrowserWebWorkerEnv", () => $39b78c5090c22bee$export$c81692cf5af97dac);
$parcel$export($39b78c5090c22bee$exports, "origin", () => $39b78c5090c22bee$export$f710a83a91838a36);
const $39b78c5090c22bee$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $39b78c5090c22bee$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $39b78c5090c22bee$export$c0bcc9250309d66 = $39b78c5090c22bee$export$c4996c4b7b93b0bf && (!$39b78c5090c22bee$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($39b78c5090c22bee$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $39b78c5090c22bee$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $39b78c5090c22bee$export$f710a83a91838a36 = $39b78c5090c22bee$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $ea81919fd25bf5ee$export$2e2bcd8739ae039 = {
    ...$39b78c5090c22bee$exports,
    ...(0, $e2de44a9ceb94f00$export$2e2bcd8739ae039)
};


"use strict";
function $30f8a2a6cf953adb$export$2e2bcd8739ae039(data, options) {
    return (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(data, new (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).isNode && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $6a3c091df0d84895$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $6a3c091df0d84895$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $6a3c091df0d84895$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $6a3c091df0d84895$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(formData) && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($6a3c091df0d84895$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $6a3c091df0d84895$export$2e2bcd8739ae039 = $6a3c091df0d84895$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $ef2ca59660cd3355$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $ef2ca59660cd3355$var$defaults = {
    transitional: (0, $752758ab0a7f5c66$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $6a3c091df0d84895$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBuffer(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isStream(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFile(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $30f8a2a6cf953adb$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $ef2ca59660cd3355$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $ef2ca59660cd3355$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isResponse(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).from(e, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $ef2ca59660cd3355$var$defaults.headers[method] = {};
});
var $ef2ca59660cd3355$export$2e2bcd8739ae039 = $ef2ca59660cd3355$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $291583a5afa8db94$var$ignoreDuplicateOf = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $291583a5afa8db94$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $291583a5afa8db94$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $48690bd6ad3e07ee$var$$internals = Symbol("internals");
function $48690bd6ad3e07ee$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $48690bd6ad3e07ee$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) ? value.map($48690bd6ad3e07ee$var$normalizeValue) : String(value);
}
function $48690bd6ad3e07ee$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $48690bd6ad3e07ee$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $48690bd6ad3e07ee$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $48690bd6ad3e07ee$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $48690bd6ad3e07ee$var$buildAccessors(obj, header) {
    const accessorName = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $48690bd6ad3e07ee$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $48690bd6ad3e07ee$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$48690bd6ad3e07ee$var$isValidHeaderName(header)) setHeaders((0, $291583a5afa8db94$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $48690bd6ad3e07ee$var$normalizeHeader(header);
        if (header) {
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $48690bd6ad3e07ee$var$parseTokens(value);
                if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $48690bd6ad3e07ee$var$normalizeHeader(header);
        if (header) {
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $48690bd6ad3e07ee$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $48690bd6ad3e07ee$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $48690bd6ad3e07ee$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$48690bd6ad3e07ee$var$$internals] = this[$48690bd6ad3e07ee$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $48690bd6ad3e07ee$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$48690bd6ad3e07ee$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).reduceDescriptors($48690bd6ad3e07ee$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).freezeMethods($48690bd6ad3e07ee$var$AxiosHeaders);
var $48690bd6ad3e07ee$export$2e2bcd8739ae039 = $48690bd6ad3e07ee$var$AxiosHeaders;


"use strict";
function $911997d73ecb1b76$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ef2ca59660cd3355$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $448296c149bd8ddc$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $6c2f3c73d6d5f6ef$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).inherits($6c2f3c73d6d5f6ef$var$CanceledError, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039 = $6c2f3c73d6d5f6ef$var$CanceledError;







"use strict";
function $55c8e0f1225ee9af$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $efa8df7222ed1688$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d372d424fc163558$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d372d424fc163558$export$2e2bcd8739ae039 = $d372d424fc163558$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $29c7b59ddef676ee$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $29c7b59ddef676ee$export$2e2bcd8739ae039 = $29c7b59ddef676ee$var$throttle;



const $88d62766b1643c16$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d372d424fc163558$export$2e2bcd8739ae039)(50, 250);
    return (0, $29c7b59ddef676ee$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $88d62766b1643c16$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $88d62766b1643c16$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $13f2a6fa0ac73c37$export$2e2bcd8739ae039 = (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin), (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $137fb9d8cf1263fb$export$2e2bcd8739ae039 = (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $eba4b00fb694fb37$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $342b126be5d771fa$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $e6f70ed6e6c8e983$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $eba4b00fb694fb37$export$2e2bcd8739ae039)(requestedURL)) return (0, $342b126be5d771fa$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f81b12bbdaede375$var$headersToObject = (thing)=>thing instanceof (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f81b12bbdaede375$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(target) && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f81b12bbdaede375$var$headersToObject(a), $f81b12bbdaede375$var$headersToObject(b), prop, true)
    };
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $3ac8458f32a7eabb$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4fd1af83f2f58271$export$2e2bcd8739ae039)((0, $e6f70ed6e6c8e983$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $13f2a6fa0ac73c37$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $137fb9d8cf1263fb$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $e2ad59241befd87c$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $e2ad59241befd87c$export$2e2bcd8739ae039 = $e2ad59241befd87c$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $3ac8458f32a7eabb$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $55c8e0f1225ee9af$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Request aborted", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Network Error", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $752758ab0a7f5c66$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ETIMEDOUT : (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $88d62766b1643c16$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $88d62766b1643c16$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $efa8df7222ed1688$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8b87899adf041493$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039) ? err : new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $8b87899adf041493$export$2e2bcd8739ae039 = $8b87899adf041493$var$composeSignals;


const $0a6968d914447494$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0a6968d914447494$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $0a6968d914447494$var$readStream(iterable))yield* $0a6968d914447494$export$71b051935044bd5d(chunk, chunkSize);
};
const $0a6968d914447494$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $0a6968d914447494$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $0a6968d914447494$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $cac6cc68d9700abe$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $cac6cc68d9700abe$var$isReadableStreamSupported = $cac6cc68d9700abe$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $cac6cc68d9700abe$var$encodeText = $cac6cc68d9700abe$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $cac6cc68d9700abe$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $cac6cc68d9700abe$var$supportsRequestStream = $cac6cc68d9700abe$var$isReadableStreamSupported && $cac6cc68d9700abe$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE = 65536;
const $cac6cc68d9700abe$var$supportsResponseStream = $cac6cc68d9700abe$var$isReadableStreamSupported && $cac6cc68d9700abe$var$test(()=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $cac6cc68d9700abe$var$resolvers = {
    stream: $cac6cc68d9700abe$var$supportsResponseStream && ((res)=>res.body)
};
$cac6cc68d9700abe$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$cac6cc68d9700abe$var$resolvers[type] && ($cac6cc68d9700abe$var$resolvers[type] = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $cac6cc68d9700abe$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(body)) return (await $cac6cc68d9700abe$var$encodeText(body)).byteLength;
};
const $cac6cc68d9700abe$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $cac6cc68d9700abe$var$getBodyLength(body) : length;
};
var $cac6cc68d9700abe$export$2e2bcd8739ae039 = $cac6cc68d9700abe$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $3ac8458f32a7eabb$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $8b87899adf041493$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $cac6cc68d9700abe$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $cac6cc68d9700abe$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $88d62766b1643c16$export$d9fadd12586c18d6)(requestContentLength, (0, $88d62766b1643c16$export$c1b28109d46c3592)((0, $88d62766b1643c16$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $0a6968d914447494$export$b0119225647bd83)(_request.body, $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $cac6cc68d9700abe$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($cac6cc68d9700abe$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $88d62766b1643c16$export$d9fadd12586c18d6)(responseContentLength, (0, $88d62766b1643c16$export$c1b28109d46c3592)((0, $88d62766b1643c16$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $0a6968d914447494$export$b0119225647bd83)(response.body, $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $cac6cc68d9700abe$var$resolvers[(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey($cac6cc68d9700abe$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $55c8e0f1225ee9af$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Network Error", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $f045b92bde59d4db$var$knownAdapters = {
    http: (0, $e672bf91317ec75e$export$2e2bcd8739ae039),
    xhr: (0, $e2ad59241befd87c$export$2e2bcd8739ae039),
    fetch: (0, $cac6cc68d9700abe$export$2e2bcd8739ae039)
};
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach($f045b92bde59d4db$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f045b92bde59d4db$var$renderReason = (reason)=>`- ${reason}`;
const $f045b92bde59d4db$var$isResolvedHandle = (adapter)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f045b92bde59d4db$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f045b92bde59d4db$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f045b92bde59d4db$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f045b92bde59d4db$var$renderReason).join("\n") : " " + $f045b92bde59d4db$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f045b92bde59d4db$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $ea0b54f24b63fdde$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(null, config);
}
function $ea0b54f24b63fdde$export$2e2bcd8739ae039(config) {
    $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
    config.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $f045b92bde59d4db$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $ef2ca59660cd3355$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $448296c149bd8ddc$export$2e2bcd8739ae039)(reason)) {
            $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $423f3e33bc14b731$export$a4ad2735b021c132 = "1.7.9";



"use strict";
const $e5581fe52505dda0$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $e5581fe52505dda0$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $e5581fe52505dda0$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $e5581fe52505dda0$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $423f3e33bc14b731$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$e5581fe52505dda0$var$deprecatedWarnings[opt]) {
            $e5581fe52505dda0$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$e5581fe52505dda0$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $e5581fe52505dda0$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("options must be an object", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $e5581fe52505dda0$export$2e2bcd8739ae039 = {
    assertOptions: $e5581fe52505dda0$var$assertOptions,
    validators: $e5581fe52505dda0$var$validators
};



"use strict";
const $9b4f9b19ff2e012e$var$validators = (0, $e5581fe52505dda0$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9b4f9b19ff2e012e$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $32eaa2f57683a696$export$2e2bcd8739ae039)(),
            response: new (0, $32eaa2f57683a696$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean),
            forcedJSONParsing: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean),
            clarifyTimeoutError: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9b4f9b19ff2e012e$var$validators.function,
                serialize: $9b4f9b19ff2e012e$var$validators.function
            }, true);
        }
        (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9b4f9b19ff2e012e$var$validators.spelling("baseURL"),
            withXsrfToken: $9b4f9b19ff2e012e$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $ea0b54f24b63fdde$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $ea0b54f24b63fdde$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $e6f70ed6e6c8e983$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $4fd1af83f2f58271$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9b4f9b19ff2e012e$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9b4f9b19ff2e012e$var$Axios.prototype[method] = generateHTTPMethod();
    $9b4f9b19ff2e012e$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $9b4f9b19ff2e012e$export$2e2bcd8739ae039 = $9b4f9b19ff2e012e$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $7ba83383195eb7dd$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $7ba83383195eb7dd$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $7ba83383195eb7dd$export$2e2bcd8739ae039 = $7ba83383195eb7dd$var$CancelToken;






"use strict";
function $23fef0d39f41681f$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $fe1e4f499686cc9d$export$2e2bcd8739ae039(payload) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $0e01926db91ea959$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($0e01926db91ea959$var$HttpStatusCode).forEach(([key, value])=>{
    $0e01926db91ea959$var$HttpStatusCode[value] = key;
});
var $0e01926db91ea959$export$2e2bcd8739ae039 = $0e01926db91ea959$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $740c54350e180ee0$var$createInstance(defaultConfig) {
    const context = new (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $6d5e785c5f814af7$export$2e2bcd8739ae039)((0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).extend(instance, (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $740c54350e180ee0$var$createInstance((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $740c54350e180ee0$var$axios = $740c54350e180ee0$var$createInstance((0, $ef2ca59660cd3355$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$740c54350e180ee0$var$axios.Axios = (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$740c54350e180ee0$var$axios.CanceledError = (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.CancelToken = (0, $7ba83383195eb7dd$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.isCancel = (0, $448296c149bd8ddc$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.VERSION = (0, $423f3e33bc14b731$export$a4ad2735b021c132);
$740c54350e180ee0$var$axios.toFormData = (0, $91eefa0e9905462d$export$2e2bcd8739ae039);
// Expose AxiosError class
$740c54350e180ee0$var$axios.AxiosError = (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$740c54350e180ee0$var$axios.Cancel = $740c54350e180ee0$var$axios.CanceledError;
// Expose all/spread
$740c54350e180ee0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$740c54350e180ee0$var$axios.spread = (0, $23fef0d39f41681f$export$2e2bcd8739ae039);
// Expose isAxiosError
$740c54350e180ee0$var$axios.isAxiosError = (0, $fe1e4f499686cc9d$export$2e2bcd8739ae039);
// Expose mergeConfig
$740c54350e180ee0$var$axios.mergeConfig = (0, $f81b12bbdaede375$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.AxiosHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.formToJSON = (thing)=>(0, $6a3c091df0d84895$export$2e2bcd8739ae039)((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$740c54350e180ee0$var$axios.getAdapter = (0, $f045b92bde59d4db$export$2e2bcd8739ae039).getAdapter;
$740c54350e180ee0$var$axios.HttpStatusCode = (0, $0e01926db91ea959$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.default = $740c54350e180ee0$var$axios;
var // this module should only have a default export
$740c54350e180ee0$export$2e2bcd8739ae039 = $740c54350e180ee0$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $31b617b2b2526a86$export$1c00760e9e5a4e95, AxiosError: $31b617b2b2526a86$export$c1fbed17c2f6a328, CanceledError: $31b617b2b2526a86$export$1ab0c6b20d94fa14, isCancel: $31b617b2b2526a86$export$3b22524397b493c6, CancelToken: $31b617b2b2526a86$export$fd08e3cb425f0d61, VERSION: $31b617b2b2526a86$export$a4ad2735b021c132, all: $31b617b2b2526a86$export$84bf76cd7afc7469, Cancel: $31b617b2b2526a86$export$848c9b7ead0df967, isAxiosError: $31b617b2b2526a86$export$fbafdbe06a5b5a9a, spread: $31b617b2b2526a86$export$3ae0fd4797ed47c8, toFormData: $31b617b2b2526a86$export$10ae0d317ea97f8b, AxiosHeaders: $31b617b2b2526a86$export$4e7d6ff0f3e6520, HttpStatusCode: $31b617b2b2526a86$export$a972f69c851492b3, formToJSON: $31b617b2b2526a86$export$86d7c59254d6a2c9, getAdapter: $31b617b2b2526a86$export$17ddc20a97d669e2, mergeConfig: $31b617b2b2526a86$export$7ec1ebcfa9d8bd6a } = (0, $740c54350e180ee0$export$2e2bcd8739ae039);


const $a7869618706c9a61$var$PASSCODE_KEY = "app_passcode";
function $a7869618706c9a61$export$98d2631d6c18ba89() {
    const stored = localStorage.getItem($a7869618706c9a61$var$PASSCODE_KEY);
    return stored ? $a7869618706c9a61$export$94fdf11bafc8de6b(stored) : undefined;
}
function $a7869618706c9a61$export$1ec41df0ac549169(passcode) {
    localStorage.setItem($a7869618706c9a61$var$PASSCODE_KEY, $a7869618706c9a61$export$8fb536984ec8b4d7(passcode));
}
function $a7869618706c9a61$export$af21e9f5c008f7f5() {
    localStorage.removeItem($a7869618706c9a61$var$PASSCODE_KEY);
}
function $a7869618706c9a61$export$8fb536984ec8b4d7(value) {
    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(value);
    const binaryString = String.fromCharCode(...uint8Array);
    return btoa(binaryString);
}
function $a7869618706c9a61$export$94fdf11bafc8de6b(encoded) {
    const decodedBinary = atob(encoded);
    const decoder = new TextDecoder();
    return decoder.decode(new Uint8Array(decodedBinary.split("").map((char)=>char.charCodeAt(0))));
}


const $637e98f16008ef32$var$API_BASE_URL = "https://api.moovy.cloud:443/api/ssk/v1/";
let $637e98f16008ef32$var$failedQueue = [];
const $637e98f16008ef32$export$1e96637348ee8e98 = (timeout)=>{
    if (timeout) $637e98f16008ef32$export$388e0302ca0d9a41.defaults.timeout = timeout;
};
const $637e98f16008ef32$var$processQueue = (error)=>{
    $637e98f16008ef32$var$failedQueue.forEach((prom)=>{
        if (error) prom.reject(error);
        else prom.resolve();
    });
    $637e98f16008ef32$var$failedQueue = [];
};
const $637e98f16008ef32$export$388e0302ca0d9a41 = $637e98f16008ef32$var$createAxiosClient({
    options: {
        baseURL: $637e98f16008ef32$var$API_BASE_URL,
        timeout: 30000
    }
});
function $637e98f16008ef32$var$createAxiosClient({ options: options }) {
    const client = (0, $740c54350e180ee0$export$2e2bcd8739ae039).create(options);
    client.interceptors.request.use((config)=>{
        const token = (0, $a7869618706c9a61$export$98d2631d6c18ba89)();
        if (token) config.headers["X-API-PASSCODE"] = token;
        else delete config.headers["X-API-PASSCODE"];
        return config;
    });
    client.interceptors.response.use((response)=>{
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, (error)=>{
        const originalRequest = error.config;
        // If error, process all the requests in the queue and logout the user.
        const handleError = (error)=>{
            $637e98f16008ef32$var$processQueue(error);
            // TODO: logout user?
            return Promise.reject(error);
        };
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
    return client;
}


const $d53f45dc6ff26360$var$getConfig = async (guid)=>{
    if (!guid) throw new Error("API configuration usergroup guid is missing");
    const response = await (0, $637e98f16008ef32$export$388e0302ca0d9a41).get("config/" + guid);
    return response.data;
};
const $d53f45dc6ff26360$var$ConfigAPI = {
    getConfig: $d53f45dc6ff26360$var$getConfig
};
var $d53f45dc6ff26360$export$2e2bcd8739ae039 = $d53f45dc6ff26360$var$ConfigAPI;



var $1Ivrw = parcelRequire("1Ivrw");


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");


var $igOtJ = parcelRequire("igOtJ");

var $5ylSM = parcelRequire("5ylSM");





var $iqdgc = parcelRequire("iqdgc");
const $89ec842665c2e3cd$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $89ec842665c2e3cd$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === "object") {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $89ec842665c2e3cd$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === "number" || typeof responsive === "string") iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $f7d327f59a148258$var$appendLevel(level) {
    if (!level) return "";
    return `Level${level}`;
}
function $f7d327f59a148258$var$isNestedContainer(ownerState) {
    return ownerState.unstable_level > 0 && ownerState.container;
}
function $f7d327f59a148258$var$createGetSelfSpacing(ownerState) {
    return function getSelfSpacing(axis) {
        return `var(--Grid-${axis}Spacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)})`;
    };
}
function $f7d327f59a148258$var$createGetParentSpacing(ownerState) {
    return function getParentSpacing(axis) {
        if (ownerState.unstable_level === 0) return `var(--Grid-${axis}Spacing)`;
        return `var(--Grid-${axis}Spacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level - 1)})`;
    };
}
function $f7d327f59a148258$var$getParentColumns(ownerState) {
    if (ownerState.unstable_level === 0) return `var(--Grid-columns)`;
    return `var(--Grid-columns${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level - 1)})`;
}
const $f7d327f59a148258$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const getParentSpacing = $f7d327f59a148258$var$createGetParentSpacing(ownerState);
    const styles = {};
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === "grow") style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        if (value === "auto") style = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        if (typeof value === "number") style = {
            flexGrow: 0,
            flexBasis: "auto",
            width: `calc(100% * ${value} / ${$f7d327f59a148258$var$getParentColumns(ownerState)} - (${$f7d327f59a148258$var$getParentColumns(ownerState)} - ${value}) * (${getParentSpacing("column")} / ${$f7d327f59a148258$var$getParentColumns(ownerState)}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $f7d327f59a148258$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const getParentSpacing = $f7d327f59a148258$var$createGetParentSpacing(ownerState);
    const styles = {};
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === "auto") style = {
            marginLeft: "auto"
        };
        if (typeof value === "number") style = {
            marginLeft: value === 0 ? "0px" : `calc(100% * ${value} / ${$f7d327f59a148258$var$getParentColumns(ownerState)} + ${getParentSpacing("column")} * ${value} / ${$f7d327f59a148258$var$getParentColumns(ownerState)})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $f7d327f59a148258$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = $f7d327f59a148258$var$isNestedContainer(ownerState) ? {
        [`--Grid-columns${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: $f7d327f59a148258$var$getParentColumns(ownerState)
    } : {
        "--Grid-columns": 12
    };
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columns${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: value
        });
    });
    return styles;
};
const $f7d327f59a148258$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $f7d327f59a148258$var$createGetParentSpacing(ownerState);
    const styles = $f7d327f59a148258$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-rowSpacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("row")
    } : {};
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-rowSpacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : theme.spacing?.(value)
        });
    });
    return styles;
};
const $f7d327f59a148258$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = $f7d327f59a148258$var$createGetParentSpacing(ownerState);
    const styles = $f7d327f59a148258$var$isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-columnSpacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: getParentSpacing("column")
    } : {};
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columnSpacing${$f7d327f59a148258$var$appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : theme.spacing?.(value)
        });
    });
    return styles;
};
const $f7d327f59a148258$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $89ec842665c2e3cd$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $f7d327f59a148258$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    const getSelfSpacing = $f7d327f59a148258$var$createGetSelfSpacing(ownerState);
    return {
        minWidth: 0,
        boxSizing: "border-box",
        ...ownerState.container && {
            display: "flex",
            flexWrap: "wrap",
            ...ownerState.wrap && ownerState.wrap !== "wrap" && {
                flexWrap: ownerState.wrap
            },
            gap: `${getSelfSpacing("row")} ${getSelfSpacing("column")}`
        }
    };
};
const $f7d327f59a148258$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $f7d327f59a148258$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = "xs")=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === "string" && !Number.isNaN(Number(val)) || typeof val === "number" && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === "object" && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $f7d327f59a148258$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === "object") return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $1Ivrw = parcelRequire("1Ivrw");
const $215619a6946be4ad$var$defaultTheme = (0, $iqdgc.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $215619a6946be4ad$var$defaultCreateStyledComponent = (0, $2a108c9b8aac6572$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $215619a6946be4ad$var$useThemePropsDefault(props) {
    return (0, $70c33c2f46246d59$export$2e2bcd8739ae039)({
        props: props,
        name: "MuiGrid",
        defaultTheme: $215619a6946be4ad$var$defaultTheme
    });
}
function $215619a6946be4ad$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $215619a6946be4ad$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $215619a6946be4ad$var$useThemePropsDefault, componentName: componentName = "MuiGrid" } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                "root",
                container && "container",
                wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
                ...(0, $f7d327f59a148258$export$a7c8efbe2b138a60)(direction),
                ...(0, $f7d327f59a148258$export$e2d1175061442d38)(size),
                ...container ? (0, $f7d327f59a148258$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $5ylSM.default)(slots, (slot)=>(0, $igOtJ.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === "object") Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $f7d327f59a148258$export$ccc4d4a4923f1b06), (0, $f7d327f59a148258$export$a89c28919b8e3bb5), (0, $f7d327f59a148258$export$68c4dad72dd49c74), (0, $f7d327f59a148258$export$84053369756c53db), (0, $f7d327f59a148258$export$2a0a3c01032b3f4), (0, $f7d327f59a148258$export$810b8c3ab5d46bf), (0, $f7d327f59a148258$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $aqdBs.forwardRef(function Grid(inProps, ref) {
        const theme = (0, $6df9c97a08eacc3d$export$2e2bcd8739ae039)();
        const themeProps = useThemeProps(inProps);
        const props = (0, $98eda6bb3dc6d08b$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = "div", direction: direction = "row", wrap: wrap = "wrap", size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $1Ivrw.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $fQojQ.default)(classes.root, className),
            ...other,
            children: $aqdBs.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $aqdBs.isValidElement(child) && (0, $af3b9cb46350c6ee$export$2e2bcd8739ae039)(child, [
                    "Grid"
                ])) return /*#__PURE__*/ $aqdBs.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = "Grid";
    return Grid;
}



var $6JVXO = parcelRequire("6JVXO");
"use client";
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://mui.com/material-ui/api/grid-2/)
 */ const $cedc5f03ce6c72cd$var$Grid2 = (0, $215619a6946be4ad$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $6JVXO.default)("div", {
        name: "MuiGrid2",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    componentName: "MuiGrid2",
    useThemeProps: (inProps)=>(0, $96e6a52dfe8d6626$export$2e2bcd8739ae039)({
            props: inProps,
            name: "MuiGrid2"
        })
});
var $cedc5f03ce6c72cd$export$2e2bcd8739ae039 = $cedc5f03ce6c72cd$var$Grid2;


var $aqdBs = parcelRequire("aqdBs");

var $fQojQ = parcelRequire("fQojQ");


var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");function $5099029afa8e746d$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $5099029afa8e746d$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $5099029afa8e746d$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $5099029afa8e746d$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $5099029afa8e746d$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $5099029afa8e746d$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $5099029afa8e746d$export$8af1d214c6c2f0f1(length) * $5099029afa8e746d$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $5099029afa8e746d$export$8af1d214c6c2f0f1(length) * $5099029afa8e746d$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $5099029afa8e746d$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $5099029afa8e746d$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $5099029afa8e746d$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $5099029afa8e746d$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $5099029afa8e746d$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $aIlUA = parcelRequire("aIlUA");
var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $7158ed91384f1ed8$export$c987db9fc844f86(slot) {
    return (0, $igOtJ.default)("MuiSkeleton", slot);
}
const $7158ed91384f1ed8$var$skeletonClasses = (0, $jIPNy.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $7158ed91384f1ed8$export$2e2bcd8739ae039 = $7158ed91384f1ed8$var$skeletonClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $36daee2a60df71de$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $7158ed91384f1ed8$export$c987db9fc844f86), classes);
};
const $36daee2a60df71de$var$pulseKeyframe = (0, $aIlUA.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $36daee2a60df71de$var$waveKeyframe = (0, $aIlUA.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $36daee2a60df71de$var$pulseAnimation = typeof $36daee2a60df71de$var$pulseKeyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$36daee2a60df71de$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $36daee2a60df71de$var$waveAnimation = typeof $36daee2a60df71de$var$waveKeyframe !== "string" ? (0, $aIlUA.css)`
        &::after {
          animation: ${$36daee2a60df71de$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $36daee2a60df71de$var$SkeletonRoot = (0, $6JVXO.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>{
    const radiusUnit = (0, $5099029afa8e746d$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $5099029afa8e746d$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return {
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $amKcf.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em",
        variants: [
            {
                props: {
                    variant: "text"
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: "auto",
                    transformOrigin: "0 55%",
                    transform: "scale(1, 0.60)",
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    "&:empty:before": {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: "circular"
                },
                style: {
                    borderRadius: "50%"
                }
            },
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    "& > *": {
                        visibility: "hidden"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: "fit-content"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: "auto"
                }
            },
            {
                props: {
                    animation: "pulse"
                },
                style: $36daee2a60df71de$var$pulseAnimation || {
                    animation: `${$36daee2a60df71de$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: "wave"
                },
                style: {
                    position: "relative",
                    overflow: "hidden",
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: "-webkit-radial-gradient(white, black)",
                    "&::after": {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: "absolute",
                        transform: "translateX(-100%)" /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: "wave"
                },
                style: $36daee2a60df71de$var$waveAnimation || {
                    "&::after": {
                        animation: `${$36daee2a60df71de$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $36daee2a60df71de$var$Skeleton = /*#__PURE__*/ $aqdBs.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $36daee2a60df71de$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($36daee2a60df71de$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $36daee2a60df71de$export$2e2bcd8739ae039 = $36daee2a60df71de$var$Skeleton;



var $aqdBs = parcelRequire("aqdBs");

var $1Ivrw = parcelRequire("1Ivrw");

const $65bd30c1f00997e9$var$MoovyErrorPage = ()=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)("h1", {
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                    id: "moovyErrorPage.oops"
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)("p", {
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                    id: "moovyErrorPage.message"
                })
            })
        ]
    });
};
var $65bd30c1f00997e9$export$2e2bcd8739ae039 = $65bd30c1f00997e9$var$MoovyErrorPage;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");


var $40jPv = parcelRequire("40jPv");



var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $2deb4d9425383a2b$export$69aecd24bc2cf7e3(slot) {
    return (0, $igOtJ.default)("MuiAlert", slot);
}
const $2deb4d9425383a2b$var$alertClasses = (0, $jIPNy.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $2deb4d9425383a2b$export$2e2bcd8739ae039 = $2deb4d9425383a2b$var$alertClasses;



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");


var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");


var $2MrFe = parcelRequire("2MrFe");


var $40jPv = parcelRequire("40jPv");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $189032c25238277e$export$5e8702d71474f093(slot) {
    return (0, $igOtJ.default)("MuiIconButton", slot);
}
const $189032c25238277e$var$iconButtonClasses = (0, $jIPNy.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $189032c25238277e$export$2e2bcd8739ae039 = $189032c25238277e$var$iconButtonClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $6370818d19ff91e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $40jPv.default)(color)}`,
            edge && `edge${(0, $40jPv.default)(edge)}`,
            `size${(0, $40jPv.default)(size)}`
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $189032c25238277e$export$5e8702d71474f093), classes);
};
const $6370818d19ff91e9$var$IconButtonRoot = (0, $6JVXO.default)((0, $27fd4653351996cf$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $40jPv.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $40jPv.default)(ownerState.edge)}`],
            styles[`size${(0, $40jPv.default)(ownerState.size)}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    disableRipple: false
                },
                style: {
                    "&:hover": {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            },
            {
                props: {
                    edge: "start"
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: "start",
                    size: "small"
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: "end"
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: "end",
                    size: "small"
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $iAnBN.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: "inherit"
                },
                style: {
                    color: "inherit"
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        "&:hover": {
                            backgroundColor: theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity),
                            // Reset on touch devices, it doesn't add specificity
                            "@media (hover: none)": {
                                backgroundColor: "transparent"
                            }
                        }
                    }
                })),
            {
                props: {
                    size: "small"
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: "large"
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $189032c25238277e$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    })));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $6370818d19ff91e9$var$IconButton = /*#__PURE__*/ $aqdBs.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, size: size = "medium", ...other } = props;
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        size: size
    };
    const classes = $6370818d19ff91e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($6370818d19ff91e9$var$IconButtonRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        disableRipple: disableRipple,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children
    });
});
var $6370818d19ff91e9$export$2e2bcd8739ae039 = $6370818d19ff91e9$var$IconButton;


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $ab6105b31d534be5$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $4a2bed16bc46b5b8$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $eb6ff51f4807ea32$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $b71b6bc254ee4c69$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("aqdBs");

var $1OFRX = parcelRequire("1OFRX");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $c72372c9a1d8d652$export$2e2bcd8739ae039 = (0, $1OFRX.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $d090c14501290520$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $40jPv.default)(color || severity)}`,
            `${variant}${(0, $40jPv.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $2deb4d9425383a2b$export$69aecd24bc2cf7e3), classes);
};
const $d090c14501290520$var$AlertRoot = (0, $6JVXO.default)((0, $f843ecc7e1945ca7$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $40jPv.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $amKcf.darken) : (0, $amKcf.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $amKcf.lighten) : (0, $amKcf.darken);
    return {
        ...theme.typography.body2,
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)([
                "light"
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $2deb4d9425383a2b$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)([
                "light"
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $2deb4d9425383a2b$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)([
                "dark"
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $d090c14501290520$var$AlertIcon = (0, $6JVXO.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $d090c14501290520$var$AlertMessage = (0, $6JVXO.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $d090c14501290520$var$AlertAction = (0, $6JVXO.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $d090c14501290520$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ab6105b31d534be5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4a2bed16bc46b5b8$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $eb6ff51f4807ea32$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b71b6bc254ee4c69$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d090c14501290520$var$Alert = /*#__PURE__*/ $aqdBs.forwardRef(function Alert(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d090c14501290520$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $d090c14501290520$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("closeButton", {
        elementType: (0, $6370818d19ff91e9$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("closeIcon", {
        elementType: (0, $c72372c9a1d8d652$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($d090c14501290520$var$AlertRoot, {
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $1Ivrw.jsx)($d090c14501290520$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d090c14501290520$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $1Ivrw.jsx)($d090c14501290520$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $1Ivrw.jsx)($d090c14501290520$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $1Ivrw.jsx)($d090c14501290520$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $d090c14501290520$export$2e2bcd8739ae039 = $d090c14501290520$var$Alert;


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");


var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $5966b00e1c7cb685$export$5269a5bce2c2f987(slot) {
    return (0, $igOtJ.default)("MuiAlertTitle", slot);
}
const $5966b00e1c7cb685$var$alertTitleClasses = (0, $jIPNy.default)("MuiAlertTitle", [
    "root"
]);
var $5966b00e1c7cb685$export$2e2bcd8739ae039 = $5966b00e1c7cb685$var$alertTitleClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $991456c1ebe45a00$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $5966b00e1c7cb685$export$5269a5bce2c2f987), classes);
};
const $991456c1ebe45a00$var$AlertTitleRoot = (0, $6JVXO.default)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})((0, $iAnBN.default)(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const $991456c1ebe45a00$var$AlertTitle = /*#__PURE__*/ $aqdBs.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $991456c1ebe45a00$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($991456c1ebe45a00$var$AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ...other
    });
});
var $991456c1ebe45a00$export$2e2bcd8739ae039 = $991456c1ebe45a00$var$AlertTitle;



var $aqdBs = parcelRequire("aqdBs");

const $6a9b99866176c7c7$var$getValidationErrors = (intl, validationErrors)=>{
    return validationErrors?.map((item)=>{
        return intl.formatMessage({
            id: `validation.code.${item.code}`,
            defaultMessage: intl.formatMessage({
                id: "validation.code.generic"
            })
        }, {
            field: intl.formatMessage({
                id: `validation.field.${item.field}`,
                defaultMessage: item.field
            })
        });
    });
};
const $6a9b99866176c7c7$export$414e01788cec8720 = (intl, error)=>{
    if (error.response?.data?.validationErrors && error.response.data.validationErrors.length > 0) return $6a9b99866176c7c7$var$getValidationErrors(intl, error.response.data.validationErrors);
    return null;
};
const $6a9b99866176c7c7$export$b2aeb2d3d984ebee = (intl, error)=>{
    if (error.response?.data?.code) return intl.formatMessage({
        id: `api.error.code.${error.response?.data?.code}`,
        defaultMessage: intl.formatMessage({
            id: "api.error.code.generic"
        })
    });
    return null;
};
const $6a9b99866176c7c7$var$MoovyMutationError = ({ mutation: mutation, query: query, errorTitleKey: errorTitleKey, errorBodyKey: errorBodyKey })=>{
    const intl = (0, $00e6da6e00acc8ce$export$2e2bcd8739ae039)();
    const MoovyAlert = ({ title: title, children: children })=>{
        const isChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).isValidElement(children);
        const RenderOnlyTitle = ()=>{
            return /*#__PURE__*/ (0, $1Ivrw.jsx)("b", {
                children: title
            });
        };
        const RenderOnlyDescription = ()=>{
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
                children: children
            });
        };
        const RenderAll = ()=>{
            return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $991456c1ebe45a00$export$2e2bcd8739ae039), {
                        children: title
                    }),
                    children
                ]
            });
        };
        return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $d090c14501290520$export$2e2bcd8739ae039), {
            severity: "error",
            children: title && isChildren ? /*#__PURE__*/ (0, $1Ivrw.jsx)(RenderAll, {}) : title ? /*#__PURE__*/ (0, $1Ivrw.jsx)(RenderOnlyTitle, {}) : /*#__PURE__*/ (0, $1Ivrw.jsx)(RenderOnlyDescription, {})
        });
    };
    const localizedErrorText = ({ mutation: mutation, query: query, errorBodyKey: errorBodyKey, errorTitleKey: errorTitleKey })=>{
        if (!mutation?.isError && !query?.isError) return "";
        const error = mutation?.error || query?.error;
        const localizedValidationErrors = $6a9b99866176c7c7$export$414e01788cec8720(intl, error);
        const localizedError = $6a9b99866176c7c7$export$b2aeb2d3d984ebee(intl, error);
        const localizedTitle = errorTitleKey && intl.formatMessage({
            id: errorTitleKey
        });
        if (localizedValidationErrors) return /*#__PURE__*/ (0, $1Ivrw.jsx)(MoovyAlert, {
            title: localizedTitle,
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
                children: localizedValidationErrors.map((item, index)=>/*#__PURE__*/ (0, $1Ivrw.jsx)("li", {
                        children: item
                    }, index))
            })
        });
        else if (localizedError) return /*#__PURE__*/ (0, $1Ivrw.jsx)(MoovyAlert, {
            title: localizedError
        });
        else return /*#__PURE__*/ (0, $1Ivrw.jsx)(MoovyAlert, {
            title: localizedTitle,
            children: errorBodyKey ? intl.formatMessage({
                id: errorBodyKey
            }) : null
        });
    };
    return localizedErrorText({
        mutation: mutation,
        query: query,
        errorBodyKey: errorBodyKey,
        errorTitleKey: errorTitleKey
    });
};
var $6a9b99866176c7c7$export$2e2bcd8739ae039 = $6a9b99866176c7c7$var$MoovyMutationError;



var $1Ivrw = parcelRequire("1Ivrw");


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");


var $5ylSM = parcelRequire("5ylSM");

var $aIlUA = parcelRequire("aIlUA");
var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $40jPv = parcelRequire("40jPv");


var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $d0596ad213081fc3$export$29cad1383b3f235d(slot) {
    return (0, $igOtJ.default)("MuiCircularProgress", slot);
}
const $d0596ad213081fc3$var$circularProgressClasses = (0, $jIPNy.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $d0596ad213081fc3$export$2e2bcd8739ae039 = $d0596ad213081fc3$var$circularProgressClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $5373eab4e5089aae$var$SIZE = 44;
const $5373eab4e5089aae$var$circularRotateKeyframe = (0, $aIlUA.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $5373eab4e5089aae$var$circularDashKeyframe = (0, $aIlUA.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $5373eab4e5089aae$var$rotateAnimation = typeof $5373eab4e5089aae$var$circularRotateKeyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$5373eab4e5089aae$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $5373eab4e5089aae$var$dashAnimation = typeof $5373eab4e5089aae$var$circularDashKeyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$5373eab4e5089aae$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $5373eab4e5089aae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $40jPv.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $40jPv.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $d0596ad213081fc3$export$29cad1383b3f235d), classes);
};
const $5373eab4e5089aae$var$CircularProgressRoot = (0, $6JVXO.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $40jPv.default)(ownerState.color)}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        display: "inline-block",
        variants: [
            {
                props: {
                    variant: "determinate"
                },
                style: {
                    transition: theme.transitions.create("transform")
                }
            },
            {
                props: {
                    variant: "indeterminate"
                },
                style: $5373eab4e5089aae$var$rotateAnimation || {
                    animation: `${$5373eab4e5089aae$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $5373eab4e5089aae$var$CircularProgressSVG = (0, $6JVXO.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $5373eab4e5089aae$var$CircularProgressCircle = (0, $6JVXO.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $40jPv.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        stroke: "currentColor",
        variants: [
            {
                props: {
                    variant: "determinate"
                },
                style: {
                    transition: theme.transitions.create("stroke-dashoffset")
                }
            },
            {
                props: {
                    variant: "indeterminate"
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: "80px, 200px",
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink,
                style: $5373eab4e5089aae$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$5373eab4e5089aae$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $5373eab4e5089aae$var$CircularProgress = /*#__PURE__*/ $aqdBs.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $5373eab4e5089aae$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($5373eab4e5089aae$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($5373eab4e5089aae$var$CircularProgressRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($5373eab4e5089aae$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$5373eab4e5089aae$var$SIZE / 2} ${$5373eab4e5089aae$var$SIZE / 2} ${$5373eab4e5089aae$var$SIZE} ${$5373eab4e5089aae$var$SIZE}`,
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)($5373eab4e5089aae$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $5373eab4e5089aae$var$SIZE,
                cy: $5373eab4e5089aae$var$SIZE,
                r: ($5373eab4e5089aae$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $5373eab4e5089aae$export$2e2bcd8739ae039 = $5373eab4e5089aae$var$CircularProgress;


const $57e7ca2b3d7d5d01$var$MoovyProgress = (props)=>{
    const { success: success = false, ...restProps } = props;
    const style = restProps.sx || {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    if (success) return null;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: style,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5373eab4e5089aae$export$2e2bcd8739ae039), {
            ...restProps
        })
    });
};
var $57e7ca2b3d7d5d01$export$2e2bcd8739ae039 = $57e7ca2b3d7d5d01$var$MoovyProgress;


const $19204c7fe597e591$export$add10c4cb4cd7fd0 = "moovyBackdropAnimation";
const $19204c7fe597e591$export$7f244bb9bb2e9e50 = "appConfig";
const $19204c7fe597e591$export$d5ed0aaafc7e72a6 = "appSettings";
const $19204c7fe597e591$export$2d645a9ab911dc4 = "apiSettings";
const $19204c7fe597e591$export$1d1c1790999e0565 = "organizations";
const $19204c7fe597e591$export$ea8c0e772da05fa5 = "location";
const $19204c7fe597e591$export$8553644368f7017 = "errorMessages";




const $cc81c8b1a5c03ee1$export$e32ce87e5105839e = (navigate, error)=>{
    if (error && (0, $740c54350e180ee0$export$2e2bcd8739ae039).isAxiosError(error)) {
        const axiosError = error;
        if (axiosError?.response?.status === 404) navigate((0, $206e3eae9507a76b$export$581a21dcf1a8a09c).ROOT);
    }
};



var $aqdBs = parcelRequire("aqdBs");
function $16cfff22ed9d8450$export$2e2bcd8739ae039(options) {
    const { key: key, initialValue: initialValue } = options;
    const [state, setState] = (0, $aqdBs.useState)(()=>{
        const storedValue = localStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : initialValue;
    });
    const updateFunction = (value)=>{
        setState(value);
        localStorage.setItem(key, JSON.stringify(value));
    };
    (0, $aqdBs.useEffect)(()=>{
        const storedValue = localStorage.getItem(key);
        if (storedValue) setState(JSON.parse(storedValue));
    }, [
        key
    ]);
    return [
        state,
        updateFunction
    ];
}



const $7e235b881bd69492$var$BackdropAnimation = ({ show: show })=>{
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const [state, setState] = (0, $16cfff22ed9d8450$export$2e2bcd8739ae039)({
        key: (0, $19204c7fe597e591$export$add10c4cb4cd7fd0),
        initialValue: {
            value: ""
        }
    });
    (0, $aqdBs.useEffect)(()=>{
        if (show != !!state.value) setState({
            value: show ? "true" : ""
        });
    }, [
        show
    ]);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: {
            opacity: 0.5,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: theme.zIndex.drawer + 1,
            visibility: show ? "visible" : "hidden"
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $9c811864513a06df$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: theme.palette.customColors.mainBackground
            },
            open: show,
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $57e7ca2b3d7d5d01$export$2e2bcd8739ae039), {})
        })
    });
};
const $7e235b881bd69492$var$ProgressAnimation = ()=>{
    const getSkeletonAnimations = ()=>{
        const skeletonCount = 8;
        const skeletonItems = [];
        for(let i = 0; i < skeletonCount; i++)skeletonItems.push(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $36daee2a60df71de$export$2e2bcd8739ae039), {
            animation: "wave"
        }, i));
        return skeletonItems.map((item)=>item);
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
        container: true,
        gap: 2,
        mt: 2,
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
                size: 12,
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $36daee2a60df71de$export$2e2bcd8739ae039), {
                    variant: "rounded",
                    height: 60
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
                size: 12,
                children: getSkeletonAnimations()
            })
        ]
    });
};
const $7e235b881bd69492$var$MoovyQueryHandler = ({ query: query, rootPageIfNotFoundError: rootPageIfNotFoundError, children: children })=>{
    const navigate = (0, $bdd5c91922f45546$export$9770f232ac06a008)();
    if (rootPageIfNotFoundError) (0, $cc81c8b1a5c03ee1$export$e32ce87e5105839e)(navigate, query.error);
    const noDataAnimation = query.isFetching && !query.data;
    const dataAnimation = query.isFetching && !!query.data;
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            query.isError ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $65bd30c1f00997e9$export$2e2bcd8739ae039), {}) : noDataAnimation ? /*#__PURE__*/ (0, $1Ivrw.jsx)($7e235b881bd69492$var$ProgressAnimation, {}) : /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)($7e235b881bd69492$var$BackdropAnimation, {
                        show: dataAnimation
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $6a9b99866176c7c7$export$2e2bcd8739ae039), {
                query: query,
                errorTitleKey: "common.actions.get.error"
            })
        ]
    });
};
var $7e235b881bd69492$export$2e2bcd8739ae039 = $7e235b881bd69492$var$MoovyQueryHandler;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");





var $9f2f177dc7e559e9$var$_client, $9f2f177dc7e559e9$var$_currentResult, $9f2f177dc7e559e9$var$_currentMutation, $9f2f177dc7e559e9$var$_mutateOptions, $9f2f177dc7e559e9$var$_updateResult, $9f2f177dc7e559e9$var$updateResult_fn, $9f2f177dc7e559e9$var$_notify, $9f2f177dc7e559e9$var$notify_fn;
var $9f2f177dc7e559e9$export$d3c1860ee66f291a = class extends (0, $6a6e3ae6bbc09ecd$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_updateResult);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_notify);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_client, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_currentResult, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_currentMutation, void 0);
        (0, $f48cbf5a79e3fcf4$export$addf369becd23283)(this, $9f2f177dc7e559e9$var$_mutateOptions, void 0);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $9f2f177dc7e559e9$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $9f2f177dc7e559e9$var$_updateResult, $9f2f177dc7e559e9$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_client).defaultMutationOptions(options);
        if (!(0, $66d37cb3d8195cdd$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $66d37cb3d8195cdd$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $66d37cb3d8195cdd$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $9f2f177dc7e559e9$var$_updateResult, $9f2f177dc7e559e9$var$updateResult_fn).call(this);
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $9f2f177dc7e559e9$var$_notify, $9f2f177dc7e559e9$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $9f2f177dc7e559e9$var$_currentMutation, void 0);
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $9f2f177dc7e559e9$var$_updateResult, $9f2f177dc7e559e9$var$updateResult_fn).call(this);
        (0, $f48cbf5a79e3fcf4$export$fa92d15b718fce20)(this, $9f2f177dc7e559e9$var$_notify, $9f2f177dc7e559e9$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $9f2f177dc7e559e9$var$_mutateOptions, options);
        (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $9f2f177dc7e559e9$var$_currentMutation, (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_client).getMutationCache().build((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_client), this.options));
        (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation).addObserver(this);
        return (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation).execute(variables);
    }
};
$9f2f177dc7e559e9$var$_client = new WeakMap();
$9f2f177dc7e559e9$var$_currentResult = new WeakMap();
$9f2f177dc7e559e9$var$_currentMutation = new WeakMap();
$9f2f177dc7e559e9$var$_mutateOptions = new WeakMap();
$9f2f177dc7e559e9$var$_updateResult = new WeakSet();
$9f2f177dc7e559e9$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $4d43d2ef3a97bc05$export$a1659b54bac3252a)();
    (0, $f48cbf5a79e3fcf4$export$42432efe6614d3b4)(this, $9f2f177dc7e559e9$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$9f2f177dc7e559e9$var$_notify = new WeakSet();
$9f2f177dc7e559e9$var$notify_fn = function(action) {
    (0, $5f301ba98937b677$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentResult).variables;
            const context = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $f48cbf5a79e3fcf4$export$18a094aefa070634)(this, $9f2f177dc7e559e9$var$_currentResult));
        });
    });
};




"use client";
function $e22549bf43b8fa18$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $da27b542cb58aea7$export$22e77b9572c4fded)(queryClient);
    const [observer] = $aqdBs.useState(()=>new (0, $9f2f177dc7e559e9$export$d3c1860ee66f291a)(client, options));
    $aqdBs.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $aqdBs.useSyncExternalStore($aqdBs.useCallback((onStoreChange)=>observer.subscribe((0, $5f301ba98937b677$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $aqdBs.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $4def3f93cfc9db2e$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $4def3f93cfc9db2e$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $9iMQk = parcelRequire("9iMQk");

var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");

var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");


var $40jPv = parcelRequire("40jPv");


var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $ea9a1c206b389eb1$export$5a6f9035944c8119(slot) {
    return (0, $igOtJ.default)("MuiButton", slot);
}
const $ea9a1c206b389eb1$var$buttonClasses = (0, $jIPNy.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $ea9a1c206b389eb1$export$2e2bcd8739ae039 = $ea9a1c206b389eb1$var$buttonClasses;



var $aqdBs = parcelRequire("aqdBs");
/**
 * @ignore - internal component.
 */ const $73e30c221d142f34$var$ButtonGroupContext = /*#__PURE__*/ $aqdBs.createContext({});
var $73e30c221d142f34$export$2e2bcd8739ae039 = $73e30c221d142f34$var$ButtonGroupContext;



var $aqdBs = parcelRequire("aqdBs");
/**
 * @ignore - internal component.
 */ const $4f560767f7e2a61f$var$ButtonGroupButtonContext = /*#__PURE__*/ $aqdBs.createContext(undefined);
var $4f560767f7e2a61f$export$2e2bcd8739ae039 = $4f560767f7e2a61f$var$ButtonGroupButtonContext;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $234a000ff615fd2f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $40jPv.default)(color)}`,
            `size${(0, $40jPv.default)(size)}`,
            `${variant}Size${(0, $40jPv.default)(size)}`,
            `color${(0, $40jPv.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $40jPv.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $40jPv.default)(size)}`
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $ea9a1c206b389eb1$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $234a000ff615fd2f$var$commonIconStyles = [
    {
        props: {
            size: "small"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: "medium"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: "large"
        },
        style: {
            "& > *:nth-of-type(1)": {
                fontSize: 22
            }
        }
    }
];
const $234a000ff615fd2f$var$ButtonRoot = (0, $6JVXO.default)((0, $27fd4653351996cf$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $40jPv.default)(ownerState.color)}`],
            styles[`size${(0, $40jPv.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $40jPv.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: "6px 16px",
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            textDecoration: "none"
        },
        [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: "contained"
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    "&:hover": {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    "&:active": {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    padding: "5px 15px",
                    border: "1px solid currentColor",
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: "text"
                },
                style: {
                    padding: "6px 8px",
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)([
                "dark",
                "contrastText"
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        "--variant-textColor": (theme.vars || theme).palette[color].main,
                        "--variant-outlinedColor": (theme.vars || theme).palette[color].main,
                        "--variant-outlinedBorder": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $amKcf.alpha)(theme.palette[color].main, 0.5),
                        "--variant-containedColor": (theme.vars || theme).palette[color].contrastText,
                        "--variant-containedBg": (theme.vars || theme).palette[color].main,
                        "@media (hover: hover)": {
                            "&:hover": {
                                "--variant-containedBg": (theme.vars || theme).palette[color].dark,
                                "--variant-textBg": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "--variant-outlinedBorder": (theme.vars || theme).palette[color].main,
                                "--variant-outlinedBg": theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: "inherit"
                },
                style: {
                    "--variant-containedColor": theme.vars ? // this is safe because grey does not change between default light/dark mode
                    theme.vars.palette.text.primary : theme.palette.getContrastText?.(inheritContainedBackgroundColor),
                    "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    "@media (hover: hover)": {
                        "&:hover": {
                            "--variant-containedBg": theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            "--variant-textBg": theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            "--variant-outlinedBg": theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $amKcf.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: "small",
                    variant: "text"
                },
                style: {
                    padding: "4px 5px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "text"
                },
                style: {
                    padding: "8px 11px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: "small",
                    variant: "outlined"
                },
                style: {
                    padding: "3px 9px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "outlined"
                },
                style: {
                    padding: "7px 21px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: "small",
                    variant: "contained"
                },
                style: {
                    padding: "4px 10px",
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: "large",
                    variant: "contained"
                },
                style: {
                    padding: "8px 22px",
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none"
                    },
                    [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: "none"
                    },
                    "&:active": {
                        boxShadow: "none"
                    },
                    [`&.${(0, $ea9a1c206b389eb1$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: "none"
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            }
        ]
    };
}));
const $234a000ff615fd2f$var$ButtonStartIcon = (0, $6JVXO.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $40jPv.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inherit",
    marginRight: 8,
    marginLeft: -4,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                marginLeft: -2
            }
        },
        ...$234a000ff615fd2f$var$commonIconStyles
    ]
});
const $234a000ff615fd2f$var$ButtonEndIcon = (0, $6JVXO.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $40jPv.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inherit",
    marginRight: -4,
    marginLeft: 8,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                marginRight: -2
            }
        },
        ...$234a000ff615fd2f$var$commonIconStyles
    ]
});
const $234a000ff615fd2f$var$Button = /*#__PURE__*/ $aqdBs.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $aqdBs.useContext((0, $73e30c221d142f34$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $aqdBs.useContext((0, $4f560767f7e2a61f$export$2e2bcd8739ae039));
    const resolvedProps = (0, $9iMQk.default)(contextProps, inProps);
    const props = (0, $2MrFe.useDefaultProps)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $234a000ff615fd2f$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $1Ivrw.jsx)($234a000ff615fd2f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $1Ivrw.jsx)($234a000ff615fd2f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($234a000ff615fd2f$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $fQojQ.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fQojQ.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        ...other,
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    });
});
var $234a000ff615fd2f$export$2e2bcd8739ae039 = $234a000ff615fd2f$var$Button;


var $aqdBs = parcelRequire("aqdBs");



"use client";
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $fd4aa80ca8b4f401$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $aqdBs.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $35a0d5759101fc88$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener("change", updateMatch);
        return ()=>{
            queryList.removeEventListener("change", updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $fd4aa80ca8b4f401$var$safeReact = {
    ...$aqdBs
};
const $fd4aa80ca8b4f401$var$maybeReactUseSyncExternalStore = $fd4aa80ca8b4f401$var$safeReact.useSyncExternalStore;
function $fd4aa80ca8b4f401$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $aqdBs.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $aqdBs.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $aqdBs.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener("change", notify);
                return ()=>{
                    mediaQueryList.removeEventListener("change", notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $fd4aa80ca8b4f401$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $fd4aa80ca8b4f401$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $27be6d923f5fe768$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $cb6a59fe0e4a296f$export$2e2bcd8739ae039)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    const useMediaQueryImplementation = $fd4aa80ca8b4f401$var$maybeReactUseSyncExternalStore !== undefined ? $fd4aa80ca8b4f401$var$useMediaQueryNew : $fd4aa80ca8b4f401$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}





var $1Ivrw = parcelRequire("1Ivrw");


var $1Ivrw = parcelRequire("1Ivrw");


var $6JVXO = parcelRequire("6JVXO");

var $fe04f12aa42d2e87$exports = {};
"use strict";
"use client";

Object.defineProperty($fe04f12aa42d2e87$exports, "__esModule", {
    value: true
});
$fe04f12aa42d2e87$exports.default = void 0;

var $fe04f12aa42d2e87$var$_createSvgIcon = $40a8df7d40f3cb7f$exports((parcelRequire("2zAtv")));

var $1Ivrw = parcelRequire("1Ivrw");
var $fe04f12aa42d2e87$var$_default = $fe04f12aa42d2e87$exports.default = (0, $fe04f12aa42d2e87$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 3h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zm-1 2H5V9h2zm0-3H5V6h2zm9 7H8v-2h8zm0-4h-2V9h2zm0-3h-2V6h2zm3 3h-2V9h2zm0-3h-2V6h2zm-7 15 4-4H8z"
}), "KeyboardHide");


var $db4e78869ca3f658$exports = {};
"use strict";
"use client";

Object.defineProperty($db4e78869ca3f658$exports, "__esModule", {
    value: true
});
$db4e78869ca3f658$exports.default = void 0;

var $db4e78869ca3f658$var$_createSvgIcon = $40a8df7d40f3cb7f$exports((parcelRequire("2zAtv")));

var $1Ivrw = parcelRequire("1Ivrw");
var $db4e78869ca3f658$var$_default = $db4e78869ca3f658$exports.default = (0, $db4e78869ca3f658$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $1Ivrw.jsx)("path", {
    d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12z"
}), "Backspace");


const $aa83881c259e5458$var$KeyboardButton = (0, $6JVXO.default)((0, $234a000ff615fd2f$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: "#FFFFFF",
        color: "#000000",
        [`@media (orientation: portrait)`]: {
            [theme.breakpoints.down("md")]: {
                margin: "3px",
                padding: "1px",
                fontSize: "2rem"
            },
            [theme.breakpoints.up("md")]: {
                margin: "3px",
                padding: "8px",
                fontSize: "2rem"
            }
        },
        [`@media (orientation: landscape)`]: {
            [`@media (max-height: 850px)`]: {
                margin: "3px",
                padding: "1px",
                fontSize: "2rem"
            },
            [`@media (min-height: 851px)`]: {
                margin: "3px",
                padding: "8px",
                fontSize: "2rem"
            }
        }
    }));
const $aa83881c259e5458$var$SpecialButtons = (0, $6JVXO.default)($aa83881c259e5458$var$KeyboardButton)(({ theme: theme })=>({
        [theme.breakpoints.down("md")]: {
            width: "132px"
        },
        [theme.breakpoints.up("md")]: {
            width: "135px"
        }
    }));
const $aa83881c259e5458$var$OkButton = (0, $6JVXO.default)($aa83881c259e5458$var$SpecialButtons)({
    background: "#0098d8",
    color: "#FFFF"
});
const $aa83881c259e5458$var$KeyboardKeys = ({ onKeyPress: onKeyPress })=>{
    const keyboardLayout = [
        [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "0",
            "delete"
        ],
        [
            "q",
            "w",
            "e",
            "r",
            "t",
            "y",
            "u",
            "i",
            "o",
            "p",
            "\xe5"
        ],
        [
            "a",
            "s",
            "d",
            "f",
            "g",
            "h",
            "j",
            "k",
            "l",
            "\xe4",
            "\xf6"
        ],
        [
            "down",
            "z",
            "x",
            "c",
            "v",
            "b",
            "n",
            "m",
            "OK"
        ]
    ];
    const handleKeyPress = (key)=>()=>onKeyPress(key);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
        children: keyboardLayout.map((row, rowIndex)=>/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "OK",
                children: row.map((key, index)=>{
                    const uniqueKey = `${rowIndex}-${index}`;
                    if (key === "OK") return /*#__PURE__*/ (0, $1Ivrw.jsx)($aa83881c259e5458$var$OkButton, {
                        onClick: handleKeyPress(key),
                        children: key
                    }, uniqueKey);
                    else if (key === "down") return /*#__PURE__*/ (0, $1Ivrw.jsx)($aa83881c259e5458$var$SpecialButtons, {
                        onClick: handleKeyPress(key),
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fe04f12aa42d2e87$exports))), {
                            sx: {
                                fontSize: 40
                            }
                        })
                    }, uniqueKey);
                    else return /*#__PURE__*/ (0, $1Ivrw.jsx)($aa83881c259e5458$var$KeyboardButton, {
                        onClick: handleKeyPress(key),
                        children: key === "delete" ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($db4e78869ca3f658$exports))), {
                            sx: {
                                fontSize: 30
                            }
                        }) : key
                    }, uniqueKey);
                })
            }, rowIndex))
    });
};
var $aa83881c259e5458$export$2e2bcd8739ae039 = $aa83881c259e5458$var$KeyboardKeys;


const $0e2c47fc5c90c473$var$MoovyVirtualKeyboard = ({ open: open, handleVirtualKeyboardInput: handleVirtualKeyboardInput, useMoovyKeyboard: useMoovyKeyboard })=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4b253693d6d955c3$export$2e2bcd8739ae039), {
        in: open,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: "#E0E0E0",
                borderRadius: "10px",
                padding: "2px"
            },
            children: useMoovyKeyboard && /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $aa83881c259e5458$export$2e2bcd8739ae039), {
                onKeyPress: handleVirtualKeyboardInput
            })
        })
    });
};
var $0e2c47fc5c90c473$export$2e2bcd8739ae039 = $0e2c47fc5c90c473$var$MoovyVirtualKeyboard;



var $1Ivrw = parcelRequire("1Ivrw");

var $515f3adbbad4e555$exports = {};
$515f3adbbad4e555$exports = new URL("Ellipse.779ef8b7.svg", import.meta.url).toString();


var $2fa8cdcce5e3e2e3$exports = {};
$2fa8cdcce5e3e2e3$exports = new URL("Car.80687930.svg", import.meta.url).toString();


const $782fb883374a8c57$var$licensePlateTextField = ({ value: value, onFocus: onFocus, onChange: onChange, redeemPermit: redeemPermit, hasError: hasError, useMoovyKeyboard: useMoovyKeyboard })=>{
    const handleEnter = (event)=>{
        if (event.key === "Enter") redeemPermit();
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4ea6f68cc48b79d3$export$2e2bcd8739ae039), {
        error: hasError,
        sx: {
            display: "flex",
            width: "98%",
            height: {
                xs: "60px",
                sm: "75px"
            },
            border: hasError ? {
                xs: "3px solid #ff4848",
                sm: "4px solid #ff4848"
            } : {
                xs: "3px solid #5a5a5a",
                sm: "4px solid #5a5a5a"
            },
            backgroundColor: "white",
            borderRadius: "16px",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                width: "98%",
                height: {
                    xs: "60px",
                    sm: "75px"
                },
                backgroundColor: "white",
                borderRadius: "16px",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: {
                            xs: "55px",
                            sm: "65px"
                        },
                        height: "100%",
                        backgroundColor: "#0098d8",
                        borderTopLeftRadius: {
                            xs: "12.5px",
                            sm: "11px"
                        },
                        borderBottomLeftRadius: {
                            xs: "12.5px",
                            sm: "11px"
                        },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                            component: "img",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($515f3adbbad4e555$exports))),
                            alt: "Icon",
                            sx: {
                                width: {
                                    xs: 25,
                                    sm: 30
                                },
                                height: {
                                    xs: 25,
                                    sm: 30
                                },
                                marginBottom: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                            component: "img",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fa8cdcce5e3e2e3$exports))),
                            alt: "Icon",
                            sx: {
                                width: {
                                    xs: 25,
                                    sm: 30
                                },
                                height: {
                                    xs: 21,
                                    sm: 26
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex"
                    },
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4990f7d2f8e3372a$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: {
                                xs: "2rem",
                                sm: "3rem"
                            },
                            fontWeight: "600",
                            textAlign: "center",
                            ml: {
                                xs: 7,
                                sm: 7
                            },
                            height: {
                                xs: 1,
                                sm: 1
                            },
                            "& input": {
                                textAlign: "center"
                            }
                        },
                        placeholder: "ABC123",
                        value: value,
                        onFocus: onFocus,
                        onChange: onChange,
                        onKeyDown: handleEnter,
                        inputProps: useMoovyKeyboard ? {
                            inputMode: "none",
                            readOnly: true
                        } : {
                            readOnly: false
                        }
                    })
                })
            ]
        })
    });
};
var $782fb883374a8c57$export$2e2bcd8739ae039 = $782fb883374a8c57$var$licensePlateTextField;


const $014b1ecb904dbc18$var$allowedKeys = [
    "delete",
    "down",
    "OK"
];
const $014b1ecb904dbc18$export$dddb845077defee2 = (licensePlate)=>{
    const pattern = /^[A-ZÅÄÖa-zåäö0-9\\s-]{2,10}$/;
    return !!licensePlate && pattern.test(licensePlate);
};
const $014b1ecb904dbc18$var$LicensePlateInput = ({ useMoovyKeyboard: useMoovyKeyboard, useButton: useButton = false, onRedeem: onRedeem, onValidationError: onValidationError, value: value, onChange: onChange })=>{
    const theme = (0, $5d230ce41f490aa3$export$2e2bcd8739ae039)();
    const [open, setOpen] = (0, $aqdBs.useState)(!useButton);
    const [showButton, setShowButton] = (0, $aqdBs.useState)(true);
    const [hasError, setHasError] = (0, $aqdBs.useState)(false);
    const [firstValidation, setFirstValidation] = (0, $aqdBs.useState)(false);
    const smallScreen = (0, $fd4aa80ca8b4f401$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const fadingTimeoutMs = 200;
    const handleOpen = ()=>{
        if (!smallScreen && useMoovyKeyboard) {
            setShowButton(false);
            setTimeout(()=>{
                setOpen(true);
            }, fadingTimeoutMs);
        }
    };
    const handleClose = ()=>{
        setOpen(false);
        setHasError(false);
        if (!smallScreen && useMoovyKeyboard) setTimeout(()=>{
            setShowButton(true);
        }, fadingTimeoutMs);
    };
    const redeemPermit = ()=>{
        const isValid = $014b1ecb904dbc18$export$dddb845077defee2(value);
        setHasError(!isValid);
        onValidationError && onValidationError(!isValid);
        if (isValid) {
            onRedeem();
            setFirstValidation(false);
        } else {
            handleOpen();
            setFirstValidation(true);
        }
    };
    const handleVirtualKeyboardInput = (key)=>{
        if (value.length >= 10 && !$014b1ecb904dbc18$var$allowedKeys.includes(key)) return;
        const upperKey = key.toUpperCase();
        if (key === "delete") {
            const updatedPlate = value.slice(0, -1);
            onChange(updatedPlate);
            if (firstValidation) setHasError(!$014b1ecb904dbc18$export$dddb845077defee2(updatedPlate));
        } else if (key === "down") handleClose();
        else if (key === "OK") {
            setFirstValidation(true);
            const isValid = $014b1ecb904dbc18$export$dddb845077defee2(value);
            setHasError(!isValid);
            if (isValid) {
                if (useButton) handleClose();
                else redeemPermit();
            }
        } else {
            const updatedPlate = value + upperKey;
            onChange(updatedPlate);
            if (firstValidation) setHasError(!$014b1ecb904dbc18$export$dddb845077defee2(updatedPlate));
        }
    };
    const handleTextChange = (event)=>{
        const inputValue = event.target.value.toUpperCase();
        onChange(inputValue);
        if (firstValidation) {
            if (!$014b1ecb904dbc18$export$dddb845077defee2(inputValue)) setHasError(true);
            else setHasError(false);
        }
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                sx: {
                    width: {
                        xs: 300,
                        sm: 400
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $782fb883374a8c57$export$2e2bcd8739ae039), {
                            useMoovyKeyboard: useMoovyKeyboard ?? false,
                            value: value,
                            onFocus: handleOpen,
                            onChange: handleTextChange,
                            hasError: hasError,
                            redeemPermit: redeemPermit
                        })
                    }),
                    useButton && /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $cedc5f03ce6c72cd$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4b253693d6d955c3$export$2e2bcd8739ae039), {
                            in: showButton,
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $234a000ff615fd2f$export$2e2bcd8739ae039), {
                                variant: "contained",
                                size: "large",
                                sx: {
                                    height: "60px",
                                    marginTop: "10px"
                                },
                                onFocus: redeemPermit,
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                    id: "moovyVirtualKeyboard.button.redeemPermit"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $0e2c47fc5c90c473$export$2e2bcd8739ae039), {
                open: open,
                handleVirtualKeyboardInput: handleVirtualKeyboardInput,
                useMoovyKeyboard: useMoovyKeyboard ?? false
            })
        ]
    });
};
var $014b1ecb904dbc18$export$2e2bcd8739ae039 = $014b1ecb904dbc18$var$LicensePlateInput;



var $aqdBs = parcelRequire("aqdBs");

var $fQojQ = parcelRequire("fQojQ");
"use client";
function $401e064a6b7f86d5$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$401e064a6b7f86d5$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $401e064a6b7f86d5$var$L = (t)=>typeof t == "number" && !isNaN(t), $401e064a6b7f86d5$var$N = (t)=>typeof t == "string", $401e064a6b7f86d5$var$P = (t)=>typeof t == "function", $401e064a6b7f86d5$var$mt = (t)=>$401e064a6b7f86d5$var$N(t) || $401e064a6b7f86d5$var$L(t), $401e064a6b7f86d5$var$B = (t)=>$401e064a6b7f86d5$var$N(t) || $401e064a6b7f86d5$var$P(t) ? t : null, $401e064a6b7f86d5$var$pt = (t, o)=>t === !1 || $401e064a6b7f86d5$var$L(t) && t > 0 ? t : o, $401e064a6b7f86d5$var$z = (t)=>(0, $aqdBs.isValidElement)(t) || $401e064a6b7f86d5$var$N(t) || $401e064a6b7f86d5$var$P(t) || $401e064a6b7f86d5$var$L(t);
function $401e064a6b7f86d5$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $401e064a6b7f86d5$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $aqdBs.useRef)(0);
        return (0, $aqdBs.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $aqdBs.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $401e064a6b7f86d5$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, a);
    };
}
function $401e064a6b7f86d5$var$J(t, o) {
    return {
        content: $401e064a6b7f86d5$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $401e064a6b7f86d5$var$tt(t, o, e = !1) {
    return (0, $aqdBs.isValidElement)(t) && !$401e064a6b7f86d5$var$N(t.type) ? (0, $aqdBs.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $401e064a6b7f86d5$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $401e064a6b7f86d5$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $401e064a6b7f86d5$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $fQojQ.default)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $401e064a6b7f86d5$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $fQojQ.default)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $401e064a6b7f86d5$var$Xt = 1, $401e064a6b7f86d5$var$at = ()=>`${$401e064a6b7f86d5$var$Xt++}`;
function $401e064a6b7f86d5$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($401e064a6b7f86d5$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $401e064a6b7f86d5$var$B(n.className || d.toastClassName),
                progressClassName: $401e064a6b7f86d5$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $401e064a6b7f86d5$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($401e064a6b7f86d5$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $401e064a6b7f86d5$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $401e064a6b7f86d5$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $401e064a6b7f86d5$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $401e064a6b7f86d5$var$I = new Map, $401e064a6b7f86d5$var$F = [], $401e064a6b7f86d5$var$st = new Set, $401e064a6b7f86d5$var$Vt = (t)=>$401e064a6b7f86d5$var$st.forEach((o)=>o(t)), $401e064a6b7f86d5$var$bt = ()=>$401e064a6b7f86d5$var$I.size > 0;
function $401e064a6b7f86d5$var$Qt() {
    $401e064a6b7f86d5$var$F.forEach((t)=>$401e064a6b7f86d5$var$nt(t.content, t.options)), $401e064a6b7f86d5$var$F = [];
}
var $401e064a6b7f86d5$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $401e064a6b7f86d5$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $401e064a6b7f86d5$var$X(t, o) {
    var r;
    if (o) return !!((r = $401e064a6b7f86d5$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $401e064a6b7f86d5$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $401e064a6b7f86d5$var$ht(t) {
    if (!$401e064a6b7f86d5$var$bt()) {
        $401e064a6b7f86d5$var$F = $401e064a6b7f86d5$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $401e064a6b7f86d5$var$mt(t)) $401e064a6b7f86d5$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $401e064a6b7f86d5$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $401e064a6b7f86d5$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $401e064a6b7f86d5$var$Ct = (t = {})=>{
    $401e064a6b7f86d5$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $401e064a6b7f86d5$var$nt(t, o) {
    $401e064a6b7f86d5$var$z(t) && ($401e064a6b7f86d5$var$bt() || $401e064a6b7f86d5$var$F.push({
        content: t,
        options: o
    }), $401e064a6b7f86d5$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $401e064a6b7f86d5$var$xt(t) {
    var o;
    (o = $401e064a6b7f86d5$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $401e064a6b7f86d5$var$rt(t, o) {
    $401e064a6b7f86d5$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $401e064a6b7f86d5$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $401e064a6b7f86d5$var$_t(o, t, $401e064a6b7f86d5$var$Vt);
            $401e064a6b7f86d5$var$I.set(o, r);
            let s = r.observe(e);
            return $401e064a6b7f86d5$var$Qt(), ()=>{
                s(), $401e064a6b7f86d5$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $401e064a6b7f86d5$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $401e064a6b7f86d5$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $401e064a6b7f86d5$var$Pt(t) {
    return $401e064a6b7f86d5$var$st.add(t), ()=>{
        $401e064a6b7f86d5$var$st.delete(t);
    };
}
function $401e064a6b7f86d5$var$Wt(t) {
    return t && ($401e064a6b7f86d5$var$N(t.toastId) || $401e064a6b7f86d5$var$L(t.toastId)) ? t.toastId : $401e064a6b7f86d5$var$at();
}
function $401e064a6b7f86d5$var$U(t, o) {
    return $401e064a6b7f86d5$var$nt(t, o), o.toastId;
}
function $401e064a6b7f86d5$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $401e064a6b7f86d5$var$Wt(o)
    };
}
function $401e064a6b7f86d5$var$Q(t) {
    return (o, e)=>$401e064a6b7f86d5$var$U(o, $401e064a6b7f86d5$var$V(t, e));
}
function $401e064a6b7f86d5$export$b410431fab84fa58(t, o) {
    return $401e064a6b7f86d5$var$U(t, $401e064a6b7f86d5$var$V("default", o));
}
$401e064a6b7f86d5$export$b410431fab84fa58.loading = (t, o)=>$401e064a6b7f86d5$var$U(t, $401e064a6b7f86d5$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $401e064a6b7f86d5$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $401e064a6b7f86d5$var$N(o) ? $401e064a6b7f86d5$export$b410431fab84fa58.loading(o, s) : $401e064a6b7f86d5$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $401e064a6b7f86d5$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $401e064a6b7f86d5$var$N(g) ? {
            render: g
        } : g;
        return l ? $401e064a6b7f86d5$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $401e064a6b7f86d5$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $401e064a6b7f86d5$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$401e064a6b7f86d5$export$b410431fab84fa58.promise = $401e064a6b7f86d5$var$Gt;
$401e064a6b7f86d5$export$b410431fab84fa58.success = $401e064a6b7f86d5$var$Q("success");
$401e064a6b7f86d5$export$b410431fab84fa58.info = $401e064a6b7f86d5$var$Q("info");
$401e064a6b7f86d5$export$b410431fab84fa58.error = $401e064a6b7f86d5$var$Q("error");
$401e064a6b7f86d5$export$b410431fab84fa58.warning = $401e064a6b7f86d5$var$Q("warning");
$401e064a6b7f86d5$export$b410431fab84fa58.warn = $401e064a6b7f86d5$export$b410431fab84fa58.warning;
$401e064a6b7f86d5$export$b410431fab84fa58.dark = (t, o)=>$401e064a6b7f86d5$var$U(t, $401e064a6b7f86d5$var$V("default", {
        theme: "dark",
        ...o
    }));
function $401e064a6b7f86d5$var$qt(t) {
    $401e064a6b7f86d5$var$ht(t);
}
$401e064a6b7f86d5$export$b410431fab84fa58.dismiss = $401e064a6b7f86d5$var$qt;
$401e064a6b7f86d5$export$b410431fab84fa58.clearWaitingQueue = $401e064a6b7f86d5$var$Ct;
$401e064a6b7f86d5$export$b410431fab84fa58.isActive = $401e064a6b7f86d5$var$X;
$401e064a6b7f86d5$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $401e064a6b7f86d5$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $401e064a6b7f86d5$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $401e064a6b7f86d5$var$U(a, l);
    }
};
$401e064a6b7f86d5$export$b410431fab84fa58.done = (t)=>{
    $401e064a6b7f86d5$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$401e064a6b7f86d5$export$b410431fab84fa58.onChange = $401e064a6b7f86d5$var$Pt;
$401e064a6b7f86d5$export$b410431fab84fa58.play = (t)=>$401e064a6b7f86d5$var$rt(!0, t);
$401e064a6b7f86d5$export$b410431fab84fa58.pause = (t)=>$401e064a6b7f86d5$var$rt(!1, t);
function $401e064a6b7f86d5$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $aqdBs.useRef)($401e064a6b7f86d5$var$Et(t)).current;
    r(t);
    let s = (a = (0, $aqdBs.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $401e064a6b7f86d5$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $401e064a6b7f86d5$var$At(t) {
    let [o, e] = (0, $aqdBs.useState)(!1), [r, s] = (0, $aqdBs.useState)(!1), l = (0, $aqdBs.useRef)(null), a = (0, $aqdBs.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $401e064a6b7f86d5$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $aqdBs.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $401e064a6b7f86d5$var$Ot = typeof window != "undefined" ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);
var $401e064a6b7f86d5$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $401e064a6b7f86d5$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $401e064a6b7f86d5$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $401e064a6b7f86d5$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $401e064a6b7f86d5$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $401e064a6b7f86d5$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $401e064a6b7f86d5$export$4f13f83fd8bb1dac = {
    info: $401e064a6b7f86d5$var$so,
    warning: $401e064a6b7f86d5$var$ao,
    success: $401e064a6b7f86d5$var$no,
    error: $401e064a6b7f86d5$var$ro,
    spinner: $401e064a6b7f86d5$var$io
}, $401e064a6b7f86d5$var$lo = (t)=>t in $401e064a6b7f86d5$export$4f13f83fd8bb1dac;
function $401e064a6b7f86d5$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($401e064a6b7f86d5$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $aqdBs.isValidElement)(r) ? s = (0, $aqdBs.cloneElement)(r, l) : e ? s = $401e064a6b7f86d5$export$4f13f83fd8bb1dac.spinner() : $401e064a6b7f86d5$var$lo(o) && (s = $401e064a6b7f86d5$export$4f13f83fd8bb1dac[o](l))), s;
}
var $401e064a6b7f86d5$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $401e064a6b7f86d5$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $fQojQ.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $401e064a6b7f86d5$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $fQojQ.default)(D, E), ft = $401e064a6b7f86d5$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($401e064a6b7f86d5$var$P(a) ? H = a(j) : (0, $aqdBs.isValidElement)(a) ? H = (0, $aqdBs.cloneElement)(a, j) : H = $401e064a6b7f86d5$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, $fQojQ.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $401e064a6b7f86d5$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $401e064a6b7f86d5$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $401e064a6b7f86d5$export$d20e79fdc3899e95 = $401e064a6b7f86d5$export$3ff7dc44d332d222($401e064a6b7f86d5$var$K("bounce", !0)), $401e064a6b7f86d5$export$d8dc01b5c85a37b9 = $401e064a6b7f86d5$export$3ff7dc44d332d222($401e064a6b7f86d5$var$K("slide", !0)), $401e064a6b7f86d5$export$65cfd44a2050f99 = $401e064a6b7f86d5$export$3ff7dc44d332d222($401e064a6b7f86d5$var$K("zoom")), $401e064a6b7f86d5$export$4d2fae537bd90431 = $401e064a6b7f86d5$export$3ff7dc44d332d222($401e064a6b7f86d5$var$K("flip"));
var $401e064a6b7f86d5$var$_o = {
    position: "top-right",
    transition: $401e064a6b7f86d5$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $401e064a6b7f86d5$export$f2815235e76a62b9(t) {
    let o = {
        ...$401e064a6b7f86d5$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $aqdBs.useState)(!0), l = (0, $aqdBs.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $401e064a6b7f86d5$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $fQojQ.default)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $401e064a6b7f86d5$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $fQojQ.default)(p, $401e064a6b7f86d5$var$B(T));
    }
    function E() {
        e && (s(!0), $401e064a6b7f86d5$export$b410431fab84fa58.play());
    }
    return $401e064a6b7f86d5$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $aqdBs.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $401e064a6b7f86d5$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $401e064a6b7f86d5$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $401e064a6b7f86d5$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($401e064a6b7f86d5$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}


var $eba09d42c059e7e8$export$266cbe012f0ab791;
(function(MoovyToast) {
    MoovyToast.showToast = (message, success = true)=>{
        success ? (0, $401e064a6b7f86d5$export$b410431fab84fa58).success(message) : (0, $401e064a6b7f86d5$export$b410431fab84fa58).error(message);
    };
})($eba09d42c059e7e8$export$266cbe012f0ab791 || ($eba09d42c059e7e8$export$266cbe012f0ab791 = {}));



var $1Ivrw = parcelRequire("1Ivrw");


var $562b5d52ea0e51f2$exports = {};
$562b5d52ea0e51f2$exports = new URL("LocationPinBlue.0d707a74.svg", import.meta.url).toString();



var $cIIWu = parcelRequire("cIIWu");
const $d34ef44fcd75733a$var$theme = (0, $cIIWu.default)({
    typography: {
        fontFamily: '"Fira Sans", sans-serif',
        h1: {
            fontSize: "1.5rem",
            fontWeight: 700
        },
        h2: {
            fontSize: "1.3rem",
            fontWeight: "bold"
        },
        body1: {
            fontSize: "1rem"
        }
    },
    palette: {
        primary: {
            main: "#0098d8"
        },
        text: {
            primary: "#626464",
            secondary: "#555555"
        },
        gradient: {
            primary: "linear-gradient(to right bottom, #08CBEF, #0098d8)"
        },
        customColors: {
            mainBackground: "#f9fafb"
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 770,
            md: 815,
            lg: 1200,
            xl: 1536
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ theme: theme })=>({
                        padding: "8px",
                        textAlign: "center",
                        borderRadius: "10px"
                    })
            }
        }
    }
});
var $d34ef44fcd75733a$export$2e2bcd8739ae039 = $d34ef44fcd75733a$var$theme;


const $a9c8587d351a7cf8$var$HeaderContent = ({ storedLocation: storedLocation, useMoovyKeyboard: useMoovyKeyboard })=>{
    const intl = (0, $00e6da6e00acc8ce$export$2e2bcd8739ae039)();
    const isTabletSize = (0, $fd4aa80ca8b4f401$export$2e2bcd8739ae039)((0, $d34ef44fcd75733a$export$2e2bcd8739ae039).breakpoints.between("md", "lg"));
    const isLaptopSize = (0, $fd4aa80ca8b4f401$export$2e2bcd8739ae039)((0, $d34ef44fcd75733a$export$2e2bcd8739ae039).breakpoints.up("lg"));
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            width: {
                xs: 300,
                sm: 400
            }
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                gap: 2,
                flexDirection: "column",
                textAlign: "center",
                mt: "20px",
                ...useMoovyKeyboard && isTabletSize && {
                    "@media (orientation: landscape)": {
                        flexDirection: "row",
                        textAlign: "left",
                        alignItems: "flex-start",
                        marginLeft: "5px"
                    }
                },
                ...isLaptopSize && {
                    flexDirection: "column",
                    textAlign: "center",
                    alignItems: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    component: "img",
                    alt: "Moovy logo",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($562b5d52ea0e51f2$exports))),
                    sx: {
                        mt: 1,
                        alignSelf: "center",
                        ...useMoovyKeyboard && isTabletSize && {
                            "@media (orientation: landscape)": {
                                alignSelf: "flex-start"
                            }
                        },
                        ...isLaptopSize && {
                            alignSelf: "center"
                        }
                    }
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        maxWidth: "400px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                            variant: "h1",
                            "aria-label": "Location",
                            sx: {
                                color: "primary.main",
                                textTransform: "uppercase"
                            },
                            children: storedLocation.name || "Welcome"
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                            variant: "h2",
                            "aria-label": "Parking info",
                            sx: {
                                color: "text.primary",
                                mt: 1
                            },
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.homePage.instructions.parkingInfo.default"
                            })
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                            variant: "body1",
                            "aria-label": intl.formatMessage({
                                id: "page.homePage.instructions.visitorMessage.organization.arialabel"
                            }),
                            sx: {
                                color: "text.primary",
                                mt: 1,
                                mb: 1
                            },
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.homePage.instructions.visitorMessage.default"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $a9c8587d351a7cf8$export$2e2bcd8739ae039 = $a9c8587d351a7cf8$var$HeaderContent;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");


var $5ylSM = parcelRequire("5ylSM");

var $fQojQ = parcelRequire("fQojQ");



var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");



var $40jPv = parcelRequire("40jPv");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");


var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $3a10ef006e23d5f8$export$f7d501e40371cd17(slot) {
    return (0, $igOtJ.default)("MuiFormLabel", slot);
}
const $3a10ef006e23d5f8$var$formLabelClasses = (0, $jIPNy.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $3a10ef006e23d5f8$export$2e2bcd8739ae039 = $3a10ef006e23d5f8$var$formLabelClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $60bb9646d09febfe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $40jPv.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $3a10ef006e23d5f8$export$f7d501e40371cd17), classes);
};
const $60bb9646d09febfe$export$aa5bc7f8a4705b27 = (0, $6JVXO.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return {
            ...styles.root,
            ...ownerState.color === "secondary" && styles.colorSecondary,
            ...ownerState.filled && styles.filled
        };
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        variants: [
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3a10ef006e23d5f8$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $3a10ef006e23d5f8$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $3a10ef006e23d5f8$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $60bb9646d09febfe$var$AsteriskComponent = (0, $6JVXO.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $iAnBN.default)(({ theme: theme })=>({
        [`&.${(0, $3a10ef006e23d5f8$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $60bb9646d09febfe$var$FormLabel = /*#__PURE__*/ $aqdBs.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, color: color, component: component = "label", disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $60bb9646d09febfe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($60bb9646d09febfe$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $1Ivrw.jsxs)($60bb9646d09febfe$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    });
});
var $60bb9646d09febfe$export$2e2bcd8739ae039 = $60bb9646d09febfe$var$FormLabel;



var $40jPv = parcelRequire("40jPv");

var $aMtHL = parcelRequire("aMtHL");

var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $89c0055715827f0b$export$c1c4b4545ad2ea5f(slot) {
    return (0, $igOtJ.default)("MuiInputLabel", slot);
}
const $89c0055715827f0b$var$inputLabelClasses = (0, $jIPNy.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $89c0055715827f0b$export$2e2bcd8739ae039 = $89c0055715827f0b$var$inputLabelClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $4dd8d119207e4ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $40jPv.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $5ylSM.default)(slots, (0, $89c0055715827f0b$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $4dd8d119207e4ec5$var$InputLabelRoot = (0, $6JVXO.default)((0, $60bb9646d09febfe$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $aMtHL.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3a10ef006e23d5f8$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: "translate(0, 20px) scale(1)"
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: "translate(0, 17px) scale(1)"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: "translate(0, -1.5px) scale(0.75)",
                    transformOrigin: "top left",
                    maxWidth: "133%"
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        "color",
                        "transform",
                        "max-width"
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: "filled"
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: "none",
                    transform: "translate(12px, 16px) scale(1)",
                    maxWidth: "calc(100% - 24px)"
                }
            },
            {
                props: {
                    variant: "filled",
                    size: "small"
                },
                style: {
                    transform: "translate(12px, 13px) scale(1)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === "filled" && ownerState.shrink,
                style: {
                    userSelect: "none",
                    pointerEvents: "auto",
                    transform: "translate(12px, 7px) scale(0.75)",
                    maxWidth: "calc(133% - 24px)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === "filled" && ownerState.shrink && size === "small",
                style: {
                    transform: "translate(12px, 4px) scale(0.75)"
                }
            },
            {
                props: {
                    variant: "outlined"
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: "none",
                    transform: "translate(14px, 16px) scale(1)",
                    maxWidth: "calc(100% - 24px)"
                }
            },
            {
                props: {
                    variant: "outlined",
                    size: "small"
                },
                style: {
                    transform: "translate(14px, 9px) scale(1)"
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === "outlined" && ownerState.shrink,
                style: {
                    userSelect: "none",
                    pointerEvents: "auto",
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: "calc(133% - 32px)",
                    transform: "translate(14px, -9px) scale(0.75)"
                }
            }
        ]
    })));
const $4dd8d119207e4ec5$var$InputLabel = /*#__PURE__*/ $aqdBs.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $4dd8d119207e4ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($4dd8d119207e4ec5$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $4dd8d119207e4ec5$export$2e2bcd8739ae039 = $4dd8d119207e4ec5$var$InputLabel;



const $c160feabb2f48a07$var$ProductContent = ({ availableProducts: availableProducts, selectedProduct: selectedProduct, handleProductChange: handleProductChange, productError: productError })=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $4ea6f68cc48b79d3$export$2e2bcd8739ae039), {
            sx: {
                width: {
                    xs: 300,
                    sm: 400,
                    marginBottom: "5px"
                }
            },
            error: productError,
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4dd8d119207e4ec5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                        id: "page.homePage.select.product"
                    })
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $58786d866a7f202c$export$2e2bcd8739ae039), {
                    label: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                        id: "page.homePage.select.product"
                    }),
                    value: selectedProduct || "",
                    onChange: handleProductChange,
                    children: availableProducts.map((product)=>/*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $609cc9f9ea58bcc3$export$2e2bcd8739ae039), {
                            value: product.id,
                            children: [
                                product.name,
                                " ",
                                product.duration && `- ${product.duration / 60}h`
                            ]
                        }, product.id))
                })
            ]
        })
    });
};
var $c160feabb2f48a07$export$2e2bcd8739ae039 = $c160feabb2f48a07$var$ProductContent;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");

var $amKcf = parcelRequire("amKcf");


var $aIlUA = parcelRequire("aIlUA");
var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");


var $2MrFe = parcelRequire("2MrFe");

var $40jPv = parcelRequire("40jPv");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $9e12ad3163f23a73$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $igOtJ.default)("MuiLinearProgress", slot);
}
const $9e12ad3163f23a73$var$linearProgressClasses = (0, $jIPNy.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $9e12ad3163f23a73$export$2e2bcd8739ae039 = $9e12ad3163f23a73$var$linearProgressClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $6821a0f749574eaa$var$TRANSITION_DURATION = 4; // seconds
const $6821a0f749574eaa$var$indeterminate1Keyframe = (0, $aIlUA.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $6821a0f749574eaa$var$indeterminate1Animation = typeof $6821a0f749574eaa$var$indeterminate1Keyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$6821a0f749574eaa$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $6821a0f749574eaa$var$indeterminate2Keyframe = (0, $aIlUA.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $6821a0f749574eaa$var$indeterminate2Animation = typeof $6821a0f749574eaa$var$indeterminate2Keyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$6821a0f749574eaa$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $6821a0f749574eaa$var$bufferKeyframe = (0, $aIlUA.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $6821a0f749574eaa$var$bufferAnimation = typeof $6821a0f749574eaa$var$bufferKeyframe !== "string" ? (0, $aIlUA.css)`
        animation: ${$6821a0f749574eaa$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $6821a0f749574eaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $40jPv.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $40jPv.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $40jPv.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $40jPv.default)(color)}`,
            variant === "buffer" && `color${(0, $40jPv.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $9e12ad3163f23a73$export$bc8a6ea1eb17d7c6), classes);
};
const $6821a0f749574eaa$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $amKcf.lighten)(theme.palette[color].main, 0.62) : (0, $amKcf.darken)(theme.palette[color].main, 0.5);
};
const $6821a0f749574eaa$var$LinearProgressRoot = (0, $6JVXO.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $40jPv.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        "@media print": {
            colorAdjust: "exact"
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $6821a0f749574eaa$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === "inherit" && ownerState.variant !== "buffer",
                style: {
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "currentColor",
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: "buffer"
                },
                style: {
                    backgroundColor: "transparent"
                }
            },
            {
                props: {
                    variant: "query"
                },
                style: {
                    transform: "rotate(180deg)"
                }
            }
        ]
    })));
const $6821a0f749574eaa$var$LinearProgressDashed = (0, $6JVXO.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $40jPv.default)(ownerState.color)}`]
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%",
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px",
        variants: [
            {
                props: {
                    color: "inherit"
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $6821a0f749574eaa$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $6821a0f749574eaa$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$6821a0f749574eaa$var$bufferKeyframe} 3s infinite linear`
});
const $6821a0f749574eaa$var$LinearProgressBar1 = (0, $6JVXO.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $40jPv.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        variants: [
            {
                props: {
                    color: "inherit"
                },
                style: {
                    backgroundColor: "currentColor"
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: "determinate"
                },
                style: {
                    transition: `transform .${$6821a0f749574eaa$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: "buffer"
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$6821a0f749574eaa$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" || ownerState.variant === "query",
                style: {
                    width: "auto"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" || ownerState.variant === "query",
                style: $6821a0f749574eaa$var$indeterminate1Animation || {
                    animation: `${$6821a0f749574eaa$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $6821a0f749574eaa$var$LinearProgressBar2 = (0, $6JVXO.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $40jPv.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        variants: [
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        "--LinearProgressBar2-barColor": (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== "buffer" && ownerState.color !== "inherit",
                style: {
                    backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
                }
            },
            {
                props: {
                    color: "inherit"
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $896610d28a93be93$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: "buffer"
                    },
                    style: {
                        backgroundColor: $6821a0f749574eaa$var$getColorShade(theme, color),
                        transition: `transform .${$6821a0f749574eaa$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" || ownerState.variant === "query",
                style: {
                    width: "auto"
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" || ownerState.variant === "query",
                style: $6821a0f749574eaa$var$indeterminate2Animation || {
                    animation: `${$6821a0f749574eaa$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $6821a0f749574eaa$var$LinearProgress = /*#__PURE__*/ $aqdBs.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate", ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $6821a0f749574eaa$var$useUtilityClasses(ownerState);
    const isRtl = (0, $4ec2abae1b3c08a6$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($6821a0f749574eaa$var$LinearProgressRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $1Ivrw.jsx)($6821a0f749574eaa$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $1Ivrw.jsx)($6821a0f749574eaa$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $1Ivrw.jsx)($6821a0f749574eaa$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $6821a0f749574eaa$export$2e2bcd8739ae039 = $6821a0f749574eaa$var$LinearProgress;




var $aqdBs = parcelRequire("aqdBs");

function $393c9f95f82a0421$export$2e2bcd8739ae039({ locationName: locationName, licensePlate: licensePlate, permitTime: permitTime, onClose: onClose }) {
    const [progress, setProgress] = (0, $aqdBs.useState)(0);
    const MODAL_DURATION = 10000;
    const UPDATE_INTERVAL = 100;
    (0, $aqdBs.useEffect)(()=>{
        const startTime = Date.now();
        const timer = setInterval(()=>{
            const elapsedTime = Date.now() - startTime;
            const newProgress = elapsedTime / MODAL_DURATION * 100;
            if (newProgress >= 100) {
                clearInterval(timer);
                onClose();
            } else setProgress(newProgress);
        }, UPDATE_INTERVAL);
        return ()=>clearInterval(timer);
    }, []);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 4,
        sx: {
            bgcolor: "background.paper",
            zIndex: 1000,
            alignItems: "center",
            justifyContent: "flex-start",
            marginTop: 10,
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    width: {
                        xs: 300,
                        sm: 400
                    }
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        gap: 2,
                        flexDirection: "column",
                        textAlign: "center",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                            component: "img",
                            alt: "Moovy logo",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($562b5d52ea0e51f2$exports))),
                            sx: {
                                mt: 1,
                                alignSelf: "center"
                            }
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                            sx: {
                                maxWidth: "600px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                    variant: "h1",
                                    sx: {
                                        color: "primary.main",
                                        textTransform: "uppercase"
                                    },
                                    children: locationName
                                }),
                                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                    variant: "h2",
                                    "aria-label": "Parking info",
                                    sx: {
                                        color: "text.primary",
                                        mt: 5
                                    },
                                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                        id: "page.homePage.success.permitType"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: "text.primary",
                                        mt: 1,
                                        fontSize: "1.2rem",
                                        marginTop: "18px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                            id: "page.homePage.success.permitTime"
                                        }),
                                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                            component: "p",
                                            sx: {
                                                fontWeight: "bold",
                                                fontSize: "1.2rem"
                                            },
                                            children: permitTime
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    sx: {
                                        color: "text.primary",
                                        mt: 1,
                                        fontSize: "1.2rem",
                                        marginTop: "18px"
                                    },
                                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                        id: "page.homePage.success.licensePlate"
                                    })
                                }),
                                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                                    component: "p",
                                    sx: {
                                        fontWeight: "bold",
                                        fontSize: "1.2rem"
                                    },
                                    children: licensePlate
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $234a000ff615fd2f$export$2e2bcd8739ae039), {
                    variant: "contained",
                    onClick: onClose,
                    sx: {
                        height: "60px",
                        marginTop: "4px",
                        fontSize: "1.5rem",
                        width: "200px"
                    },
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                        id: "page.homePage.success.okButton"
                    })
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "center",
                    mt: 4
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        width: "150px"
                    },
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $6821a0f749574eaa$export$2e2bcd8739ae039), {
                        variant: "determinate",
                        value: progress,
                        sx: {
                            height: 4,
                            borderRadius: 1,
                            "& .MuiLinearProgress-bar": {
                                transition: "none",
                                borderRadius: 1
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                variant: "body1",
                "aria-label": "Permit granted successfully",
                sx: {
                    color: "text.primary",
                    mt: 1,
                    fontSize: "1rem",
                    marginTop: "18px"
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                    id: "page.homePage.success.clearingPage"
                })
            })
        ]
    });
}






const $f5cc3b92690db343$var$createPermit = async (guid, LisencePlateNumber, VoucherTemplate)=>{
    if (!guid) throw new Error("UserGroup guid is missing");
    const response = await (0, $637e98f16008ef32$export$388e0302ca0d9a41).post(guid + "/permit", {
        LisencePlateNumber: LisencePlateNumber,
        VoucherTemplate: VoucherTemplate,
        UserGroupRef: guid
    });
    return response.data;
};
var $f5cc3b92690db343$export$2e2bcd8739ae039 = {
    createPermit: $f5cc3b92690db343$var$createPermit
};


function $8a29d15bb4bab780$var$formatValidity(from, to) {
    const now = new Date(from);
    const end = new Date(to);
    const dateFormatter = new Intl.DateTimeFormat("fi-FI", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    const timeFormatter = new Intl.DateTimeFormat("fi-FI", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    });
    const startDate = dateFormatter.format(now);
    const endDate = dateFormatter.format(end);
    const startTime = timeFormatter.format(now);
    const endTime = timeFormatter.format(end);
    // Show end date only if it's different from start date
    if (startDate !== endDate) return `${startDate} ${startTime} - ${endDate} ${endTime}`;
    return `${startDate} ${startTime} - ${endTime}`;
}
const $8a29d15bb4bab780$var$HomePage = ({ configuration: configuration })=>{
    const [showSuccess, setShowSuccess] = (0, $aqdBs.useState)(false);
    const [selectedOrganizationId, setSelectedOrganizationId] = (0, $aqdBs.useState)("");
    const [selectedProductId, setSelectedProductId] = (0, $aqdBs.useState)("");
    const [licensePlate, setLicensePlate] = (0, $aqdBs.useState)("");
    const [productError, setProductError] = (0, $aqdBs.useState)(false);
    const intl = (0, $00e6da6e00acc8ce$export$2e2bcd8739ae039)();
    (0, $aqdBs.useEffect)(()=>{
        if (configuration.organizations.length === 1) {
            const firstOrganization = configuration.organizations[0];
            setSelectedOrganizationId(firstOrganization.id);
            if (firstOrganization.products.length === 1) setSelectedProductId(firstOrganization.products[0].id);
        }
    }, [
        showSuccess
    ]);
    const organizations = configuration.organizations;
    const location = configuration.permitOffering;
    const storedAppSettings = configuration.appSettings;
    const useMoovyKeyboard = storedAppSettings.virtualKeyboard ?? false;
    const { guid: guid } = (0, $bdd5c91922f45546$export$99eaa27ddbbb95ef)();
    const handleProductChange = (event)=>{
        setSelectedProductId(event.target.value);
        setProductError(false);
    };
    const validateSelection = ()=>{
        if (!selectedProductId) {
            setProductError(true);
            return false;
        }
        return true;
    };
    const selectedOrg = organizations.find((organization)=>organization.id === selectedOrganizationId);
    const availableProducts = selectedOrg?.products || [];
    const createPermitMutation = (0, $e22549bf43b8fa18$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $f5cc3b92690db343$export$2e2bcd8739ae039).createPermit(guid, licensePlate, selectedProductId),
        onSuccess: ()=>{
            setShowSuccess(true);
        },
        onError: (error)=>{
            const typedError = error;
            const language = (0, $6c154842fccf6556$export$2e2bcd8739ae039).language;
            const errorDescription = typedError.response?.data?.errorDescriptor?.errorDescription;
            if (errorDescription?.[language]) (0, $eba09d42c059e7e8$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                id: "page.homePage.toast.errorCreatingPermit.localizedErrorMessage",
                values: {
                    message: errorDescription[language]
                }
            }), false);
            else (0, $eba09d42c059e7e8$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                id: "page.homePage.toast.errorCreatingPermit"
            }), false);
        }
    });
    const handleRedeem = ()=>{
        if (createPermitMutation.isPending || !validateSelection()) return;
        createPermitMutation.mutate();
    };
    const handleSuccessClose = ()=>{
        setShowSuccess(false);
        setSelectedOrganizationId("");
        setSelectedProductId("");
        setLicensePlate("");
    };
    if (showSuccess) {
        const permitTime = createPermitMutation.data?.validityFrom && createPermitMutation.data?.validityTo ? $8a29d15bb4bab780$var$formatValidity(createPermitMutation.data.validityFrom, createPermitMutation.data.validityTo) : "-";
        return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $393c9f95f82a0421$export$2e2bcd8739ae039), {
            locationName: location.name,
            licensePlate: licensePlate,
            onClose: handleSuccessClose,
            permitTime: permitTime
        });
    }
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $9c811864513a06df$export$2e2bcd8739ae039), {
                open: createPermitMutation.isPending,
                sx: {
                    zIndex: 9999 // Korkein z-index, jotta tulee kaiken päälle
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $57e7ca2b3d7d5d01$export$2e2bcd8739ae039), {
                    size: 60,
                    success: !createPermitMutation.isPending && !createPermitMutation.isError
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
                direction: "column",
                spacing: 1,
                sx: {
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginTop: 10
                },
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a9c8587d351a7cf8$export$2e2bcd8739ae039), {
                        storedLocation: location,
                        useMoovyKeyboard: useMoovyKeyboard
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $c160feabb2f48a07$export$2e2bcd8739ae039), {
                        availableProducts: availableProducts,
                        selectedProduct: selectedProductId,
                        handleProductChange: handleProductChange,
                        productError: productError
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                        variant: "h2",
                        "aria-label": intl.formatMessage({
                            id: "page.homePage.instructions.registerNumber.arialabel"
                        }),
                        sx: {
                            color: "text.primary",
                            textAlign: "center",
                            mt: 2,
                            mb: 1
                        },
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                            id: "page.homePage.instructions.enterRegisterNumber"
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $014b1ecb904dbc18$export$2e2bcd8739ae039), {
                        onRedeem: handleRedeem,
                        useMoovyKeyboard: useMoovyKeyboard,
                        value: licensePlate,
                        onChange: (value)=>{
                            setLicensePlate(value);
                        }
                    })
                ]
            })
        ]
    });
};
var $8a29d15bb4bab780$export$2e2bcd8739ae039 = $8a29d15bb4bab780$var$HomePage;





var $1Ivrw = parcelRequire("1Ivrw");
parcelRequire("aqdBs");



function $79e106857a712590$var$ConfigurationError({ onRetry: onRetry, isLoading: isLoading }) {
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 4,
        sx: {
            bgcolor: "background.paper",
            zIndex: 1000,
            alignItems: "center",
            justifyContent: "flex-start",
            marginTop: 10,
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    width: {
                        xs: 300,
                        sm: 400
                    }
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        gap: 2,
                        flexDirection: "column",
                        textAlign: "center",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                            variant: "h2",
                            sx: {
                                color: "text.primary",
                                mt: 2
                            },
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.homePage.configurationError.title"
                            })
                        }),
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                            variant: "body1",
                            sx: {
                                color: "text.primary",
                                mt: 1,
                                fontSize: "1.2rem",
                                marginTop: "18px"
                            },
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.homePage.configurationError.body"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $d090c14501290520$export$2e2bcd8739ae039), {
                severity: "warning",
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                    id: "page.homePage.configurationError.alert"
                })
            }),
            isLoading ? /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5373eab4e5089aae$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $234a000ff615fd2f$export$2e2bcd8739ae039), {
                variant: "contained",
                onClick: onRetry,
                sx: {
                    marginTop: "4px"
                },
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                    id: "page.homePage.configurationError.button"
                })
            })
        ]
    });
}
var $79e106857a712590$export$2e2bcd8739ae039 = $79e106857a712590$var$ConfigurationError;


// 15 minutes
const $f7a8bf8ae72a994f$var$CONFIGURATION_POLLING_TIME = 900000;
const $f7a8bf8ae72a994f$var$DevicePage = ()=>{
    const { guid: guid } = (0, $bdd5c91922f45546$export$99eaa27ddbbb95ef)();
    const queryClient = (0, $da27b542cb58aea7$export$22e77b9572c4fded)();
    const queryConfig = (0, $a83b6e6e4e1b774b$export$dd0a697e1782aedd)({
        queryKey: [
            "getConfig",
            guid
        ],
        queryFn: ()=>(0, $d53f45dc6ff26360$export$2e2bcd8739ae039).getConfig(guid),
        refetchInterval: $f7a8bf8ae72a994f$var$CONFIGURATION_POLLING_TIME,
        staleTime: $f7a8bf8ae72a994f$var$CONFIGURATION_POLLING_TIME
    });
    const timeout = queryConfig.data?.apiSettings?.timeout;
    (0, $aqdBs.useEffect)(()=>{
        if (timeout) (0, $637e98f16008ef32$export$1e96637348ee8e98)(timeout);
    }, [
        timeout
    ]);
    if (queryConfig.isError) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $79e106857a712590$export$2e2bcd8739ae039), {
        onRetry: ()=>queryClient.invalidateQueries({
                queryKey: [
                    "getConfig",
                    guid
                ]
            }),
        isLoading: queryConfig.isFetching
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $31cc929a959e1d45$export$2e2bcd8739ae039), {
        sx: {
            marginTop: 10
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $7e235b881bd69492$export$2e2bcd8739ae039), {
            query: queryConfig,
            rootPageIfNotFoundError: true,
            children: queryConfig.isSuccess && /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8a29d15bb4bab780$export$2e2bcd8739ae039), {
                configuration: queryConfig.data
            })
        })
    });
};
var $f7a8bf8ae72a994f$export$2e2bcd8739ae039 = $f7a8bf8ae72a994f$var$DevicePage;



var $1Ivrw = parcelRequire("1Ivrw");


var $1Ivrw = parcelRequire("1Ivrw");


var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");



var $6JVXO = parcelRequire("6JVXO");

var $2MrFe = parcelRequire("2MrFe");






var $aqdBs = parcelRequire("aqdBs");


var $fQojQ = parcelRequire("fQojQ");

var $5ylSM = parcelRequire("5ylSM");



var $6JVXO = parcelRequire("6JVXO");

var $iAnBN = parcelRequire("iAnBN");

var $2MrFe = parcelRequire("2MrFe");

var $40jPv = parcelRequire("40jPv");

var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $169fd8bcf8e07426$export$a394fa61b1d583a9(slot) {
    return (0, $igOtJ.default)("MuiFormHelperText", slot);
}
const $169fd8bcf8e07426$var$formHelperTextClasses = (0, $jIPNy.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $169fd8bcf8e07426$export$2e2bcd8739ae039 = $169fd8bcf8e07426$var$formHelperTextClasses;



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
var $9547b24056f5d4ce$var$_span;
const $9547b24056f5d4ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $40jPv.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $169fd8bcf8e07426$export$a394fa61b1d583a9), classes);
};
const $9547b24056f5d4ce$var$FormHelperTextRoot = (0, $6JVXO.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $40jPv.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $iAnBN.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $169fd8bcf8e07426$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $169fd8bcf8e07426$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $9547b24056f5d4ce$var$FormHelperText = /*#__PURE__*/ $aqdBs.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p", disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $67d20c430b7ed8a6$export$2e2bcd8739ae039)();
    const fcs = (0, $485a8839646c9150$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $9547b24056f5d4ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($9547b24056f5d4ce$var$FormHelperTextRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === " " ? $9547b24056f5d4ce$var$_span || ($9547b24056f5d4ce$var$_span = /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    });
});
var $9547b24056f5d4ce$export$2e2bcd8739ae039 = $9547b24056f5d4ce$var$FormHelperText;




var $jIPNy = parcelRequire("jIPNy");

var $igOtJ = parcelRequire("igOtJ");
function $cdd9e5b934350199$export$c1bdcbaf0596aeda(slot) {
    return (0, $igOtJ.default)("MuiTextField", slot);
}
const $cdd9e5b934350199$var$textFieldClasses = (0, $jIPNy.default)("MuiTextField", [
    "root"
]);
var $cdd9e5b934350199$export$2e2bcd8739ae039 = $cdd9e5b934350199$var$textFieldClasses;




var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $092ab83212f7322b$var$variantComponent = {
    standard: (0, $5c4cceefff246698$export$2e2bcd8739ae039),
    filled: (0, $4acd92adf7ce06be$export$2e2bcd8739ae039),
    outlined: (0, $e5536adbffcfe8db$export$2e2bcd8739ae039)
};
const $092ab83212f7322b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $5ylSM.default)(slots, (0, $cdd9e5b934350199$export$c1bdcbaf0596aeda), classes);
};
const $092ab83212f7322b$var$TextFieldRoot = (0, $6JVXO.default)((0, $4ea6f68cc48b79d3$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $092ab83212f7322b$var$TextField = /*#__PURE__*/ $aqdBs.forwardRef(function TextField(inProps, ref) {
    const props = (0, $2MrFe.useDefaultProps)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = "outlined", ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $092ab83212f7322b$var$useUtilityClasses(ownerState);
    const id = (0, $5bb3c8b9df84a75b$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $092ab83212f7322b$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === "outlined") {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== "undefined") inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps["aria-describedby"] = undefined;
    }
    const [InputSlot, inputProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("input", {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("inputLabel", {
        elementType: (0, $4dd8d119207e4ec5$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("htmlInput", {
        elementType: "input",
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("formHelperText", {
        elementType: (0, $9547b24056f5d4ce$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $bbfd36af71b5b056$export$2e2bcd8739ae039)("select", {
        elementType: (0, $58786d866a7f202c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $1Ivrw.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($092ab83212f7322b$var$TextFieldRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState,
        ...other,
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $1Ivrw.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $1Ivrw.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $1Ivrw.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $092ab83212f7322b$export$2e2bcd8739ae039 = $092ab83212f7322b$var$TextField;



var $aqdBs = parcelRequire("aqdBs");







function $d5a8c3c962d45857$var$PasscodePrompt() {
    const [passcode, setPasscode] = (0, $aqdBs.useState)("");
    const { guid: guid } = (0, $bdd5c91922f45546$export$99eaa27ddbbb95ef)();
    // The actual method is GET, but use a mutation because of the side effect of setting the passcode in localstorage
    const mutation = (0, $e22549bf43b8fa18$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $d53f45dc6ff26360$export$2e2bcd8739ae039).getConfig(guid),
        onError: ()=>{
            (0, $a7869618706c9a61$export$af21e9f5c008f7f5)();
        }
    });
    const handleSubmit = (e)=>{
        e.preventDefault();
        tryToFetchConfiguration();
    };
    const tryToFetchConfiguration = ()=>{
        (0, $a7869618706c9a61$export$1ec41df0ac549169)(passcode);
        mutation.mutate();
    };
    const handleVirtualKeyboardInput = (key)=>{
        if (key === "delete") setPasscode((previous)=>previous.slice(0, -1));
        else if (key === "OK") tryToFetchConfiguration();
        else setPasscode((previous)=>previous + key);
    };
    let errorMessageId = "api.error.code.generic";
    if ((0, $740c54350e180ee0$export$2e2bcd8739ae039).isAxiosError(mutation.error) && mutation.error.status === 401) errorMessageId = "page.passcodePrompt.configurationFetch.error.401";
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsxs)("div", {
                children: [
                    mutation.isError && /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $d090c14501290520$export$2e2bcd8739ae039), {
                        severity: "error",
                        children: [
                            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $991456c1ebe45a00$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                    id: "page.passcodePrompt.configurationFetch.error"
                                })
                            }),
                            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: errorMessageId
                            })
                        ]
                    }),
                    mutation.isPending && /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5373eab4e5089aae$export$2e2bcd8739ae039), {}),
                    mutation.isSuccess && /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $d090c14501290520$export$2e2bcd8739ae039), {
                                severity: "success",
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                    id: "page.passcodePrompt.configurationFetch.success"
                                })
                            }),
                            /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                                style: {
                                    marginTop: "1rem",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $234a000ff615fd2f$export$2e2bcd8739ae039), {
                                    onClick: ()=>window.location.reload(),
                                    variant: "contained",
                                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                        id: "page.passcodePrompt.configurationFetch.reload"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !mutation.isSuccess && /*#__PURE__*/ (0, $1Ivrw.jsxs)("form", {
                onSubmit: handleSubmit,
                style: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $fafac108772b9e19$export$2e2bcd8739ae039), {
                        variant: "h1",
                        "aria-label": "Location",
                        sx: {
                            color: "primary.main",
                            textTransform: "uppercase",
                            marginTop: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                            id: "page.passcodePrompt.header"
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $092ab83212f7322b$export$2e2bcd8739ae039), {
                            id: "passcode",
                            label: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.passcodePrompt.label"
                            }),
                            variant: "standard",
                            name: "passcode",
                            type: "password",
                            value: passcode,
                            autoFocus: true,
                            onChange: (e)=>setPasscode(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $234a000ff615fd2f$export$2e2bcd8739ae039), {
                            variant: "contained",
                            disabled: !passcode,
                            type: "submit",
                            sx: {
                                marginTop: 2,
                                marginBottom: 2
                            },
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a30851f4d571c489$export$2e2bcd8739ae039), {
                                id: "page.passcodePrompt.submit"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)("div", {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $0e2c47fc5c90c473$export$2e2bcd8739ae039), {
                            open: true,
                            handleVirtualKeyboardInput: handleVirtualKeyboardInput,
                            useMoovyKeyboard: true
                        })
                    })
                ]
            })
        ]
    });
}
var $d5a8c3c962d45857$export$2e2bcd8739ae039 = $d5a8c3c962d45857$var$PasscodePrompt;



function $02acc2ee2d3064e4$var$PasscodeChecker({ children: children }) {
    const passcode = (0, $a7869618706c9a61$export$98d2631d6c18ba89)();
    if (passcode == null) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b5d4434a9401e2dd$export$2e2bcd8739ae039), {
        direction: "column",
        spacing: 1,
        sx: {
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 10
        },
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $d5a8c3c962d45857$export$2e2bcd8739ae039), {})
    });
    return children;
}
var $02acc2ee2d3064e4$export$2e2bcd8739ae039 = $02acc2ee2d3064e4$var$PasscodeChecker;



var $aqdBs = parcelRequire("aqdBs");



function $6300b1dff0020c46$export$af19277cb2d4d3c5() {
    const [isOffline, setIsOffline] = (0, $aqdBs.useState)(false);
    const intl = (0, $00e6da6e00acc8ce$export$2e2bcd8739ae039)();
    (0, $aqdBs.useEffect)(()=>{
        const unsubscribe = (0, $7221da7d70dd3c1e$export$b113e788b2dd3fdc).subscribe((isOnline)=>{
            setIsOffline(!isOnline);
        });
        return ()=>{
            unsubscribe();
        };
    }, []);
    (0, $aqdBs.useEffect)(()=>{
        if (isOffline) (0, $401e064a6b7f86d5$export$b410431fab84fa58).error(intl.formatMessage({
            id: "common.network.offline"
        }), {
            toastId: "offline",
            autoClose: false,
            closeButton: false
        });
        else (0, $401e064a6b7f86d5$export$b410431fab84fa58).dismiss("offline");
    }, [
        isOffline
    ]);
}


const $206e3eae9507a76b$var$appRoutes = ()=>{
    (0, $6300b1dff0020c46$export$af19277cb2d4d3c5)();
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $bdd5c91922f45546$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $bdd5c91922f45546$export$e7b0ac011bb776c6), {
                path: "code/:appId",
                element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $7e5751a376ee6bc4$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $bdd5c91922f45546$export$e7b0ac011bb776c6), {
                path: "device/:guid",
                element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $02acc2ee2d3064e4$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $f7a8bf8ae72a994f$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $206e3eae9507a76b$export$2e2bcd8739ae039 = $206e3eae9507a76b$var$appRoutes;
const $206e3eae9507a76b$export$581a21dcf1a8a09c = {
    ROOT: "/",
    CODE: "/code/:appId",
    DEVICE: "/device/:guid"
};




const $b2ec325d366241ee$var$messageResources = {
    en: (0, (/*@__PURE__*/$parcel$interopDefault($83394db86e022347$exports))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($5b7c337df226eaa3$exports)))
};
const $b2ec325d366241ee$var$storedAppSettings = JSON.parse(localStorage.getItem((0, $19204c7fe597e591$export$d5ed0aaafc7e72a6)) || "{}");
const $b2ec325d366241ee$var$initialLanguage = $b2ec325d366241ee$var$storedAppSettings.defaultLanguage || "fi";
const $b2ec325d366241ee$var$queryClient = new (0, $217e29d78e49d51a$export$405d0624ed55a03f)();
function $b2ec325d366241ee$var$App() {
    const [currentLanguage, setCurrentLanguage] = (0, $aqdBs.useState)(()=>{
        return localStorage.getItem("locale") || $b2ec325d366241ee$var$initialLanguage;
    });
    const messages = $b2ec325d366241ee$var$messageResources[currentLanguage] || (0, (/*@__PURE__*/$parcel$interopDefault($83394db86e022347$exports)));
    (0, $aqdBs.useEffect)(()=>{
        (0, $6c154842fccf6556$export$2e2bcd8739ae039).changeLanguage(currentLanguage);
        localStorage.setItem("locale", currentLanguage);
    }, [
        currentLanguage
    ]);
    const handleLanguageChange = (newLanguage)=>{
        setCurrentLanguage(newLanguage);
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3c16bc68840ca824$export$2e2bcd8739ae039), {
        locale: currentLanguage,
        messages: messages,
        children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $da27b542cb58aea7$export$45604f0cc8ae667b), {
            client: $b2ec325d366241ee$var$queryClient,
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $65991b192542b017$export$2e2bcd8739ae039), {
                    language: currentLanguage,
                    onLanguageChange: handleLanguageChange
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $401e064a6b7f86d5$export$f2815235e76a62b9), {
                    position: "top-right"
                }),
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $206e3eae9507a76b$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $b2ec325d366241ee$export$2e2bcd8739ae039 = $b2ec325d366241ee$var$App;


parcelRequire("aqdBs");
parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");
const $0e433d5437f114e5$var$ThemeContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $0e433d5437f114e5$export$2e2bcd8739ae039 = $0e433d5437f114e5$var$ThemeContext;



var $aqdBs = parcelRequire("aqdBs");

function $338e43837c74ae72$export$2e2bcd8739ae039() {
    const theme = $aqdBs.useContext((0, $0e433d5437f114e5$export$2e2bcd8739ae039));
    return theme;
}


const $114147eb3b5f5af5$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $114147eb3b5f5af5$export$2e2bcd8739ae039 = $114147eb3b5f5af5$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $1Ivrw = parcelRequire("1Ivrw");
function $1f8f24d053296120$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $1f8f24d053296120$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $338e43837c74ae72$export$2e2bcd8739ae039)();
    const theme = $aqdBs.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $1f8f24d053296120$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $114147eb3b5f5af5$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $0e433d5437f114e5$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $1f8f24d053296120$export$2e2bcd8739ae039 = $1f8f24d053296120$var$ThemeProvider;



parcelRequire("aIlUA");
var $j6Zbs = parcelRequire("j6Zbs");



var $8lEpA = parcelRequire("8lEpA");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const $320a9c058a9fced4$var$EMPTY_THEME = {};
function $320a9c058a9fced4$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $aqdBs.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $320a9c058a9fced4$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $27be6d923f5fe768$export$2e2bcd8739ae039)($320a9c058a9fced4$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $338e43837c74ae72$export$2e2bcd8739ae039)() || $320a9c058a9fced4$var$EMPTY_THEME;
    const engineTheme = $320a9c058a9fced4$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $320a9c058a9fced4$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1f8f24d053296120$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $j6Zbs.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4ec2abae1b3c08a6$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $8lEpA.default), {
                    value: engineTheme?.components,
                    children: children
                })
            })
        })
    });
}
var $320a9c058a9fced4$export$2e2bcd8739ae039 = $320a9c058a9fced4$var$ThemeProvider;



var $dbHL4 = parcelRequire("dbHL4");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $a3c28e1cdbc97988$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $dbHL4.default) in themeInput ? themeInput[0, $dbHL4.default] : undefined;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $320a9c058a9fced4$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $dbHL4.default) : undefined,
        theme: scopedTheme || themeInput
    });
}


parcelRequire("aqdBs");

var $3WTHp = parcelRequire("3WTHp");

var $aqdBs = parcelRequire("aqdBs");


var $LkOKM = parcelRequire("LkOKM");


/**
 * Split this component for RSC import
 */ parcelRequire("aqdBs");

var $1Ivrw = parcelRequire("1Ivrw");
const $ff7b4bafdaa43ae2$export$ff0fa3047d11164c = "mode";
const $ff7b4bafdaa43ae2$export$665054ea9d94dab9 = "color-scheme";
const $ff7b4bafdaa43ae2$export$14ebe5b26ee7fb38 = "data-color-scheme";
function $ff7b4bafdaa43ae2$export$2e2bcd8739ae039(options) {
    const { defaultLightColorScheme: defaultLightColorScheme = "light", defaultDarkColorScheme: defaultDarkColorScheme = "dark", modeStorageKey: modeStorageKey = $ff7b4bafdaa43ae2$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $ff7b4bafdaa43ae2$export$665054ea9d94dab9, attribute: initialAttribute = $ff7b4bafdaa43ae2$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = "document.documentElement", nonce: nonce } = options || {};
    let setter = "";
    let attribute = initialAttribute;
    if (initialAttribute === "class") attribute = ".%s";
    if (initialAttribute === "data") attribute = "[data-%s]";
    if (attribute.startsWith(".")) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split("=");
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $1Ivrw.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === "undefined" ? nonce : "",
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || 'system';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $aqdBs = parcelRequire("aqdBs");

"use client";
function $99958f69ef189fa8$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== "undefined" && typeof window.matchMedia === "function" && mode === "system") {
        const mql = window.matchMedia("(prefers-color-scheme: dark)");
        if (mql.matches) return "dark";
        return "light";
    }
    return undefined;
}
function $99958f69ef189fa8$var$processState(state, callback) {
    if (state.mode === "light" || state.mode === "system" && state.systemMode === "light") return callback("light");
    if (state.mode === "dark" || state.mode === "system" && state.systemMode === "dark") return callback("dark");
    return undefined;
}
function $99958f69ef189fa8$export$3caa7590cc1987bd(state) {
    return $99958f69ef189fa8$var$processState(state, (mode)=>{
        if (mode === "light") return state.lightColorScheme;
        if (mode === "dark") return state.darkColorScheme;
        return undefined;
    });
}
function $99958f69ef189fa8$var$initializeValue(key, defaultValue) {
    if (typeof window === "undefined") return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch (e) {
    // Unsupported
    }
    return value || defaultValue;
}
function $99958f69ef189fa8$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = "light", defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $ff7b4bafdaa43ae2$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $ff7b4bafdaa43ae2$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === "undefined" ? undefined : window } = options;
    const joinedColorSchemes = supportedColorSchemes.join(",");
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const [state, setState] = $aqdBs.useState(()=>{
        const initialMode = $99958f69ef189fa8$var$initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = $99958f69ef189fa8$var$initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = $99958f69ef189fa8$var$initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: $99958f69ef189fa8$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    // This could be improved with `React.useSyncExternalStore` in the future.
    const [, setHasMounted] = $aqdBs.useState(false);
    const hasMounted = $aqdBs.useRef(false);
    $aqdBs.useEffect(()=>{
        if (isMultiSchemes) setHasMounted(true); // to rerender the component after hydration
        hasMounted.current = true;
    }, [
        isMultiSchemes
    ]);
    const colorScheme = $99958f69ef189fa8$export$3caa7590cc1987bd(state);
    const setMode = $aqdBs.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch (e) {
            // Unsupported
            }
            return {
                ...currentState,
                mode: newMode,
                systemMode: $99958f69ef189fa8$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = $aqdBs.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch (e) {
            // Unsupported
            }
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === "string") {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $99958f69ef189fa8$var$processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch (e) {
                    // Unsupported
                    }
                    if (mode === "light") newState.lightColorScheme = value;
                    if (mode === "dark") newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $aqdBs.useCallback((event)=>{
        if (state.mode === "system") setState((currentState)=>{
            const systemMode = event?.matches ? "dark" : "light";
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $aqdBs.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $aqdBs.useEffect(()=>{
        if (typeof window.matchMedia !== "function" || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia("(prefers-color-scheme: dark)");
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $aqdBs.useEffect(()=>{
        if (storageWindow && isMultiSchemes) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === "string" && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith("light")) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith("dark")) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    "light",
                    "dark",
                    "system"
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener("storage", handleStorage);
            return ()=>{
                storageWindow.removeEventListener("storage", handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes
    ]);
    return {
        ...state,
        mode: hasMounted.current || !isMultiSchemes ? state.mode : undefined,
        systemMode: hasMounted.current || !isMultiSchemes ? state.systemMode : undefined,
        colorScheme: hasMounted.current || !isMultiSchemes ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



var $1Ivrw = parcelRequire("1Ivrw");
const $9dde7dc2555c3c71$export$c09f426c4535c3ec = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function $9dde7dc2555c3c71$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $ff7b4bafdaa43ae2$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $ff7b4bafdaa43ae2$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $aqdBs.createContext(undefined);
    const useColorScheme = ()=>$aqdBs.useContext(ColorSchemeContext) || defaultContext;
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageWindow: storageWindow = typeof window === "undefined" ? undefined : window, documentNode: documentNode = typeof document === "undefined" ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === "undefined" ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false } = props;
        const hasMounted = $aqdBs.useRef(false);
        const upperTheme = (0, $338e43837c74ae72$export$2e2bcd8739ae039)();
        const ctx = $aqdBs.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $aqdBs.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === "function" ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const { colorSchemes: colorSchemes = {}, components: components = {}, cssVarPrefix: cssVarPrefix, ...restThemeProp } = scopedTheme || initialTheme;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(",");
        const allColorSchemes = $aqdBs.useMemo(()=>joinedColorSchemes.split(","), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? "system" : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $99958f69ef189fa8$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageWindow: storageWindow
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        // 2. get the `vars` object that refers to the CSS custom properties
        const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
        // 3. Start composing the theme object
        const theme = {
            ...restThemeProp,
            components: components,
            colorSchemes: colorSchemes,
            cssVarPrefix: cssVarPrefix,
            vars: themeVars
        };
        if (typeof theme.generateSpacing === "function") theme.spacing = theme.generateSpacing();
        // 4. Resolve the color scheme and merge it to the theme
        if (calculatedColorScheme) {
            const scheme = colorSchemes[calculatedColorScheme];
            if (scheme && typeof scheme === "object") // 4.1 Merge the selected color scheme to the theme
            Object.keys(scheme).forEach((schemeKey)=>{
                if (scheme[schemeKey] && typeof scheme[schemeKey] === "object") // shallow merge the 1st level structure of the theme.
                theme[schemeKey] = {
                    ...theme[schemeKey],
                    ...scheme[schemeKey]
                };
                else theme[schemeKey] = scheme[schemeKey];
            });
        }
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        $aqdBs.useEffect(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== "media") {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === "class") rule = `.%s`;
                if (selector === "data") rule = `[data-%s]`;
                if (selector?.startsWith("data-") && !selector.includes("%s")) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith(".")) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace("%s", scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace("%s", colorScheme));
                } else {
                    const matches = rule.replace("%s", colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split("=");
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, "") : "");
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $aqdBs.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement("style");
                css.appendChild(documentNode.createTextNode($9dde7dc2555c3c71$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $aqdBs.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $aqdBs.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $1Ivrw.jsxs)($aqdBs.Fragment, {
            children: [
                /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $320a9c058a9fced4$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: resolveTheme ? resolveTheme(theme) : theme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $LkOKM.default), {
                    styles: theme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $1Ivrw.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === "string" ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $ff7b4bafdaa43ae2$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $cIIWu = parcelRequire("cIIWu");

var $9J536 = parcelRequire("9J536");

var $dbHL4 = parcelRequire("dbHL4");
parcelRequire("aqdBs");


var $1Ivrw = parcelRequire("1Ivrw");
const $b7228cb9dd5051d2$export$f84bd70098573c5c = {
    attribute: "data-mui-color-scheme",
    colorSchemeStorageKey: "mui-color-scheme",
    defaultLightColorScheme: "light",
    defaultDarkColorScheme: "dark",
    modeStorageKey: "mui-mode"
};
var $b7228cb9dd5051d2$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ff7b4bafdaa43ae2$export$2e2bcd8739ae039), {
        ...$b7228cb9dd5051d2$export$f84bd70098573c5c,
        ...props
    });
};



var $1Ivrw = parcelRequire("1Ivrw");
"use client";
const { CssVarsProvider: $de99e9f78e561229$var$InternalCssVarsProvider, useColorScheme: $de99e9f78e561229$export$6343629ee1b29116, getInitColorSchemeScript: $de99e9f78e561229$var$deprecatedGetInitColorSchemeScript } = (0, $9dde7dc2555c3c71$export$2e2bcd8739ae039)({
    themeId: (0, $dbHL4.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $cIIWu.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $b7228cb9dd5051d2$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $b7228cb9dd5051d2$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $b7228cb9dd5051d2$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $b7228cb9dd5051d2$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $9J536.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $3WTHp.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $de99e9f78e561229$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $de99e9f78e561229$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $1Ivrw.jsx)($de99e9f78e561229$var$InternalCssVarsProvider, {
        ...props
    });
}
let $de99e9f78e561229$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $de99e9f78e561229$export$f9a57b4a2abf8ed = (params)=>{
    if (!$de99e9f78e561229$var$warnedInitScriptOnce) {
        console.warn([
            "MUI: The getInitColorSchemeScript function has been deprecated.",
            "",
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            "and replace the function call with `<InitColorSchemeScript />` instead."
        ].join("\n"));
        $de99e9f78e561229$var$warnedInitScriptOnce = true;
    }
    return $de99e9f78e561229$var$deprecatedGetInitColorSchemeScript(params);
};
const $de99e9f78e561229$export$50ec01b133c61652 = $de99e9f78e561229$var$InternalCssVarsProvider;



var $dbHL4 = parcelRequire("dbHL4");

var $1Ivrw = parcelRequire("1Ivrw");
"use client";
function $657f1bac60ce4512$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    if (typeof theme === "function") return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a3c28e1cdbc97988$export$2e2bcd8739ae039), {
        theme: theme,
        ...props
    });
    const muiTheme = (0, $dbHL4.default) in theme ? theme[0, $dbHL4.default] : theme;
    if (!("colorSchemes" in muiTheme)) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a3c28e1cdbc97988$export$2e2bcd8739ae039), {
        theme: theme,
        ...props
    });
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $de99e9f78e561229$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}



const $70fc9a727fa662ae$var$root = (0, $c920eedc27eaef64$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $657f1bac60ce4512$export$2e2bcd8739ae039), {
    theme: (0, $d34ef44fcd75733a$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $bdd5c91922f45546$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $b2ec325d366241ee$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.9582f175.js.map
